import {
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instanceat14thlj150z as Unit_instance,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  toString30pk9tzaqopn as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  println2shhhgwwt4c61 as println,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  printStackTrace18lnx7a39cni as printStackTrace,
  getKClass1s3j9wy1cofik as getKClass,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  first58ocm7j58k3q as first,
  CoroutineContext3n9ge8bnnq7z2 as CoroutineContext,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  ArrayList3it5z8td81qkl as ArrayList,
  toList383f556t1dixk as toList,
  toMutableList20rdgwi7d3cwi as toMutableList,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  lazy2hsh8ze7j6ikd as lazy,
  toList3jhuyej2anx2q as toList_0,
  retainAll1hufpctl19y6u as retainAll,
  toSet2orjxp16sotqu as toSet,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  toSet1glep2u1u9tcb as toSet_0,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  isNaNymqb93xtq8w8 as isNaN_0,
  to2cs3ny02qtbcb as to,
  Enum3alwj03lh1n41 as Enum,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  CancellationException3b36o9qz53rgr as CancellationException,
  captureStack1fzi4aczwc4hg as captureStack,
  numberToDouble210hrknaofnhf as numberToDouble,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  emptyList1g2z5xcrvp2zy as emptyList,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  Duration5ynfiptaqcrg as Duration,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  protoOf180f3jzyo7rfj as protoOf,
  KProperty02ce7r476m8633 as KProperty0,
  THROW_ISE25y4rao9gcv5s as THROW_ISE,
  getLocalDelegateReferencenlta2y7wt3po as getLocalDelegateReference,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  maxOrNull5i0eu9xqz7pb as maxOrNull,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  intercepted2ogpsikxxj4u0 as intercepted,
  returnIfSuspendednggonvg9333x as returnIfSuspended,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  indexOfa2zokh3tu4p6 as indexOf,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  compareTo3ankvs086tmwq as compareTo,
  getOrNull1go7ef9ldk0df as getOrNull,
  sortWith4fnm6b3vw03s as sortWith,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  KtList3hktaavzmj137 as KtList,
  listOfvhqybd2zx248 as listOf,
  firstOrNull1982767dljvdy as firstOrNull,
  coerceAtMost322komnqp70ag as coerceAtMost,
  contains1tccixv8iwdcq as contains,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  until1jbpn0z3f8lbg as until,
  Duration__times_impl_sfuzvp1gzave8ckyu1a as Duration__times_impl_sfuzvp,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  HashMap1a0ld5kgwhmhv as HashMap,
  replace3le3ie7l9k8aq as replace,
  plus310ted5e4i90h as plus,
  createThis2j2avj17cvnv2 as createThis,
  isFinite1tx0gn65nl9tj as isFinite,
  get_lastIndex327lnwnipm748 as get_lastIndex,
  countTrailingZeroBitszhs0313cn11e as countTrailingZeroBits,
  removeAll3o43e67jmwdpc as removeAll,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_0,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Level_TRACE_getInstance1ni95vo21pald as Level_TRACE_getInstance,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  Companion_getInstancet6d3dkp9rzuf as Companion_getInstance_1,
  invoke2sf88d1xeuyqh as invoke,
  Signal3nnez3346azzf as Signal,
  AsyncSignal3p186s2w7f15b as AsyncSignal,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope1245ljoj2flcu as coroutineScope,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  cancel2en0dn4yvpufo as cancel,
  Key_instance2expa55gr45sc as Key_instance,
  TimeoutCancellationException198b5zwr3v3uw as TimeoutCancellationException,
  withTimeout2wixyx2dhn9kz as withTimeout,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
} from './kotlinx-coroutines-core.mjs';
import {
  get_RegisteredImageFormats243xf60qkmjxj as get_RegisteredImageFormats,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  RGBA34obx2i62wcl3 as RGBA,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  readBitmapdk80pcjw6p8f as readBitmap,
  Bitmaps_instance27726euemn90u as Bitmaps_instance,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  RGBA__withAd_impl_cralao1ojb8pkalp2nb as RGBA__withAd_impl_cralao,
  Companion_getInstance2ou2xyvohty1g as Companion_getInstance_2,
  _RGBA___get_premultipliedFast__impl__qiau4g35hwdu9bo5950 as _RGBA___get_premultipliedFast__impl__qiau4g,
  get_lazyBitmap3pyj425xl7cp4 as get_lazyBitmap,
  RGBA__times_impl_wehs9n2bi9iz06j1oam as RGBA__times_impl_wehs9n,
  get_Bitmaps_transparent3nm2857y3u3hn as get_Bitmaps_transparent,
  MaterialColors_getInstance39ky4hjexuaug as MaterialColors_getInstance,
  RichTextData1m4oei1jdcuz5 as RichTextData,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  Companion_getInstancezw1wxvwtmh0g as Companion_getInstance_3,
  RGBA__withAf_impl_dpdu32g4ua5xko755s as RGBA__withAf_impl_dpdu32,
  _RGBA___get_ad__impl__pt5rdj2rhup0gteq97n as _RGBA___get_ad__impl__pt5rdj,
  get_bmpevghw2zw2fa7 as get_bmp,
  NativeImageOrBitmap3211fg7set8uiki as NativeImageOrBitmap32,
  slice2pfxfvku0ybgy as slice,
  get_isLow1k7uocm2ojjr8 as get_isLow,
  ShapeBuilderk05da5wk16e9 as ShapeBuilder,
  EmptyShape_instance1905h5dvjxi3r as EmptyShape_instance,
  readBitmapSlice2r7knpwifec2u as readBitmapSlice,
  readFont34z4s2654u5hd as readFont,
  HorizontalAlign__getOffsetX_impl_urzzxfa8fekmmr9non as HorizontalAlign__getOffsetX_impl_urzzxf,
  VerticalAlign__getOffsetY_impl_iso0y6m9d6k6n5h47j as VerticalAlign__getOffsetY_impl_iso0y6,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  Text2TextRendererActions1307nbc4pqqhs as Text2TextRendererActions,
  Entry3jfmfe0iy8gwc as Entry,
  FontMetrics1b1o1zbrk6cew as FontMetrics,
  TextMetrics1vfyzci74zdhy as TextMetrics,
  BitmapFont35unsvaxq1brd as BitmapFont,
  Font2bg7nte760csr as Font,
  getTextBoundsio1pfpt2q8ze as getTextBounds,
  TextMetricsResult1qr6b0fc6i56z as TextMetricsResult,
  invoke2ot88cm6qcfmr as invoke_0,
  LineInfo27uw564y6w2d2 as LineInfo,
  _VerticalAlign___get_ratioFake__impl__1h2fwv1dj21d0zq5uhq as _VerticalAlign___get_ratioFake__impl__1h2fwv,
  Companion_getInstance2w9pdpq8h2ue0 as Companion_getInstance_4,
  NativeImage33w1i7ec8zfym as NativeImage,
  drawRichTextyqpa5ren8u0j as drawRichText,
  placem8wpiy4fm4tw as place,
  ColorTransformMul2rawiv5hyxh9p as ColorTransformMul,
  _RGBA___get_hexString__impl__kocngmis57bfwjkwav as _RGBA___get_hexString__impl__kocngm,
  _RGBA___get_rgb__impl__tijaqtysv8goadjy9q as _RGBA___get_rgb__impl__tijaqt,
  PolylineShape2w5p5crr94b97 as PolylineShape,
  FillShape13c5zk3dmjgcf as FillShape,
  TextShape3u9vrw15swk1x as TextShape,
  CompoundShape2jsp34o6wp7wp as CompoundShape,
  _RGBA___get_premultiplied__impl__3bulqc3rk78ta2124j5 as _RGBA___get_premultiplied__impl__3bulqc,
  Bitmap321klycakvwgb5w as Bitmap32,
  _RgbaPremultipliedArray___init__impl__lx83hy2e5m664sv80uc as _RgbaPremultipliedArray___init__impl__lx83hy,
  GradientPaint1uc4xuo0s2w8w as GradientPaint,
  BitmapPaintgyia0tdij0bl as BitmapPaint,
  NonePaint2h93brzruznft as NonePaint,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  Companion_instance3gshkh79a96f7 as Companion_instance_0,
  Companion_instance293l0r179rei7 as Companion_instance_1,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_5,
  DateTime2gld4ho36azq9 as DateTime,
  TimeProvider2j6wl2le6n0p3 as TimeProvider,
  FastDuration3d3pupg2e5ora as FastDuration,
  FastDuration__times_impl_h6amcp3u6kv4tju4mnx as FastDuration__times_impl_h6amcp,
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  FastDuration__compareTo_impl_4fhnj73optjj2wg605h as FastDuration__compareTo_impl_4fhnj7_0,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds_0,
  FastDuration__toString_impl_c9xohb3u75ye94mx1dw as FastDuration__toString_impl_c9xohb,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  _FastDuration___get_fastSeconds__impl__amo4s31n2ucdhlz8ys6 as _FastDuration___get_fastSeconds__impl__amo4s3,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237,
  get_slowaqovrrnrezzv as get_slow,
  get_fast37cu8s8qwnuyi as get_fast,
  DateTime__minus_impl_10njw812puhhvc4b9kf as DateTime__minus_impl_10njw8,
  DateTime__hashCode_impl_yf0bc92s64omsn0fynv as DateTime__hashCode_impl_yf0bc9,
  get_DURATION_NIL2lkiawowwp1us as get_DURATION_NIL,
  FastDuration__div_impl_rlslck3eqcfgtjve915 as FastDuration__div_impl_rlslck,
  _FastDuration___get_nanoseconds__impl__pxizcb1ry8wyoc0dr5c as _FastDuration___get_nanoseconds__impl__pxizcb,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  div1s6t4x2ts64sh as div,
  get_fastMicroseconds16wth98xujxdo as get_fastMicroseconds_0,
  _FastDuration___get_fastMicroseconds__impl__e641g11wrcl3xo4cr7g as _FastDuration___get_fastMicroseconds__impl__e641g1,
  FastDuration__div_impl_rlslck2moqkr2wlhp55 as FastDuration__div_impl_rlslck_0,
  toDuration15w5sljvx2ut2 as toDuration_0,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Injectorxjyp19tp5mfu as Injector,
  InjectorContextps0ngmjb9onz as InjectorContext,
  InjectorDependency2f8dsqe1kn3nn as InjectorDependency,
  injectorznx5rgygah7n as injector,
} from './korlibs-inject-root-korlibs-inject.mjs';
import {
  Companion_getInstance1dp345vz250gb as Companion_getInstance_6,
  DefaultViewport_getInstance3ta8638tkh0q1 as DefaultViewport_getInstance,
  Quality_PERFORMANCE_getInstance2edcjnp9auwx5 as Quality_PERFORMANCE_getInstance,
  GameWindowCreationConfigbzmga8g39et1 as GameWindowCreationConfig,
  configure1a7py4k2lj4vi as configure,
  Input3ljaq07eyi73v as Input,
  Statslnkcsgem8jjl as Stats,
  AGPrint2do8iynklt71b as AGPrint,
  GameWindow35197f3hcbh1b as GameWindow,
  KorgeReload_getInstance1jsrcs9uzp4z9 as KorgeReload_getInstance,
  configureLoggerFromProperties2zy8apzr93pqp as configureLoggerFromProperties,
  CoroutineKey_getInstance2jikmq30sknr8 as CoroutineKey_getInstance,
  CreateDefaultGameWindow1l94icsbq4y8h as CreateDefaultGameWindow,
  Kind_MOUSE_getInstance104tc4m897tyy as Kind_MOUSE_getInstance,
  ResourcesRoot36ooexy6oq69y as ResourcesRoot,
  Type_START_getInstance27oonvh9zpi1o as Type_START_getInstance,
  Status_ADD_getInstance22apyg5ct4px7 as Status_ADD_getInstance,
  Type_END_getInstance3ekhp9k4xqwsb as Type_END_getInstance,
  Status_REMOVE_getInstance19drpw6lfvon8 as Status_REMOVE_getInstance,
  Type_MOVE_getInstanceavavmobr5nzz as Type_MOVE_getInstance,
  Status_KEEP_getInstance3tj4183qdgyi5 as Status_KEEP_getInstance,
  MouseButton_LEFT_getInstance2pxjdxrpl68c5 as MouseButton_LEFT_getInstance,
  Type_DRAG_getInstance1oyczma3u1sfi as Type_DRAG_getInstance,
  Type_UP_getInstance1azeslmnft6l5 as Type_UP_getInstance,
  Type_DOWN_getInstance1zas01g4tazis as Type_DOWN_getInstance,
  AG35f0xk1ko87rh as AG,
  TouchEvent37l81isz00qgj as TouchEvent,
  Companion_getInstancekjblelnta22u as Companion_getInstance_7,
  Companion_getInstance1wltq3fgn1avz as Companion_getInstance_8,
  Companion_getInstance2ckr5i14ndxro as Companion_getInstance_9,
  Companion_getInstance18y91gyxi2z7 as Companion_getInstance_10,
  Companion_instance3i2v9jzzqvdkl as Companion_instance_2,
  Companion_instance2ovjg7lp6gfg7 as Companion_instance_3,
  Companion_instancef7estul0zruo as Companion_instance_4,
  Companion_instance99w5lpdgjzr4 as Companion_instance_5,
  MouseEventmt8xebywpdp9 as MouseEvent,
  Companion_getInstance6ryfwvwg9trm as Companion_getInstance_11,
  Companion_getInstanceok0yphc67vv6 as Companion_getInstance_12,
  Companion_instancekcgdgz2aik3h as Companion_instance_6,
  Companion_instance12t49ingjwxzt as Companion_instance_7,
  ReshapeEvent3137ki3m95agm as ReshapeEvent,
  Companion_instance7uo85wjiqj61 as Companion_instance_8,
  KeyEvent3kdv2rq8w0dew as KeyEvent,
  Type_TYPE_getInstance3kl3gtiytkq1p as Type_TYPE_getInstance,
  Type_DOWN_getInstance3w3upujzs6x5 as Type_DOWN_getInstance_0,
  Type_UP_getInstance2onpl7vaj0n6f as Type_UP_getInstance_0,
  Cursor_DEFAULT_getInstancemdqrzfwu4c9e as Cursor_DEFAULT_getInstance,
  Companion_getInstance1ifu77pbb1si2 as Companion_getInstance_13,
  drawText2ld6eqw3mc9xd as drawText,
  UniformBlock2qoqszhm3r9i2 as UniformBlock,
  ProgramBuilderDefault3573mhybddt0b as ProgramBuilderDefault,
  SDFShaders_getInstance2aqc6fv2u457r as SDFShaders_getInstance,
  If1av5krmfyt44s as If,
  FragmentShader2u3ycaqbgbmdi as FragmentShader,
  V22su20mpwty0v0 as V2,
  _interpolateRatio2cj6ldbl0g6ae as _interpolateRatio,
  get_BB_MAX_TEXTURES19x2awozztfc7 as get_BB_MAX_TEXTURES,
  Companion_instanceyamrbth4pjfq as Companion_instance_9,
  _interpolateColor3ps0kri0tazz4 as _interpolateColor,
  Cursor_HAND_getInstance18p4ksi2yuad6 as Cursor_HAND_getInstance,
  Key_SPACE_getInstance3ccpin6uc1wp0 as Key_SPACE_getInstance,
  Companion_getInstance2y4l90zc9q53m as Companion_getInstance_14,
  Key_TAB_getInstancerm3v8lzruhq1 as Key_TAB_getInstance,
  _interpolated0idy8l9id9j as _interpolate,
  V2Callback2d6dtckx13wqz as V2Callback,
  BaseEventListener6clplq3qhf9k as BaseEventListener,
  Companion_getInstance23l94gq35u9ye as Companion_getInstance_15,
  TextureBase31xvoisoo1pp7 as TextureBase,
  Texture39uvj3jju6ujd as Texture,
  AGScissor1lpa42gfyr1p2 as AGScissor,
  ProjViewUB_getInstance2c14wyrj73xek as ProjViewUB_getInstance,
  get_debugLineRenderContext3s3h9yq8a0rtj as get_debugLineRenderContext,
  Companion_getInstance2vwksse73neff as Companion_getInstance_16,
  get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz as get_TEXTURED_ARRAY_QUAD_INDICES,
  TexturedVertexArrayt1cf0uhgxqi1 as TexturedVertexArray,
  BoundsProvideri69utw6h2duh as BoundsProvider,
  debugBmpFont2i7i2ml66o1iy as debugBmpFont,
  Basef4lqzcfsxjhi as Base,
  UpdateEvent2wwv3f0im2cby as UpdateEvent,
  RenderContext3l27as458i66g as RenderContext,
  EventResult1qajuo9ssrvv5 as EventResult,
  Key_F12_getInstance20smmrbslhgku as Key_F12_getInstance,
  Key_F7_getInstance1fxfgbmldwoq6 as Key_F7_getInstance,
  StopPropagatingException3fryyzw9pc422 as StopPropagatingException,
  DeviceDimensionsProvider22igvmdnpe2w1 as DeviceDimensionsProvider,
  Eventnral6s6c3h27 as Event,
  VarType_Int1_getInstance3lnu8nb18gbk8 as VarType_Int1_getInstance,
  ForSimple22pqvfecoo85d as ForSimple,
  Texture2obedkmljq67n as Texture_0,
  DefaultShaders_getInstance2nkm3g7twu3qg as DefaultShaders_getInstance,
  Shader39o79ur9unxav as Shader,
  Program1hnygp9hph4ry as Program,
  AGTextureUnits3k80ikbk5qbv9 as AGTextureUnits,
  Companion_getInstance27aqys8b8jo0e as Companion_getInstance_17,
  AGTextureUnitInfoArray__get_impl_xhvpef1gqflly73w69y as AGTextureUnitInfoArray__get_impl_xhvpef,
  Companion_getInstanceae40js4gnuwg as Companion_getInstance_18,
  Companion_getInstance2cx7brx0y6bm1 as Companion_getInstance_19,
  Companion_getInstance3dym1csqm206y as Companion_getInstance_20,
  toAGScissor50oxbqy8vpfx as toAGScissor,
  plus3tmekjwnqrsa6 as plus_0,
  _AGColorMask___init__impl__j38ai819ejt5rq8iy6o as _AGColorMask___init__impl__j38ai8,
  Companion_getInstancei2plsq4vst79 as Companion_getInstance_21,
  AGStencilOpFunc__withEnabled_impl_mpcwmr3endm713vq1t4 as AGStencilOpFunc__withEnabled_impl_mpcwmr,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv2a7p3ocsjaav3 as AGStencilOpFunc__withCompareMode$default_impl_rzbauv,
  Companion_getInstance203qp9xyfv543 as Companion_getInstance_22,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgoupfk5vp49hcf as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo,
  AGStencilReference__withWriteMask$default_impl_b7j7b425xwuml31ig42 as AGStencilReference__withWriteMask$default_impl_b7j7b4,
  Companion_getInstance14dcva8uz4sb6 as Companion_getInstance_23,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at1fkyyctti87u0 as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at,
  AGStencilReference__withReadMask$default_impl_7mdffx3h4nrtbyv01sb as AGStencilReference__withReadMask$default_impl_7mdffx,
  AGCompareMode__inverted_impl_7xxk8m1fvhgazpgzedy as AGCompareMode__inverted_impl_7xxk8m,
  AGStencilReference__withReferenceValue$default_impl_2trj0vn7k078mgur5t as AGStencilReference__withReferenceValue$default_impl_2trj0v,
  _AGColorMask___init__impl__j38ai828hvpfxybxjk7 as _AGColorMask___init__impl__j38ai8_0,
  Companion_getInstance29a9zmyrrw3c9 as Companion_getInstance_24,
  AGDrawType__toString_impl_eonaeb3ais8d8qrz6pw as AGDrawType__toString_impl_eonaeb,
  AGColorMask__toString_impl_5i5oqgpd3xxn1kc5a as AGColorMask__toString_impl_5i5oqg,
  AGStencilOpFunc__toString_impl_pl8quy1rqibzqlcrdqz as AGStencilOpFunc__toString_impl_pl8quy,
  AGStencilReference__toString_impl_qu5r8s2c4bvb2linrx as AGStencilReference__toString_impl_qu5r8s,
  AGCullFace__toString_impl_7d891w3d9dwll45l9u7 as AGCullFace__toString_impl_7d891w,
  AGDrawType__hashCode_impl_ylaurytzzq8sas7cp2 as AGDrawType__hashCode_impl_ylaury,
  AGColorMask__hashCode_impl_g9082fge542b8j3bn5 as AGColorMask__hashCode_impl_g9082f,
  AGStencilOpFunc__hashCode_impl_nopebb37r56bx19rj5s as AGStencilOpFunc__hashCode_impl_nopebb,
  AGStencilReference__hashCode_impl_52zufx32vlakxm4newn as AGStencilReference__hashCode_impl_52zufx,
  AGCullFace__hashCode_impl_t4e5urey2md6modztx as AGCullFace__hashCode_impl_t4e5ur,
  AGDrawType11vxw4gf0yugk as AGDrawType,
  AGColorMaskwqd86t1dhpnk as AGColorMask,
  AGStencilOpFunc1juigl5mvjr07 as AGStencilOpFunc,
  AGStencilReference8at184sv64zi as AGStencilReference,
  AGCullFaceff7di2v9k2ne as AGCullFace,
  AgCachedBuffer8k1i505isl6b as AgCachedBuffer,
  AGVertexArrayObjectp6l6cor3jhq8 as AGVertexArrayObject,
  AGVertexDatawn78bdwnwjab as AGVertexData,
  applyMatrixBounds3j13fpymjibm6 as applyMatrixBounds,
  AGBatch2bse24318tbhc as AGBatch,
  draw3n7i8s75fp58g as draw,
  UniformBlockBuffer2p2oao2ic417b as UniformBlockBuffer,
  VarType_Float2_getInstance321ftm11bbyai as VarType_Float2_getInstance,
  Attribute3obvnbxr5w4xd as Attribute,
  VarType_Float1_getInstance1fp6gxp2vmo7y as VarType_Float1_getInstance,
  Precision_MEDIUM_getInstancewn61okav7bh4 as Precision_MEDIUM_getInstance,
  Varying105nnu9x9j75f as Varying,
  ProgramLayout373hh4xkth3qt as ProgramLayout,
  VertexShader26kcg39ndf3s1 as VertexShader,
  Companion_instance31en7fj48z7ti as Companion_instance_10,
  Companion_getInstance31h96uhdj5cc as Companion_getInstance_25,
} from './korge-root-korge-core.mjs';
import {
  Companion_getInstance23o88a0u6ly94 as Companion_getInstance_26,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance_27,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance_28,
  Size2Dum5ayuyhhau7 as Size2D,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_29,
  Companion_getInstance3lu3946d91kk8 as Companion_getInstance_30,
  Vector2F2yb91r49vy4m7 as Vector2F,
  timesatqrmkwmiu2z as times,
  Marginzmgz0t8x8vn as Margin,
  Rectangle3q03woyn9k8x1 as Rectangle,
  place35kwuvwdaw5nl as place_0,
  RectCorners2yrtl8r42p5bs as RectCorners,
  Companion_getInstance2yu48324co92b as Companion_getInstance_31,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x,
  _BoundsBuilder___get_xmax__impl__gsz0km31n4zf6la54qa as _BoundsBuilder___get_xmax__impl__gsz0km,
  _BoundsBuilder___get_ymax__impl__oia4uz2kb33iwdnvg1r as _BoundsBuilder___get_ymax__impl__oia4uz,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_32,
  Scale2cm697xlulcp5 as Scale,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_33,
  Companion_getInstance3la8ioxhl91va as Companion_getInstance_34,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_35,
  interpolatewhd2sgxffql5 as interpolate,
  _Angle___get_degrees__impl__qg56vw2n539uvc01e1n as _Angle___get_degrees__impl__qg56vw,
  _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle as _Angle___get_absoluteValue__impl__4qoakv,
  SizeInte6w85oa6mz6v as SizeInt,
  toFloat3b315y36g90cd as toFloat,
  toIntp2twe4onfbic as toInt,
  get_degrees3czcd4ojw4i as get_degrees,
  MarginInt3jiec8xsxkfd as MarginInt,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_36,
  _Angle___get_sine__impl__15nmyi39oh4tio4auz1 as _Angle___get_sine__impl__15nmyi,
  _Angle___get_cosine__impl__vprvmu3ab5uwcliuboq as _Angle___get_cosine__impl__vprvmu,
  BoundsBuilder__plus_impl_cz7f7xiu6sbkxslhhl as BoundsBuilder__plus_impl_cz7f7x_0,
  _BoundsBuilder___get_xmin__impl__o2sib0fqg01yornfcx as _BoundsBuilder___get_xmin__impl__o2sib0,
  _BoundsBuilder___get_ymin__impl__5n2e8j1x2fwruhjr6r5 as _BoundsBuilder___get_ymin__impl__5n2e8j,
  Vector4F1clr35ctch8js as Vector4F,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_37,
  convertRange1a6ancvyn151r as convertRange,
  clamp011ml7wx1d2b7sp as clamp01,
  toRatio1hooqit5gulhr as toRatio,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_38,
  Ratio136tf4z2t0p2d as Ratio,
  Ratio__toString_impl_mfgt3e2iqv27qr9i5ak as Ratio__toString_impl_mfgt3e,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
  clampdicp8njiht45 as clamp,
  clamp1qclpmpfxm7xb as clamp_0,
  toLongRound7crzegvo2qbo as toLongRound,
  _Ratio___get_value__impl__57cli6w1n0arietzij as _Ratio___get_value__impl__57cli6,
  toIntCeil3h286vm49zgwd as toIntCeil,
  clamp31lhm66c28ic8 as clamp_1,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  roundDecimalPlacespck2j5mpzhqn as roundDecimalPlaces,
  convertRange24n2xnngpze54 as convertRange_0,
  niceStr1ftz2qvn4gdyq as niceStr,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  toIntCeiltm5lvaa6k4k9 as toIntCeil_0,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  get_EASElq2v0gsk9fz7 as get_EASE,
  get_immutablepxpdoj6e54ll as get_immutable,
  get_EASE_IN3dgilxucimnao as get_EASE_IN,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  HitTestDirection_ANY_getInstance1hlnrhgqmsigf as HitTestDirection_ANY_getInstance,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance3u9930f4wm838 as StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance,
  toStrokePointsList2dojuc3rfktd4 as toStrokePointsList,
  get_cachedPoints16ehjcv6uuio1 as get_cachedPoints,
  getPoints2List1zux0vi6zk0wt as getPoints2List,
  Winding_NON_ZERO_getInstance38kh1ikwl48ly as Winding_NON_ZERO_getInstance,
  LineScaleMode_NONE_getInstance2mlqkio15xcm4 as LineScaleMode_NONE_getInstance,
  LineCap_BUTT_getInstancetv7srcehoz43 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance35lw9h64apo2h as LineJoin_MITER_getInstance,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_39,
  cancel1n0qjc93h2v6w as cancel_0,
  CloseableCancellable3mxnqaxyfppmn as CloseableCancellable,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_11,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  PerformanceCounter_getInstance3b8d94s1bsc37 as PerformanceCounter_getInstance,
  toFrequency3flbtmp5xney7 as toFrequency,
  _Frequency___get_hertz__impl__9m7k6x25q6mu7133pq1 as _Frequency___get_hertz__impl__9m7k6x,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediately11za8mkid9pxu as launchImmediately,
  Companion_instance20wy3vp7551rj as Companion_instance_12,
  get_workerImpl14jb6v5ie8q11 as get_workerImpl,
  get_DEBUG_WORKER2r7zp31jch3ip as get_DEBUG_WORKER,
  get_localCurrentDirVfs2lka1gsv26an5 as get_localCurrentDirVfs,
  Resources1ysf2j4wd5yk7 as Resources,
  launchImmediatelylnv8lnistpdy as launchImmediately_0,
  Once1q3lxlgflq3fq as Once,
  launchUnscopedAndWait1ibbocika451b as launchUnscopedAndWait,
  launchUnscopedpyoa01nqmf1z as launchUnscoped,
  launchUnscoped2lqe6wwpvfo83 as launchUnscoped_0,
  StandardPaths_instanceid246em8v040 as StandardPaths_instance,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  Companion_instance2nobhthyyb9yj as Companion_instance_13,
  Dyn__set_impl_2ozvx82bmztjcahblz8 as Dyn__set_impl_2ozvx8,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import { get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider } from './korlibs-audio-core-root-korlibs-audio-core.mjs';
import {
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  getExtra307y0o9pd6mp3 as getExtra,
  toFastList1btvvxvv57pw as toFastList,
  Resourceable38whwgli3ts8g as Resourceable,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  TGenDeque2zx9g0ftfbw19 as TGenDeque,
  Pool1zbsw0zhvh8ca as Pool,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  getCyclicOrNull12fem85bj0m7u as getCyclicOrNull,
  Ref2y4j4snnxo6gs as Ref,
  IntDeque2ebok66x2sofm as IntDeque,
  toRef3av6zm8yavumw as toRef,
  Ref11k43t82thcp3 as Ref_0,
  floatArrayListOfa8snvg2p0fhc as floatArrayListOf,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  arrayfill2iqmyqqqfwuaf as arrayfill,
  arraycopy3uxsqjlixmnz3 as arraycopy,
  arrayequal25g4om83vd8w1 as arrayequal,
  _Float32Buffer___init__impl__403k2m1hlz2hcoqnaef as _Float32Buffer___init__impl__403k2m,
  _Float32Buffer___get_buffer__impl__x5nu9xp04xjj40882q as _Float32Buffer___get_buffer__impl__x5nu9x,
} from './korlibs-memory-root-korlibs-memory.mjs';
//region block: imports
var imul = Math.imul;
var log2 = Math.log2;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance_14 = this;
    this.b9f_1 = Companion_getInstance_0().ew('Korge');
    this.c9f_1 = 'korlibs.korge.unknown';
  }
}
class Korge$_init_$slambda_ys8r4w {
  d9f(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  od(p1, $completion) {
    return this.d9f(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$start$slambda {
  constructor(this$0, $entry) {
    this.p9d_1 = this$0;
    this.q9d_1 = $entry;
  }
  u1n($this$withContext, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withContext), $completion);
  }
  od(p1, $completion) {
    return this.u1n((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Korge {
  constructor(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    Companion_getInstance_40();
    var tmp;
    if (args === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    injector = injector === VOID ? new Injector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$_init_$lambda_95dffl;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_40().c9f_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().i86_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? DefaultViewport_getInstance().u83_1 : windowSize;
    virtualSize = virtualSize === VOID ? windowSize : virtualSize;
    displayMode = displayMode === VOID ? Companion_getInstance_41().o3m() : displayMode;
    title = title === VOID ? 'Game' : title;
    backgroundColor = backgroundColor === VOID ? Colors_getInstance().b3y_1 : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? new GameWindowCreationConfig(multithreaded, VOID, VOID, VOID, VOID, VOID, fullscreen) : windowCreationConfig;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$_init_$slambda_ys8r4w_0();
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().a3y_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$_init_$lambda_95dffl_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
    unit = unit === VOID ? Unit_instance : unit;
    this.r9d_1 = args;
    this.s9d_1 = imageFormats;
    this.t9d_1 = gameWindow;
    this.u9d_1 = mainSceneClass;
    this.v9d_1 = timeProvider;
    this.w9d_1 = injector;
    this.x9d_1 = configInjector;
    this.y9d_1 = debug;
    this.z9d_1 = trace;
    this.a9e_1 = context;
    this.b9e_1 = fullscreen;
    this.c9e_1 = blocking;
    this.d9e_1 = gameId;
    this.e9e_1 = settingsFolder;
    this.f9e_1 = batchMaxQuads;
    this.g9e_1 = windowSize;
    this.h9e_1 = virtualSize;
    this.i9e_1 = displayMode;
    this.j9e_1 = title;
    this.k9e_1 = backgroundColor;
    this.l9e_1 = quality;
    this.m9e_1 = icon;
    this.n9e_1 = multithreaded;
    this.o9e_1 = forceRenderEveryFrame;
    this.p9e_1 = windowCreationConfig;
    this.q9e_1 = main;
    this.r9e_1 = debugAg;
    this.s9e_1 = debugFontExtraScale;
    this.t9e_1 = debugFontColor;
    this.u9e_1 = stageBuilder;
    this.v9e_1 = targetFps;
    this.w9e_1 = preferSyncIo;
    this.x9e_1 = debugCoroutines;
    this.y9e_1 = unit;
  }
  y9h(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_start__v5y7pu.bind(VOID, this, entry), $completion);
  }
  z9h(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    return new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
  }
  z9e(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit, $super) {
    args = args === VOID ? this.r9d_1 : args;
    imageFormats = imageFormats === VOID ? this.s9d_1 : imageFormats;
    gameWindow = gameWindow === VOID ? this.t9d_1 : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? this.u9d_1 : mainSceneClass;
    timeProvider = timeProvider === VOID ? this.v9d_1 : timeProvider;
    injector = injector === VOID ? this.w9d_1 : injector;
    configInjector = configInjector === VOID ? this.x9d_1 : configInjector;
    debug = debug === VOID ? this.y9d_1 : debug;
    trace = trace === VOID ? this.z9d_1 : trace;
    context = context === VOID ? this.a9e_1 : context;
    fullscreen = fullscreen === VOID ? this.b9e_1 : fullscreen;
    blocking = blocking === VOID ? this.c9e_1 : blocking;
    gameId = gameId === VOID ? this.d9e_1 : gameId;
    settingsFolder = settingsFolder === VOID ? this.e9e_1 : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? this.f9e_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? this.g9e_1 : windowSize;
    virtualSize = virtualSize === VOID ? this.h9e_1 : virtualSize;
    displayMode = displayMode === VOID ? this.i9e_1 : displayMode;
    title = title === VOID ? this.j9e_1 : title;
    backgroundColor = backgroundColor === VOID ? this.k9e_1 : backgroundColor;
    quality = quality === VOID ? this.l9e_1 : quality;
    icon = icon === VOID ? this.m9e_1 : icon;
    multithreaded = multithreaded === VOID ? this.n9e_1 : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? this.o9e_1 : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? this.p9e_1 : windowCreationConfig;
    main = main === VOID ? this.q9e_1 : main;
    debugAg = debugAg === VOID ? this.r9e_1 : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? this.s9e_1 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? this.t9e_1 : debugFontColor;
    stageBuilder = stageBuilder === VOID ? this.u9e_1 : stageBuilder;
    targetFps = targetFps === VOID ? this.v9e_1 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? this.w9e_1 : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? this.x9e_1 : debugCoroutines;
    unit = unit === VOID ? this.y9e_1 : unit;
    var tmp;
    if ($super === VOID) {
      tmp = this.z9h(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
    } else {
      var tmp_0 = $super.z9h;
      var tmp_1 = backgroundColor;
      var tmp_2 = tmp_1 == null ? null : new RGBA(tmp_1);
      tmp = tmp_0.call(this, args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, tmp_2, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, new RGBA(debugFontColor), stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance);
    }
    return tmp;
  }
  toString() {
    var tmp = toString(this.r9d_1);
    var tmp_0 = this.s9d_1.toString();
    var tmp_1 = toString_0(this.t9d_1);
    var tmp_2 = toString_0(this.u9d_1);
    var tmp_3 = toString(this.v9d_1);
    var tmp_4 = this.w9d_1.toString();
    var tmp_5 = toString(this.x9d_1);
    var tmp_6 = toString_0(this.a9e_1);
    var tmp_7 = this.g9e_1.toString();
    var tmp_8 = this.h9e_1.toString();
    var tmp_9 = this.i9e_1.toString();
    var tmp_10 = this.k9e_1;
    return 'Korge(args=' + tmp + ', imageFormats=' + tmp_0 + ', gameWindow=' + tmp_1 + ', mainSceneClass=' + tmp_2 + ', timeProvider=' + tmp_3 + ', injector=' + tmp_4 + ', configInjector=' + tmp_5 + ', debug=' + this.y9d_1 + ', trace=' + this.z9d_1 + ', context=' + tmp_6 + ', fullscreen=' + this.b9e_1 + ', blocking=' + this.c9e_1 + ', gameId=' + this.d9e_1 + ', settingsFolder=' + this.e9e_1 + ', batchMaxQuads=' + this.f9e_1 + ', windowSize=' + tmp_7 + ', virtualSize=' + tmp_8 + ', displayMode=' + tmp_9 + ', title=' + this.j9e_1 + ', backgroundColor=' + toString_0(tmp_10 == null ? null : new RGBA(tmp_10)) + ', quality=' + toString(this.l9e_1) + ', icon=' + this.m9e_1 + ', multithreaded=' + this.n9e_1 + ', forceRenderEveryFrame=' + this.o9e_1 + ', windowCreationConfig=' + this.p9e_1.toString() + ', main=' + toString(this.q9e_1) + ', debugAg=' + this.r9e_1 + ', debugFontExtraScale=' + this.s9e_1 + ', debugFontColor=' + RGBA__toString_impl_4lw6dp(this.t9e_1) + ', stageBuilder=' + toString(this.u9e_1) + ', targetFps=' + this.v9e_1 + ', preferSyncIo=' + this.w9e_1 + ', debugCoroutines=' + this.x9e_1 + ', unit=' + this.y9e_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.r9d_1);
    result = imul(result, 31) + hashCode(this.s9d_1) | 0;
    result = imul(result, 31) + (this.t9d_1 == null ? 0 : hashCode(this.t9d_1)) | 0;
    result = imul(result, 31) + (this.u9d_1 == null ? 0 : this.u9d_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.v9d_1) | 0;
    result = imul(result, 31) + hashCode(this.w9d_1) | 0;
    result = imul(result, 31) + hashCode(this.x9d_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y9d_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z9d_1) | 0;
    result = imul(result, 31) + (this.a9e_1 == null ? 0 : hashCode(this.a9e_1)) | 0;
    result = imul(result, 31) + (this.b9e_1 == null ? 0 : getBooleanHashCode(this.b9e_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c9e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d9e_1) | 0;
    result = imul(result, 31) + (this.e9e_1 == null ? 0 : getStringHashCode(this.e9e_1)) | 0;
    result = imul(result, 31) + this.f9e_1 | 0;
    result = imul(result, 31) + this.g9e_1.hashCode() | 0;
    result = imul(result, 31) + this.h9e_1.hashCode() | 0;
    result = imul(result, 31) + this.i9e_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.j9e_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.k9e_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.k9e_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + this.l9e_1.hashCode() | 0;
    result = imul(result, 31) + (this.m9e_1 == null ? 0 : getStringHashCode(this.m9e_1)) | 0;
    result = imul(result, 31) + (this.n9e_1 == null ? 0 : getBooleanHashCode(this.n9e_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o9e_1) | 0;
    result = imul(result, 31) + this.p9e_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.q9e_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r9e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s9e_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.t9e_1) | 0;
    result = imul(result, 31) + hashCode(this.u9e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v9e_1) | 0;
    result = imul(result, 31) + (this.w9e_1 == null ? 0 : getBooleanHashCode(this.w9e_1)) | 0;
    result = imul(result, 31) + (this.x9e_1 == null ? 0 : getBooleanHashCode(this.x9e_1)) | 0;
    var tmp_2 = imul(result, 31);
    result = tmp_2 + hashCode(Unit_instance) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Korge))
      return false;
    var tmp0_other_with_cast = other instanceof Korge ? other : THROW_CCE();
    if (!equals(this.r9d_1, tmp0_other_with_cast.r9d_1))
      return false;
    if (!equals(this.s9d_1, tmp0_other_with_cast.s9d_1))
      return false;
    if (!equals(this.t9d_1, tmp0_other_with_cast.t9d_1))
      return false;
    if (!equals(this.u9d_1, tmp0_other_with_cast.u9d_1))
      return false;
    if (!equals(this.v9d_1, tmp0_other_with_cast.v9d_1))
      return false;
    if (!equals(this.w9d_1, tmp0_other_with_cast.w9d_1))
      return false;
    if (!equals(this.x9d_1, tmp0_other_with_cast.x9d_1))
      return false;
    if (!(this.y9d_1 === tmp0_other_with_cast.y9d_1))
      return false;
    if (!(this.z9d_1 === tmp0_other_with_cast.z9d_1))
      return false;
    if (!equals(this.a9e_1, tmp0_other_with_cast.a9e_1))
      return false;
    if (!(this.b9e_1 == tmp0_other_with_cast.b9e_1))
      return false;
    if (!(this.c9e_1 === tmp0_other_with_cast.c9e_1))
      return false;
    if (!(this.d9e_1 === tmp0_other_with_cast.d9e_1))
      return false;
    if (!(this.e9e_1 == tmp0_other_with_cast.e9e_1))
      return false;
    if (!(this.f9e_1 === tmp0_other_with_cast.f9e_1))
      return false;
    if (!this.g9e_1.equals(tmp0_other_with_cast.g9e_1))
      return false;
    if (!this.h9e_1.equals(tmp0_other_with_cast.h9e_1))
      return false;
    if (!this.i9e_1.equals(tmp0_other_with_cast.i9e_1))
      return false;
    if (!(this.j9e_1 === tmp0_other_with_cast.j9e_1))
      return false;
    var tmp = this.k9e_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.k9e_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!this.l9e_1.equals(tmp0_other_with_cast.l9e_1))
      return false;
    if (!(this.m9e_1 == tmp0_other_with_cast.m9e_1))
      return false;
    if (!(this.n9e_1 == tmp0_other_with_cast.n9e_1))
      return false;
    if (!(this.o9e_1 === tmp0_other_with_cast.o9e_1))
      return false;
    if (!this.p9e_1.equals(tmp0_other_with_cast.p9e_1))
      return false;
    if (!equals(this.q9e_1, tmp0_other_with_cast.q9e_1))
      return false;
    if (!(this.r9e_1 === tmp0_other_with_cast.r9e_1))
      return false;
    if (!equals(this.s9e_1, tmp0_other_with_cast.s9e_1))
      return false;
    if (!(this.t9e_1 === tmp0_other_with_cast.t9e_1))
      return false;
    if (!equals(this.u9e_1, tmp0_other_with_cast.u9e_1))
      return false;
    if (!equals(this.v9e_1, tmp0_other_with_cast.v9e_1))
      return false;
    if (!(this.w9e_1 == tmp0_other_with_cast.w9e_1))
      return false;
    if (!(this.x9e_1 == tmp0_other_with_cast.x9e_1))
      return false;
    if (!equals(Unit_instance, Unit_instance))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_15 = this;
    this.u9h_1 = new KorgeDisplayMode(Companion_getInstance_26().w2f_1, Companion_getInstance_27().n24(), true);
    this.v9h_1 = new KorgeDisplayMode(Companion_getInstance_26().w2f_1, Companion_getInstance_27().n24(), false);
    this.w9h_1 = new KorgeDisplayMode(Companion_getInstance_26().w2f_1, Companion_getInstance_27().b24_1, false);
    this.x9h_1 = new KorgeDisplayMode(Companion_getInstance_26().y2f_1, Companion_getInstance_27().b24_1, false);
  }
  o3m() {
    return this.u9h_1;
  }
}
class KorgeDisplayMode {
  constructor(scaleMode, scaleAnchor, clipBorders) {
    Companion_getInstance_41();
    this.a9i_1 = scaleMode;
    this.b9i_1 = scaleAnchor;
    this.c9i_1 = clipBorders;
  }
  toString() {
    return 'KorgeDisplayMode(scaleMode=' + this.a9i_1.toString() + ', scaleAnchor=' + this.b9i_1.toString() + ', clipBorders=' + this.c9i_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.a9i_1);
    result = imul(result, 31) + this.b9i_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c9i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeDisplayMode))
      return false;
    var tmp0_other_with_cast = other instanceof KorgeDisplayMode ? other : THROW_CCE();
    if (!equals(this.a9i_1, tmp0_other_with_cast.a9i_1))
      return false;
    if (!this.b9i_1.equals(tmp0_other_with_cast.b9i_1))
      return false;
    if (!(this.c9i_1 === tmp0_other_with_cast.c9i_1))
      return false;
    return true;
  }
}
class KorgeRunner$invoke$slambda$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.r9k_1 = $config;
    this.s9k_1 = $views;
    this.t9k_1 = $entry;
    this.u9k_1 = $gameWindow;
  }
  u1n($this$coroutineScope, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$coroutineScope), $completion);
  }
  od(p1, $completion) {
    return this.u1n((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$invoke$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.x9p_1 = $config;
    this.y9p_1 = $views;
    this.z9p_1 = $entry;
    this.a9q_1 = $gameWindow;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class KorgeRunner$invoke$slambda {
  constructor($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
    this.b9q_1 = $realGameWindow;
    this.c9q_1 = $windowSize;
    this.d9q_1 = $config;
    this.e9q_1 = $iconPath;
    this.f9q_1 = $imageFormats;
    this.g9q_1 = $entry;
  }
  o9q($this$loop, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$loop), $completion);
  }
  od(p1, $completion) {
    return this.o9q(p1 instanceof GameWindow ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$prepareViewsBase$lambda$slambda {
  constructor($views) {
    this.p9q_1 = $views;
  }
  nd($completion) {
    this.p9q_1.z5();
  }
}
class KorgeRunner {
  a9f(config, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, config), $completion);
  }
  k9q(views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, forceRenderEveryFrame, configInjector) {
    var injector = views.k9i_1;
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    injector.x62(getKClass(Views), views);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance = views.j9i_1;
    injector.x62(getKClass(AG), instance);
    injector.x62(getKClass(Resources), views.r9q());
    var tmp = getKClass(ResourcesRoot);
    injector.a63(tmp, KorgeRunner$prepareViewsBase$lambda);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_0 = views.l9i_1;
    injector.x62(getKClass(Input), instance_0);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_1 = views.n9i_1;
    injector.x62(getKClass(Stats), instance_1);
    injector.x62(getKClass(CoroutineContext), views.i9i_1);
    var tmp_0 = getKClass(EmptyScene);
    injector.b63(tmp_0, KorgeRunner$prepareViewsBase$lambda_0);
    injector.x62(getKClass(TimeProvider), views.m9i_1);
    configInjector(injector);
    var input = views.l9i_1;
    var ag = views.j9i_1;
    var downPos = {_v: Companion_getInstance_29().e25_1};
    var upPos = {_v: Companion_getInstance_29().e25_1};
    var downTime = {_v: new DateTime(Companion_getInstance_5().h1u_1)};
    var moveTime = {_v: new DateTime(Companion_getInstance_5().h1u_1)};
    var upTime = Companion_getInstance_5().h1u_1;
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    views.s9q(forceRenderEveryFrame);
    var mouseTouchEvent = new TouchEvent();
    var tmp_1 = Companion_getInstance_7().t67_1.slice();
    eventDispatcher.e66(tmp_1, KorgeRunner$prepareViewsBase$lambda_1(views, input, downPos, downTime, mouseTouchEvent, upPos, moveTime, moveMouseOutsideInNextFrame));
    var tmp_2 = Companion_getInstance_8().f67_1.slice();
    eventDispatcher.e66(tmp_2, KorgeRunner$prepareViewsBase$lambda_2(views));
    var tmp_3 = Companion_getInstance_9().u68_1.slice();
    eventDispatcher.e66(tmp_3, KorgeRunner$prepareViewsBase$lambda_3(views));
    var tmp_4 = Companion_getInstance_10().b69_1.slice();
    eventDispatcher.e66(tmp_4, KorgeRunner$prepareViewsBase$lambda_4(views));
    var tmp_5 = Companion_instance_2;
    eventDispatcher.s65(tmp_5, KorgeRunner$prepareViewsBase$lambda_5(views));
    var tmp_6 = Companion_instance_3;
    eventDispatcher.s65(tmp_6, KorgeRunner$prepareViewsBase$lambda_6(views));
    var tmp_7 = Companion_instance_4;
    eventDispatcher.s65(tmp_7, KorgeRunner$prepareViewsBase$lambda_7(views));
    var tmp_8 = Companion_instance_5;
    eventDispatcher.s65(tmp_8, KorgeRunner$prepareViewsBase$lambda_8(views));
    var touchMouseEvent = new MouseEvent();
    var tmp_9 = Companion_getInstance_11().w69_1.slice();
    eventDispatcher.e66(tmp_9, KorgeRunner$prepareViewsBase$lambda_9(input, views, touchMouseEvent, moveMouseOutsideInNextFrame, downPos, downTime, upPos, moveTime));
    var tmp_10 = Companion_getInstance_12().b6c_1.slice();
    eventDispatcher.e66(tmp_10, KorgeRunner$prepareViewsBase$lambda_10(views));
    var tmp_11 = Companion_instance_6;
    eventDispatcher.s65(tmp_11, KorgeRunner$prepareViewsBase$lambda_11(views, input));
    var tmp_12 = Companion_instance_7;
    eventDispatcher.s65(tmp_12, KorgeRunner$prepareViewsBase$lambda_12(views, ag));
    eventDispatcher.d66(new ReshapeEvent(0, 0, views.t9q(), views.u9q()));
    var tmp_13 = Companion_instance_8;
    eventDispatcher.s65(tmp_13, KorgeRunner$prepareViewsBase$lambda_13(views));
    var renderShown = {_v: false};
    views.i9j_1 = clearEachFrame;
    views.j9j_1 = bgcolor;
    var firstRenderDeferred = CompletableDeferred();
    views.o9i_1.b8i(KorgeRunner$prepareViewsBase$lambda_14(views, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  }
}
class Korge$slambda {
  d9f(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  od(p1, $completion) {
    return this.d9f(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$slambda_0 {
  d9f(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  od(p1, $completion) {
    return this.d9f(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_16 = this;
    var tmp = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp.e9r_1 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
    this.f9r_1 = 128.0;
    this.g9r_1 = get_EASE(Companion_getInstance_37());
    this.h9r_1 = true;
  }
}
class RootAnimationNode {
  constructor($outer) {
    this.c9s_1 = $outer;
    this.a9s_1 = null;
    this.b9s_1 = fastArrayListOf([]);
  }
  a2q() {
    this.a9s_1 = null;
  }
  d9s(dt) {
    var dt_0 = !(this.c9s_1.u9r_1 === 1.0) ? FastDuration__times_impl_h6amcp(dt, this.c9s_1.u9r_1) : dt;
    ensureInit(this.c9s_1);
    if (this.c9s_1.m9r_1) {
      var completedTime = get_fastSeconds(0);
      this.b9s_1.f3();
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var tmp0_iterator = this.c9s_1.t9r_1.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.animate.RootAnimationNode.update.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var index_0 = checkIndexOverflow(tmp1);
        var result = item.d9s(dt_0);
        if (FastDuration__compareTo_impl_4fhnj7(result, get_fastSeconds(0)) >= 0) {
          this.b9s_1.h(item);
        }
        var tmp;
        if (index_0 === 0) {
          tmp = result;
        } else {
          // Inline function 'kotlin.math.min' call
          var a = _FastDuration___get_fastMilliseconds__impl__pe68va(completedTime);
          var b = _FastDuration___get_fastMilliseconds__impl__pe68va(result);
          var tmp$ret$0 = Math.min(a, b);
          tmp = get_fastMilliseconds(tmp$ret$0);
        }
        completedTime = tmp;
      }
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.b9s_1.g1()) {
        this.c9s_1.t9r_1.x2l(this.b9s_1);
      }
      this.b9s_1.f3();
      this.c9s_1.x9r_1 = true;
      return completedTime;
    }
    $l$loop: while (true) {
      if (this.a9s_1 == null) {
        var tmp_0 = this;
        var tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.c9s_1.t9r_1.g1()) {
          tmp_1 = this.c9s_1.t9r_1.kk();
        } else {
          tmp_1 = null;
        }
        tmp_0.a9s_1 = tmp_1;
        var tmp0_safe_receiver = this.a9s_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.a2q();
        }
        if (this.c9s_1.n9r_1) {
          var tmp1_safe_receiver = this.a9s_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            this.c9s_1.t9r_1.m2l(tmp1_safe_receiver);
          }
        }
      }
      if (!(this.a9s_1 == null)) {
        var node = ensureNotNull(this.a9s_1);
        var extraTime = node.d9s(dt_0);
        if (FastDuration__compareTo_impl_4fhnj7_0(extraTime, Companion_getInstance().ij_1) >= 0) {
          this.a9s_1 = null;
          dt_0 = extraTime;
        }
        if (FastDuration__compareTo_impl_4fhnj7_0(extraTime, Companion_getInstance().ij_1) > 0) {
          continue $l$loop;
        }
      }
      var tmp_2;
      var tmp_3;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.c9s_1.t9r_1.g1()) {
        tmp_3 = true;
      } else {
        tmp_3 = !(this.a9s_1 == null);
      }
      if (tmp_3) {
        tmp_2 = get_fastSeconds(-1);
      } else {
        tmp_2 = Companion_instance_1.q1u();
      }
      return tmp_2;
    }
  }
  toString() {
    return 'RootAnimationNode(' + toString(this.c9s_1) + ')';
  }
}
class TweenNode {
  constructor(vs, lazyVs, time, lazyTime, easing, name) {
    lazyVs = lazyVs === VOID ? null : lazyVs;
    time = time === VOID ? get_fastMilliseconds_0(1000) : time;
    lazyTime = lazyTime === VOID ? null : lazyTime;
    name = name === VOID ? null : name;
    this.v9q_1 = vs;
    this.w9q_1 = lazyVs;
    this.x9q_1 = time;
    this.y9q_1 = lazyTime;
    this.z9q_1 = easing;
    this.a9r_1 = name;
    var tmp = this;
    tmp.b9r_1 = lazy(Animator$TweenNode$computedVs$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.c9r_1 = lazy(Animator$TweenNode$totalTime$delegate$lambda(this));
    this.d9r_1 = Companion_instance_1.q1u();
  }
  e9s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b9r_1;
    computedVs$factory();
    return this_0.p1();
  }
  toString() {
    return 'TweenNode(totalTime=' + FastDuration__toString_impl_c9xohb(_get_totalTime__xgts5c(this)) + ', name=' + this.a9r_1 + ', ' + toString(toList_0(this.e9s())) + ')';
  }
  a2q() {
    this.d9r_1 = Companion_instance_1.q1u();
  }
  d9s(dt) {
    if (equals(this.d9r_1, Companion_instance_1.q1u())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.e9s();
      var n = 0;
      while (n < this_0.e1()) {
        // Inline function 'korlibs.korge.animate.TweenNode.update.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.d1(_unary__edvuaz).g35();
      }
    }
    this.d9r_1 = FastDuration__plus_impl_q1enab(this.d9r_1, dt);
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.e9s();
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      // Inline function 'korlibs.korge.animate.TweenNode.update.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var it = this_1.d1(_unary__edvuaz_0);
      var ratio = equals(_get_totalTime__xgts5c(this), Companion_instance_1.q1u()) ? 1.0 : convertRange(_FastDuration___get_fastSeconds__impl__amo4s3(this.d9r_1), _FastDuration___get_fastSeconds__impl__amo4s3(it.o8d_1), _FastDuration___get_fastSeconds__impl__amo4s3(it.u8d(_get_totalTime__xgts5c(this))), 0.0, 1.0);
      if (ratio >= 0.0) {
        it.v8d(toRatio(this.z9q_1.ww(clamp01(ratio))));
      }
    }
    return FastDuration__minus_impl_evs237(this.d9r_1, _get_totalTime__xgts5c(this));
  }
}
class BlockNode {
  constructor(name, callback) {
    name = name === VOID ? null : name;
    this.f9s_1 = name;
    this.g9s_1 = callback;
    this.h9s_1 = false;
  }
  toString() {
    return 'BlockNode(name=' + this.f9s_1 + ')';
  }
  a2q() {
    this.h9s_1 = false;
  }
  d9s(dt) {
    this.i9s();
    return dt;
  }
  i9s() {
    if (this.h9s_1)
      return Unit_instance;
    this.h9s_1 = true;
    this.g9s_1();
  }
}
class Animator {
  constructor(root, fastDefaultTime, defaultSpeed, defaultEasing, parallel, looped, parent, lazyInit, level, startImmediately) {
    Companion_getInstance_42();
    parallel = parallel === VOID ? false : parallel;
    looped = looped === VOID ? false : looped;
    lazyInit = lazyInit === VOID ? null : lazyInit;
    this.i9r_1 = root;
    this.j9r_1 = fastDefaultTime;
    this.k9r_1 = defaultSpeed;
    this.l9r_1 = defaultEasing;
    this.m9r_1 = parallel;
    this.n9r_1 = looped;
    this.o9r_1 = parent;
    this.p9r_1 = lazyInit;
    this.q9r_1 = level;
    this.r9r_1 = startImmediately;
    this.s9r_1 = new Signal();
    this.t9r_1 = TGenDeque.l2l();
    this.u9r_1 = 1.0;
    this.v9r_1 = null;
    this.w9r_1 = false;
    this.x9r_1 = false;
    this.y9r_1 = new RootAnimationNode(this);
  }
  l9s() {
    return get_slow(this.j9r_1);
  }
  z9r() {
    var tmp0_safe_receiver = this.o9r_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z9r();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  }
  m9s(props) {
    var _iterator__ex2g4s = this.t9r_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var node = _iterator__ex2g4s.c1();
      if (node instanceof TweenNode) {
        var tmp = node.e9s();
        retainAll(tmp, Animator$removeProps$lambda(props));
      }
    }
  }
  n9s(node) {
    this.t9r_1.u2l(node);
    ensure(this);
  }
  z5() {
    this.k9s();
  }
  tr(e) {
    this.k9s();
  }
  k9s() {
    this.y9r_1.a2q();
    this.t9r_1.f3();
    var tmp0_safe_receiver = this.z9r().v9r_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cancel_0(tmp0_safe_receiver);
    }
    this.z9r().v9r_1 = null;
    this.x9r_1 = false;
    invoke(this.s9r_1);
    return this;
  }
  o9s(vs, lazyVs, time, lazyTime, easing, name, replace) {
    if (replace && this.m9r_1) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(vs.length);
      var inductionVariable = 0;
      var last = vs.length;
      while (inductionVariable < last) {
        var item = vs[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.animate.Animator.__tween.<anonymous>' call
        var tmp$ret$0 = item.j8d_1;
        destination.h(tmp$ret$0);
      }
      this.m9s(toSet(destination));
    }
    this.n9s(new TweenNode(vs.slice(), lazyVs, time, lazyTime, easing, name));
  }
  p9s(vs, lazyVs, time, lazyTime, easing, name, replace, $super) {
    lazyVs = lazyVs === VOID ? null : lazyVs;
    time = time === VOID ? this.j9r_1 : time;
    lazyTime = lazyTime === VOID ? null : lazyTime;
    easing = easing === VOID ? this.l9r_1 : easing;
    replace = replace === VOID ? true : replace;
    var tmp;
    if ($super === VOID) {
      this.o9s(vs, lazyVs, time, lazyTime, easing, name, replace);
      tmp = Unit_instance;
    } else {
      tmp = $super.o9s.call(this, vs, lazyVs, new FastDuration(time), lazyTime, easing, name, replace);
    }
    return tmp;
  }
}
class KeysEvents$down$slambda {
  constructor($keys, $callback) {
    this.q9s_1 = $keys;
    this.r9s_1 = $callback;
  }
  g9t(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, it), $completion);
  }
  od(p1, $completion) {
    return this.g9t(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$up$slambda {
  constructor($keys, $callback) {
    this.s9s_1 = $keys;
    this.t9s_1 = $callback;
  }
  g9t(e, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, e), $completion);
  }
  od(p1, $completion) {
    return this.g9t(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$lambda$slambda {
  constructor(this$0, $event) {
    this.a9t_1 = this$0;
    this.b9t_1 = $event;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_0 {
  constructor(this$0, $event) {
    this.c9t_1 = this$0;
    this.d9t_1 = $event;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_1 {
  constructor(this$0, $event) {
    this.e9t_1 = this$0;
    this.f9t_1 = $event;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
  }
}
class KeysEvents {
  constructor(view) {
    this.u9s_1 = view;
    this.w9s_1 = new AsyncSignal();
    this.x9s_1 = new AsyncSignal();
    this.y9s_1 = new AsyncSignal();
    this.z9s_1 = new CancellableGroup();
    var tmp = Type_TYPE_getInstance();
    this.u9s_1.s65(tmp, KeysEvents$lambda(this));
    var tmp_0 = Type_DOWN_getInstance_0();
    this.u9s_1.s65(tmp_0, KeysEvents$lambda_0(this));
    var tmp_1 = Type_UP_getInstance_0();
    this.u9s_1.s65(tmp_1, KeysEvents$lambda_1(this));
  }
  h9t() {
    var tmp = this.v9s_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  i9t(keys, callback) {
    return this.w9s_1.h1w(KeysEvents$down$slambda_0(keys, callback));
  }
  j9t(keys, callback) {
    return this.i9t(toSet_0(keys), callback);
  }
  k9t(keys, callback) {
    return this.x9s_1.h1w(KeysEvents$up$slambda_0(keys, callback));
  }
  l9t(keys, callback) {
    return this.k9t(toSet_0(keys), callback);
  }
  z5() {
    this.z9s_1.z5();
  }
}
class MouseDragInfo {
  constructor(view, dx, dy, start, end, startTime, time, sx, sy, cx, cy) {
    dx = dx === VOID ? 0.0 : dx;
    dy = dy === VOID ? 0.0 : dy;
    start = start === VOID ? false : start;
    end = end === VOID ? false : end;
    startTime = startTime === VOID ? Companion_getInstance_5().h1u_1 : startTime;
    time = time === VOID ? Companion_getInstance_5().h1u_1 : time;
    sx = sx === VOID ? 0.0 : sx;
    sy = sy === VOID ? 0.0 : sy;
    cx = cx === VOID ? 0.0 : cx;
    cy = cy === VOID ? 0.0 : cy;
    this.m9t_1 = view;
    this.n9t_1 = dx;
    this.o9t_1 = dy;
    this.p9t_1 = start;
    this.q9t_1 = end;
    this.r9t_1 = startTime;
    this.s9t_1 = time;
    this.t9t_1 = sx;
    this.u9t_1 = sy;
    this.v9t_1 = cx;
    this.w9t_1 = cy;
    this.y9t_1 = NaN;
    this.z9t_1 = NaN;
    this.a9u_1 = 0.0;
    this.b9u_1 = 0.0;
  }
  toString() {
    return 'MouseDragInfo(start=' + this.p9t_1 + ', end=' + this.q9t_1 + ', sx=' + this.t9t_1 + ', sy=' + this.u9t_1 + ', cx=' + this.v9t_1 + ', cy=' + this.w9t_1 + ')';
  }
  c9u(view) {
    var tmp0_safe_receiver = view.l23();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d9u(Vector2D.s24(0.0, 0.0), Vector2D.s24(this.n9t_1, this.o9t_1));
    return tmp1_elvis_lhs == null ? Vector2D.s24(this.n9t_1, this.o9t_1) : tmp1_elvis_lhs;
  }
  e9u(view) {
    return this.c9u(view).q24_1;
  }
  f9u(view) {
    return this.c9u(view).r24_1;
  }
  a2q() {
    this.y9t_1 = NaN;
    this.z9t_1 = NaN;
    this.a9u_1 = 0.0;
    this.b9u_1 = 0.0;
    this.n9t_1 = 0.0;
    this.o9t_1 = 0.0;
    this.t9t_1 = 0.0;
    this.u9t_1 = 0.0;
    this.v9t_1 = 0.0;
    this.w9t_1 = 0.0;
  }
  g9u(dx, dy, start, end, time, sx, sy, cx, cy) {
    this.n9t_1 = dx;
    this.o9t_1 = dy;
    this.t9t_1 = sx;
    this.u9t_1 = sy;
    this.v9t_1 = cx;
    this.w9t_1 = cy;
    if (!isNaN_0(this.y9t_1) && !isNaN_0(this.z9t_1)) {
      this.a9u_1 = this.y9t_1 - dx;
      this.b9u_1 = this.z9t_1 - dy;
    }
    this.y9t_1 = dx;
    this.z9t_1 = dy;
    this.p9t_1 = start;
    this.q9t_1 = end;
    if (start)
      this.r9t_1 = time;
    this.s9t_1 = time;
    return this;
  }
}
class OnMouseDragCloseable {
  constructor(onDownCloseable, onUpAnywhereCloseable, onMoveAnywhereCloseable) {
    this.h9u_1 = onDownCloseable;
    this.i9u_1 = onUpAnywhereCloseable;
    this.j9u_1 = onMoveAnywhereCloseable;
  }
  z5() {
    this.h9u_1.z5();
    this.i9u_1.z5();
    this.j9u_1.z5();
  }
  toString() {
    return 'OnMouseDragCloseable(onDownCloseable=' + toString(this.h9u_1) + ', onUpAnywhereCloseable=' + toString(this.i9u_1) + ', onMoveAnywhereCloseable=' + toString(this.j9u_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.h9u_1);
    result = imul(result, 31) + hashCode(this.i9u_1) | 0;
    result = imul(result, 31) + hashCode(this.j9u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OnMouseDragCloseable))
      return false;
    var tmp0_other_with_cast = other instanceof OnMouseDragCloseable ? other : THROW_CCE();
    if (!equals(this.h9u_1, tmp0_other_with_cast.h9u_1))
      return false;
    if (!equals(this.i9u_1, tmp0_other_with_cast.i9u_1))
      return false;
    if (!equals(this.j9u_1, tmp0_other_with_cast.j9u_1))
      return false;
    return true;
  }
}
class MouseDragState extends Enum {
  u6a() {
    return this.equals(MouseDragState_START_getInstance());
  }
  v6a() {
    return this.equals(MouseDragState_END_getInstance());
  }
}
class DraggableInfo extends MouseDragInfo {
  constructor(view) {
    super(view);
    this.c9v_1 = Vector2D.w27();
    this.d9v_1 = Vector2D.w27();
    this.e9v_1 = Vector2D.w27();
    this.f9v_1 = Companion_getInstance_29().e25_1;
  }
  g9v() {
    return this.c9v_1.q24_1;
  }
  h9v() {
    return this.c9v_1.r24_1;
  }
  i9v() {
    return this.d9v_1.q24_1;
  }
  j9v() {
    return this.d9v_1.r24_1;
  }
  k9v() {
    return this.e9v_1.q24_1;
  }
  l9v() {
    return this.e9v_1.r24_1;
  }
}
class DraggableCloseable {
  constructor(onMouseDragCloseable) {
    this.m9v_1 = onMouseDragCloseable;
  }
  z5() {
    this.m9v_1.z5();
  }
  toString() {
    return 'DraggableCloseable(onMouseDragCloseable=' + toString(this.m9v_1) + ')';
  }
  hashCode() {
    return hashCode(this.m9v_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DraggableCloseable))
      return false;
    var tmp0_other_with_cast = other instanceof DraggableCloseable ? other : THROW_CCE();
    if (!equals(this.m9v_1, tmp0_other_with_cast.m9v_1))
      return false;
    return true;
  }
}
class onMouseDragInternal$slambda {
  constructor($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
    this.q9v_1 = $dragging;
    this.r9v_1 = $info;
    this.s9v_1 = $mousePos;
    this.t9v_1 = $sx;
    this.u9v_1 = $sy;
    this.v9v_1 = $cx;
    this.w9v_1 = $cy;
    this.x9v_1 = $callback;
    this.y9v_1 = $timeProvider;
    this.z9v_1 = $view;
  }
  a9w(it, $completion) {
    onMouseDragInternal$handle(this.q9v_1, this.r9v_1, this.s9v_1, this.t9v_1, this.u9v_1, this.v9v_1, this.w9v_1, this.x9v_1, this.y9v_1, this.z9v_1, it, MouseDragState_START_getInstance());
  }
  od(p1, $completion) {
    return this.a9w(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class onMouseDragInternal$lambda$slambda {
  constructor($handler, $it) {
    this.b9w_1 = $handler;
    this.c9w_1 = $it;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
  }
}
class onMouseDragInternal$slambda_0 {
  constructor($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
    this.t9x_1 = $dragging;
    this.u9x_1 = $info;
    this.v9x_1 = $mousePos;
    this.w9x_1 = $sx;
    this.x9x_1 = $sy;
    this.y9x_1 = $cx;
    this.z9x_1 = $cy;
    this.a9y_1 = $callback;
    this.b9y_1 = $timeProvider;
    this.c9y_1 = $view;
  }
  a9w(it, $completion) {
    onMouseDragInternal$handle(this.t9x_1, this.u9x_1, this.v9x_1, this.w9x_1, this.x9x_1, this.y9x_1, this.z9x_1, this.a9y_1, this.b9y_1, this.c9y_1, it, MouseDragState_END_getInstance());
  }
  od(p1, $completion) {
    return this.a9w(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class onMouseDragInternal$lambda$slambda_0 {
  constructor($handler, $it) {
    this.d9y_1 = $handler;
    this.e9y_1 = $it;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this), $completion);
  }
}
class onMouseDragInternal$slambda_1 {
  constructor($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
    this.f9y_1 = $dragging;
    this.g9y_1 = $info;
    this.h9y_1 = $mousePos;
    this.i9y_1 = $sx;
    this.j9y_1 = $sy;
    this.k9y_1 = $cx;
    this.l9y_1 = $cy;
    this.m9y_1 = $callback;
    this.n9y_1 = $timeProvider;
    this.o9y_1 = $view;
  }
  a9w(it, $completion) {
    onMouseDragInternal$handle(this.f9y_1, this.g9y_1, this.h9y_1, this.i9y_1, this.j9y_1, this.k9y_1, this.l9y_1, this.m9y_1, this.n9y_1, this.o9y_1, it, MouseDragState_DRAG_getInstance());
  }
  od(p1, $completion) {
    return this.a9w(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class onMouseDragInternal$lambda$slambda_1 {
  constructor($handler, $it) {
    this.p9y_1 = $handler;
    this.q9y_1 = $it;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
  }
}
class Companion_2 {
  x9y(views) {
    // Inline function 'korlibs.io.util.Once.invoke' call
    var this_0 = get_mouseDebugHandlerOnce(views);
    if (!this_0.h34_1) {
      this_0.h34_1 = true;
      // Inline function 'korlibs.korge.input.Companion.installDebugExtensionOnce.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = views.a9k_1;
      var element = MouseEvents$Companion$installDebugExtensionOnce$lambda(views);
      this_1.h(element);
    }
  }
}
class MouseEventsUpdate {
  constructor($outer, view) {
    this.a9z_1 = $outer;
    this.y9y_1 = new Mixin();
    this.z9y_1 = view;
    addUpdaterWithViews(this.z9y_1, MouseEvents$MouseEventsUpdate$lambda(this.a9z_1));
  }
  ox(value) {
    this.y9y_1.ox(value);
  }
  px() {
    return this.y9y_1.px();
  }
}
class MouseEvents {
  constructor(view) {
    this.d9w_1 = new Mixin();
    this.e9w_1 = view;
    this.e9w_1.d9z(true);
    this.g9w_1 = new Signal();
    this.h9w_1 = new Signal();
    this.i9w_1 = new Signal();
    this.j9w_1 = new Signal();
    this.k9w_1 = new Signal();
    this.l9w_1 = new Signal();
    this.m9w_1 = new Signal();
    this.n9w_1 = new Signal();
    this.o9w_1 = new Signal();
    this.p9w_1 = new Signal();
    this.q9w_1 = new Signal();
    this.r9w_1 = new Signal();
    this.s9w_1 = new Signal();
    this.t9w_1 = new Signal();
    this.u9w_1 = new Signal();
    this.v9w_1 = new Signal();
    this.w9w_1 = new Signal();
    this.x9w_1 = new Signal();
    this.y9w_1 = new Signal();
    this.z9w_1 = null;
    this.a9x_1 = false;
    this.b9x_1 = false;
    this.c9x_1 = false;
    this.d9x_1 = PerformanceCounter_getInstance().s63();
    this.e9x_1 = PerformanceCounter_getInstance().s63();
    this.f9x_1 = Vector2D.w27();
    this.g9x_1 = Vector2D.w27();
    this.h9x_1 = Vector2D.w27();
    this.i9x_1 = Vector2D.w27();
    this.j9x_1 = Vector2D.w27();
    this.k9x_1 = 0;
    this.l9x_1 = false;
    this.m9x_1 = null;
    this.n9x_1 = new MouseEvent();
    this.o9x_1 = false;
    this.p9x_1 = new MouseEvent();
    var tmp = this;
    var tmp_0 = Companion_getInstance_7().t67_1.slice();
    tmp.q9x_1 = this.e9w_1.e66(tmp_0, MouseEvents$closeable$lambda(this));
    this.r9x_1 = new MouseEventsUpdate(this, this.e9w_1);
  }
  o9v() {
    var tmp = this.f9w_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  s9x() {
    return this.o9v().i9i_1;
  }
  c9z() {
    var tmp0_safe_receiver = this.z9w_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, this.e9w_1);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  e9z() {
    return !(this.o9v().l9i_1.u82_1 === 0);
  }
  toString() {
    return this.n9x_1.toString();
  }
  w9y(views, dt) {
    if (!this.e9w_1.b9z())
      return Unit_instance;
    this.f9w_1 = views;
    Companion_instance_17.x9y(views);
    this.z9w_1 = mouseHitTest(Companion_instance_17, views);
    var over = this.c9z();
    var inside = views.l9i_1.w82_1;
    if (over) {
      set_mouseHitResultUsed(views.l9i_1, this.e9w_1);
    }
    var overChanged = !(this.a9x_1 === over);
    var insideChanged = !(this.b9x_1 === inside);
    var pressingChanged = !(this.e9z() === this.c9x_1);
    this.j9x_1 = views.l9i_1.k83();
    if (!overChanged && over && !this.j9x_1.equals(this.i9x_1)) {
      this.s9w_1.w1v(this);
    }
    if (!overChanged && !over && !this.j9x_1.equals(this.i9x_1)) {
      this.u9w_1.w1v(this);
    }
    if (!this.j9x_1.equals(this.i9x_1)) {
      this.t9w_1.w1v(this);
    }
    if (overChanged && over) {
      this.i9w_1.w1v(this);
    }
    if (overChanged && !over) {
      this.j9w_1.w1v(this);
    }
    if (pressingChanged && this.e9z()) {
      this.h9x_1 = this.j9x_1;
      if (over) {
        this.k9w_1.w1v(this);
      }
      if (!over) {
        this.l9w_1.w1v(this);
      }
    }
    if (overChanged && this.e9z()) {
      this.m9w_1.w1v(this);
    }
    if (pressingChanged && !this.e9z()) {
      var tmp = this.p9x_1;
      temporalLastEvent(this, tmp, MouseEvents$update$lambda(over, this));
    }
    over && this.k9x_1 > 0;
    if (insideChanged && !inside) {
      this.u9w_1.w1v(this);
      this.j9w_1.w1v(this);
      this.p9w_1.w1v(this);
      this.q9w_1.w1v(this);
      this.v9w_1.w1v(this);
    }
    this.a9x_1 = over;
    this.b9x_1 = inside;
    this.c9x_1 = this.e9z();
    this.i9x_1 = this.j9x_1;
    this.k9x_1 = 0;
  }
  z5() {
    this.q9x_1.z5();
  }
  ox(value) {
    this.d9w_1.ox(value);
  }
  px() {
    return this.d9w_1.px();
  }
}
class Info {
  constructor(index, id, local, startLocal, startTime, global, startGlobal, time) {
    index = index === VOID ? -1 : index;
    id = id === VOID ? 0 : id;
    local = local === VOID ? Vector2D.w27() : local;
    startLocal = startLocal === VOID ? Vector2D.w27() : startLocal;
    startTime = startTime === VOID ? Companion_getInstance_5().h1u_1 : startTime;
    global = global === VOID ? Vector2D.w27() : global;
    startGlobal = startGlobal === VOID ? Vector2D.w27() : startGlobal;
    time = time === VOID ? Companion_getInstance_5().h1u_1 : time;
    this.f9z_1 = new Mixin();
    this.g9z_1 = index;
    this.h9z_1 = id;
    this.i9z_1 = local;
    this.j9z_1 = startLocal;
    this.k9z_1 = startTime;
    this.l9z_1 = global;
    this.m9z_1 = startGlobal;
    this.n9z_1 = time;
  }
  p9z() {
    return DateTime__minus_impl_10njw8(this.n9z_1, this.k9z_1);
  }
  o9v() {
    var tmp = this.o9z_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  q9z() {
    return this.i9z_1.q24_1;
  }
  r9z() {
    return this.i9z_1.r24_1;
  }
  toString() {
    return 'Touch[' + this.h9z_1 + '](' + numberToInt(this.q9z()) + ', ' + numberToInt(this.r9z()) + ')';
  }
  hashCode() {
    var result = this.g9z_1;
    result = imul(result, 31) + this.h9z_1 | 0;
    result = imul(result, 31) + this.i9z_1.hashCode() | 0;
    result = imul(result, 31) + this.j9z_1.hashCode() | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.k9z_1) | 0;
    result = imul(result, 31) + this.l9z_1.hashCode() | 0;
    result = imul(result, 31) + this.m9z_1.hashCode() | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.n9z_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Info))
      return false;
    var tmp0_other_with_cast = other instanceof Info ? other : THROW_CCE();
    if (!(this.g9z_1 === tmp0_other_with_cast.g9z_1))
      return false;
    if (!(this.h9z_1 === tmp0_other_with_cast.h9z_1))
      return false;
    if (!this.i9z_1.equals(tmp0_other_with_cast.i9z_1))
      return false;
    if (!this.j9z_1.equals(tmp0_other_with_cast.j9z_1))
      return false;
    if (!equals(this.k9z_1, tmp0_other_with_cast.k9z_1))
      return false;
    if (!this.l9z_1.equals(tmp0_other_with_cast.l9z_1))
      return false;
    if (!this.m9z_1.equals(tmp0_other_with_cast.m9z_1))
      return false;
    if (!equals(this.n9z_1, tmp0_other_with_cast.n9z_1))
      return false;
    return true;
  }
  ox(value) {
    this.f9z_1.ox(value);
  }
  px() {
    return this.f9z_1.px();
  }
}
class TouchEvents {
  constructor(view) {
    this.s9z_1 = view;
    this.t9z_1 = new Signal();
    this.u9z_1 = new Signal();
    this.v9z_1 = new Signal();
    this.w9z_1 = new Signal();
    this.x9z_1 = new Signal();
    this.y9z_1 = new Signal();
    this.z9z_1 = new Signal();
    var tmp = this;
    tmp.aa0_1 = Pool.h2p(VOID, TouchEvents$infoPool$lambda);
    this.ba0_1 = FastIntMap();
    this.ca0_1 = FastArrayList.gy();
    var tmp_0 = Companion_getInstance_11().w69_1.slice();
    this.s9z_1.e66(tmp_0, TouchEvents$lambda(this));
  }
  da0(_this__u8e3s4, touch) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.TouchEvents.copyFrom.<anonymous>' call
    _this__u8e3s4.h9z_1 = touch.n69_1;
    _this__u8e3s4.l9z_1 = touch.o69_1;
    _this__u8e3s4.i9z_1 = this.s9z_1.fa0(touch.o69_1);
    return _this__u8e3s4;
  }
  ea0(_this__u8e3s4) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.TouchEvents.start.<anonymous>' call
    _this__u8e3s4.j9z_1 = _this__u8e3s4.i9z_1;
    _this__u8e3s4.m9z_1 = _this__u8e3s4.l9z_1;
    return _this__u8e3s4;
  }
  ga0(views, globalXY) {
    var ev = new TouchEvent(Type_START_getInstance());
    ev.m6a(Type_START_getInstance());
    ev.r6a(0, globalXY, Status_ADD_getInstance());
    ev.n6a();
    onTouchEvent(this, views, ev);
    ev.m6a(Type_END_getInstance());
    ev.r6a(0, globalXY, Status_REMOVE_getInstance());
    ev.n6a();
    onTouchEvent(this, views, ev);
    get_mouse(this.s9z_1).h9w_1.w1v(get_mouse(this.s9z_1));
  }
}
class SingleTouchHandler {
  constructor() {
    this.ha0_1 = new Signal();
    this.ia0_1 = new Signal();
    this.ja0_1 = new Signal();
    this.ka0_1 = new Signal();
    this.la0_1 = new Signal();
    this.ma0_1 = new Signal();
    this.na0_1 = new Signal();
    this.oa0_1 = new Signal();
  }
}
class singleTouch$SingleTouchInfo {
  constructor(handler, startedInside) {
    handler = handler === VOID ? new SingleTouchHandler() : handler;
    startedInside = startedInside === VOID ? false : startedInside;
    this.pa0_1 = handler;
    this.qa0_1 = startedInside;
  }
  toString() {
    return 'SingleTouchInfo(handler=' + toString(this.pa0_1) + ', startedInside=' + this.qa0_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.pa0_1);
    result = imul(result, 31) + getBooleanHashCode(this.qa0_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof singleTouch$SingleTouchInfo))
      return false;
    var tmp0_other_with_cast = other instanceof singleTouch$SingleTouchInfo ? other : THROW_CCE();
    if (!equals(this.pa0_1, tmp0_other_with_cast.pa0_1))
      return false;
    if (!(this.qa0_1 === tmp0_other_with_cast.qa0_1))
      return false;
    return true;
  }
}
class MaterialBlockUB extends UniformBlock {
  constructor() {
    MaterialBlockUB_instance = null;
    super(3);
    MaterialBlockUB_instance = this;
    this.wa0_1 = this.r6t().f6t(this, u_ShadowColor$factory());
    this.xa0_1 = this.n6t().f6t(this, u_ShadowRadius$factory());
    this.ya0_1 = this.p6t().f6t(this, u_ShadowOffset$factory());
    this.za0_1 = this.p6t().f6t(this, u_HighlightPos$factory());
    this.aa1_1 = this.n6t().f6t(this, u_HighlightRadius$factory());
    this.ba1_1 = this.r6t().f6t(this, u_HighlightColor$factory());
    this.ca1_1 = this.p6t().f6t(this, u_Size$factory());
    this.da1_1 = this.r6t().f6t(this, u_Radius$factory());
    this.ea1_1 = this.n6t().f6t(this, u_BorderSizeHalf$factory());
    this.fa1_1 = this.r6t().f6t(this, u_BorderColor$factory());
    this.ga1_1 = this.r6t().f6t(this, u_BackgroundColor$factory());
  }
  pa1() {
    return this.wa0_1.ho(this, u_ShadowColor$factory_0());
  }
  ra1() {
    return this.xa0_1.ho(this, u_ShadowRadius$factory_0());
  }
  qa1() {
    return this.ya0_1.ho(this, u_ShadowOffset$factory_0());
  }
  ka1() {
    return this.za0_1.ho(this, u_HighlightPos$factory_0());
  }
  la1() {
    return this.aa1_1.ho(this, u_HighlightRadius$factory_0());
  }
  ma1() {
    return this.ba1_1.ho(this, u_HighlightColor$factory_0());
  }
  ia1() {
    return this.ca1_1.ho(this, u_Size$factory_0());
  }
  ha1() {
    return this.da1_1.ho(this, u_Radius$factory_0());
  }
  na1() {
    return this.ea1_1.ho(this, u_BorderSizeHalf$factory_0());
  }
  oa1() {
    return this.fa1_1.ho(this, u_BorderColor$factory_0());
  }
  ja1() {
    return this.ga1_1.ho(this, u_BackgroundColor$factory_0());
  }
}
class MaterialRender {
  constructor() {
    MaterialRender_instance = this;
    this.sa1_1 = MaterialBlockUB_getInstance().pa1();
    this.ta1_1 = MaterialBlockUB_getInstance().ra1();
    this.ua1_1 = MaterialBlockUB_getInstance().qa1();
    this.va1_1 = MaterialBlockUB_getInstance().ka1();
    this.wa1_1 = MaterialBlockUB_getInstance().la1();
    this.xa1_1 = MaterialBlockUB_getInstance().ma1();
    this.ya1_1 = MaterialBlockUB_getInstance().ia1();
    this.za1_1 = MaterialBlockUB_getInstance().ha1();
    this.aa2_1 = MaterialBlockUB_getInstance().na1();
    this.ba2_1 = MaterialBlockUB_getInstance().oa1();
    this.ca2_1 = MaterialBlockUB_getInstance().ja1();
    var tmp = this;
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var tmp1_$this = Companion_getInstance_6().p86_1;
    var tmp2_name = null == null ? Companion_getInstance_6().p86_1.f6m_1 : null;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.o6v();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>' call
    var roundedDist = this_0.v6w(this_0.k6x());
    var borderDist = this_0.v6w(this_0.k6x());
    var highlightDist = this_0.v6w(this_0.k6x());
    var borderAlpha = this_0.v6w(this_0.k6x());
    var highlightAlpha = this_0.v6w(this_0.k6x());
    var size = MaterialRender_getInstance().ya1_1;
    this_0.t6v(roundedDist, this_0.y6w(SDFShaders_getInstance().o8c(), this_0.f6y(this_0.p6v(), this_0.j6y(size, 2.0)), this_0.j6y(size, 2.0), MaterialRender_getInstance().za1_1));
    this_0.t6v(this_0.w6v(), this_0.x6v(MaterialRender_getInstance().ca2_1, this_0.w6w(SDFShaders_getInstance().i8c(), roundedDist)));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_0.q6y(MaterialRender_getInstance().wa1_1, 0.0);
    var body = this_0.k6w();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>' call
    body.t6v(highlightDist, body.x6w(SDFShaders_getInstance().d8c(), roundedDist, body.x6w(SDFShaders_getInstance().n8c(), body.f6y(this_0.p6v(), MaterialRender_getInstance().va1_1), MaterialRender_getInstance().wa1_1)));
    body.t6v(highlightAlpha, body.w6w(SDFShaders_getInstance().i8c(), highlightDist));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_0 = body.q6y(highlightAlpha, 0.0);
    var body_0 = body.k6w();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>.<anonymous>' call
    body_0.t6v(body_0.w6v(), body_0.x6w(SDFShaders_getInstance().q8c(), body_0.w6v(), body_0.x6v(MaterialRender_getInstance().xa1_1, highlightAlpha)));
    var stmIf = new If(cond_0, body_0.m6w());
    // Inline function 'kotlin.collections.plusAssign' call
    body.s6v_1.h(stmIf);
    var stmIf_0 = new If(cond, body.m6w());
    // Inline function 'kotlin.collections.plusAssign' call
    this_0.s6v_1.h(stmIf_0);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_1 = this_0.q6y(MaterialRender_getInstance().aa2_1, 0.0);
    var body_1 = this_0.k6w();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>' call
    body_1.t6v(borderDist, body_1.x6w(SDFShaders_getInstance().h8c(), roundedDist, body_1.i6y(MaterialRender_getInstance().aa2_1, 2.0)));
    body_1.t6v(borderAlpha, body_1.w6w(SDFShaders_getInstance().i8c(), borderDist));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_2 = body_1.q6y(borderAlpha, 0.0);
    var body_2 = body_1.k6w();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>.<anonymous>' call
    body_2.t6v(body_2.w6v(), body_2.x6w(SDFShaders_getInstance().q8c(), body_2.w6v(), body_2.x6v(MaterialRender_getInstance().ba2_1, borderAlpha)));
    var stmIf_1 = new If(cond_2, body_2.m6w());
    // Inline function 'kotlin.collections.plusAssign' call
    body_1.s6v_1.h(stmIf_1);
    var stmIf_2 = new If(cond_1, body_1.m6w());
    // Inline function 'kotlin.collections.plusAssign' call
    this_0.s6v_1.h(stmIf_2);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_3 = this_0.s6y(this_0.n6y(this_0.g6w(this_0.w6v()), 1.0), this_0.q6y(MaterialRender_getInstance().ta1_1, 0.0));
    var body_3 = this_0.k6w();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>' call
    var shadowSoftness = MaterialRender_getInstance().ta1_1;
    var shadowOffset = MaterialRender_getInstance().ua1_1;
    var shadowDistance = body_3.y6w(SDFShaders_getInstance().o8c(), body_3.f6y(body_3.h6y(body_3.c6w(this_0.p6v(), 'xy'), shadowOffset), body_3.j6y(size, 2.0)), body_3.j6y(size, 2.0), MaterialRender_getInstance().za1_1);
    var shadowAlpha = body_3.g6y(1.0, body_3.w6x(body_3.e6y(shadowSoftness), shadowSoftness, shadowDistance));
    body_3.t6v(body_3.w6v(), body_3.x6w(SDFShaders_getInstance().q8c(), body_3.x6v(MaterialRender_getInstance().sa1_1, shadowAlpha), body_3.w6v()));
    var stmIf_3 = new If(cond_3, body_3.m6w());
    // Inline function 'kotlin.collections.plusAssign' call
    this_0.s6v_1.h(stmIf_3);
    this_0.t6v(this_0.w6v(), this_0.x6v(this_0.w6v(), this_0.u6v()));
    var tmp3_fragment = FragmentShader(this_0.b6w());
    tmp.da2_1 = tmp1_$this.w7j(VOID, tmp3_fragment, tmp2_name);
  }
}
class SceneCancellationException extends CancellationException {
  static ka2(scene) {
    var $this = this.fd('Scene.sceneAfterDestroyInternal:' + toString(scene));
    captureStack($this, $this.ja2_1);
    $this.ia2_1 = scene;
    return $this;
  }
}
class Scene {
  constructor() {
    this.la2_1 = new Mixin();
    this.qa2_1 = Container.ia5();
    this.ra2_1 = new CancellableGroup();
    var tmp = this;
    tmp.sa2_1 = lazy(Scene$coroutineContext$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.ta2_1 = lazy(Scene$sceneView$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.ua2_1 = lazy(Scene$resources$delegate$lambda(this));
  }
  wa2() {
    var tmp = this.ma2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  }
  ja5(_set____db54di) {
    this.na2_1 = _set____db54di;
  }
  o9v() {
    var tmp = this.na2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  xa2() {
    var tmp = this.oa2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  }
  ka5() {
    return this.o9v().o9i_1;
  }
  q14() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.sa2_1;
    coroutineContext$factory();
    return this_0.p1();
  }
  la5() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ta2_1;
    sceneView$factory();
    return this_0.p1();
  }
  ya2(size) {
    return SContainer.xa7(size);
  }
  i63(injector) {
    this.ma2_1 = injector;
    // Inline function 'korlibs.inject.Injector.get' call
    var tmp$ret$0 = injector.g63(getKClass(Views));
    this.ja5(tmp$ret$0);
    var tmp = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp.oa2_1 = injector.g63(getKClass(SceneContainer));
    var tmp_0 = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp_0.pa2_1 = injector.g63(getKClass(ResourcesRoot));
  }
  ya7(_this__u8e3s4, $completion) {
  }
  za7(_this__u8e3s4, $completion) {
  }
  aa8($completion) {
  }
  ba8($completion) {
  }
  ca8($completion) {
  }
  da8() {
    cancel_0(this.ra2_1);
    this.wa2().j63();
  }
  va2($completion) {
  }
  ea8($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneAfterDestroyInternal__rup219.bind(VOID, this), $completion);
  }
  fa8(size) {
    size_0(this.la5(), size);
  }
  ox(value) {
    this.la2_1.ox(value);
  }
  px() {
    return this.la2_1.px();
  }
}
class EmptyScene extends Scene {
  za7(_this__u8e3s4, $completion) {
  }
}
class ScaledScene extends Scene {
  constructor(sceneWidth, sceneHeight, sceneScaleMode, sceneAnchor, sceneSmoothing) {
    sceneScaleMode = sceneScaleMode === VOID ? Companion_getInstance_26().w2f_1 : sceneScaleMode;
    sceneAnchor = sceneAnchor === VOID ? Companion_getInstance_27().n24() : sceneAnchor;
    sceneSmoothing = sceneSmoothing === VOID ? true : sceneSmoothing;
    super();
    this.aa9_1 = sceneWidth;
    this.ba9_1 = sceneHeight;
    this.ca9_1 = sceneScaleMode;
    this.da9_1 = sceneAnchor;
    this.ea9_1 = sceneSmoothing;
  }
  fa9() {
    return this.aa9_1;
  }
  ga9() {
    return this.ba9_1;
  }
  fa8(size) {
    onSizeChanged(this, this.la5(), size);
  }
  ya2(size) {
    // Inline function 'kotlin.also' call
    var this_0 = SContainer.xa7(size);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.ScaledScene.createSceneView.<anonymous>' call
    onSizeChanged(this, this_0, size);
    return this_0;
  }
}
class PixelatedScene extends ScaledScene {
  constructor(sceneWidth, sceneHeight, sceneScaleMode, sceneAnchor, sceneSmoothing) {
    sceneScaleMode = sceneScaleMode === VOID ? Companion_getInstance_26().w2f_1 : sceneScaleMode;
    sceneAnchor = sceneAnchor === VOID ? Companion_getInstance_27().n24() : sceneAnchor;
    sceneSmoothing = sceneSmoothing === VOID ? false : sceneSmoothing;
    super(sceneWidth, sceneHeight, sceneScaleMode, sceneAnchor, sceneSmoothing);
  }
}
class VisitEntry {
  constructor(clazz, injects) {
    this.nac_1 = clazz;
    this.oac_1 = injects;
  }
  toString() {
    return 'VisitEntry(clazz=' + toString(this.nac_1) + ', injects=' + toString(this.oac_1) + ')';
  }
  hashCode() {
    var result = this.nac_1.hashCode();
    result = imul(result, 31) + hashCode(this.oac_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this.nac_1.equals(tmp0_other_with_cast.nac_1))
      return false;
    if (!equals(this.oac_1, tmp0_other_with_cast.oac_1))
      return false;
    return true;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_18 = this;
    this.ra9_1 = Companion_getInstance_0().ew('SceneContainer');
    var tmp = this;
    var tmp_0 = getKClass(EmptyScene);
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp.sa9_1 = new VisitEntry(tmp_0, tmp$ret$0);
  }
}
class SceneContainer$lambda$slambda {
  constructor(this$0, $event) {
    this.ha9_1 = this$0;
    this.ia9_1 = $event;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda {
  constructor($newScene) {
    this.ua9_1 = $newScene;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_0 {
  constructor($newScene) {
    this.va9_1 = $newScene;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_1 {
  constructor($oldScene) {
    this.wa9_1 = $oldScene;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_2 {
  constructor($oldScene) {
    this.xa9_1 = $oldScene;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_3 {
  constructor($oldScene) {
    this.ya9_1 = $oldScene;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_17.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_4 {
  constructor($newScene) {
    this.za9_1 = $newScene;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_18.bind(VOID, this), $completion);
  }
}
class BaseView extends BaseEventListener {
  static tbz() {
    return this.q65();
  }
  j9s() {
  }
}
class View extends BaseView {
  static nc2(isContainer) {
    var $this = this.tbz();
    $this.z9k_1 = isContainer;
    var tmp = $this;
    tmp.a9l_1 = lazy(View$bviewAll$delegate$lambda($this));
    $this.b9l_1 = true;
    $this.c9l_1 = null;
    $this.d9l_1 = null;
    $this.e9l_1 = null;
    $this.f9l_1 = 0;
    $this.g9l_1 = null;
    $this.h9l_1 = 1.0;
    $this.i9l_1 = null;
    $this.j9l_1 = null;
    $this.k9l_1 = null;
    $this.l9l_1 = Companion_getInstance_13().l7y_1;
    $this.m9l_1 = 0.0;
    $this.n9l_1 = 0.0;
    $this.o9l_1 = 1.0;
    $this.p9l_1 = 1.0;
    $this.q9l_1 = Companion_getInstance_35().v24_1;
    $this.r9l_1 = Companion_getInstance_35().v24_1;
    $this.s9l_1 = Companion_getInstance_35().v24_1;
    $this.t9l_1 = 0.0;
    $this.u9l_1 = scale$factory($this);
    $this.v9l_1 = false;
    $this.w9l_1 = true;
    $this.x9l_1 = true;
    $this.y9l_1 = true;
    $this.z9l_1 = true;
    $this.a9m_1 = Companion_getInstance_33().w28_1;
    $this.b9m_1 = Companion_getInstance_33().w28_1;
    $this.c9m_1 = -1;
    $this.d9m_1 = Companion_getInstance_33().w28_1;
    $this.e9m_1 = -1;
    $this.f9m_1 = new ColorTransformMul();
    $this.g9m_1 = new ColorTransformMul();
    $this.h9m_1 = -1;
    $this.i9m_1 = Companion_getInstance_13().l7y_1;
    $this.j9m_1 = -1;
    $this.k9m_1 = true;
    $this.l9m_1 = 0;
    $this.m9m_1 = 0;
    $this.n9m_1 = false;
    $this.o9m_1 = false;
    $this.p9m_1 = null;
    $this.q9m_1 = false;
    $this.r9m_1 = null;
    $this.s9m_1 = 0;
    $this.t9m_1 = true;
    $this.u9m_1 = null;
    return $this;
  }
  gaj() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a9l_1;
    bviewAll$factory();
    return this_0.p1();
  }
  static ic8() {
    return this.nc2(false);
  }
  haj() {
    return 0.0;
  }
  iaj() {
    return 0.0;
  }
  mai() {
    return null;
  }
  sbz(_set____db54di) {
    this.d9l_1 = _set____db54di;
  }
  jaj() {
    return this.d9l_1;
  }
  kaj() {
    return this.e9l_1;
  }
  laj(value) {
    this.f9l_1 = value;
  }
  m6c() {
    return this.f9l_1;
  }
  maj(value) {
    if (this.i9l_1 === value)
      return Unit_instance;
    this.i9l_1 = value;
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.mai();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.View.<set-_stage>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).maj(value);
      }
      tmp = Unit_instance;
    }
    this.naj();
  }
  naj() {
  }
  oaj(value) {
    if (this.j9l_1 === value)
      return Unit_instance;
    this.j9l_1 = value;
    var parent = this.kai();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.mai();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.View.<set-_invalidateNotifier>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).oaj(parent);
      }
      tmp = Unit_instance;
    }
  }
  kai() {
    return this.j9l_1;
  }
  paj() {
    var tmp0_safe_receiver = this.g9l_1;
    this.oaj(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kai());
  }
  qaj(value) {
    if (this.g9l_1 === value)
      return Unit_instance;
    this.g9l_1 = value;
    var tmp0_safe_receiver = this.g9l_1;
    this.maj(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i9l_1);
    this.paj();
    this.dal();
    this.r65(value);
  }
  l23() {
    return this.g9l_1;
  }
  raj() {
    return !(this.l23() == null) ? ensureNotNull(this.l23()).raj() * this.h9l_1 : this.h9l_1;
  }
  saj(x, y) {
    this.tak();
    if (!(this.m9l_1 === x) || !(this.n9l_1 === y)) {
      this.m9l_1 = x;
      this.n9l_1 = y;
      this.bal();
    }
  }
  y4z(value) {
    return this.saj(value.q24_1, value.r24_1);
  }
  lw() {
    return Vector2D.s24(this.t69(), this.u69());
  }
  taj(v) {
    this.saj(v, this.u69());
  }
  t69() {
    this.tak();
    return this.m9l_1;
  }
  uaj(v) {
    this.saj(this.t69(), v);
  }
  u69() {
    this.tak();
    return this.n9l_1;
  }
  acf(v) {
    var tmp0_safe_receiver = this.l23();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.baj(this, this.t9l_1, v);
    }
    this.t9l_1 = v;
  }
  vaj() {
    return this.t9l_1;
  }
  waj(v) {
    this.cak(Scale.g2d(v, v));
  }
  xaj() {
    return this.dak().i2b();
  }
  yaj(v) {
    this.tak();
    if (!(this.o9l_1 === v)) {
      this.o9l_1 = v;
      this.bal();
    }
  }
  zaj() {
    this.tak();
    return this.o9l_1;
  }
  aak(v) {
    this.tak();
    if (!(this.p9l_1 === v)) {
      this.p9l_1 = v;
      this.bal();
    }
  }
  bak() {
    this.tak();
    return this.p9l_1;
  }
  cak(value) {
    this.yaj(value.e2d_1);
    this.aak(value.f2d_1);
  }
  dak() {
    return Scale.g2d(this.zaj(), this.bak());
  }
  eak() {
    this.tak();
    return this.q9l_1;
  }
  fak() {
    this.tak();
    return this.r9l_1;
  }
  bcf(v) {
    this.tak();
    if (!equals(this.s9l_1, v)) {
      this.s9l_1 = v;
      this.bal();
    }
  }
  gak() {
    this.tak();
    return this.s9l_1;
  }
  hak() {
    var tmp0_safe_receiver = this.l23();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kal(Vector2D.s24(this.t69(), this.u69()));
    return tmp1_elvis_lhs == null ? Vector2D.s24(this.t69(), this.u69()) : tmp1_elvis_lhs;
  }
  iak(value) {
    this.oaf(value);
  }
  e1() {
    return this.paf();
  }
  oaf(value) {
    var size = this.e1();
    this.cak(Scale.g2d((this.zaj() === 0.0 ? 1.0 : this.zaj()) * (value.h26_1 / size.h26_1), (this.bak() === 0.0 ? 1.0 : this.bak()) * (value.i26_1 / size.i26_1)));
  }
  paf() {
    return this.s9y().e1();
  }
  jak(value) {
    this.oaf(this.paf().g2g(value));
  }
  kak() {
    return this.paf().h26_1;
  }
  lak(value) {
    this.oaf(this.paf().g2g(VOID, value));
  }
  mak() {
    return this.paf().i26_1;
  }
  nak(value) {
    this.jak(this.zaj() === 0.0 ? value : value / this.zaj());
  }
  oak() {
    return this.kak() * this.zaj();
  }
  pak(value) {
    this.lak(this.bak() === 0.0 ? value : value / this.bak());
  }
  qak() {
    return this.mak() * this.bak();
  }
  n2i() {
    return this.kak();
  }
  o2i() {
    return this.mak();
  }
  m4d(v) {
    if (!(v === this.f9m_1.o4d())) {
      this.f9m_1.m4d(v);
      this.oai();
    }
  }
  o4d() {
    return this.f9m_1.o4d();
  }
  rak(v) {
    if (!(this.f9m_1.l4d() === v)) {
      this.f9m_1.k4d(v);
      this.oai();
    }
  }
  sak() {
    return this.f9m_1.l4d();
  }
  tak() {
    if (this.y9l_1)
      return Unit_instance;
    this.y9l_1 = true;
    var t = this.a9m_1.k2a();
    this.m9l_1 = t.w2a_1;
    this.n9l_1 = t.x2a_1;
    this.o9l_1 = t.y2a_1;
    this.p9l_1 = t.z2a_1;
    this.q9l_1 = t.a2b_1;
    this.r9l_1 = t.b2b_1;
    this.s9l_1 = t.c2b_1;
  }
  f23() {
    var tmp0_safe_receiver = this.l23();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f23();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  }
  n9v() {
    return this.i9l_1;
  }
  d9z(_set____db54di) {
    this.v9l_1 = _set____db54di;
  }
  b9z() {
    return this.v9l_1;
  }
  uak() {
    return this.w9l_1;
  }
  i8i(value) {
    if (!(this.x9l_1 === value)) {
      this.x9l_1 = value;
      this.nai();
    }
  }
  vak() {
    return this.x9l_1;
  }
  wak() {
    if (!this.z9l_1) {
      this.z9l_1 = true;
      this.n9m_1 = true;
      this.a9m_1 = Companion_getInstance_33().i29(this.t69(), this.u69(), this.gak(), this.zaj(), this.bak(), this.eak(), this.fak(), 0.0, 0.0);
    }
    return this.a9m_1;
  }
  u9y() {
    if (!(this.c9m_1 === this.l9m_1)) {
      this.c9m_1 = this.l9m_1;
      this.n9m_1 = true;
      this.b9m_1 = !(this.l23() == null) ? this.wak().k29(ensureNotNull(this.l23()).u9y()) : this.wak();
    }
    return this.b9m_1;
  }
  xak() {
    if (!(this.e9m_1 === this.l9m_1)) {
      this.e9m_1 = this.l9m_1;
      this.n9m_1 = true;
      this.d9m_1 = this.u9y().j2a();
    }
    return this.d9m_1;
  }
  yak() {
    updateRenderColorTransformIfRequired(this);
    return this.g9m_1;
  }
  zak() {
    updateRenderBlendModeIfRequired(this);
    return this.i9m_1;
  }
  aal() {
    updateRenderColorTransformIfRequired(this);
    return this.g9m_1.o4d();
  }
  qc2(views) {
    return this.fa0(views.l9i_1.k83());
  }
  bal() {
    this.z9l_1 = false;
    this.nai();
  }
  nai() {
    this.l9m_1 = this.l9m_1 + 1 | 0;
    this.n9m_1 = false;
    this.k9m_1 = true;
    this.j9s();
  }
  cal() {
    if (!(this.p9m_1 == null)) {
      this.p9m_1 = null;
      var tmp0_safe_receiver = this.l23();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.cal();
      }
    }
  }
  dal() {
    this.saf();
  }
  eal() {
    this.saf();
  }
  saf() {
  }
  j9s() {
    var tmp0_safe_receiver = this.j9l_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.lai(this);
    }
    this.cal();
  }
  oai() {
    this.m9m_1 = this.m9m_1 + 1 | 0;
    this.o9m_1 = false;
    this.k9m_1 = true;
    this.j9s();
  }
  fal(phase) {
    if (this.r9m_1 == null)
      this.r9m_1 = fastArrayListOf([]);
    var tmp0_safe_receiver = this.r9m_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.h(phase);
    var tmp1_safe_receiver = this.r9m_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.sortBy' call
      if (tmp1_safe_receiver.e1() > 1) {
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp = View$addRenderPhase$lambda;
        var tmp$ret$0 = new sam$kotlin_Comparator$0_0(tmp);
        sortWith(tmp1_safe_receiver, tmp$ret$0);
      }
    }
  }
  qaf(ctx) {
    if (!this.vak())
      return Unit_instance;
    var tmp0_safe_receiver = this.r9m_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = tmp0_safe_receiver.ey_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].acm(this, ctx);
      }
    }
    try {
      this.gal(ctx);
    }finally {
      var tmp1_safe_receiver = this.r9m_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp1_safe_receiver.ey_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array_0[(tmp1_safe_receiver.e1() - n_0 | 0) - 1 | 0].bcm(this, ctx);
          n_0 = n_0 + 1 | 0;
        }
      }
    }
  }
  gal(ctx) {
    var oldPhase = this.s9m_1;
    try {
      this.s9m_1 = 0;
      this.hal(ctx);
    }finally {
      this.s9m_1 = oldPhase;
    }
  }
  hal(ctx) {
    var stages = this.r9m_1;
    if (!(stages == null) && this.s9m_1 < stages.e1()) {
      var _unary__edvuaz = this.s9m_1;
      this.s9m_1 = _unary__edvuaz + 1 | 0;
      stages.d1(_unary__edvuaz).ccm(this, ctx);
    } else {
      var tmp = this.s9m_1;
      var tmp1_elvis_lhs = stages == null ? null : stages.e1();
      if (equals(tmp, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs)) {
        this.uaf(ctx);
        this.s9m_1 = this.s9m_1 + 1 | 0;
      }
    }
  }
  yai(ctx) {
    if (this.q9m_1 || this === get_debugAnnotateView(ctx)) {
      this.ial(ctx);
    }
  }
  ial(ctx) {
    var local = this.s9y();
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_0 = get_debugLineRenderContext(ctx);
    var this_1 = this_0.f89_1;
    if (!(this_1.h80_1 === this_0)) {
      this_1.h80_1 = this_0;
      this_1.r81();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_2 = get_debugLineRenderContext(ctx);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory_0(this_2);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(null == null))
          this_2.r89_1 = null;
        // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_13().u7y_1;
          var doUpdate = !(this_0.q89_1 === blending);
          var old = this_0.q89_1;
          try {
            if (doUpdate) {
              this_0.f89_1.r81();
              this_0.q89_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
            var color = Colors_getInstance().c3y_1;
            var m = this_0.r89_1;
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var oldColor = this_0.i89_1;
            this_0.i89_1 = color;
            try {
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
              // Inline function 'kotlin.apply' call
              var this_3 = new VectorPath();
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>.<anonymous>' call
              this_3.f3m(this.wal());
              this_0.x89(this_3, m);
            }finally {
              this_0.i89_1 = oldColor;
            }
            break $l$block;
          }finally {
            if (doUpdate) {
              this_0.f89_1.r81();
            }
            this_0.q89_1 = old;
          }
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_0 = Colors_getInstance().c3y_1;
        var m_0 = this_0.r89_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_0 = this_0.i89_1;
        this_0.i89_1 = color_0;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_4 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          this_4.x3c(this.kal(Vector2D.s24(local.t25(), local.v25())));
          this_4.k3d(this.kal(Vector2D.s24(local.u25(), local.v25())));
          this_4.k3d(this.kal(Vector2D.s24(local.u25(), local.w25())));
          this_4.k3d(this.kal(Vector2D.s24(local.t25(), local.w25())));
          this_4.z5();
          this_0.x89(this_4, m_0);
        }finally {
          this_0.i89_1 = oldColor_0;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_1 = Colors_getInstance().q43_1;
        var m_1 = this_0.r89_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_1 = this_0.i89_1;
        this_0.i89_1 = color_1;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_5 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var anchorSize = 6.0 * ensureNotNull(get_views(ctx)).y88();
          this_5.k3m(this.kal(local.l26()), anchorSize);
          this_5.k3m(this.kal(local.e2e()), anchorSize);
          this_5.k3m(this.kal(local.n26()), anchorSize);
          this_5.k3m(this.kal(local.f2e()), anchorSize);
          this_5.k3m(this.kal(interpolate(Companion_getInstance_38().ex_1, local.l26(), local.e2e())), anchorSize);
          this_5.k3m(this.kal(interpolate(Companion_getInstance_38().ex_1, local.e2e(), local.n26())), anchorSize);
          this_5.k3m(this.kal(interpolate(Companion_getInstance_38().ex_1, local.n26(), local.f2e())), anchorSize);
          this_5.k3m(this.kal(interpolate(Companion_getInstance_38().ex_1, local.f2e(), local.l26())), anchorSize);
          this_0.x89(this_5, m_1);
        }finally {
          this_0.i89_1 = oldColor_1;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_2 = Colors_getInstance().e3y_1;
        var m_2 = this_0.r89_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_2 = this_0.i89_1;
        this_0.i89_1 = color_2;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_6 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var center = this.hak();
          this_6.e3m(Vector2D.s24(center.q24_1, center.r24_1 - 5), Vector2D.s24(center.q24_1, center.r24_1 + 5));
          this_6.e3m(Vector2D.s24(center.q24_1 - 5, center.r24_1), Vector2D.s24(center.q24_1 + 5, center.r24_1));
          this_0.x89(this_6, m_2);
        }finally {
          this_0.i89_1 = oldColor_2;
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
  }
  toString() {
    var out = get_portableSimpleName(getKClassFromExpression(this));
    if (!(this.t69() === 0.0) || !(this.u69() === 0.0))
      out = out + (':pos=(' + this.jal(this.t69()) + ',' + this.jal(this.u69()) + ')');
    if (!(this.zaj() === 1.0) || !(this.bak() === 1.0))
      out = out + (':scale=(' + this.jal(this.zaj()) + ',' + this.jal(this.bak()) + ')');
    if (!equals(this.eak(), Companion_getInstance_35().v24_1) || !equals(this.fak(), Companion_getInstance_35().v24_1))
      out = out + (':skew=(' + this.jal(_Angle___get_degrees__impl__qg56vw(this.eak())) + ',' + this.jal(_Angle___get_degrees__impl__qg56vw(this.fak())) + ')');
    if (!equals(_Angle___get_absoluteValue__impl__4qoakv(this.gak()), Companion_getInstance_35().v24_1))
      out = out + (':rotation=(' + this.jal(_Angle___get_degrees__impl__qg56vw(this.gak())) + '\xBA)');
    if (!(this.k9l_1 == null))
      out = out + (':name=(' + this.k9l_1 + ')');
    if (!this.l9l_1.equals(Companion_getInstance_13().l7y_1))
      out = out + (':blendMode=(' + this.l9l_1.toString() + ')');
    if (!this.vak())
      out = out + (':visible=' + this.vak());
    if (!(this.sak() === 1.0))
      out = out + (':alpha=' + niceStr(this.sak(), 2));
    if (!(_RGBA___get_rgb__impl__tijaqt(this.o4d()) === _RGBA___get_rgb__impl__tijaqt(Colors_getInstance().a3y_1)))
      out = out + (':colorMul=' + _RGBA___get_hexString__impl__kocngm(this.o4d()));
    return out;
  }
  jal(_this__u8e3s4) {
    return toStringDecimal(_this__u8e3s4, 2, true);
  }
  fa0(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.xak();
      if (this_0.r25()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.s24(this_0.o29(p.q24_1, p.r24_1), this_0.r29(p.q24_1, p.r24_1));
    }
    return tmp$ret$0;
  }
  d9u(p0, p1) {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this.fa0(p1);
    var that = this.fa0(p0);
    return Vector2D.s24(this_0.q24_1 - that.q24_1, this_0.r24_1 - that.r24_1);
  }
  kal(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.u9y();
      if (this_0.r25()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.s24(this_0.o29(p.q24_1, p.r24_1), this_0.r29(p.q24_1, p.r24_1));
    }
    return tmp$ret$0;
  }
  lal(globalPos, direction) {
    if (!this.t9m_1)
      return null;
    if (!this.vak())
      return null;
    var tmp0_safe_receiver = this.mai();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.View.hitTest.<anonymous>' call
        var tmp0_safe_receiver_0 = tmp0_safe_receiver.d1((tmp0_safe_receiver.e1() - n | 0) - 1 | 0).lal(globalPos, direction);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          return tmp0_safe_receiver_0;
        }
        n = n + 1 | 0;
      }
    }
    var res = this.oal(globalPos);
    if (!(res == null))
      return res;
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      tmp = null;
    }
    return tmp;
  }
  ra0(globalPos, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.lal(globalPos, direction) : $super.lal.call(this, globalPos, direction);
  }
  r9y(p) {
    if (!this.t9m_1)
      return null;
    if (!this.vak())
      return null;
    if (this.uak()) {
      var tmp0_safe_receiver = this.mai();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
        var n = 0;
        while (n < tmp0_safe_receiver.e1()) {
          // Inline function 'korlibs.korge.view.View.mouseHitTest.<anonymous>' call
          var tmp0_safe_receiver_0 = tmp0_safe_receiver.d1((tmp0_safe_receiver.e1() - n | 0) - 1 | 0).r9y(p);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            return tmp0_safe_receiver_0;
          }
          n = n + 1 | 0;
        }
      }
    }
    if (!this.b9z())
      return null;
    var tmp1_safe_receiver = this.oal(p);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var area = this.mal();
      if (!area.r25() && !area.i27(p))
        return null;
      return tmp1_safe_receiver;
    }
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      tmp = null;
    }
    return tmp;
  }
  mal() {
    var out = Companion_getInstance_32().z25_1;
    var count = 0;
    // Inline function 'korlibs.korge.view.forEachAscendant' call
    var view = this;
    if (!true) {
      var tmp0_safe_receiver = view;
      view = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l23();
    }
    while (!(view == null)) {
      // Inline function 'korlibs.korge.view.View.getClippingAreaInternal.<anonymous>' call
      var it = view;
      var tmp;
      var tmp_0;
      if (!(it instanceof Stage)) {
        tmp_0 = it instanceof FixedSizeContainer;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = it.s5y();
      } else {
        tmp = false;
      }
      if (tmp) {
        var _localBounds = it.yal();
        if (count === 0) {
          out = _localBounds;
        } else {
          out = out.m2e(_localBounds);
        }
        count = count + 1 | 0;
      }
      view = view.l23();
    }
    return count === 0 ? Companion_getInstance_32().b26() : out;
  }
  nal(p, direction) {
    if (!this.t9m_1)
      return null;
    var ll = this.fa0(p);
    var bounds = this.s9y();
    if (!bounds.i27(ll)) {
      return null;
    }
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.g2a(this.haj(), this.iaj());
    var l = Vector2D.s24(ll.q24_1 + that.q24_1, ll.r24_1 + that.r24_1);
    if (this.u9m_1 === false)
      return this;
    var hitShape = this.jaj();
    var hitShapes = this.kaj();
    if (this.u9m_1 == null && (!(hitShape == null) || !(hitShapes == null))) {
      if (hitShapes == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < hitShapes.e1()) {
          // Inline function 'korlibs.korge.view.View.hitTestInternal.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          if (hitShapes.d1(_unary__edvuaz).r3m(l))
            return this;
        }
      }
      if (!(hitShape == null) && hitShape.r3m(l))
        return this;
      return null;
    } else {
      return this;
    }
  }
  oal(p, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.nal(p, direction) : $super.nal.call(this, p, direction);
  }
  pal() {
    var tmp0_safe_receiver = this.l23();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.faj(this);
  }
  qal(target, inclusive) {
    var tmp;
    if (target === this.l23()) {
      tmp = this.wak();
    } else if (target === this) {
      tmp = Companion_getInstance_33().w28_1;
    } else {
      var commonAncestor = Companion_instance_26.xcl(this, target);
      var tmp_0;
      if (!(commonAncestor === null)) {
        if (target.l23() == null && inclusive) {
          return this.u9y();
        }
        tmp_0 = this.u9y().k29(target.xak());
      } else {
        tmp_0 = Companion_getInstance_33().w28_1;
      }
      tmp = tmp_0;
    }
    var out = tmp;
    if (inclusive) {
      out = out.k29(target.wak());
    }
    return out;
  }
  ral() {
    var tmp0_elvis_lhs = this.sal();
    return tmp0_elvis_lhs == null ? this.yal() : tmp0_elvis_lhs;
  }
  sal() {
    var stage = this.f23();
    if (!(stage instanceof Stage))
      return null;
    return this.tal(stage);
  }
  tal(bp) {
    return this.yal().u2e(bp.u88());
  }
  ual(ctx) {
    return ctx.f8a() ? this.tal(ctx) : this.yal();
  }
  val(ctx) {
    return this.ual(ctx);
  }
  wal() {
    return this.yal();
  }
  xal(includeFilters) {
    return this.dam(this.f23(), VOID, true, includeFilters);
  }
  yal(includeFilters, $super) {
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.xal(includeFilters) : $super.xal.call(this, includeFilters);
  }
  zal(target, inclusive, includeFilters) {
    return this.cam(target, false, inclusive, includeFilters);
  }
  aam(target, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.zal(target, inclusive, includeFilters) : $super.zal.call(this, target, inclusive, includeFilters);
  }
  bam(concat, doAnchoring, includeFilters) {
    var out = this.eam(doAnchoring, includeFilters);
    if (concat.s25() && !concat.l29()) {
      var tmp = Companion_getInstance_31();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p = out.l26();
        if (concat.r25()) {
          tmp$ret$0 = p;
          break $l$block;
        }
        tmp$ret$0 = Vector2D.s24(concat.o29(p.q24_1, p.r24_1), concat.r29(p.q24_1, p.r24_1));
      }
      var tmp_0 = tmp$ret$0;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_0 = out.e2e();
        if (concat.r25()) {
          tmp$ret$1 = p_0;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.s24(concat.o29(p_0.q24_1, p_0.r24_1), concat.r29(p_0.q24_1, p_0.r24_1));
      }
      var tmp_1 = tmp$ret$1;
      var tmp$ret$2;
      $l$block_1: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = out.n26();
        if (concat.r25()) {
          tmp$ret$2 = p_1;
          break $l$block_1;
        }
        tmp$ret$2 = Vector2D.s24(concat.o29(p_1.q24_1, p_1.r24_1), concat.r29(p_1.q24_1, p_1.r24_1));
      }
      var tmp_2 = tmp$ret$2;
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_2 = out.f2e();
        if (concat.r25()) {
          tmp$ret$3 = p_2;
          break $l$block_2;
        }
        tmp$ret$3 = Vector2D.s24(concat.o29(p_2.q24_1, p_2.r24_1), concat.r29(p_2.q24_1, p_2.r24_1));
      }
      out = _BoundsBuilder___get_bounds__impl__s1l1gx(tmp.d26(tmp_0, tmp_1, tmp_2, tmp$ret$3));
    }
    return out;
  }
  cam(target, doAnchoring, inclusive, includeFilters) {
    return this.bam(this.qal(target == null ? this : target, inclusive), doAnchoring, includeFilters);
  }
  dam(target, doAnchoring, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.cam(target, doAnchoring, inclusive, includeFilters) : $super.cam.call(this, target, doAnchoring, inclusive, includeFilters);
  }
  eam(doAnchoring, includeFilters) {
    var tmp0_elvis_lhs = this.p9m_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.raf();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getLocalBounds.<anonymous>' call
      this.p9m_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var out = tmp;
    if (!doAnchoring) {
      out = out.a2a(Vector2D.g2a(this.haj(), this.iaj()));
    }
    if (includeFilters) {
      var tmp1_safe_receiver = get_filter(this);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        out = expandedBorderRectangle(tmp1_safe_receiver, out);
      }
    }
    return out;
  }
  s9y(doAnchoring, includeFilters, $super) {
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.eam(doAnchoring, includeFilters) : $super.eam.call(this, doAnchoring, includeFilters);
  }
  raf() {
    return Companion_getInstance_32().b26();
  }
  z65(type, event, result) {
    var tmp0_safe_receiver = this.l23();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.g66(type, event, result);
  }
}
class Container extends View {
  static ia5(cull) {
    cull = cull === VOID ? false : cull;
    var $this = this.nc2(true);
    $this.za4_1 = cull;
    $this.aa5_1 = FastArrayList.gy();
    $this.ba5_1 = new ContainerCollection($this, $this.aa5_1);
    $this.ca5_1 = null;
    $this.da5_1 = new MMatrix();
    $this.ea5_1 = false;
    $this.fa5_1 = false;
    $this.ga5_1 = FastArrayList.gy();
    return $this;
  }
  mai() {
    return this.aa5_1;
  }
  nai() {
    super.nai();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ba5_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidate.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      if (child.n9m_1) {
        child.nai();
      }
    }
  }
  oai() {
    super.oai();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ba5_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidateColorTransform.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      if (child.o9m_1) {
        child.oai();
      }
    }
  }
  pai() {
    return this.aa5_1.e1();
  }
  qai(view) {
  }
  rai(view) {
  }
  saf() {
    super.saf();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.mai();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.Container.onAncestorChanged.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).eal();
      }
      tmp = Unit_instance;
    }
  }
  sai(index) {
    return this.aa5_1.d1(index);
  }
  tai(index) {
    return getOrNull(this.aa5_1, index);
  }
  uai(index) {
    return this.faj(this.tai(index));
  }
  vai() {
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ba5_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.removeChildren.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      child.qaj(null);
      child.laj(-1);
    }
    this.aa5_1.f3();
    this.aaj();
  }
  wai(view) {
    return this.eaj(view, this.pai());
  }
  ha5(view) {
    this.eaj(view, this.pai());
  }
  d1(index) {
    return this.sai(index);
  }
  uaf(ctx) {
    if (!this.vak())
      return Unit_instance;
    this.xai(ctx);
  }
  xai(ctx) {
    if (!this.za4_1) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
      if (!this.ea5_1) {
        this.ea5_1 = true;
        this.ga5_1.f3();
        this.ga5_1.f1(this.ba5_1);
        if (this.zai())
          this.fa5_1 = false;
      }
      if (!this.fa5_1) {
        this.fa5_1 = true;
        sortWith(this.ga5_1, ZIndexComparator_instance);
      }
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.ga5_1.ey_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
        array[_unary__edvuaz].qaf(ctx);
      }
      return Unit_instance;
    }
    var tmp = findFirstAscendant(this, Container$renderChildrenInternal$lambda);
    var clippingContainer = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
    var renderedCount = 0;
    var culledCount = 0;
    var tmp1_elvis_lhs = clippingContainer == null ? null : clippingContainer.yal();
    var bounds = tmp1_elvis_lhs == null ? Companion_getInstance_32().b26() : tmp1_elvis_lhs;
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.ea5_1) {
      this.ea5_1 = true;
      this.ga5_1.f3();
      this.ga5_1.f1(this.ba5_1);
      if (this.zai())
        this.fa5_1 = false;
    }
    if (!this.fa5_1) {
      this.fa5_1 = true;
      sortWith(this.ga5_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.ga5_1.ey_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
      var child = array_0[_unary__edvuaz_0];
      if (bounds.r25() || bounds.j2e(child.xal(true))) {
        child.qaf(ctx);
        renderedCount = renderedCount + 1 | 0;
      } else {
        culledCount = culledCount + 1 | 0;
      }
    }
  }
  yai(ctx) {
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.ea5_1) {
      this.ea5_1 = true;
      this.ga5_1.f3();
      this.ga5_1.f1(this.ba5_1);
      if (this.zai())
        this.fa5_1 = false;
    }
    if (!this.fa5_1) {
      this.fa5_1 = true;
      sortWith(this.ga5_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.ga5_1.ey_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderDebug.<anonymous>' call
      array[_unary__edvuaz].yai(ctx);
    }
    super.yai(ctx);
  }
  raf() {
    var bb = Companion_getInstance_31().c26();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ba5_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.getLocalBoundsInternal.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, child.dam(this));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  zai() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.aa5_1.ey_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.shouldSortChildren.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(array[_unary__edvuaz].vaj() === 0.0)) {
        return true;
      }
    }
    return false;
  }
  aaj() {
    this.ea5_1 = false;
    this.caj();
  }
  baj(child, oldZIndex, newZIndex) {
    if (!equals(child.l23(), this))
      return Unit_instance;
    this.fa5_1 = false;
    this.caj();
  }
  caj() {
    var tmp0_safe_receiver = this.n9v();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o9v();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.lai(this);
    }
  }
  daj(child) {
    var parent = this;
    if (parent === child) {
      invalidOp("Can't addChild to itself");
    }
    if (hasAncestor(parent, child)) {
      invalidOp("Can't addChild to an ancestor");
    }
  }
  eaj(view, index) {
    this.daj(view);
    var tmp0_safe_receiver = view.l23();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.aaj();
    }
    view.pal();
    var aindex = clamp_1(index, 0, this.pai());
    view.laj(aindex);
    var children = this.aa5_1;
    children.u6(aindex, view);
    var inductionVariable = aindex + 1 | 0;
    var last = children.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        children.d1(n).laj(n);
      }
       while (inductionVariable < last);
    view.qaj(this);
    view.nai();
    this.qai(view);
    this.aaj();
    this.caj();
    this.cal();
  }
  faj(view) {
    if (!((view == null ? null : view.l23()) === this))
      return false;
    var inductionVariable = view.m6c() + 1 | 0;
    var last = this.pai();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _receiver__tnumb7 = this.aa5_1.d1(i);
        var _unary__edvuaz = _receiver__tnumb7.m6c();
        _receiver__tnumb7.laj(_unary__edvuaz - 1 | 0);
      }
       while (inductionVariable < last);
    this.aa5_1.j3(view.m6c());
    view.qaj(null);
    view.laj(-1);
    this.aaj();
    this.caj();
    this.cal();
    return true;
  }
  w65(type, event, result) {
    if (this.ca5_1 == null)
      this.ca5_1 = FastArrayList.fy(this.ba5_1.e1());
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
    var this_0 = this.aa5_1;
    var temp = ensureNotNull(this.ca5_1);
    toFastList(this_0, temp);
    try {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = temp.ey_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.dispatchChildren.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].f66(type, event, result);
      }
    }finally {
      temp.f3();
    }
  }
}
class CachedContainer extends Container {
  static ubz(cache, renderQuality) {
    cache = cache === VOID ? true : cache;
    renderQuality = renderQuality === VOID ? null : renderQuality;
    var $this = this.ia5();
    $this.dai_1 = cache;
    $this.eai_1 = renderQuality;
    $this.fai_1 = null;
    $this.gai_1 = true;
    $this.hai_1 = -1.0;
    $this.iai_1 = Companion_getInstance_32().z28();
    $this.jai_1 = Scale.q2f(1);
    return $this;
  }
  j9s() {
    super.j9s();
    this.gai_1 = true;
  }
  uaf(ctx) {
    if (!this.vak())
      return Unit_instance;
    if (!this.dai_1) {
      return super.uaf(ctx);
    }
    if (this.fai_1 == null) {
      this.fai_1 = new CacheTexture(this, ctx);
      this.gai_1 = true;
    }
    var cache = ensureNotNull(this.fai_1);
    ctx.j8a(cache);
    var renderScale = ctx.z89().l3_1 === 0 ? 1.0 : ctx.r8a();
    var tmp1_elvis_lhs = this.eai_1;
    var doExpensiveScaling = !get_isLow(tmp1_elvis_lhs == null ? ctx.z89() : tmp1_elvis_lhs);
    if (this.gai_1 || !(this.hai_1 === renderScale)) {
      this.hai_1 = renderScale;
      this.iai_1 = this.s9y(VOID, false);
      this.jai_1 = doExpensiveScaling ? this.ral().e1().s2f(this.iai_1.e1()) : Scale.q2f(1);
      this.gai_1 = false;
      var texWidth = coerceAtLeast(numberToInt(this.iai_1.o25_1 * renderScale * this.jai_1.e2d_1), 1);
      var texHeight = coerceAtLeast(numberToInt(this.iai_1.p25_1 * renderScale * this.jai_1.f2d_1), 1);
      cache.ac0(texWidth, texHeight);
      ctx.r81();
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      var frameBuffer = cache.wbz_1;
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.o8a(frameBuffer);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_0 = ctx.d80_1;
        var this_1 = this_0.m80_1;
        if (!(this_1.h80_1 === this_0)) {
          this_1.h80_1 = this_0;
          this_1.r81();
        }
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var scissor = AGScissor.h6p(0, 0, frameBuffer.i6e_1, frameBuffer.j6e_1);
          var temp = this_0.k81_1;
          this_0.t87();
          this_0.k81_1 = scissor;
          try {
            if (true) {
              ctx.h8a(Colors_getInstance().f3y_1);
            }
            // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>' call
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
            var matrix = this.xak().c2a(-this.iai_1.m25_1, -this.iai_1.n25_1).w29(renderScale * this.jai_1.e2d_1, renderScale * this.jai_1.f2d_1);
            ctx.r81();
            var temp4 = ctx.s7z_1;
            var temp2d = ctx.t7z_1;
            ctx.t7z_1 = matrix;
            ctx.s7z_1 = toMatrix4(matrix);
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var this_2 = ctx.t6l(ProjViewUB_getInstance());
              var _unary__edvuaz = this_2.i6n();
              this_2.x7a(_unary__edvuaz + 1 | 0);
              this_2.y7a(this_2.i6n() + 1 | 0);
              var blockSize = this_2.m6l_1;
              var index0 = imul(this_2.i6n() - 1 | 0, blockSize);
              var index1 = imul(this_2.i6n(), blockSize);
              var texBlockSize = this_2.j6l_1.i6t().e1();
              var texIndex0 = imul(this_2.i6n() - 1 | 0, texBlockSize);
              var texIndex1 = imul(this_2.i6n(), texBlockSize);
              if (this_2.i6n() > 0) {
                arraycopy(this_2.o6l_1, index0, this_2.o6l_1, index1, blockSize);
              } else {
                arrayfill(this_2.o6l_1, 0, 0, blockSize);
              }
              // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
              var $this$push = this_2.j6l_1;
              this_2.p6l_1.l7b($this$push.h6t(), ctx.s7z_1);
              if (true && this_2.i6n() >= 1) {
                var equals = arrayequal(this_2.o6l_1, index0, this_2.o6l_1, index1, blockSize);
                if (equals) {
                  var _unary__edvuaz_0 = this_2.i6n();
                  this_2.x7a(_unary__edvuaz_0 - 1 | 0);
                  break $l$block;
                }
              }
            }
            try {
              // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>.<anonymous>' call
              super.uaf(ctx);
            }finally {
              ctx.r81();
              ctx.s7z_1 = temp4;
              ctx.t7z_1 = temp2d;
              ctx.t6l(ProjViewUB_getInstance()).z7a();
            }
            break $l$block_0;
          }finally {
            this_0.t87();
            this_0.k81_1 = temp;
          }
        }
      }finally {
        ctx.p8a();
      }
    }
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_3 = ctx.d80_1;
    var this_4 = this_3.m80_1;
    if (!(this_4.h80_1 === this_3)) {
      this_4.h80_1 = this_3;
      this_4.r81();
    }
    this_3.t81(cache.ybz_1, VOID, VOID, VOID, VOID, this.u9y().h2a(this.iai_1.m25_1, this.iai_1.n25_1).y29(1.0 / (renderScale * this.jai_1.e2d_1), 1.0 / (renderScale * this.jai_1.f2d_1)), VOID, this.aal(), this.l9l_1);
  }
  kai() {
    return this;
  }
  lai(view) {
    this.gai_1 = true;
    var tmp0_safe_receiver = this.l23();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j9l_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.lai(view);
    }
  }
}
class FixedSizeCachedContainer extends CachedContainer {
  static obt(size, cache, clip) {
    size = size === VOID ? Size2D.j26(100, 100) : size;
    cache = cache === VOID ? true : cache;
    clip = clip === VOID ? true : clip;
    var $this = this.ubz(cache);
    $this.lbt_1 = clip;
    $this.mbt_1 = size;
    $this.nbt_1 = Ref(false);
    return $this;
  }
  oaf(_set____db54di) {
    this.mbt_1 = _set____db54di;
  }
  paf() {
    return this.mbt_1;
  }
  raf() {
    return new Rectangle(0.0, 0.0, this.n2i(), this.o2i());
  }
  uaf(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.lbt_1;
      var renderingInternalRef = this.nbt_1;
      if (renderingInternalRef.p1()) {
        super.uaf(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.u9y();
        var hasRotation = !(m.c29_1 === 0.0) || !(m.d29_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.p1();
          try {
            renderingInternalRef.q2q(true);
            renderFiltered(this, ctx, Companion_getInstance_60());
          }finally {
            renderingInternalRef.q2q(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.d80_1;
        if (!(ctx.h80_1 === batcher)) {
          ctx.h80_1 = batcher;
          ctx.r81();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.f80_1;
        var bounds = this.val(ctx).u2e(ctx.t7z_1).v2e();
        var rect = c2d.v8a_1.d87().p6p();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.j2e(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_15().k6p(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.v8a_1;
            var scissor_0 = c2d.h8b(scissor);
            var temp = this_0.k81_1;
            this_0.t87();
            this_0.k81_1 = scissor_0;
            try {
              super.uaf(ctx);
              break $l$block_1;
            }finally {
              this_0.t87();
              this_0.k81_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
          super.uaf(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
        super.uaf(ctx);
      }
    }
  }
}
class UIView extends FixedSizeCachedContainer {
  static jaf(size, cache) {
    Companion_getInstance_46();
    size = size === VOID ? Companion_getInstance_46().gav_1 : size;
    cache = cache === VOID ? false : cache;
    var $this = this.obt(size, cache, false);
    $this.haf_1 = size;
    $this.iaf_1 = false;
    return $this;
  }
  oaf(value) {
    if (!this.haf_1.equals(value)) {
      this.haf_1 = value;
      this.laf();
    }
  }
  paf() {
    return this.haf_1;
  }
  raf() {
    return new Rectangle(0.0, 0.0, this.n2i(), this.o2i());
  }
  iav() {
    return this.b9z();
  }
  laf() {
    var tmp0_safe_receiver = this.l23();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.rai(this);
    }
  }
  saf() {
    super.saf();
    this.taf();
  }
  taf() {
    this.nai();
  }
  uaf(ctx) {
    registerUISupportOnce(this);
    super.uaf(ctx);
  }
}
class SceneContainer extends UIView {
  static v9p(views, defaultTransition, name, size) {
    Companion_getInstance_44();
    defaultTransition = defaultTransition === VOID ? withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_37())) : defaultTransition;
    name = name === VOID ? 'sceneContainer' : name;
    size = size === VOID ? views.u9j_1.e1() : size;
    var $this = this.jaf(size);
    $this.p9p_1 = views;
    $this.q9p_1 = defaultTransition;
    $this.k9l_1 = name;
    var tmp = $this;
    // Inline function 'kotlin.also' call
    var this_0 = TransitionView.kaf();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.transitionView.<anonymous>' call
    $this.ha5(this_0);
    tmp.r9p_1 = this_0;
    $this.s9p_1 = null;
    var tmp_0 = Companion_instance_8;
    $this.s65(tmp_0, SceneContainer$lambda($this));
    $this.t9p_1 = arrayListOf([Companion_getInstance_44().sa9_1]);
    $this.u9p_1 = 0;
    return $this;
  }
  laf() {
    var tmp0_safe_receiver = this.s9p_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.fa8(Size2D.a2e(this.n2i(), this.o2i()));
    }
  }
  maf(clazz, injects, time, transition, $completion) {
    this.naf(new VisitEntry(clazz, toList(injects)));
    return _changeTo(this, clazz, injects.slice(), time, transition, $completion);
  }
  w9p(clazz, injects, time, transition, $completion, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    transition = transition === VOID ? this.q9p_1 : transition;
    return $super === VOID ? this.maf(clazz, injects, time, transition, $completion) : $super.maf.call(this, clazz, injects, new Duration(time), transition, $completion);
  }
  ta9(newScene, time, transition, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq_0.bind(VOID, this, newScene, time, transition), $completion);
  }
  naf(entry) {
    while (this.t9p_1.e1() <= this.u9p_1) {
      this.t9p_1.h(Companion_getInstance_44().sa9_1);
    }
    this.t9p_1.i3(this.u9p_1, entry);
  }
  q14() {
    return this.p9p_1.i9i_1;
  }
}
class TransitionProcess {}
function start(prev, next) {
  return Unit_instance;
}
function end(prev, next) {
  return Unit_instance;
}
function render(ctx, prev, next, ratio) {
  return Unit_instance;
}
class TransitionView extends Container {
  static kaf() {
    var $this = this.ia5();
    dummyView($this);
    dummyView($this);
    $this.iac_1 = Companion_getInstance_38().cx_1;
    $this.jac_1 = get_AlphaTransition();
    return $this;
  }
  y1h() {
    return this.d1(0);
  }
  v1h() {
    return this.d1(1);
  }
  lac(next, transition) {
    this.jac_1 = transition;
    this.iac_1 = Companion_getInstance_38().cx_1;
    this.kac_1 = transition.iam();
    this.jam(this.v1h(), next);
    _get_transitionProcess__5hlux5(this).fam(this.y1h(), this.v1h());
  }
  toString() {
    return super.toString() + (':ratio=' + Ratio__toString_impl_mfgt3e(this.iac_1) + ':transition=' + toString(this.jac_1));
  }
  mac() {
    this.iac_1 = Companion_getInstance_38().fx_1;
    _get_transitionProcess__5hlux5(this).gam(this.y1h(), this.v1h());
    this.jam(dummyView(this), this.v1h());
  }
  jam(prev, next) {
    this.vai();
    this.wai(prev);
    this.wai(next);
  }
  uaf(ctx) {
    if (Ratio__compareTo_impl_z2ienc(this.iac_1, Companion_getInstance_38().cx_1) <= 0) {
      this.y1h().qaf(ctx);
    } else if (Ratio__compareTo_impl_z2ienc(this.iac_1, Companion_getInstance_38().fx_1) >= 0) {
      this.v1h().qaf(ctx);
    } else {
      _get_transitionProcess__5hlux5(this).ham(ctx, this.y1h(), this.v1h(), this.iac_1);
    }
  }
}
class Transition$1 {
  constructor($render, $name) {
    this.kam_1 = $render;
    this.lam_1 = $name;
  }
  iam() {
    return this;
  }
  ham(ctx, prev, next, ratio) {
    return this.kam_1(ctx, prev, next, new Ratio(ratio));
  }
  toString() {
    return this.lam_1;
  }
}
class withEasing$1$create$1 {
  constructor($process, $easing) {
    this.mam_1 = $process;
    this.nam_1 = $easing;
  }
  fam(prev, next) {
    return this.mam_1.fam(prev, next);
  }
  gam(prev, next) {
    return this.mam_1.gam(prev, next);
  }
  ham(ctx, prev, next, ratio) {
    return this.mam_1.ham(ctx, prev, next, this.nam_1.xw(ratio));
  }
}
class withEasing$1 {
  constructor($this_withEasing, $easing) {
    this.oam_1 = $this_withEasing;
    this.pam_1 = $easing;
  }
  toString() {
    return toString(this.oam_1) + '.withEasing';
  }
  iam() {
    var process = this.oam_1.iam();
    return new withEasing$1$create$1(process, this.pam_1);
  }
}
class MsdfRender {
  constructor() {
    MsdfRender_instance = this;
    this.qam_1 = this.uam(true, VOID, false);
    this.ram_1 = this.uam(true, VOID, true);
    this.sam_1 = this.vam(false, 'r', false);
    this.tam_1 = this.vam(false, 'a', false);
  }
  vam(msdf, sdf, inverted) {
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var name = 'PROGRAM_msdf=' + msdf + ',sdf=' + sdf + ',inverted=' + inverted;
    var tmp1_$this = Companion_getInstance_6().p86_1;
    var tmp2_name = name == null ? Companion_getInstance_6().p86_1.f6m_1 : name;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.o6v();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.text.MsdfRender.createProgram.<anonymous>' call
    var tmp = this_0.k6x();
    var tmp_0 = this_0.k6x();
    var tmp_1 = this_0.k6x();
    var tmp_2 = this_0.k6x();
    var median$delegate = this_0.u6w(tmp, tmp_0, tmp_1, VOID, tmp_2, MsdfRender$createProgram$lambda).w6t(null, getLocalDelegateReference('median', KProperty0, false, function () {
      return THROW_ISE();
    }));
    var tmp_3 = Companion_getInstance_6().m86_1;
    var tmp_4 = get_BB_MAX_TEXTURES() - 1 | 0;
    this_0.a6x(tmp_3, 0, tmp_4, MsdfRender$createProgram$lambda_0(this_0));
    var d = this_0.a6y(this_0.h6w());
    var alpha = this_0.b6y(this_0.h6w());
    this_0.t6v(this_0.w6v(), this_0.f6y(this_0.w6v(), this_0.a6w([this_0.z6v(0.5)])));
    if (msdf) {
      this_0.t6v(d, this_0.y6w(createProgram$_anonymous_$lambda$0_hhid5m(median$delegate), this_0.c6w(this_0.w6v(), 'r'), this_0.c6w(this_0.w6v(), 'g'), this_0.c6w(this_0.w6v(), 'b')));
    } else {
      this_0.t6v(d, this_0.c6w(this_0.w6v(), sdf));
    }
    this_0.t6v(alpha, this_0.w6w(SDFShaders_getInstance().j8c(), d));
    if (inverted) {
      this_0.t6v(alpha, this_0.f6y(this_0.z6v(1.0), alpha));
    }
    this_0.t6v(this_0.w6v(), this_0.x6v(this_0.u6v(), alpha));
    var tmp3_fragment = FragmentShader(this_0.b6w());
    return tmp1_$this.w7j(VOID, tmp3_fragment, tmp2_name);
  }
  uam(msdf, sdf, inverted, $super) {
    sdf = sdf === VOID ? 'a' : sdf;
    inverted = inverted === VOID ? false : inverted;
    return $super === VOID ? this.vam(msdf, sdf, inverted) : $super.vam.call(this, msdf, sdf, inverted);
  }
}
class TweenComponent {
  constructor(view, vs, fastTime, easing, callback, c, fastWaitTime, autoInvalidate) {
    fastTime = fastTime === VOID ? Companion_instance_1.r1u() : fastTime;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    fastWaitTime = fastWaitTime === VOID ? Companion_instance_1.r1u() : fastWaitTime;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    this.wam_1 = view;
    this.xam_1 = vs;
    this.yam_1 = fastTime;
    this.zam_1 = easing;
    this.aan_1 = callback;
    this.ban_1 = c;
    this.can_1 = fastWaitTime;
    this.dan_1 = autoInvalidate;
    this.ean_1 = Companion_instance_1.q1u();
    var tmp = this;
    var tmp_0;
    if (!equals(this.yam_1, Companion_instance_1.r1u())) {
      tmp_0 = this.yam_1;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.xam_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.tween.TweenComponent.hrtime.<anonymous>' call
        var tmp$ret$0 = _FastDuration___get_nanoseconds__impl__pxizcb(item.r8d_1);
        destination.h(tmp$ret$0);
      }
      var tmp0_elvis_lhs = maxOrNull(destination);
      tmp_0 = get_fastNanoseconds(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
    }
    tmp.fan_1 = tmp_0;
    this.gan_1 = false;
    this.han_1 = false;
    this.ian_1 = false;
    var tmp_1 = this;
    var tmp_2 = Companion_instance_9;
    tmp_1.jan_1 = this.wam_1.s65(tmp_2, TweenComponent$updater$lambda(this));
    var tmp0_safe_receiver = this.ban_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.o17(TweenComponent$lambda(this));
    }
    _update(this, Companion_instance_1.q1u());
  }
  qan() {
    return get_slow(this.can_1);
  }
  ran() {
    if (this.ian_1)
      return Unit_instance;
    this.ian_1 = true;
    var tmp0_safe_receiver = this.ban_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp0_safe_receiver.mc(tmp$ret$0);
    }
  }
  pan() {
    if (this.han_1)
      return Unit_instance;
    this.han_1 = true;
    var tmp0_safe_receiver = this.jan_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.z5();
    }
    this.jan_1 = null;
    this.ran();
  }
  kan(elapsed) {
    if (equals(elapsed, Companion_instance_1.q1u())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.xam_1;
      var n = 0;
      while (n < this_0.e1()) {
        // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.d1(_unary__edvuaz).g35();
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.xam_1;
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var v = this_1.d1(_unary__edvuaz_0);
      var durationInTween = equals(v.p8d_1, Companion_instance_1.r1u()) ? FastDuration__minus_impl_evs237(this.fan_1, v.o8d_1) : v.p8d_1;
      var elapsedInTween = get_fastMilliseconds(clamp_0(_FastDuration___get_fastMilliseconds__impl__pe68va(FastDuration__minus_impl_evs237(elapsed, v.o8d_1)), 0.0, _FastDuration___get_fastMilliseconds__impl__pe68va(durationInTween)));
      var ratioInTween = FastDuration__compareTo_impl_4fhnj7_0(durationInTween, Companion_getInstance().ij_1) <= 0 || FastDuration__compareTo_impl_4fhnj7(elapsedInTween, durationInTween) >= 0 ? 1.0 : FastDuration__div_impl_rlslck(elapsedInTween, durationInTween);
      var easedRatioInTween = this.zam_1.ww(ratioInTween);
      v.v8d(toRatio(easedRatioInTween));
    }
  }
  toString() {
    return 'TweenComponent(' + toString(this.wam_1) + ')';
  }
}
class tween$slambda {
  constructor($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
    this.san_1 = $this_tween;
    this.tan_1 = $tc;
    this.uan_1 = $vs;
    this.van_1 = $time;
    this.wan_1 = $easing;
    this.xan_1 = $callback;
    this.yan_1 = $waitTime;
    this.zan_1 = $autoInvalidate;
  }
  u1n($this$withTimeoutNullable, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_19.bind(VOID, this, $this$withTimeoutNullable), $completion);
  }
  od(p1, $completion) {
    return this.u1n((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_19 = this;
    this.eao_1 = get_UI_DEFAULT_SIZE();
  }
}
class UIButton$slambda {
  constructor($$this$mouse, this$0) {
    this.iay_1 = $$this$mouse;
    this.jay_1 = this$0;
  }
  a9w(it, $completion) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    this.iay_1;
    this.jay_1.kay();
  }
  od(p1, $completion) {
    return this.a9w(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class UIButton$lambda$slambda {
  constructor($handler, $it) {
    this.aao_1 = $handler;
    this.bao_1 = $it;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_20.bind(VOID, this), $completion);
  }
}
class UIButton$slambda_0 {
  constructor($$this$mouse, this$0) {
    this.lay_1 = $$this$mouse;
    this.may_1 = this$0;
  }
  a9w(it, $completion) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    this.lay_1;
    this.may_1.nay();
  }
  od(p1, $completion) {
    return this.a9w(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class UIButton$lambda$slambda_0 {
  constructor($handler, $it) {
    this.cao_1 = $handler;
    this.dao_1 = $it;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_21.bind(VOID, this), $completion);
  }
}
class UIButton$slambda_1 {
  constructor(this$0) {
    this.oay_1 = this$0;
  }
  g9t(it, $completion) {
    if (get_focused(this.oay_1)) {
      this.oay_1.jav(0.5, 0.5);
    }
  }
  od(p1, $completion) {
    return this.g9t(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class UIButton$slambda_2 {
  constructor(this$0, $$this$keys) {
    this.pay_1 = this$0;
    this.qay_1 = $$this$keys;
  }
  g9t(it, $completion) {
    if (this.pay_1.oar_1) {
      this.pay_1.hay();
      this.pay_1.ray(this.qay_1.h9t());
    }
  }
  od(p1, $completion) {
    return this.g9t(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class UIFocusable {}
class UIFocusableView extends UIView {
  static tay(size, cache) {
    size = size === VOID ? Size2D.j26(90, 32) : size;
    cache = cache === VOID ? false : cache;
    var $this = this.jaf(size, cache);
    $this.eay_1 = 0;
    $this.fay_1 = true;
    return $this;
  }
  zb4(_this__u8e3s4) {
    return this;
  }
  ab5() {
    return this.eay_1;
  }
  gay() {
    return this.fay_1;
  }
  yb4(value) {
  }
}
class UIButton extends UIFocusableView {
  static say(size, text, icon, richText) {
    Companion_getInstance_45();
    size = size === VOID ? Companion_getInstance_45().eao_1 : size;
    text = text === VOID ? '' : text;
    icon = icon === VOID ? null : icon;
    richText = richText === VOID ? null : richText;
    var $this = this.tay(size);
    $this.bar_1 = false;
    $this.car_1 = Companion_getInstance_38().gx_1;
    $this.dar_1 = 6.0;
    $this.ear_1 = MaterialColors_getInstance().h4g_1;
    $this.far_1 = MaterialColors_getInstance().i4g_1;
    $this.gar_1 = MaterialColors_getInstance().j4g_1;
    $this.har_1 = Colors_getInstance().s4d('#777777ff');
    $this.iar_1 = true;
    var tmp = $this;
    // Inline function 'korlibs.korge.ui.uiMaterialLayer' call
    // Inline function 'kotlin.apply' call
    var this_0 = addTo(UIMaterialLayer.uay(size), $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.ui.UIButton.background.<anonymous>' call
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_30();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    this_0.cav(tmp$ret$0);
    tmp.jar_1 = this_0;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.textBlock' call
    var text_0 = richText == null ? RichTextData.l5r(text, get_DefaultTtfFontAsBitmap()) : richText;
    var align = Companion_getInstance_3().a4w_1;
    var size_0 = Size2D.j26(100, 100);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = TextBlock.gb2(text_0, align, size_0);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.textBlock.<anonymous>' call
    tmp_0.kar_1 = addTo(this_1, $this);
    $this.lar_1 = align$factory($this.kar_1);
    var tmp_1 = $this;
    // Inline function 'korlibs.korge.view.image' call
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var texture = get_Bitmaps_transparent();
    var anchor = Companion_getInstance_27().b24_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Image.rb4(texture, anchor);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.image.<anonymous>' call
    tmp_1.mar_1 = addTo(this_2, $this);
    $this.nar_1 = false;
    $this.oar_1 = false;
    var tmp_2 = $this;
    var tmp0_defaultEasing = Companion_getInstance_37().zw_1;
    tmp_2.par_1 = animator($this, VOID, VOID, tmp0_defaultEasing, true);
    var tmp_3 = $this;
    var tmp0_defaultEasing_0 = Companion_getInstance_37().zw_1;
    tmp_3.qar_1 = animator($this, VOID, VOID, tmp0_defaultEasing_0, true);
    $this.rar_1 = text$factory($this.kar_1);
    $this.sar_1 = icon;
    $this.tar_1 = new Signal();
    singleTouch($this, VOID, VOID, UIButton$lambda($this));
    // Inline function 'korlibs.korge.input.mouse' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var $this$mouse = get_mouse($this);
    // Inline function 'korlibs.korge.input.MouseEvents.onOver' call
    var handler = UIButton$slambda_3($this$mouse, $this);
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_4 = over$factory().get($this$mouse);
    tmp_4.p1v(UIButton$lambda_0($this$mouse, handler));
    // Inline function 'korlibs.korge.input.MouseEvents.onOut' call
    var handler_0 = UIButton$slambda_4($this$mouse, $this);
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_5 = out$factory().get($this$mouse);
    tmp_5.p1v(UIButton$lambda_1($this$mouse, handler_0));
    set_cursor($this, Cursor_HAND_getInstance());
    setInitialState($this);
    $this.uar_1 = false;
    $this.sb4(false, false, VOID, VOID, true);
    $this.var_1 = 0.0;
    // Inline function 'korlibs.korge.input.keys' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.ui.UIButton.<anonymous>' call
    var $this$keys = get_keys($this);
    var tmp_6 = [Key_SPACE_getInstance(), Companion_getInstance_14().s6c_1];
    $this$keys.j9t(tmp_6, UIButton$slambda_5($this));
    var tmp_7 = [Key_SPACE_getInstance(), Companion_getInstance_14().s6c_1];
    $this$keys.l9t(tmp_7, UIButton$slambda_6($this, $this$keys));
    return $this;
  }
  war() {
    return !isNaN_0(this.dar_1) ? this.dar_1 : _Ratio___get_value__impl__57cli6(this.car_1) * _get_halfSide__37ya73(this);
  }
  iav() {
    return super.iav();
  }
  laf() {
    setInitialState(this);
  }
  kay() {
    if (this.nar_1)
      return Unit_instance;
    this.nar_1 = true;
    this.sb4(VOID, true);
  }
  nay() {
    if (!this.nar_1)
      return Unit_instance;
    this.nar_1 = false;
    this.sb4(VOID, false);
  }
  jav(x, y) {
    return this.tb4(Vector2D.s24(x, y));
  }
  tb4(p) {
    if (this.oar_1)
      return Unit_instance;
    this.oar_1 = true;
    this.sb4(true, VOID, VOID, p);
  }
  hay() {
    if (!this.oar_1)
      return Unit_instance;
    this.oar_1 = false;
    this.sb4(false);
  }
  ray(views) {
    get_touch(this).ga0(views, this.kal(Vector2D.s24(this.n2i() * 0.5, this.o2i() * 0.5)));
  }
  ub4(down, over, enable, pos, immediate) {
    if (this.iav() && !(down == null)) {
      if (down) {
        this.jar_1.wb4(pos);
      } else {
        this.jar_1.vb4();
      }
    }
    var bgColor = enable === false || !this.iav() ? this.har_1 : over === true ? this.far_1 : this.uar_1 ? this.gar_1 : this.ear_1;
    if (immediate) {
      this.jar_1.xb4(bgColor);
    } else {
      // Inline function 'korlibs.korge.tween.get' call
      var this_0 = bgColor$factory(this.jar_1);
      var tmp = this_0.get();
      var tmp_0 = [new V2(this_0, tmp, new RGBA(bgColor), _interpolateColor$ref(), false)];
      // Inline function 'korlibs.time.seconds' call
      var tmp$ret$1 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
      tween(this.par_1, tmp_0, tmp$ret$1);
    }
  }
  sb4(down, over, enable, pos, immediate, $super) {
    down = down === VOID ? null : down;
    over = over === VOID ? null : over;
    enable = enable === VOID ? null : enable;
    pos = pos === VOID ? Companion_getInstance_29().e25_1 : pos;
    immediate = immediate === VOID ? false : immediate;
    var tmp;
    if ($super === VOID) {
      this.ub4(down, over, enable, pos, immediate);
      tmp = Unit_instance;
    } else {
      tmp = $super.ub4.call(this, down, over, enable, pos, immediate);
    }
    return tmp;
  }
  taf() {
    super.taf();
    this.sb4(VOID, VOID, VOID, VOID, true);
  }
  yb4(value) {
    this.sb4(VOID, value);
  }
}
class UIBaseContainer extends UIView {
  static xbj(size) {
    var $this = this.jaf(size);
    $this.xbd_1 = false;
    $this.ybd_1 = true;
    return $this;
  }
  qai(view) {
    super.qai(view);
    this.zbd();
  }
  rai(view) {
    super.rai(view);
    this.zbd();
  }
  laf() {
    super.laf();
    this.zbd();
  }
  zbd() {
    if (this.xbd_1)
      return Unit_instance;
    this.xbd_1 = true;
    try {
      this.cbb();
    }finally {
      this.xbd_1 = false;
    }
  }
}
class UIContainer extends UIBaseContainer {
  static wbj(size) {
    return this.xbj(size);
  }
  cbb() {
  }
}
class UIVerticalHorizontalStack extends UIContainer {
  static bbb(size, padding, adjustSize) {
    size = size === VOID ? get_UI_DEFAULT_SIZE() : size;
    padding = padding === VOID ? 0.0 : padding;
    var $this = this.wbj(size);
    $this.zba_1 = adjustSize;
    $this.abb_1 = numberToDouble(padding);
    return $this;
  }
}
class UIVerticalStack extends UIVerticalHorizontalStack {
  static cb8(forcedWidth, padding, adjustSize) {
    forcedWidth = forcedWidth === VOID ? null : forcedWidth;
    padding = padding === VOID ? 0.0 : padding;
    adjustSize = adjustSize === VOID ? true : adjustSize;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_28();
    var width = forcedWidth == null ? 100.0 : forcedWidth;
    var tmp$ret$0 = Size2D.a2e(numberToDouble(width), numberToDouble(0.0));
    var $this = this.bbb(tmp$ret$0, padding, adjustSize);
    var tmp = $this;
    tmp.bb8_1 = forcedWidth == null ? null : numberToDouble(forcedWidth);
    return $this;
  }
  cbb() {
    var y = 0.0;
    var bb = Companion_getInstance_31().c26();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.mai();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.ui.UIVerticalStack.relayoutInternal.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var it = tmp0_safe_receiver.d1(_unary__edvuaz);
        it.uaj(y);
        if (this.zba_1 && !(this.bb8_1 == null)) {
          it.nak(this.n2i());
        }
        var bounds = it.s9y();
        y = y + (bounds.w25() + this.abb_1);
        bb = BoundsBuilder__plus_impl_cz7f7x(bb, it.dam(this));
      }
      tmp = Unit_instance;
    }
    this.oaf(Size2D.a2e(this.bb8_1 == null ? _BoundsBuilder___get_xmax__impl__gsz0km(bb) : ensureNotNull(this.bb8_1), y));
  }
}
class UIHorizontalStack extends UIVerticalHorizontalStack {
  static zbg(forcedHeight, padding, adjustHeight) {
    forcedHeight = forcedHeight === VOID ? null : forcedHeight;
    padding = padding === VOID ? 0.0 : padding;
    adjustHeight = adjustHeight === VOID ? true : adjustHeight;
    var $this = this.bbb(Size2D.a2e(0.0, forcedHeight == null ? 32.0 : forcedHeight), padding, adjustHeight);
    $this.ybg_1 = forcedHeight;
    return $this;
  }
  cbb() {
    var x = 0.0;
    var bb = Companion_getInstance_31().c26();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.mai();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.ui.UIHorizontalStack.relayoutInternal.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var it = tmp0_safe_receiver.d1(_unary__edvuaz);
        it.taj(x);
        if (this.zba_1 && !(this.ybg_1 == null)) {
          it.pak(this.o2i());
        }
        var bounds = it.s9y();
        x = x + (bounds.u25() + this.abb_1);
        bb = BoundsBuilder__plus_impl_cz7f7x(bb, it.dam(this));
      }
      tmp = Unit_instance;
    }
    this.oaf(Size2D.a2e(x, this.ybg_1 == null ? _BoundsBuilder___get_ymax__impl__oia4uz(bb) : ensureNotNull(this.ybg_1)));
  }
}
class Scope {}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.cbk_1 = function_0;
  }
  ri(a, b) {
    return this.cbk_1(a, b);
  }
  compare(a, b) {
    return this.ri(a, b);
  }
  h4() {
    return this.cbk_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.h4(), other.h4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.h4());
  }
}
class UIFocusManager {
  constructor(view) {
    this.ybj_1 = view;
    this.zbj_1 = this.ybj_1;
    this.abk_1 = null;
    var tmp = Type_DOWN_getInstance_0();
    this.ybj_1.s65(tmp, UIFocusManager$lambda(this));
  }
  o9v() {
    return this.zbj_1.o9v();
  }
  bbk(value) {
    if (equals(this.abk_1, value))
      return Unit_instance;
    var tmp0_safe_receiver = this.abk_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.yb4(false);
    }
    this.abk_1 = value;
    var tmp1_safe_receiver = this.abk_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.yb4(true);
    }
    if (!(value == null)) {
      this.o9v().ebk(_get_rfocusView__qys03k(value, this), true);
    }
  }
  dbk(dir) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = descendantsWith(this.zbj_1, VOID, UIFocusManager$changeFocusIndex$lambda);
    var destination = ArrayList.h1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
      var tmp0_safe_receiver = get_focusable(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver);
      }
    }
    var focusables = destination;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = UIFocusManager$changeFocusIndex$lambda_0;
    var tmp$ret$4 = new sam$kotlin_Comparator$0(tmp);
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = sortedWith(focusables, tmp$ret$4);
    var destination_0 = ArrayList.h1();
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
      if (element_0.gay()) {
        destination_0.h(element_0);
      }
    }
    var sortedFocusables = destination_0;
    // Inline function 'kotlin.takeIf' call
    var this_2 = indexOf(sortedFocusables, this.abk_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
    if (this_2 >= 0) {
      tmp_0 = this_2;
    } else {
      tmp_0 = null;
    }
    var index = tmp_0;
    var tmp0_safe_receiver_0 = getCyclicOrNull(sortedFocusables, !(index == null) ? index + dir | 0 : dir < 0 ? -1 : 0);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
      focus(tmp0_safe_receiver_0);
      scrollParentsToMakeVisible(_get_rfocusView__qys03k(tmp0_safe_receiver_0, this));
    }
  }
}
class Highlight {
  constructor(pos, radiusRatio, alpha, below, scale) {
    below = below === VOID ? false : below;
    scale = scale === VOID ? 1.0 : scale;
    this.ibk_1 = pos;
    this.jbk_1 = radiusRatio;
    this.kbk_1 = alpha;
    this.lbk_1 = below;
    this.mbk_1 = scale;
  }
}
class Highlights {
  constructor(view) {
    this.fbk_1 = view;
    this.gbk_1 = fastArrayListOf([]);
    this.hbk_1 = fastArrayListOf([]);
  }
  nbk(pos, below, scale, startRadius) {
    this.vb4();
    var highlight = new Highlight(pos, startRadius, 1.0, below, scale);
    // Inline function 'kotlin.collections.plusAssign' call
    this.gbk_1.h(highlight);
    // Inline function 'kotlin.collections.plusAssign' call
    this.hbk_1.h(highlight);
    var tmp = get_simpleAnimator(this.fbk_1);
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = radiusRatio$factory(highlight);
    var tmp_0 = this_0.get();
    var tmp_1 = new V2(this_0, tmp_0, 1.0, _interpolate$ref(), false);
    var tmp_2 = [tmp_1, V2Callback(VOID, UIMaterialLayer$Highlights$addHighlight$lambda(this))];
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(0.5, DurationUnit_SECONDS_getInstance());
    tween(tmp, tmp_2, tmp$ret$1, get_EASE_IN(Companion_getInstance_37()));
    return highlight;
  }
  obk(highlight) {
    // Inline function 'korlibs.korge.animate.Animator.sequence' call
    var this_0 = get_simpleAnimator(this.fbk_1);
    var defaultTime = this_0.l9s();
    var defaultSpeed = this_0.k9r_1;
    var easing = this_0.l9r_1;
    var startImmediately = this_0.r9r_1;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var tmp0_root = this_0.i9r_1;
    var tmp1_fastDefaultTime = get_fast(defaultTime);
    var tmp2_level = this_0.q9r_1 + 1 | 0;
    var this_1 = new Animator(tmp0_root, tmp1_fastDefaultTime, defaultSpeed, easing, false, false, this_0, VOID, tmp2_level, startImmediately);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.animate.Animator.sequence.<anonymous>' call
    // Inline function 'korlibs.korge.ui.Highlights.removeHighlight.<anonymous>' call
    var tmp;
    if (highlight.lbk_1) {
      // Inline function 'korlibs.korge.tween.get' call
      var this_2 = radiusRatio$factory_0(highlight);
      var tmp_0 = this_2.get();
      tmp = new V2(this_2, tmp_0, 0.0, _interpolate$ref_0(), false);
    } else {
      // Inline function 'korlibs.korge.tween.get' call
      var this_3 = alpha$factory(highlight);
      var tmp_1 = this_3.get();
      tmp = new V2(this_3, tmp_1, 0.0, _interpolate$ref_1(), false);
    }
    var tmp_2 = tmp;
    var tmp_3 = [tmp_2, V2Callback(VOID, UIMaterialLayer$Highlights$removeHighlight$lambda(this))];
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$2 = toDuration(0.3, DurationUnit_SECONDS_getInstance());
    tween(this_1, tmp_3, tmp$ret$2, get_EASE_IN(Companion_getInstance_37()));
    block(this_1, VOID, UIMaterialLayer$Highlights$removeHighlight$lambda_0(this, highlight));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.animate.Animator.sequence.<anonymous>' call
    this_0.n9s(this_1.y9r_1);
    this.hbk_1.h3(highlight);
  }
  pbk(highlights) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = toList_0(highlights);
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.ui.Highlights.removeHighlights.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.d1(_unary__edvuaz);
      this.obk(it);
    }
  }
  vb4() {
    this.pbk(this.hbk_1);
  }
}
class UIMaterialLayer extends UIView {
  static uay(size) {
    size = size === VOID ? Size2D.j26(100, 100) : size;
    var $this = this.jaf(size);
    $this.rau_1 = Colors_getInstance().a3y_1;
    $this.sau_1 = null;
    $this.tau_1 = null;
    $this.uau_1 = Colors_getInstance().b3y_1;
    $this.vau_1 = 0.0;
    $this.wau_1 = RGBA__withAf_impl_dpdu32(Colors_getInstance().b3y_1, 0.3);
    $this.xau_1 = 10.0;
    $this.yau_1 = Companion_getInstance_29().e25_1;
    $this.zau_1 = RGBA__withAd_impl_cralao(Colors_getInstance().a3y_1, 0.4);
    $this.aav_1 = new Highlights($this);
    $this.bav_1 = Companion_getInstance_27().b24_1;
    return $this;
  }
  xb4(value) {
    this.rau_1 = value;
    this.j9s();
  }
  cav(value) {
    this.sau_1 = value;
    this.j9s();
  }
  dav(value) {
    this.xau_1 = value;
    this.j9s();
  }
  qbk(value) {
    if (!this.bav_1.equals(value)) {
      this.bav_1 = value;
      this.cal();
    }
  }
  haj() {
    return this.n2i() * this.bav_1.k24_1;
  }
  iaj() {
    return this.o2i() * this.bav_1.l24_1;
  }
  raf() {
    return new Rectangle(-this.haj(), -this.iaj(), this.n2i(), this.o2i());
  }
  uaf(ctx) {
    if (!this.vak())
      return Unit_instance;
    // Inline function 'korlibs.korge.render.renderCtx2d' call
    // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var batcher = ctx.d80_1;
    if (!(ctx.h80_1 === batcher)) {
      ctx.h80_1 = batcher;
      ctx.r81();
    }
    // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
    // Inline function 'korlibs.korge.render.renderCtx2d.<anonymous>' call
    var context = ctx.f80_1;
    // Inline function 'korlibs.korge.render.RenderContext2D.keep' call
    $l$block_3: {
      // Inline function 'korlibs.korge.render.RenderContext2D.keepMatrix' call
      var old = context.z8a_1;
      try {
        // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>' call
        $l$block_2: {
          // Inline function 'korlibs.korge.render.RenderContext2D.keepBlendMode' call
          var oldBlendFactors = context.a8b_1;
          try {
            // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>' call
            $l$block_1: {
              // Inline function 'korlibs.korge.render.RenderContext2D.keepColor' call
              var multiplyColor = context.b8b_1;
              try {
                // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>' call
                $l$block_0: {
                  // Inline function 'korlibs.korge.render.RenderContext2D.keepFiltering' call
                  var filtering = context.c8b_1;
                  try {
                    // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    $l$block: {
                      // Inline function 'korlibs.korge.render.RenderContext2D.keepSize' call
                      var size = context.x8a_1;
                      try {
                        // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        context.x8a_1 = Size2D.a2e(this.n2i(), this.o2i());
                        context.a8b_1 = this.zak();
                        context.b8b_1 = this.aal();
                        context.d8b(this.u9y());
                        this.rbk(context, true);
                        materialRoundRect(context, -this.haj(), -this.iaj(), this.n2i(), this.o2i(), this.rau_1, _get_computedRadius__cigsus(this), this.yau_1, this.wau_1, this.xau_1, VOID, VOID, VOID, this.vau_1, this.uau_1);
                        this.rbk(context, false);
                        break $l$block;
                      }finally {
                        context.x8a_1 = size;
                      }
                    }
                    break $l$block_0;
                  }finally {
                    context.c8b_1 = filtering;
                  }
                }
                break $l$block_1;
              }finally {
                context.b8b_1 = multiplyColor;
              }
            }
            break $l$block_2;
          }finally {
            context.a8b_1 = oldBlendFactors;
          }
        }
        break $l$block_3;
      }finally {
        context.z8a_1 = old;
      }
    }
  }
  rbk(ctx2d, below) {
    // Inline function 'korlibs.korge.ui.Highlights.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.aav_1.gbk_1.ey_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.ui.UIMaterialLayer.renderHighlights.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      if (below === it.lbk_1) {
        materialRoundRect(ctx2d, -this.haj() * it.mbk_1, -this.iaj() * it.mbk_1, this.n2i() * it.mbk_1, this.o2i() * it.mbk_1, Colors_getInstance().f3y_1, _get_computedRadius__cigsus(this).t2d(it.mbk_1), VOID, VOID, VOID, it.ibk_1, it.jbk_1 * this.xaj(), RGBA__withAd_impl_cralao(this.zau_1, _RGBA___get_ad__impl__pt5rdj(this.zau_1) * it.kbk_1));
      }
    }
  }
  nbk(pos, below, scale, startRadius) {
    return this.aav_1.nbk(pos, below, scale, startRadius);
  }
  wb4(pos, below, scale, startRadius, $super) {
    below = below === VOID ? false : below;
    scale = scale === VOID ? 1.0 : scale;
    startRadius = startRadius === VOID ? 0.0 : startRadius;
    return $super === VOID ? this.nbk(pos, below, scale, startRadius) : $super.nbk.call(this, pos, below, scale, startRadius);
  }
  vb4() {
    this.aav_1.vb4();
  }
}
class UIScrollable extends UIView {
  rbn() {
    return this.o2i() * this.qbn_1;
  }
  sbn() {
    return this.n2i() * this.qbn_1;
  }
  tbn() {
    return this.rbn();
  }
  ubn() {
    return this.rbn();
  }
  vbn() {
    return this.sbn();
  }
  wbn() {
    return this.sbn();
  }
  xbn(rect, anchor) {
    this.pbn_1.ibo(rect.t25(), rect.u25(), anchor.k24_1);
    this.obn_1.ibo(rect.v25(), rect.w25(), anchor.l24_1);
  }
  jbo(view, anchor) {
    this.xbn(view.dam(this), anchor);
    scrollParentsToMakeVisible(this);
  }
  kbo(view, anchor, $super) {
    anchor = anchor === VOID ? Companion_getInstance_27().n24() : anchor;
    var tmp;
    if ($super === VOID) {
      this.jbo(view, anchor);
      tmp = Unit_instance;
    } else {
      tmp = $super.jbo.call(this, view, anchor);
    }
    return tmp;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_20 = this;
    this.eav_1 = 90.0;
    this.fav_1 = 32.0;
    this.gav_1 = Size2D.w2d(90.0, 32.0);
  }
  hav(iconView, bmp, width, height, anchor_0) {
    var iconScaleX = width / bmp.e3f_1;
    var iconScaleY = height / bmp.f3f_1;
    // Inline function 'kotlin.math.min' call
    var iconScale = Math.min(iconScaleX, iconScaleY);
    iconView.vbq(bmp);
    anchor(iconView, anchor_0);
    position(iconView, width * anchor_0.k24_1, height * anchor_0.l24_1);
    scale(iconView, iconScale, iconScale);
  }
}
class InternalViewAutoscaling {
  constructor() {
    this.obw_1 = 1.0;
    this.pbw_1 = 1.0;
    this.qbw_1 = 1.0;
    this.rbw_1 = 1.0;
    this.sbw_1 = 1.0;
    this.tbw_1 = MatrixTransform.g2b();
  }
  ubw(autoScaling, autoScalingPrecise, globalMatrix) {
    if (autoScaling) {
      this.tbw_1 = globalMatrix.k2a();
      // Inline function 'kotlin.math.abs' call
      var x = this.tbw_1.y2a_1;
      var sx = Math.abs(x);
      // Inline function 'kotlin.math.abs' call
      var x_0 = this.tbw_1.z2a_1;
      var sy = Math.abs(x_0);
      // Inline function 'kotlin.math.max' call
      var sxy = Math.max(sx, sy);
      // Inline function 'kotlin.math.abs' call
      var x_1 = sx / this.qbw_1 - 1.0;
      var diffX = Math.abs(x_1);
      // Inline function 'kotlin.math.abs' call
      var x_2 = sy / this.rbw_1 - 1.0;
      var diffY = Math.abs(x_2);
      var tmp;
      switch (autoScalingPrecise) {
        case true:
          tmp = diffX > 0.0 || diffY > 0.0;
          break;
        case false:
          tmp = diffX >= 0.1 || diffY >= 0.1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var shouldUpdate = tmp;
      if (shouldUpdate) {
        this.qbw_1 = sx;
        this.rbw_1 = sy;
        this.sbw_1 = sxy;
        this.obw_1 = 1.0 / sx;
        this.pbw_1 = 1.0 / sy;
        return true;
      }
    } else {
      this.qbw_1 = 1.0;
      this.rbw_1 = 1.0;
      this.sbw_1 = 1.0;
      this.obw_1 = 1.0;
      this.pbw_1 = 1.0;
    }
    return false;
  }
}
class RectBase extends View {
  static ccf(anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().b24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.ic8();
    $this.dbz_1 = smoothing;
    $this.sbz(hitShape);
    var tmp = $this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    tmp.ebz_1 = get_Bitmaps_white();
    $this.fbz_1 = anchor;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_16();
    var tmp$ret$1 = get_TEXTURED_ARRAY_QUAD_INDICES();
    tmp_0.gbz_1 = new TexturedVertexArray(4, tmp$ret$1);
    $this.hbz_1 = null;
    $this.ibz_1 = null;
    return $this;
  }
  pbz(v) {
    if (!(this.ebz_1 === v)) {
      this.ebz_1 = v;
      this.k9m_1 = true;
      this.j9s();
    }
  }
  qbk(v) {
    if (!this.fbz_1.equals(v)) {
      this.fbz_1 = v;
      this.k9m_1 = true;
      this.j9s();
    }
  }
  jbz() {
    return this.fbz_1;
  }
  bbx() {
    return 0.0;
  }
  cbx() {
    return 0.0;
  }
  haj() {
    return this.jbz().k24_1 * this.bbx();
  }
  iaj() {
    return this.jbz().l24_1 * this.cbx();
  }
  kbz() {
    return -this.haj();
  }
  lbz() {
    return -this.iaj();
  }
  uaf(ctx) {
    if (!this.vak())
      return Unit_instance;
    var tmp = this.ebz_1;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    if (tmp === get_Bitmaps_transparent())
      return Unit_instance;
    if (this.k9m_1) {
      this.k9m_1 = false;
      this.rbz();
    }
    this.qbz(ctx);
  }
  qbz(ctx) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.d80_1;
    var this_1 = this_0.m80_1;
    if (!(this_1.h80_1 === this_0)) {
      this_1.h80_1 = this_0;
      this_1.r81();
    }
    var tmp0_safe_receiver = this.ibz_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(ctx);
    var array = this.gbz_1;
    var tex = ctx.i8a(this.ebz_1).e3g();
    var smoothing = this.dbz_1;
    var blendMode = this.zak();
    var program = this.hbz_1;
    var vcount = array.n87_1;
    var icount = array.o87_1;
    var matrix = Companion_getInstance_33().x28_1;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.n84_1;
      this_0.g87(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_6().p86_1 : program;
      if (this_0.v87(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this_0.x86();
      if (!contains(this_0.c81_1, tex_0)) {
        this_0.b81_1 = 0;
        this_0.c81_1[0] = tex_0;
      }
      this_0.d81_1 = smoothing;
      this_0.e81_1 = blendMode;
      this_0.f81_1 = pprogram;
    }
    this_0.s87(array, matrix, vcount, icount);
  }
  rbz() {
    this.gbz_1.u8c(0, this.kbz(), this.lbz(), this.bbx(), this.cbx(), this.u9y(), this.ebz_1, this.aal());
  }
  raf() {
    return Companion_getInstance_32().v2d(this.kbz(), this.lbz(), this.bbx(), this.cbx());
  }
  toString() {
    var out = super.toString();
    if (!this.jbz().equals(Companion_getInstance_27().b24_1))
      out = out + (':anchor=(' + this.jal(this.jbz().k24_1) + ', ' + this.jal(this.jbz().l24_1) + ')');
    return out;
  }
}
class BaseImage extends RectBase {
  static tce(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().b24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.ccf(anchor, hitShape, smoothing);
    $this.tbq_1 = false;
    $this.ubq_1 = bitmap;
    $this.mbz();
    return $this;
  }
  static wbw(bmpCoords, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().b24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.tce(Resourceable(bmpCoords), anchor, hitShape, smoothing);
  }
  vbq(value) {
    if (equals(this.ebz_1, value))
      return Unit_instance;
    this.tbq_1 = true;
    this.pbz(value);
  }
  z5h() {
    return this.ebz_1;
  }
  mbz() {
    if (this.tbq_1)
      return Unit_instance;
    trySetSourceActually(this);
  }
  uaf(ctx) {
    this.mbz();
    super.uaf(ctx);
  }
  bbx() {
    return this.ebz_1.n2i();
  }
  cbx() {
    return this.ebz_1.o2i();
  }
  b3h() {
    return this.ebz_1.b3h();
  }
  c3h() {
    return this.ebz_1.c3h();
  }
  h3g() {
    return this.ebz_1.h3g();
  }
  i3g() {
    return this.ebz_1.i3g();
  }
  nbz() {
    return this.jbz().k24_1 * this.h3g();
  }
  obz() {
    return this.jbz().l24_1 * this.i3g();
  }
  haj() {
    return this.nbz() - this.b3h();
  }
  iaj() {
    return this.obz() - this.c3h();
  }
  raf() {
    return Companion_getInstance_32().v2d(-this.nbz(), -this.obz(), this.h3g(), this.i3g());
  }
  toString() {
    return super.toString() + (':bitmap=' + toString(this.z5h()));
  }
}
class BaseGraphics extends BaseImage {
  static vbw(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    var $this = this.wbw(tmp$ret$0);
    $this.xbv_1 = autoScaling;
    $this.ybv_1 = true;
    $this.zbv_1 = false;
    $this.abw_1 = false;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.bbw_1 = ArrayList.h1();
    $this.cbw_1 = new InternalViewAutoscaling();
    $this.dbw_1 = 1;
    $this.ebw_1 = true;
    $this.fbw_1 = true;
    $this.gbw_1 = null;
    $this.hbw_1 = 1.0;
    $this.ibw_1 = 1.0;
    $this.jbw_1 = true;
    $this.kbw_1 = true;
    $this.lbw_1 = Companion_getInstance_32().z28();
    $this.mbw_1 = Companion_getInstance_32().z28();
    return $this;
  }
  xbw(value) {
    this.ybv_1 = value;
    this.ybw();
  }
  ybw() {
    this.ebw_1 = true;
    this.fbw_1 = true;
    this.cal();
  }
  saf() {
    super.saf();
    if (this.l23() == null || this.n9v() == null) {
      var tmp = this.z5h().e3g();
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      if (!equals(tmp, get_bmp(tmp$ret$0))) {
        this.bbw_1.h(this.z5h().e3g());
      }
      clearBitmaps(this, true);
    }
  }
  uaf(ctx) {
    this.gbw_1 = ctx;
    clearBitmaps(this, false);
    this.zbw();
    super.uaf(ctx);
  }
  zbw() {
    if (this.cbw_1.ubw(this.xbv_1, this.zbv_1, this.u9y())) {
      this.ebw_1 = true;
    }
    if (!this.ebw_1)
      return false;
    this.ebw_1 = false;
    var boundsWithShapes = boundsUnsafe(this, true);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>' call
    this.bbw_1.h(this.z5h().e3g());
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var imageWidth = coerceAtLeast(toIntCeil(boundsWithShapes.o25_1 * this.cbw_1.qbw_1), 1);
    var imageHeight = coerceAtLeast(toIntCeil(boundsWithShapes.p25_1 * this.cbw_1.rbw_1), 1);
    var image = NativeImageOrBitmap32(imageWidth + this.dbw_1 | 0, imageHeight + this.dbw_1 | 0, this.ybv_1, true);
    this.hbw_1 = this.cbw_1.qbw_1;
    this.ibw_1 = this.cbw_1.rbw_1;
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = image.x3w_1;
    if (true) {
      image.g3x();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = image.p44(true);
      try {
        // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>.<anonymous>' call
        ctx.o5g(this.hbw_1, this.ibw_1);
        ctx.s4z(-boundsWithShapes.m25_1, -boundsWithShapes.n25_1);
        this.abx(ctx);
      }finally {
        ctx.a18();
      }
    }finally {
      result = true ? image.i3x(rect) : 0;
    }
    this.vbq(slice(image));
    return true;
  }
  bbx() {
    return _get_bitmapWidth__ndy7bu(this) / this.hbw_1;
  }
  cbx() {
    return _get_bitmapHeight__5t1vx1(this) / this.ibw_1;
  }
  h3g() {
    return this.bbx();
  }
  i3g() {
    return this.cbx();
  }
  haj() {
    return this.jbz().k24_1 * this.bbx();
  }
  iaj() {
    return this.jbz().l24_1 * this.cbx();
  }
  kbz() {
    return _getLocalBoundsInternal(this, this.jbw_1).m25_1;
  }
  lbz() {
    return _getLocalBoundsInternal(this, this.jbw_1).n25_1;
  }
  raf() {
    return _getLocalBoundsInternal$default(this);
  }
}
class CacheTexture {
  constructor($outer, ctx) {
    this.zbz_1 = $outer;
    this.vbz_1 = ctx;
    this.wbz_1 = this.vbz_1.m8a(16, 16, VOID, VOID, VOID, false);
    this.xbz_1 = TextureBase.q84(this.wbz_1.i6j(), 16, 16);
    this.ybz_1 = Texture(this.xbz_1);
  }
  ac0(width, height) {
    this.wbz_1.k6j(0, 0, width, height);
    this.xbz_1.r84(width);
    this.xbz_1.s84(height);
    this.ybz_1 = Texture(this.xbz_1);
  }
  z5() {
    this.zbz_1.fai_1 = null;
    this.vbz_1.n8a(this.wbz_1);
  }
}
class ZIndexComparator {
  bc0(a, b) {
    return compareTo(a.vaj(), b.vaj());
  }
  compare(a, b) {
    var tmp = a instanceof View ? a : THROW_CCE();
    return this.bc0(tmp, b instanceof View ? b : THROW_CCE());
  }
}
class ContainerCollection$iterator$1 {
  constructor(this$0) {
    this.sc2_1 = this$0;
    this.rc2_1 = 0;
  }
  b1() {
    return this.rc2_1 < this.sc2_1.pc2_1.pai();
  }
  c1() {
    var _unary__edvuaz = this.rc2_1;
    this.rc2_1 = _unary__edvuaz + 1 | 0;
    return this.sc2_1.pc2_1.sai(_unary__edvuaz);
  }
  d6() {
    this.rc2_1 = this.rc2_1 - 1 | 0;
    this.sc2_1.pc2_1.uai(this.rc2_1);
  }
}
class ContainerCollection {
  constructor(container, children) {
    this.oc2_1 = children;
    this.pc2_1 = container;
  }
  e1() {
    return this.pc2_1.pai();
  }
  tc2(element) {
    return element.l23() === this.pc2_1;
  }
  u2(element) {
    if (!(element instanceof View))
      return false;
    return this.tc2(element instanceof View ? element : THROW_CCE());
  }
  uc2(elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.ContainerCollection.containsAll.<anonymous>' call
        if (!(element.l23() === this.pc2_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  v2(elements) {
    return this.uc2(elements);
  }
  g1() {
    return this.pc2_1.pai() === 0;
  }
  vc2(element) {
    this.pc2_1.wai(element);
    return true;
  }
  h(element) {
    return this.vc2(element instanceof View ? element : THROW_CCE());
  }
  wc2(elements) {
    if (elements.g1())
      return false;
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var element = _iterator__ex2g4s.c1();
      this.pc2_1.wai(element);
    }
    return true;
  }
  f1(elements) {
    return this.wc2(elements);
  }
  a1() {
    return new ContainerCollection$iterator$1(this);
  }
  xc2(element) {
    return this.pc2_1.faj(element);
  }
  h3(element) {
    if (!(element instanceof View))
      return false;
    return this.xc2(element instanceof View ? element : THROW_CCE());
  }
  d1(index) {
    return this.oc2_1.d1(index);
  }
  yc2(element) {
    return this.oc2_1.l1(element);
  }
  l1(element) {
    if (!(element instanceof View))
      return -1;
    return this.yc2(element instanceof View ? element : THROW_CCE());
  }
  w2() {
    return this.oc2_1.w2();
  }
  i1(index) {
    return this.oc2_1.i1(index);
  }
  x2(fromIndex, toIndex) {
    return this.oc2_1.x2(fromIndex, toIndex);
  }
}
class CpuGraphics extends BaseGraphics {
  static fc6(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    var $this = this.vbw(autoScaling);
    $this.xc5_1 = 0;
    $this.yc5_1 = null;
    $this.zc5_1 = true;
    $this.ac6_1 = -1;
    $this.bc6_1 = -1;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.cc6_1 = ArrayList.h1();
    $this.dc6_1 = null;
    $this.ec6_1 = null;
    $this.u9m_1 = true;
    return $this;
  }
  gc6(value) {
    this.yc5_1 = value;
    this.xc5_1 = this.xc5_1 + 1 | 0;
    this.ybw();
  }
  sbz(value) {
    var tmp = this;
    var tmp_0;
    if (value == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.<set-hitShape>.<anonymous>' call
      tmp_0 = listOf(value);
    }
    tmp.ec6_1 = tmp_0;
  }
  jaj() {
    var tmp0_safe_receiver = this.kaj();
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  }
  kaj() {
    if (!(this.ec6_1 == null))
      return this.ec6_1;
    if (!(this.ac6_1 === this.xc5_1)) {
      this.ac6_1 = this.xc5_1;
      this.cc6_1.f3();
      var tmp = this.cc6_1;
      var tmp0_safe_receiver = this.yc5_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e51();
      tmp.h(tmp1_elvis_lhs == null ? new VectorPath() : tmp1_elvis_lhs);
    }
    return this.cc6_1;
  }
  abx(ctx) {
    var tmp0_safe_receiver = this.yc5_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.l50(ctx);
    }
  }
  nbw(includeStrokes) {
    var tmp0_safe_receiver = this.yc5_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k5y(includeStrokes);
    return tmp1_elvis_lhs == null ? Companion_getInstance_32().y25_1 : tmp1_elvis_lhs;
  }
}
class DummyView extends View {
  static hc8() {
    return this.ic8();
  }
  uaf(ctx) {
    return Unit_instance;
  }
}
class Companion_6 {}
class FixedSizeContainer extends Container {
  static jc8(size, clip) {
    size = size === VOID ? Size2D.j26(100, 100) : size;
    clip = clip === VOID ? false : clip;
    var $this = this.ia5();
    $this.kc2_1 = clip;
    $this.lc2_1 = size;
    $this.mc2_1 = Ref(false);
    return $this;
  }
  s5y() {
    return this.kc2_1;
  }
  oaf(_set____db54di) {
    this.lc2_1 = _set____db54di;
  }
  paf() {
    return this.lc2_1;
  }
  raf() {
    return new Rectangle(0.0, 0.0, this.n2i(), this.o2i());
  }
  toString() {
    var out = super.toString();
    out = out + (':size=(' + get_niceStr(this.n2i()) + 'x' + get_niceStr(this.o2i()) + ')');
    return out;
  }
  uaf(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.s5y();
      var renderingInternalRef = this.mc2_1;
      if (renderingInternalRef.p1()) {
        super.uaf(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.u9y();
        var hasRotation = !(m.c29_1 === 0.0) || !(m.d29_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.p1();
          try {
            renderingInternalRef.q2q(true);
            renderFiltered(this, ctx, Companion_getInstance_60());
          }finally {
            renderingInternalRef.q2q(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.d80_1;
        if (!(ctx.h80_1 === batcher)) {
          ctx.h80_1 = batcher;
          ctx.r81();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.f80_1;
        var bounds = this.val(ctx).u2e(ctx.t7z_1).v2e();
        var rect = c2d.v8a_1.d87().p6p();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.j2e(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_15().k6p(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.v8a_1;
            var scissor_0 = c2d.h8b(scissor);
            var temp = this_0.k81_1;
            this_0.t87();
            this_0.k81_1 = scissor_0;
            try {
              super.uaf(ctx);
              break $l$block_1;
            }finally {
              this_0.t87();
              this_0.k81_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
          super.uaf(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
        super.uaf(ctx);
      }
    }
  }
}
class SContainer extends FixedSizeContainer {
  static xa7(size, clip) {
    size = size === VOID ? Size2D.j26(100, 100) : size;
    clip = clip === VOID ? false : clip;
    return this.jc8(size, clip);
  }
}
class TimeSlidingWindow {
  constructor(capacity) {
    this.lc8_1 = capacity;
    this.mc8_1 = IntDeque.g2m(this.lc8_1);
    this.nc8_1 = 0;
  }
  e1() {
    return this.mc8_1.e1();
  }
  oc8() {
    return this.mc8_1.e1() === 0 ? get_fastSeconds(0) : get_fastMicroseconds(this.nc8_1 / this.mc8_1.e1());
  }
  pc8() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(1, DurationUnit_SECONDS_getInstance());
    return div(tmp$ret$1, this.oc8());
  }
  qc8(index) {
    return get_fastMicroseconds_0(this.mc8_1.d1(index));
  }
  rc8(value) {
    var intValue = numberToInt(_FastDuration___get_fastMicroseconds__impl__e641g1(value));
    this.mc8_1.l2m(intValue);
    this.nc8_1 = this.nc8_1 + intValue | 0;
    if (this.mc8_1.e1() > this.lc8_1) {
      this.nc8_1 = this.nc8_1 - this.mc8_1.kk() | 0;
    }
  }
}
class GraphicsRenderer extends Enum {}
class Graphics extends Container {
  static kce(shape, renderer) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.ia5();
    $this.acb_1 = null;
    $this.bcb_1 = null;
    $this.ccb_1 = true;
    $this.dcb_1 = false;
    $this.ecb_1 = true;
    $this.fcb_1 = true;
    $this.gcb_1 = EmptyShape_instance;
    $this.hcb_1 = renderer;
    $this.ice(shape);
    return $this;
  }
  lce() {
    var tmp0_elvis_lhs = this.acb_1;
    return ensureNotNull(tmp0_elvis_lhs == null ? this.bcb_1 : tmp0_elvis_lhs);
  }
  qbk(value) {
    _get_anchorable__ebfoik(this).qbk(value);
    this.j9s();
  }
  haj() {
    return this.lce().haj();
  }
  iaj() {
    return this.lce().iaj();
  }
  mce(value) {
    if (this.ecb_1 === value)
      return Unit_instance;
    this.ecb_1 = value;
    var tmp0_safe_receiver = this.acb_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dbz_1 = value;
    }
    var tmp1_safe_receiver = this.bcb_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.kcd_1 = value;
    }
    this.j9s();
  }
  nce(value) {
    if (this.fcb_1 === value)
      return Unit_instance;
    this.fcb_1 = value;
    var tmp0_safe_receiver = this.acb_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.xbv_1 = value;
    }
    var tmp1_safe_receiver = this.bcb_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.icd_1 = value;
    }
    this.j9s();
  }
  ice(value) {
    if (this.gcb_1 === value)
      return Unit_instance;
    this.gcb_1 = value;
    ensure_0(this);
    var tmp0_safe_receiver = this.acb_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.gc6(value);
    }
    var tmp1_safe_receiver = this.bcb_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.ice(value);
    }
    this.j9s();
  }
  oce() {
    ensure_0(this);
    var tmp0_safe_receiver = this.acb_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ybw();
    }
    var tmp1_safe_receiver = this.acb_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.zbw();
  }
}
class ViewFileRef {}
function forceLoadSourceFile$default(views, currentVfs, sourceFile, $completion, $super) {
  currentVfs = currentVfs === VOID ? views.f9j_1 : currentVfs;
  sourceFile = sourceFile === VOID ? null : sourceFile;
  return $super === VOID ? this.vce(views, currentVfs, sourceFile, $completion) : $super.vce.call(this, views, currentVfs, sourceFile, $completion);
}
class Image extends BaseImage {
  static sce(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().b24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.tce(bitmap, anchor, hitShape, smoothing);
    $this.pb4_1 = new Mixin_0();
    $this.qb4_1 = sourceFile$factory($this);
    return $this;
  }
  static rb4(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().b24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.sce(Resourceable(bitmap), anchor, hitShape, smoothing);
  }
  uaf(ctx) {
    this.uce(ctx, this);
    super.uaf(ctx);
  }
  vce(views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadSourceFile__yy5vos.bind(VOID, this, views, currentVfs, sourceFile), $completion);
  }
  xce(_set____db54di) {
    this.pb4_1.qce_1 = _set____db54di;
  }
  yce(_set____db54di) {
    this.pb4_1.yce(_set____db54di);
  }
  zce() {
    return this.pb4_1.rce_1;
  }
  pce(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_baseForceLoadSourceFile__natc6b.bind(VOID, _this__u8e3s4, this, views, currentVfs, sourceFile), $completion);
  }
  uce(ctx, view) {
    this.pb4_1.uce(ctx, view);
  }
}
class Companion_7 {}
class Companion_8 {}
class SolidRect extends RectBase {
  static kch(size, color) {
    color = color === VOID ? Colors_getInstance().a3y_1 : color;
    var $this = this.ccf();
    $this.jch_1 = size;
    $this.m4d(color);
    return $this;
  }
  oaf(value) {
    if (this.jch_1.equals(value))
      return Unit_instance;
    this.jch_1 = value;
    this.k9m_1 = true;
    this.j9s();
  }
  paf() {
    return this.jch_1;
  }
  bbx() {
    return this.n2i();
  }
  cbx() {
    return this.o2i();
  }
}
class Stage extends FixedSizeContainer {
  static t9h(views) {
    var $this = this.jc8();
    $this.p9h_1 = views.s9i_1;
    $this.q9h_1 = views;
    $this.r9h_1 = clipBorders$factory($this.o9v());
    $this.s9h_1 = virtualSizeDouble$factory($this.o9v());
    $this.maj($this);
    $this.oaj($this);
    return $this;
  }
  o9v() {
    return this.q9h_1;
  }
  lch(_set____db54di) {
    var this_0 = this.r9h_1;
    clip$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  s5y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r9h_1;
    clip$factory_0();
    return this_0.get();
  }
  oaf(_set____db54di) {
    var this_0 = this.s9h_1;
    unscaledSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  paf() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s9h_1;
    unscaledSize$factory_0();
    return this_0.get();
  }
  n9v() {
    return this;
  }
  kai() {
    return this;
  }
  k83() {
    return this.qc2(this.o9v());
  }
  lai(view) {
    this.o9v().lai(view);
  }
  toString() {
    return 'Stage';
  }
  q14() {
    return this.q9h_1.i9i_1;
  }
  a89(pos) {
    return this.p9h_1.a89(pos);
  }
  p88(value) {
    this.p9h_1.p88(value);
  }
  q88() {
    return this.p9h_1.q88();
  }
  r88(value) {
    this.p9h_1.r88(value);
  }
  s88() {
    return this.p9h_1.s88();
  }
  t88(value) {
    this.p9h_1.t88(value);
  }
  u88() {
    return this.p9h_1.u88();
  }
  v88(value) {
    this.p9h_1.v88(value);
  }
  w88() {
    return this.p9h_1.w88();
  }
  x88(value) {
    this.p9h_1.x88(value);
  }
  y88() {
    return this.p9h_1.y88();
  }
  z88() {
    return this.p9h_1.z88();
  }
}
class Companion_9 {
  constructor() {
    this.ncl_1 = 16.0;
    this.ocl_1 = true;
  }
}
class Text$_renderInternal$slambda {
  constructor(this$0, $ctx, $fontSource) {
    this.och_1 = this$0;
    this.pch_1 = $ctx;
    this.qch_1 = $fontSource;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_22.bind(VOID, this), $completion);
  }
}
class Text extends Container {
  static rcl(text, textSize, color, font, alignment, renderer, autoScaling, fill, stroke) {
    textSize = textSize === VOID ? Companion_instance_24.ncl_1 : textSize;
    color = color === VOID ? Colors_getInstance().a3y_1 : color;
    font = font === VOID ? get_DefaultTtfFontAsBitmap() : font;
    alignment = alignment === VOID ? Companion_getInstance_3().n4v_1 : alignment;
    renderer = renderer === VOID ? get_DefaultStringTextRenderer() : renderer;
    autoScaling = autoScaling === VOID ? Companion_instance_24.ocl_1 : autoScaling;
    fill = fill === VOID ? null : fill;
    stroke = stroke === VOID ? null : stroke;
    var $this = this.ia5();
    $this.zcj_1 = true;
    $this.ack_1 = -1;
    $this.bck_1 = -1;
    $this.cck_1 = 0;
    $this.dck_1 = 0;
    $this.eck_1 = text;
    updateLineCount($this);
    var tmp = $this;
    tmp.fck_1 = fill == null ? new RGBA(color) : fill;
    $this.gck_1 = stroke;
    $this.hck_1 = font;
    $this.ick_1 = numberToDouble(textSize);
    $this.jck_1 = textSize$factory($this);
    $this.kck_1 = 0;
    $this.lck_1 = 2147483647;
    $this.mck_1 = renderer;
    $this.nck_1 = alignment;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.ia5(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp_0.ock_1 = addTo(this_0, $this);
    $this.pck_1 = new Text2TextRendererActions();
    $this.qck_1 = false;
    $this.rck_1 = autoScaling;
    $this.sck_1 = false;
    $this.tck_1 = null;
    $this.uck_1 = Companion_getInstance_32().u2d(0, 0, 2048, 2048);
    $this.vck_1 = true;
    $this.wck_1 = -1;
    $this.xck_1 = new MMatrix();
    $this.yck_1 = -1;
    $this.zck_1 = null;
    $this.acl_1 = new Entry();
    $this.bcl_1 = new FontMetrics();
    $this.ccl_1 = new TextMetrics();
    $this.dcl_1 = null;
    $this.ecl_1 = null;
    $this.fcl_1 = null;
    $this.gcl_1 = null;
    $this.hcl_1 = new MMatrix();
    $this.icl_1 = GraphicsRenderer_SYSTEM_getInstance();
    $this.jcl_1 = true;
    $this.kcl_1 = null;
    $this.lcl_1 = fontSource$factory($this);
    return $this;
  }
  scl(value) {
    if (!(this.eck_1 === value)) {
      this.eck_1 = value;
      updateLineCount(this);
      this.nai();
      this.j9s();
    }
  }
  y5p() {
    return this.eck_1;
  }
  j5d() {
    var tmp = this.fck_1;
    var tmp_0;
    if (tmp == null ? true : tmp instanceof RGBA) {
      var tmp_1 = tmp;
      tmp_0 = tmp_1 == null ? null : tmp_1.u4d_1;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_2;
    var tmp_3 = tmp0_elvis_lhs;
    if ((tmp_3 == null ? null : new RGBA(tmp_3)) == null) {
      tmp_2 = Colors_getInstance().a3y_1;
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    return tmp_2;
  }
  qcl(value) {
    if (!equals(this.hck_1, value)) {
      this.hck_1 = value;
      this.nai();
    }
  }
  tcl(value) {
    if (!(this.ick_1 === value)) {
      this.ick_1 = value;
      this.nai();
    }
  }
  ucl(_set____db54di) {
    var this_0 = this.jck_1;
    fontSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  o4o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.jck_1;
    fontSize$factory_0();
    return this_0.get();
  }
  nai() {
    this.cck_1 = this.cck_1 + 1 | 0;
    super.nai();
  }
  w5t() {
    return this.nck_1.g4x_1;
  }
  pcl(value) {
    this.tck_1 = value;
    this.qck_1 = false;
    this.nai();
  }
  mcl(currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadFontSource__wlrz09.bind(VOID, this, currentVfs, sourceFile), $completion);
  }
  raf() {
    this.vcl(null);
    if (!(get_filter(this) == null) || !(get_backdropFilter(this) == null)) {
      return super.raf();
    } else {
      return this.uck_1;
    }
  }
  uaf(ctx) {
    this.vcl(ctx);
    var tva = this.gcl_1;
    if (!(tva == null)) {
      this.xck_1.x3n(this.u9y());
      this.xck_1.y3n(this.ock_1.t69(), this.ock_1.u69());
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.d80_1;
      var this_1 = this_0.m80_1;
      if (!(this_1.h80_1 === this_0)) {
        this_1.h80_1 = this_0;
        this_1.r81();
      }
      var tmp = this.hck_1;
      var bmpfont = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
      var tex = bmpfont.t4o();
      this_0.x87(tex, this.zcj_1, this.zak(), get_agProgram(bmpfont), tva.o87_1, tva.n87_1);
      this_0.s87(tva, this.xck_1.v3n());
    } else {
      super.uaf(ctx);
    }
  }
  vcl(ctx) {
    if (!(ctx == null)) {
      var fontSource = this.tck_1;
      if (!this.qck_1 && !(fontSource == null)) {
        this.qck_1 = true;
        launchImmediately_0(ctx.j7z_1, Text$_renderInternal$slambda_0(this, ctx, fontSource));
      }
    }
    var font = this.hck_1.sy();
    var tmp;
    var tmp_0;
    if (this.vck_1) {
      tmp_0 = !(font == null) ? isInterface(font, Font) : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(this.wck_1 === this.cck_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.wck_1 = this.cck_1;
      var metrics = getTextBounds(font, this.ick_1, this.y5p(), this.ccl_1, this.mck_1, this.nck_1);
      this.uck_1 = new Rectangle(metrics.t25(), VerticalAlign__getOffsetY_impl_iso0y6(this.nck_1.g4x_1, metrics.o2i(), -metrics.n4x()), metrics.n2i(), font.x4o(this.ick_1, this.bcl_1).p4o() * this.dck_1);
    }
    if (font != null) {
      if (!(font == null) ? isInterface(font, BitmapFont) : false) {
        var rversion = this.mck_1.p5s();
        if (!(this.ecl_1 === this.zcj_1) || !(this.ack_1 === this.cck_1) || !(this.bck_1 === rversion)) {
          this.ecl_1 = this.zcj_1;
          this.bck_1 = rversion;
          this.ack_1 = this.cck_1;
          if (!(this.kcl_1 == null)) {
            this.kcl_1 = null;
            this.ock_1.vai();
          }
          this.pck_1.a5u();
          this.pck_1.n5t_1 = Companion_getInstance_3().r4v_1;
          invoke_0(this.mck_1, this.pck_1, this.y5p(), this.ick_1, font);
          while (this.ock_1.pai() < this.pck_1.e1()) {
            // Inline function 'korlibs.korge.view.image' call
            var this_0 = this.ock_1;
            // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
            var texture = get_Bitmaps_transparent();
            var anchor_0 = Companion_getInstance_27().b24_1;
            // Inline function 'korlibs.korge.view.addTo' call
            var this_1 = Image.rb4(texture, anchor_0);
            // Inline function 'kotlin.apply' call
            addTo(this_1, this_0);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.image.<anonymous>' call
          }
          while (this.ock_1.pai() > this.pck_1.e1()) {
            this.ock_1.d1(this.ock_1.pai() - 1 | 0).pal();
          }
          var bounds = this.pck_1.o39();
          var firstBounds = this.pck_1.y5t(0);
          var lineInfos = this.pck_1.x5t();
          var tmp1_elvis_lhs = firstOrNull(lineInfos);
          var firstLineInfos = tmp1_elvis_lhs == null ? new LineInfo() : tmp1_elvis_lhs;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0;
          var tmp0_iterator = lineInfos.a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            var tmp_1 = sum;
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            sum = tmp_1 + element.w5s_1;
          }
          var totalHeight = sum;
          var textWidth = bounds.o25_1;
          var textHeight = bounds.p25_1;
          var dx = this.uck_1.m25_1;
          var tmp2_subject = this.w5t();
          var dy = equals(tmp2_subject, Companion_getInstance_4().j5s_1) ? 0.0 : equals(tmp2_subject, Companion_getInstance_4().g5s_1) ? firstLineInfos.u5s_1 : firstLineInfos.u5s_1 - totalHeight * _VerticalAlign___get_ratioFake__impl__1h2fwv(this.w5t());
          var program = get_agProgram(font);
          var inductionVariable = 0;
          var last = this.pck_1.e1();
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var entry = this.pck_1.z5t(n, this.acl_1);
              var tmp_2 = this.ock_1.d1(n);
              var it = tmp_2 instanceof Image ? tmp_2 : THROW_CCE();
              it.hbz_1 = program;
              it.m4d(this.j5d());
              // Inline function 'korlibs.korge.view.anchor' call
              anchor(it, Anchor2D.o24(numberToDouble(0), numberToDouble(0)));
              it.dbz_1 = this.zcj_1;
              it.vbq(entry.x5s_1);
              it.y4z(Vector2D.s24(entry.y5s_1 + dx, entry.z5s_1 + dy));
              it.cak(Scale.g2d(entry.a5t_1, entry.b5t_1));
              it.bcf(entry.c5t_1);
              var containsLower = this.kck_1;
              it.i8i(n < this.lck_1 ? containsLower <= n : false);
            }
             while (inductionVariable < last);
        }
      } else {
        if (!(this.ecl_1 === this.zcj_1) || !(this.fcl_1 === this.jcl_1)) {
          this.cck_1 = this.cck_1 + 1 | 0;
          this.fcl_1 = this.jcl_1;
          this.dcl_1 = this.rck_1;
          this.ecl_1 = this.zcj_1;
        }
        if (!(this.ack_1 === this.cck_1)) {
          this.ack_1 = this.cck_1;
          var realTextSize = this.ick_1;
          if (this.kcl_1 == null) {
            this.ock_1.vai();
            var tmp_3 = this;
            // Inline function 'korlibs.korge.view.graphics' call
            var this_2 = this.ock_1;
            var renderer = this.icl_1;
            // Inline function 'kotlin.also' call
            var this_3 = addTo(Graphics.kce(EmptyShape_instance, renderer), this_2);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape' call
            var result;
            // Inline function 'korlibs.image.vector.buildShape' call
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            result = Unit_instance;
            var tmp$ret$10 = (new ShapeBuilder(null, null)).p4u();
            this_3.ice(tmp$ret$10);
            this_3.oce();
            tmp_3.kcl_1 = this_3;
            var tmp3_safe_receiver = this.kcl_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.nce(true);
            }
          }
          // Inline function 'korlibs.korge.view.Graphics.updateShape' call
          var this_4 = ensureNotNull(this.kcl_1);
          var result_0;
          // Inline function 'korlibs.image.vector.buildShape' call
          // Inline function 'kotlin.apply' call
          var this_5 = new ShapeBuilder(null, null);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
          // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
          var tmp0_text = this.y5p();
          var tmp1_pos = Companion_getInstance_29().e25_1;
          var tmp2_paint = this.j5d();
          var tmp3_renderer = this.mck_1;
          var tmp4_align = this.nck_1;
          var tmp5_outMetrics = new TextMetricsResult();
          var tmp6_fillStyle = this.fck_1;
          var tmp7_stroke = this.gck_1;
          var tmp8_textRangeStart = this.kck_1;
          var tmp9_textRangeEnd = this.lck_1;
          result_0 = this_5.w5r(tmp0_text, tmp1_pos, VOID, new RGBA(tmp2_paint), font, realTextSize, tmp3_renderer, tmp4_align, tmp5_outMetrics, tmp6_fillStyle, tmp7_stroke, tmp8_textRangeStart, tmp9_textRangeEnd);
          var tmp$ret$16 = this_5.p4u();
          this_4.ice(tmp$ret$16);
          var metrics_0 = result_0;
          this.yck_1 = this.cck_1;
          this.zck_1 = metrics_0;
          setContainerPosition(this, Companion_getInstance_29().e25_1, font.x4o(this.o4o(), this.bcl_1).b4p_1);
        }
        var tmp4_safe_receiver = this.kcl_1;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.mce(this.zcj_1);
        }
      }
    }
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_25 = this;
    this.wcl_1 = until(0, 2147483647);
  }
}
class TextBlock extends UIView {
  static gb2(text, align, size) {
    Companion_getInstance_51();
    var tmp;
    if (text === VOID) {
      var tmp0_font = get_DefaultTtfFontAsBitmap();
      tmp = RichTextData.l5r('', tmp0_font, 16.0);
    } else {
      tmp = text;
    }
    text = tmp;
    align = align === VOID ? Companion_getInstance_3().n4v_1 : align;
    size = size === VOID ? Size2D.j26(100, 100) : size;
    var $this = this.jaf(size);
    $this.pb1_1 = true;
    $this.qb1_1 = text;
    $this.rb1_1 = align;
    $this.sb1_1 = false;
    $this.tb1_1 = true;
    $this.ub1_1 = new RGBA($this.o4d());
    $this.vb1_1 = null;
    $this.wb1_1 = true;
    $this.xb1_1 = '...';
    $this.yb1_1 = Companion_getInstance_34().d28_1;
    $this.zb1_1 = false;
    $this.ab2_1 = 0;
    $this.bb2_1 = 2147483647;
    $this.cb2_1 = true;
    $this.db2_1 = null;
    $this.eb2_1 = null;
    invalidateText($this);
    $this.fb2_1 = null;
    return $this;
  }
  cb5(value) {
    if (!this.qb1_1.equals(value)) {
      this.qb1_1 = value;
      invalidateText(this);
    }
  }
  bb5(value) {
    if (!this.rb1_1.equals(value)) {
      this.rb1_1 = value;
      invalidProps(this);
    }
  }
  laf() {
    invalidProps(this);
  }
  uaf(ctx) {
    if (_get_allBitmap__bdn8f(this) === true) {
      if (this.pb1_1 || this.fb2_1 == null) {
        this.pb1_1 = false;
        this.fb2_1 = place(this.qb1_1, new Rectangle(this.yb1_1.h28_1, this.yb1_1.e28_1, this.n2i() - this.yb1_1.f28_1, this.o2i() - this.yb1_1.g28_1), this.wb1_1, this.sb1_1, this.xb1_1, this.ub1_1, this.vb1_1, this.rb1_1, this.tb1_1);
      }
      var tmp0_safe_receiver = this.db2_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.pal();
      }
      this.db2_1 = null;
      // Inline function 'korlibs.korge.render.renderCtx2d' call
      // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      var batcher = ctx.d80_1;
      if (!(ctx.h80_1 === batcher)) {
        ctx.h80_1 = batcher;
        ctx.r81();
      }
      // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
      // Inline function 'korlibs.korge.render.renderCtx2d.<anonymous>' call
      var context = ctx.f80_1;
      // Inline function 'korlibs.korge.render.RenderContext2D.keep' call
      $l$block_3: {
        // Inline function 'korlibs.korge.render.RenderContext2D.keepMatrix' call
        var old = context.z8a_1;
        try {
          // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>' call
          $l$block_2: {
            // Inline function 'korlibs.korge.render.RenderContext2D.keepBlendMode' call
            var oldBlendFactors = context.a8b_1;
            try {
              // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>' call
              $l$block_1: {
                // Inline function 'korlibs.korge.render.RenderContext2D.keepColor' call
                var multiplyColor = context.b8b_1;
                try {
                  // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>' call
                  $l$block_0: {
                    // Inline function 'korlibs.korge.render.RenderContext2D.keepFiltering' call
                    var filtering = context.c8b_1;
                    try {
                      // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      $l$block: {
                        // Inline function 'korlibs.korge.render.RenderContext2D.keepSize' call
                        var size = context.x8a_1;
                        try {
                          // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                          context.x8a_1 = Size2D.a2e(this.n2i(), this.o2i());
                          context.a8b_1 = this.zak();
                          context.b8b_1 = this.aal();
                          context.d8b(this.u9y());
                          drawText_0(context, ensureNotNull(this.fb2_1), this.ab2_1, this.bb2_1, this.cb2_1);
                          break $l$block;
                        }finally {
                          context.x8a_1 = size;
                        }
                      }
                      break $l$block_0;
                    }finally {
                      context.c8b_1 = filtering;
                    }
                  }
                  break $l$block_1;
                }finally {
                  context.b8b_1 = multiplyColor;
                }
              }
              break $l$block_2;
            }finally {
              context.a8b_1 = oldBlendFactors;
            }
          }
          break $l$block_3;
        }finally {
          context.z8a_1 = old;
        }
      }
    } else {
      ensureTexture(this);
    }
    super.uaf(ctx);
  }
}
class ColorReference {}
class Companion_11 {
  xcl(left, right) {
    var l = left;
    var r = right;
    var lCount = get_ancestorCount(l);
    var rCount = get_ancestorCount(r);
    while (lCount >= 0 || rCount >= 0) {
      if (equals(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        lCount = lCount - 1 | 0;
        var tmp0_safe_receiver = l;
        l = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l23();
      }
      if (rdec) {
        rCount = rCount - 1 | 0;
        var tmp1_safe_receiver = r;
        r = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.l23();
      }
    }
    return null;
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.ycl_1 = function_0;
  }
  ri(a, b) {
    return this.ycl_1(a, b);
  }
  compare(a, b) {
    return this.ri(a, b);
  }
  h4() {
    return this.ycl_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.h4(), other.h4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.h4());
  }
}
class ViewRenderPhase {}
function get_priority() {
  return 0;
}
function render_0(view, ctx) {
  return view.hal(ctx);
}
function beforeRender(view, ctx) {
  return Unit_instance;
}
function afterRender(view, ctx) {
  return Unit_instance;
}
class ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda {
  constructor($view, $ctx, this$0) {
    this.icm_1 = $view;
    this.jcm_1 = $ctx;
    this.kcm_1 = this$0;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_23.bind(VOID, this), $completion);
  }
}
class Mixin_0 {
  constructor() {
    this.qce_1 = true;
    this.rce_1 = null;
  }
  xce(_set____db54di) {
    this.qce_1 = _set____db54di;
  }
  yce(value) {
    this.qce_1 = false;
    this.rce_1 = value;
  }
  pce(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    _this__u8e3s4.yce(sourceFile);
    _this__u8e3s4.xce(true);
  }
  vce(views, currentVfs, sourceFile, $completion) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Must override this';
    throw NotImplementedError.md('An operation is not implemented: ' + reason);
  }
  uce(ctx, view) {
    if (this.qce_1)
      return Unit_instance;
    this.lcm(ctx, view);
  }
  lcm(ctx, view) {
    if (!this.qce_1 && !(this.rce_1 == null)) {
      this.qce_1 = true;
      launchImmediately_0(ctx.j7z_1, ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0(view, ctx, this));
    }
  }
}
class Views$close$slambda {
  constructor(this$0) {
    this.mcm_1 = this$0;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_24.bind(VOID, this), $completion);
  }
}
class Views extends BaseEventListener {
  static h9q(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder) {
    injector = injector === VOID ? new Injector() : injector;
    input = input === VOID ? new Input() : input;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    stats = stats === VOID ? new Stats() : stats;
    gameId = gameId === VOID ? 'korgegame' : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().i86_1 : batchMaxQuads;
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (stageBuilder === VOID) {
      tmp = Views$_init_$lambda_jivasj;
    } else {
      tmp = stageBuilder;
    }
    stageBuilder = tmp;
    var $this = this.q65();
    $this.h9i_1 = new Mixin();
    $this.i9i_1 = coroutineContext;
    $this.j9i_1 = ag;
    $this.k9i_1 = injector;
    $this.l9i_1 = input;
    $this.m9i_1 = timeProvider;
    $this.n9i_1 = stats;
    $this.o9i_1 = gameWindow;
    $this.p9i_1 = gameId;
    $this.q9i_1 = settingsFolder;
    $this.r9i_1 = batchMaxQuads;
    $this.s9i_1 = bp;
    $this.t9i_1 = stageBuilder;
    $this.u9i_1 = quality$factory($this.o9i_1);
    $this.v9i_1 = $this;
    $this.w9i_1 = false;
    $this.x9i_1 = continuousRenderMode$factory($this.o9i_1);
    $this.y9i_1 = new ReshapeEvent(0, 0);
    $this.z9i_1 = new UpdateEvent();
    $this.a9j_1 = new ViewsUpdateEvent($this);
    $this.b9j_1 = new ViewsResizedEvent($this);
    var tmp_0 = $this;
    tmp_0.c9j_1 = lazy(Views$realSettingsFolder$delegate$lambda($this));
    $this.e9j_1 = null;
    $this.f9j_1 = get_resourcesVfs();
    $this.g9j_1 = get_RegisteredImageFormats();
    $this.h9j_1 = new RenderContext($this.j9i_1, $this, $this.o9i_1, $this.n9i_1, $this.i9i_1, $this.r9i_1, $this.o9i_1);
    $this.i9j_1 = true;
    $this.j9j_1 = Colors_getInstance().b3y_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.k9j_1 = HashMap.e8();
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp_2.l9j_1 = toDuration(100.0, DurationUnit_MILLISECONDS_getInstance());
    $this.m9j_1 = new Resources($this.i9i_1, $this.f9j_1);
    $this.n9j_1 = false;
    $this.o9j_1 = 1280;
    $this.p9j_1 = 720;
    var tmp_3 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_3.q9j_1 = ArrayList.h1();
    $this.r9j_1 = Companion_getInstance_26().w2f_1;
    $this.s9j_1 = Companion_getInstance_27().f24_1;
    $this.t9j_1 = true;
    $this.u9j_1 = $this.t9i_1($this);
    $this.v9j_1 = $this.u9j_1;
    $this.w9j_1 = true;
    $this.x9j_1 = false;
    $this.y9j_1 = debugExtraFontScale$factory($this.h9j_1);
    $this.z9j_1 = debugExtraFontColor$factory($this.h9j_1);
    $this.a9k_1 = FastArrayList.gy();
    $this.b9k_1 = $this.m9i_1.l1u();
    var tmp_4 = $this;
    tmp_4.c9k_1 = Pool.h2p(VOID, Views$tempViewsPool$lambda);
    $this.d9k_1 = SizeInt.k2g();
    $this.e9k_1 = SizeInt.k2g();
    $this.f9k_1 = SizeInt.k2g();
    $this.g9k_1 = new Signal();
    $this.h9k_1 = new Signal();
    $this.i9k_1 = -1.0;
    $this.k9i_1.x62(getKClass(CoroutineContext), $this.i9i_1);
    $this.k9i_1.x62(getKClass(AG), $this.j9i_1);
    $this.k9i_1.x62(getKClass(Views), $this);
    $this.h9k_1.v1v(Views$lambda($this));
    $this.g9k_1.v1v(Views$lambda_0($this));
    installFpsDebugOverlay($this);
    $this.j9k_1 = Companion_instance_11.yh('SHOW_FRAME_UPDATE_AND_RENDER') === 'true';
    $this.k9k_1 = new EventResult();
    $this.l9k_1 = new Signal();
    $this.m9k_1 = Companion_getInstance_0().ew('debugHightlightView');
    $this.n9k_1 = new Signal();
    $this.o9k_1 = new Signal();
    $this.p9k_1 = ArrayList.h1();
    $this.q9k_1 = updatedSinceFrame$factory($this.o9i_1);
    return $this;
  }
  q14() {
    return this.i9i_1;
  }
  o9v() {
    return this.v9i_1;
  }
  s9q(_set____db54di) {
    var this_0 = this.x9i_1;
    forceRenderEveryFrame$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  m9q() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x9i_1;
    forceRenderEveryFrame$factory_0();
    return this_0.get();
  }
  ocm() {
    return replace(replace(replace(this.p9i_1, '\\', ''), '/', ''), '..', '');
  }
  v9y() {
    var tmp = this.d9j_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('debugBmpFont');
    }
  }
  u22($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_init__qn9atk.bind(VOID, this), $completion);
  }
  r9q() {
    return this.m9j_1;
  }
  t9q() {
    return this.j9i_1.p6e().i6e_1;
  }
  u9q() {
    return this.j9i_1.p6e().j6e_1;
  }
  pcm(value) {
    this.o9j_1 = numberToInt(value);
  }
  qcm() {
    return this.o9j_1;
  }
  rcm(value) {
    this.p9j_1 = numberToInt(value);
  }
  scm() {
    return this.p9j_1;
  }
  nch(value) {
    this.pcm(value.h26_1);
    this.rcm(value.i26_1);
  }
  mch() {
    return Size2D.a2e(this.qcm(), this.scm());
  }
  z5() {
    launchImmediately(this, Views$close$slambda_0(this));
  }
  ncm($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_closeSuspend__agjafw.bind(VOID, this), $completion);
  }
  p9v() {
    return this.u9j_1.k83();
  }
  i9q(_set____db54di) {
    var this_0 = this.y9j_1;
    debugFontExtraScale$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  tcm() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y9j_1;
    debugFontExtraScale$factory_0();
    return this_0.get();
  }
  j9q(_set____db54di) {
    var this_0 = this.z9j_1;
    debugFontColor$factory();
    var value = new RGBA(_set____db54di);
    this_0.set(value);
    return Unit_instance;
  }
  ucm() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z9j_1;
    debugFontColor$factory_0();
    return this_0.get().u4d_1;
  }
  kc8(block) {
    this.a9k_1.h(block);
  }
  u65(type, event, result, up, down) {
    event.n66(false);
    var result_0 = super.u65(type, event, result, up, down);
    var e = event;
    e.m66(this.v9i_1);
    if (e instanceof KeyEvent) {
      this.l9i_1.r83(e);
      this.l9i_1.y82_1.i82(e);
      if (e.i67_1.equals(Type_UP_getInstance_0()) && this.w9j_1 && (e.k67_1.equals(Key_F12_getInstance()) || e.k67_1.equals(Key_F7_getInstance()))) {
        this.x9j_1 = !this.x9j_1;
        this.o9i_1.m8i(this.x9j_1);
        this.lai(this.u9j_1);
      }
    }
    try {
      return this.u9j_1.d66(e);
    } catch ($p) {
      if ($p instanceof StopPropagatingException) {
        var e_0 = $p;
      } else {
        throw $p;
      }
    }
    return result_0;
  }
  vcm(frameBuffer) {
    this.h9j_1.i80_1 = frameBuffer;
    if (this.i9j_1) {
      var tmp0_$this = this.h9j_1;
      var tmp1_color = this.j9j_1;
      tmp0_$this.h8a(tmp1_color, 1.0, 0, true, true, true);
    }
    this.g9k_1.w1v(this.h9j_1);
    this.h9j_1.r81();
    this.u9j_1.qaf(this.h9j_1);
    this.h9j_1.r81();
    this.u9j_1.yai(this.h9j_1);
    if (this.x9j_1) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.a9k_1.ey_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Views.renderNew.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz](this, this.h9j_1);
      }
    }
    this.h9k_1.w1v(this.h9j_1);
    this.h9j_1.r81();
  }
  wcm(frameBuffer, $super) {
    frameBuffer = frameBuffer === VOID ? this.j9i_1.p6e() : frameBuffer;
    var tmp;
    if ($super === VOID) {
      this.vcm(frameBuffer);
      tmp = Unit_instance;
    } else {
      tmp = $super.vcm.call(this, frameBuffer);
    }
    return tmp;
  }
  xcm() {
    this.j9i_1.t6e();
    this.wcm();
  }
  n9q(fixedSizeStep, forceRender, doUpdate, doRender) {
    var currentTime = this.m9i_1.l1u();
    this.v9i_1.n9i_1.t6e();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_40().b9f_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.h2t(level)) {
      // Inline function 'korlibs.korge.view.Views.frameUpdateAndRender.<anonymous>' call
      var tmp$ret$0 = 'ag.onRender';
      this_0.i2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var delta = DateTime__minus_impl_10njw8(currentTime, this.b9k_1);
    var adelta = Duration__compareTo_impl_pchp0f(delta, this.v9i_1.l9j_1) > 0 ? this.v9i_1.l9j_1 : delta;
    this.b9k_1 = currentTime;
    if (doUpdate) {
      if (!equals(fixedSizeStep, Companion_instance_1.r1u())) {
        this.zcm(fixedSizeStep);
      } else {
        this.ycm(adelta);
      }
    }
    var doRender2 = doRender && (forceRender || this.acn() > 0);
    if (doRender2) {
      if (this.j9k_1) {
        println('Views.frameUpdateAndRender[' + Companion_getInstance_5().n1u().toString() + ']: doRender=' + doRender2 + ' -> [forceRender=' + forceRender + ', updatedSinceFrame=' + this.acn() + ']');
      }
      this.xcm();
      this.t6e();
    }
  }
  ycm(elapsed) {
    return this.zcm(get_fast(elapsed));
  }
  zcm(elapsed) {
    this.l9i_1.p83(elapsed);
    this.k9k_1.a2q();
    updateSingleViewWithViewsAll(this.u9j_1, this, elapsed);
    this.l9i_1.q83(elapsed);
  }
  l9q() {
  }
  q9q(width, height) {
    var actualWidth = width;
    var actualHeight = height;
    this.e9k_1 = SizeInt.j2g(actualWidth, actualHeight);
    this.bcn();
  }
  bcn() {
    setBoundsInfo(this.s9i_1, Size2D.j26(this.o9j_1, this.p9j_1), toFloat(this.e9k_1), this.r9j_1, this.s9j_1, toRef(virtualSize$factory(this)), toRef(targetSize$factory(this)));
    this.h9j_1.p7z_1 = this.s9i_1.u88();
    this.h9j_1.q7z_1 = this.s9i_1.q88();
    // Inline function 'kotlin.also' call
    var this_0 = this.y9i_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_0.c67_1 = this.e9k_1.h2g_1;
    this_0.d67_1 = this.e9k_1.i2g_1;
    this.d66(this_0);
    // Inline function 'kotlin.also' call
    var this_1 = this.b9j_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_1.fcn_1 = this.d9k_1;
    this.d66(this_1);
    this.u9j_1.nai();
  }
  ebk(viewToHightlight, onlyIfDebuggerOpened) {
    if (onlyIfDebuggerOpened && !this.o9i_1.n8i())
      return Unit_instance;
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = this.m9k_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.h2t(level)) {
      // Inline function 'korlibs.korge.view.Views.debugHightlightView.<anonymous>' call
      var tmp$ret$0 = 'debugHightlightView: ' + toString_0(viewToHightlight);
      this_0.i2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.l9k_1.w1v(viewToHightlight);
  }
  t9y(viewToHightlight, onlyIfDebuggerOpened, $super) {
    onlyIfDebuggerOpened = onlyIfDebuggerOpened === VOID ? false : onlyIfDebuggerOpened;
    var tmp;
    if ($super === VOID) {
      this.ebk(viewToHightlight, onlyIfDebuggerOpened);
      tmp = Unit_instance;
    } else {
      tmp = $super.ebk.call(this, viewToHightlight, onlyIfDebuggerOpened);
    }
    return tmp;
  }
  gcn(_set____db54di) {
    var this_0 = this.q9k_1;
    updatedSinceFrame$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  acn() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q9k_1;
    updatedSinceFrame$factory_1();
    return this_0.get();
  }
  t6e() {
    this.o9i_1.t6e();
  }
  lai(view) {
    this.o9i_1.b8j();
  }
  ox(value) {
    this.h9i_1.ox(value);
  }
  px() {
    return this.h9i_1.px();
  }
  a89(pos) {
    return this.s9i_1.a89(pos);
  }
  p88(value) {
    this.s9i_1.p88(value);
  }
  q88() {
    return this.s9i_1.q88();
  }
  r88(value) {
    this.s9i_1.r88(value);
  }
  s88() {
    return this.s9i_1.s88();
  }
  t88(value) {
    this.s9i_1.t88(value);
  }
  u88() {
    return this.s9i_1.u88();
  }
  v88(value) {
    this.s9i_1.v88(value);
  }
  w88() {
    return this.s9i_1.w88();
  }
  x88(value) {
    this.s9i_1.x88(value);
  }
  y88() {
    return this.s9i_1.y88();
  }
  z88() {
    return this.s9i_1.z88();
  }
  r8a() {
    return this.o9i_1.r8a();
  }
  s8a() {
    return this.o9i_1.s8a();
  }
  t8a() {
    return this.o9i_1.t8a();
  }
  c8a() {
    return this.o9i_1.c8a();
  }
}
class Companion_12 {}
class ViewsUpdateEvent extends Event {
  constructor(views, fastDelta) {
    fastDelta = fastDelta === VOID ? Companion_instance_1.q1u() : fastDelta;
    super();
    this.fcm_1 = views;
    this.gcm_1 = fastDelta;
  }
  hcm() {
    return toDuration_0(this.gcm_1);
  }
  m29() {
    return Companion_instance_27;
  }
  toString() {
    return 'ViewsUpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.gcm_1) + ')';
  }
}
class Companion_13 {}
class ViewsResizedEvent extends Event {
  constructor(views, size) {
    size = size === VOID ? SizeInt.j2g(0, 0) : size;
    super();
    this.ecn_1 = views;
    this.fcn_1 = size;
  }
  m29() {
    return Companion_instance_28;
  }
  toString() {
    return 'ViewsResizedEvent(size=' + this.fcn_1.toString() + ')';
  }
}
class Companion_14 {}
class Filter {}
function get_recommendedFilterScale() {
  return 1.0;
}
function computeBorder(texWidth, texHeight) {
  return Companion_getInstance_36().n28_1;
}
class ComposedFilter {
  static qco(filters, unit) {
    unit = unit === VOID ? Unit_instance : unit;
    var $this = createThis(this);
    $this.ncn_1 = filters;
    return $this;
  }
  static ocn() {
    // Inline function 'kotlin.collections.mutableListOf' call
    var tmp$ret$0 = ArrayList.h1();
    return this.pco(tmp$ret$0);
  }
  static pco(filters) {
    var tmp;
    if (filters instanceof FastArrayList) {
      tmp = filters;
    } else {
      tmp = FastArrayList.uy(filters);
    }
    return this.qco(tmp);
  }
  kco() {
    var out = 1.0;
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.ncn_1.ey_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.filter.ComposedFilter.<get-recommendedFilterScale>.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      out = out * array[_unary__edvuaz].kco();
    }
    return out;
  }
  lco(texWidth, texHeight) {
    var sumLeft = 0;
    var sumTop = 0;
    var sumRight = 0;
    var sumBottom = 0;
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.ncn_1.ey_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.filter.ComposedFilter.computeBorder.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var out = array[_unary__edvuaz].lco(texWidth, texHeight);
      sumLeft = sumLeft + out.r28_1 | 0;
      sumRight = sumRight + out.p28_1 | 0;
      sumTop = sumTop + out.o28_1 | 0;
      sumBottom = sumBottom + out.q28_1 | 0;
    }
    return MarginInt.s28(sumTop, sumRight, sumBottom, sumLeft);
  }
  l29() {
    return false;
  }
  mco(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    var mat = matrix;
    var tex = texture;
    var last = null;
    var texWidth_0 = texWidth;
    var texHeight_0 = texHeight;
    var filterScale_0 = filterScale;
    var resultPool = get_renderToTextureResultPool(ctx);
    if (!this.l29()) {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.ncn_1.ey_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.filter.ComposedFilter.render.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var filter = array[_unary__edvuaz];
        var result = resultPool.j2p();
        this.nco();
        renderToTextureWithBorderUnsafe(filter, ctx, mat, tex, texWidth_0, texHeight_0, filterScale_0, result);
        result.xcm();
        ctx.r81();
        resultPool.l2p(last);
        last = result;
        mat = result.xco_1;
        tex = ensureNotNull(result.acp_1);
        texWidth_0 = result.sco_1;
        texHeight_0 = result.tco_1;
      }
    }
    Companion_getInstance_60().mco(ctx, mat, tex, texWidth_0, texHeight_0, renderColorMul, blendMode, filterScale_0);
    resultPool.l2p(last);
  }
  nco() {
  }
}
class BlurFilter extends ComposedFilter {
  static mcn(radius, expandBorder, optimize) {
    radius = radius === VOID ? 4.0 : radius;
    expandBorder = expandBorder === VOID ? true : expandBorder;
    optimize = optimize === VOID ? true : optimize;
    var $this = this.ocn();
    $this.icn_1 = optimize;
    var tmp = $this;
    // Inline function 'kotlin.also' call
    var this_0 = new DirectionalBlurFilter(get_degrees(0), radius, expandBorder);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.filter.BlurFilter.horizontal.<anonymous>' call
    $this.ncn_1.h(this_0);
    tmp.jcn_1 = this_0;
    var tmp_0 = $this;
    // Inline function 'kotlin.also' call
    var this_1 = new DirectionalBlurFilter(get_degrees(90), radius, expandBorder);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.filter.BlurFilter.vertical.<anonymous>' call
    $this.ncn_1.h(this_1);
    tmp_0.kcn_1 = this_1;
    $this.lcn_1 = radius;
    return $this;
  }
  pcn(value) {
    this.jcn_1.pcn(value);
    this.kcn_1.pcn(value);
  }
  xcn() {
    return this.jcn_1.xcn();
  }
  ycn(value) {
    this.lcn_1 = value;
    this.jcn_1.hco_1 = this.lcn_1;
    this.kcn_1.hco_1 = this.lcn_1;
  }
  kco() {
    var tmp;
    if (!this.icn_1 || this.lcn_1 <= 2.0) {
      tmp = 1.0;
    } else {
      // Inline function 'kotlin.math.log2' call
      var x = this.lcn_1 * 0.5;
      tmp = 1.0 / log2(x);
    }
    return tmp;
  }
  l29() {
    return this.lcn_1 === 0.0;
  }
}
class Companion_15 {
  oco(left, right) {
    var tmp;
    if (left == null) {
      tmp = right.g1() ? null : right.e1() === 1 ? first(right) : ComposedFilter.pco(right);
    } else {
      if (left instanceof ComposedFilter) {
        tmp = ComposedFilter.pco(plus(left.ncn_1, right));
      } else {
        tmp = ComposedFilter.pco(plus(listOf(left), right));
      }
    }
    return tmp;
  }
}
class BlurUB extends UniformBlock {
  constructor() {
    BlurUB_instance = null;
    super(5);
    BlurUB_instance = this;
    this.hcp_1 = this.n6t().f6t(this, u_radius$factory());
    this.icp_1 = this.n6t().f6t(this, u_constant1$factory());
    this.jcp_1 = this.n6t().f6t(this, u_constant2$factory());
    this.kcp_1 = this.p6t().f6t(this, u_direction$factory());
  }
  lcp() {
    return this.hcp_1.ho(this, u_radius$factory_0());
  }
  mcp() {
    return this.icp_1.ho(this, u_constant1$factory_0());
  }
  ncp() {
    return this.jcp_1.ho(this, u_constant2$factory_0());
  }
  ocp() {
    return this.kcp_1.ho(this, u_direction$factory_0());
  }
}
class BaseProgramProvider {
  constructor() {
    Companion_getInstance_61();
    this.gcq_1 = Companion_getInstance_6().p86_1.d6m_1;
    this.hcq_1 = Companion_getInstance_62().ycp_1;
    var tmp = this;
    tmp.icq_1 = lazy(ShaderFilter$BaseProgramProvider$_program$delegate$lambda(this));
  }
  jcq(vertex, fragment) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.graphics.shader.appending' call
      if (fragment.x7j()) {
        tmp$ret$0 = fragment;
        break $l$block;
      }
      // Inline function 'kotlin.also' call
      var this_0 = ProgramBuilderDefault.o6v().c6x(fragment);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.filter.BaseProgramProvider.createProgram.<anonymous>' call
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this_0.o6y(this_0.c6w(this_0.w6v(), 'a'), this_0.z6v(0.0));
      var body = this_0.k6w();
      // Inline function 'korlibs.korge.view.filter.BaseProgramProvider.createProgram.<anonymous>.<anonymous>' call
      body.e6x();
      var stmIf = new If(cond, body.m6w());
      // Inline function 'kotlin.collections.plusAssign' call
      this_0.s6v_1.h(stmIf);
      var pair = this_0.b6w();
      tmp$ret$0 = new Shader(fragment.a7c_1, pair.bl_1, pair.cl_1);
    }
    return new Program(vertex, tmp$ret$0);
  }
  kcq() {
    return this.gcq_1;
  }
  fcq() {
    return this.hcq_1;
  }
  lcq() {
    return _get__program__9g4ap2(this);
  }
}
class Companion_16 extends BaseProgramProvider {
  constructor() {
    Companion_instance_31 = null;
    super();
    Companion_instance_31 = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.o6v();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.filter.Companion.fragment.<anonymous>' call
    var loopLen = this_0.i6x(this_0.j6x());
    var gaussianResult = this_0.i6x(this_0.k6x());
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_0.m6y(BlurUB_getInstance().lcp(), this_0.z6v(1.0));
    var body = this_0.k6w();
    // Inline function 'korlibs.korge.view.filter.Companion.fragment.<anonymous>.<anonymous>' call
    body.t6v(body.w6v(), body.e6w(this_0.d6w(), Companion_getInstance_62().zcp(body)));
    var stmIf = new If(cond, body.m6w());
    // Inline function 'kotlin.collections.plusAssign' call
    this_0.s6v_1.h(stmIf);
    var tmp_0 = stmIf;
    this_0.z6w(tmp_0, DirectionalBlurFilter$Companion$fragment$lambda(loopLen, gaussianResult, this_0));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.filter.Companion.fragment.<anonymous>' call
    tmp.ecq_1 = FragmentShader(this_0.b6w());
  }
  fcq() {
    return this.ecq_1;
  }
}
class ShaderFilter {
  constructor() {
    Companion_getInstance_62();
    this.qcn_1 = true;
    this.rcn_1 = Vector2D.w27();
    this.scn_1 = Vector2D.w27();
    this.tcn_1 = Vector2D.w27();
    this.ucn_1 = Companion_getInstance_61();
    this.vcn_1 = AGTextureUnits.a6i();
    this.wcn_1 = 0;
  }
  pcn(_set____db54di) {
    this.qcn_1 = _set____db54di;
  }
  xcn() {
    return this.qcn_1;
  }
  lco(texWidth, texHeight) {
    return Companion_getInstance_36().n28_1;
  }
  ncq() {
    return this.ucn_1;
  }
  mcq(ctx, filterScale) {
  }
  l29() {
    return false;
  }
  mco(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    if (this.l29())
      return Companion_getInstance_60().mco(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale);
    var _margin = getBorder(this, texWidth, texHeight);
    var marginLeft = toIntCeil(_margin.r28_1 * filterScale);
    var marginRight = toIntCeil(_margin.p28_1 * filterScale);
    var marginTop = toIntCeil(_margin.o28_1 * filterScale);
    var marginBottom = toIntCeil(_margin.q28_1 * filterScale);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.d80_1;
    var this_1 = this_0.m80_1;
    if (!(this_1.h80_1 === this_0)) {
      this_1.h80_1 = this_0;
      this_1.r81();
    }
    var slice = texture.k3g(-marginLeft | 0, -marginTop | 0, texture.e3f_1 + marginRight | 0, texture.f3f_1 + marginBottom | 0, VOID, false);
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.temporalTextureUnit' call
      var sampler = DefaultShaders_getInstance().d6w();
      var tex = slice.v3e_1.n84_1;
      var info = Companion_getInstance_17().g6i_1;
      var oldTex = this_0.m80_1.o7z_1.y6h_1[sampler.t6i_1];
      var oldInfo = AGTextureUnitInfoArray__get_impl_xhvpef(this_0.m80_1.o7z_1.z6h_1, sampler.t6i_1);
      this_0.m80_1.o7z_1.h6i(sampler, tex, info);
      try {
        _updateUniforms(this, ctx, filterScale, texture, texWidth, texHeight);
        this_0.t81(slice, -marginLeft, -marginTop, VOID, VOID, matrix, this.xcn(), renderColorMul, blendMode, this.ncq().lcq());
        break $l$block;
      }finally {
        this_0.x86();
        this_0.m80_1.o7z_1.h6i(sampler, oldTex, oldInfo);
      }
    }
    _restoreUniforms(this, ctx, filterScale);
  }
}
class DirectionalBlurFilter extends ShaderFilter {
  constructor(angle, radius, expandBorder) {
    Companion_getInstance_57();
    angle = angle === VOID ? get_degrees(0) : angle;
    radius = radius === VOID ? 4.0 : radius;
    expandBorder = expandBorder === VOID ? true : expandBorder;
    super();
    this.gco_1 = angle;
    this.hco_1 = radius;
    this.ico_1 = expandBorder;
    var tmp = this;
    // Inline function 'kotlin.math.sqrt' call
    // Inline function 'kotlin.math.ln' call
    var x = 2 * Math.log(255.0);
    tmp.jco_1 = Math.sqrt(x);
  }
  lco(texWidth, texHeight) {
    if (!this.ico_1)
      return Companion_getInstance_36().n28_1;
    var radius = _get_rradius__1gjegj(this);
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = _Angle___get_sine__impl__15nmyi(this.gco_1);
    var tmp$ret$0 = Math.abs(this_0);
    var tmp = toIntCeil(tmp$ret$0 * radius);
    // Inline function 'kotlin.math.absoluteValue' call
    var this_1 = _Angle___get_cosine__impl__vprvmu(this.gco_1);
    var tmp$ret$1 = Math.abs(this_1);
    return MarginInt.t28(tmp, toIntCeil(tmp$ret$1 * radius));
  }
  mcq(ctx, filterScale) {
    var radius = _get_rradius__1gjegj(this) * filterScale;
    var sigma = (radius + 1) / this.jco_1;
    // Inline function 'kotlin.math.sqrt' call
    var x = 2.0 * 3.141592653589793;
    var constant1 = 1.0 / (sigma * Math.sqrt(x));
    var constant2 = 1.0 / (2.0 * sigma * sigma);
    var scaleSum = 0.0;
    if (isFinite(radius)) {
      var inductionVariable = 0;
      var last = toIntCeil_0(radius);
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var gauss = gaussian(this, n, constant1, constant2);
          scaleSum = scaleSum + (!(n === 0) ? gauss * 2 : gauss);
        }
         while (inductionVariable < last);
    }
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_0 = ctx.t6l(BlurUB_getInstance());
      var _unary__edvuaz = this_0.i6n();
      this_0.x7a(_unary__edvuaz + 1 | 0);
      this_0.y7a(this_0.i6n() + 1 | 0);
      var blockSize = this_0.m6l_1;
      var index0 = imul(this_0.i6n() - 1 | 0, blockSize);
      var index1 = imul(this_0.i6n(), blockSize);
      var texBlockSize = this_0.j6l_1.i6t().e1();
      var texIndex0 = imul(this_0.i6n() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_0.i6n(), texBlockSize);
      if (this_0.i6n() > 0) {
        arraycopy(this_0.o6l_1, index0, this_0.o6l_1, index1, blockSize);
      } else {
        arrayfill(this_0.o6l_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.view.filter.DirectionalBlurFilter.updateUniforms.<anonymous>' call
      var $this$push = this_0.j6l_1;
      var it = this_0.p6l_1;
      it.d7b($this$push.lcp(), radius);
      it.d7b($this$push.mcp(), constant1 * (1.0 / scaleSum));
      it.d7b($this$push.ncp(), constant2);
      it.g7b($this$push.ocp(), Vector2D.s24(_Angle___get_cosine__impl__vprvmu(this.gco_1), _Angle___get_sine__impl__15nmyi(this.gco_1)));
      if (true && this_0.i6n() >= 1) {
        var equals = arrayequal(this_0.o6l_1, index0, this_0.o6l_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_0.i6n();
          this_0.x7a(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
  }
  ncq() {
    return Companion_getInstance_57();
  }
  l29() {
    return this.hco_1 === 0.0;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_32 = this;
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.replacingFragment' call
    var this_0 = Companion_getInstance_6().p86_1;
    var extraName = 'nontransparentiswhite';
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder = ProgramBuilderDefault.o6v();
    // Inline function 'korlibs.korge.view.filter.Companion.NON_TRANSPARENT_IS_WHITE.<anonymous>' call
    Companion_getInstance_6().w86(builder);
    builder.t6v(builder.w6v(), builder.h6y(builder.w6v(), builder.z6x(new Float32Array([1.0, 1.0, 1.0, 0.0]))));
    builder.t6v(builder.w6v(), builder.x6v(builder.w6v(), Companion_getInstance_6().v86()));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = builder.o6y(builder.c6w(builder.w6v(), 'a'), builder.z6v(0.0));
    var body = builder.k6w();
    // Inline function 'korlibs.korge.view.filter.Companion.NON_TRANSPARENT_IS_WHITE.<anonymous>.<anonymous>' call
    body.e6x();
    var stmIf = new If(cond, body.m6w());
    // Inline function 'kotlin.collections.plusAssign' call
    builder.s6v_1.h(stmIf);
    var tmp$ret$1 = FragmentShader(builder.b6w());
    tmp.ocq_1 = this_0.w7j(VOID, tmp$ret$1, this_0.f6m_1 + '-' + extraName);
  }
}
class DropshadowFilter {
  constructor(dropX, dropY, shadowColor, blurRadius, smoothing) {
    Companion_getInstance_58();
    dropX = dropX === VOID ? 10.0 : dropX;
    dropY = dropY === VOID ? 10.0 : dropY;
    shadowColor = shadowColor === VOID ? RGBA__withAd_impl_cralao(Colors_getInstance().b3y_1, 0.75) : shadowColor;
    blurRadius = blurRadius === VOID ? 4.0 : blurRadius;
    smoothing = smoothing === VOID ? true : smoothing;
    this.pcq_1 = dropX;
    this.qcq_1 = dropY;
    this.rcq_1 = shadowColor;
    this.scq_1 = blurRadius;
    this.tcq_1 = smoothing;
    this.ucq_1 = BlurFilter.mcn(16.0);
    this.vcq_1 = filtering$factory(this.ucq_1);
  }
  lco(texWidth, texHeight) {
    var out = this.ucq_1.lco(texWidth, texHeight);
    var top = out.o28_1;
    var right = out.p28_1;
    var bottom = out.q28_1;
    var left = out.r28_1;
    if (this.pcq_1 >= 0.0)
      right = right + toIntCeil(this.pcq_1) | 0;
    else
      left = left - toIntCeil(this.pcq_1) | 0;
    if (this.qcq_1 >= 0.0)
      bottom = bottom + toIntCeil(this.qcq_1) | 0;
    else
      top = top - toIntCeil(this.qcq_1) | 0;
    return MarginInt.s28(top, right, bottom, left);
  }
  mco(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    this.ucq_1.ycn(this.scq_1);
    renderToTextureWithBorder(this.ucq_1, ctx, matrix, texture, texWidth, texHeight, filterScale, DropshadowFilter$render$lambda(ctx, this, filterScale, blendMode));
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.d80_1;
    var this_1 = this_0.m80_1;
    if (!(this_1.h80_1 === this_0)) {
      this_1.h80_1 = this_0;
      this_1.r81();
    }
    this_0.t81(texture, VOID, VOID, VOID, VOID, matrix, this.tcq_1, renderColorMul, blendMode, Companion_getInstance_6().p86_1);
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_33 = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.wcq_1 = new Float64Array([0.03125, 0.0625, 0.125, 0.25, 0.5, 0.75, 1.0]);
  }
  xcq(scale) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var this_0 = this.wcq_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var minElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block_0;
      }
      // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_1 = scale - minElem;
      var minValue = Math.abs(this_1);
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
          // Inline function 'kotlin.math.absoluteValue' call
          var this_2 = scale - e;
          var v = Math.abs(this_2);
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    return ensureNotNull(tmp$ret$1);
  }
}
class RenderToTextureResult {
  constructor() {
    this.rco_1 = null;
    this.sco_1 = 0;
    this.tco_1 = 0;
    this.uco_1 = 0;
    this.vco_1 = 0;
    this.wco_1 = 1.0;
    this.xco_1 = Companion_getInstance_33().w28_1;
    this.yco_1 = null;
    this.zco_1 = null;
    this.acp_1 = null;
    this.bcp_1 = null;
  }
  xcm() {
    var tmp0_elvis_lhs = this.zco_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var fb = tmp;
    var tmp1_elvis_lhs = this.bcp_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var ctx = tmp_0;
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.o8a(fb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.d80_1;
      var this_1 = this_0.m80_1;
      if (!(this_1.h80_1 === this_0)) {
        this_1.h80_1 = this_0;
        this_1.r81();
      }
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var scissor = AGScissor.h6p(0, 0, fb.i6e_1, fb.j6e_1);
        var temp = this_0.k81_1;
        this_0.t87();
        this_0.k81_1 = scissor;
        try {
          if (true) {
            ctx.h8a(Colors_getInstance().f3y_1);
          }
          // Inline function 'korlibs.korge.view.filter.RenderToTextureResult.render.<anonymous>' call
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          var this_2 = ctx.d80_1;
          var matrix = Companion_getInstance_33().w28_1;
          var this_3 = this_2.m80_1;
          this_3.r81();
          var temp4 = this_3.s7z_1;
          var temp2d = this_3.t7z_1;
          this_3.t7z_1 = matrix;
          this_3.s7z_1 = toMatrix4(matrix);
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var this_4 = this_3.t6l(ProjViewUB_getInstance());
            var _unary__edvuaz = this_4.i6n();
            this_4.x7a(_unary__edvuaz + 1 | 0);
            this_4.y7a(this_4.i6n() + 1 | 0);
            var blockSize = this_4.m6l_1;
            var index0 = imul(this_4.i6n() - 1 | 0, blockSize);
            var index1 = imul(this_4.i6n(), blockSize);
            var texBlockSize = this_4.j6l_1.i6t().e1();
            var texIndex0 = imul(this_4.i6n() - 1 | 0, texBlockSize);
            var texIndex1 = imul(this_4.i6n(), texBlockSize);
            if (this_4.i6n() > 0) {
              arraycopy(this_4.o6l_1, index0, this_4.o6l_1, index1, blockSize);
            } else {
              arrayfill(this_4.o6l_1, 0, 0, blockSize);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
            var $this$push = this_4.j6l_1;
            this_4.p6l_1.l7b($this$push.h6t(), this_3.s7z_1);
            if (true && this_4.i6n() >= 1) {
              var equals = arrayequal(this_4.o6l_1, index0, this_4.o6l_1, index1, blockSize);
              if (equals) {
                var _unary__edvuaz_0 = this_4.i6n();
                this_4.x7a(_unary__edvuaz_0 - 1 | 0);
                break $l$block;
              }
            }
          }
          var tmp_1;
          try {
            var tmp0_safe_receiver = this.yco_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              var tmp0_safe_receiver_0 = this.rco_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.mco(ctx, Companion_getInstance_33().w28_1.b2a(this.uco_1, this.vco_1), tmp0_safe_receiver, this.sco_1, this.tco_1, Colors_getInstance().a3y_1, Companion_getInstance_13().k7y_1, this.wco_1);
              }
            }
            tmp_1 = Unit_instance;
          }finally {
            this_3.r81();
            this_3.s7z_1 = temp4;
            this_3.t7z_1 = temp2d;
            this_3.t6l(ProjViewUB_getInstance()).z7a();
          }
          break $l$block_0;
        }finally {
          this_0.t87();
          this_0.k81_1 = temp;
        }
      }
    }finally {
      ctx.p8a();
    }
    this.acp_1 = Texture_0(fb).m3g(0, 0, this.sco_1, this.tco_1);
  }
  a18() {
    if (this.zco_1 == null || this.bcp_1 == null)
      return Unit_instance;
    var tmp0_safe_receiver = this.zco_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.filter.RenderToTextureResult.dispose.<anonymous>' call
      var tmp0_safe_receiver_0 = this.bcp_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver_0.n8a(tmp0_safe_receiver);
        tmp = Unit_instance;
      }
    }
    this.rco_1 = null;
    this.yco_1 = null;
    this.zco_1 = null;
    this.bcp_1 = null;
    this.acp_1 = null;
  }
}
class IdentityFilter {
  constructor(smoothing) {
    Companion_getInstance_60();
    this.ccp_1 = smoothing;
  }
  mco(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.d80_1;
    var this_1 = this_0.m80_1;
    if (!(this_1.h80_1 === this_0)) {
      this_1.h80_1 = this_0;
      this_1.r81();
    }
    this_0.t81(texture, VOID, VOID, VOID, VOID, matrix, this.ccp_1, renderColorMul, blendMode, Companion_getInstance_6().p86_1);
  }
}
class Companion_19 extends IdentityFilter {
  constructor() {
    Companion_instance_34 = null;
    super(true);
    Companion_instance_34 = this;
  }
}
class Linear extends IdentityFilter {
  constructor() {
    Linear_instance = null;
    super(true);
    Linear_instance = this;
  }
}
class Nearest extends IdentityFilter {
  constructor() {
    Nearest_instance = null;
    super(false);
    Nearest_instance = this;
  }
}
class Companion_20 extends BaseProgramProvider {
  constructor() {
    Companion_instance_35 = null;
    super();
    Companion_instance_35 = this;
  }
}
class TexInfoUB extends UniformBlock {
  constructor() {
    TexInfoUB_instance = null;
    super(4);
    TexInfoUB_instance = this;
    this.tcp_1 = this.p6t().f6t(this, u_TextureSize$factory());
    this.ucp_1 = this.p6t().f6t(this, u_MaxTexCoords$factory());
    this.vcp_1 = this.p6t().f6t(this, u_StdTexDerivates$factory());
    this.wcp_1 = this.n6t().f6t(this, u_filterScale$factory());
  }
  ycq() {
    return this.tcp_1.ho(this, u_TextureSize$factory_0());
  }
  zcq() {
    return this.ucp_1.ho(this, u_MaxTexCoords$factory_0());
  }
  xcp() {
    return this.vcp_1.ho(this, u_StdTexDerivates$factory_0());
  }
  acr() {
    return this.wcp_1.ho(this, u_filterScale$factory_0());
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_36 = this;
    this.ycp_1 = Companion_getInstance_6().p86_1.e6m_1;
  }
  zcp(_this__u8e3s4) {
    return _this__u8e3s4.c6w(DefaultShaders_getInstance().j6r_1, 'xy');
  }
  acq(_this__u8e3s4, sampler, coords, check) {
    var tmp;
    if (check) {
      tmp = _this__u8e3s4.n6x(_this__u8e3s4.s6y(_this__u8e3s4.t6y(_this__u8e3s4.a6y(coords), _this__u8e3s4.z6v(0.0), _this__u8e3s4.z6v(1.0)), _this__u8e3s4.t6y(_this__u8e3s4.b6y(coords), _this__u8e3s4.z6v(0.0), _this__u8e3s4.z6v(1.0))), _this__u8e3s4.e6w(sampler, coords), _this__u8e3s4.a6w([_this__u8e3s4.z6v(0.0)]));
    } else {
      tmp = _this__u8e3s4.e6w(sampler, coords);
    }
    return tmp;
  }
}
class ViewRenderPhaseBackdropFilter {}
class Companion_22 {
  constructor() {
    this.dcr_1 = -200;
  }
}
class ViewRenderPhaseFilter {
  constructor(filter) {
    filter = filter === VOID ? null : filter;
    this.ccr_1 = filter;
  }
  zcl() {
    return -200;
  }
  ccm(view, ctx) {
    if (!(this.ccr_1 == null)) {
      renderFiltered(view, ctx, ensureNotNull(this.ccr_1), false);
    } else {
      render_0.call(this, view, ctx);
    }
  }
}
class PointsResult {
  constructor(bounds, vertexCount, vertexStart, vertexEnd) {
    this.ocs_1 = bounds;
    this.pcs_1 = vertexCount;
    this.qcs_1 = vertexStart;
    this.rcs_1 = vertexEnd;
  }
}
class GpuShapeView extends View {
  static hce(shape, antialiased, autoScaling) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    antialiased = antialiased === VOID ? true : antialiased;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    var $this = this.ic8();
    $this.icd_1 = autoScaling;
    $this.jcd_1 = true;
    $this.kcd_1 = true;
    $this.lcd_1 = true;
    $this.mcd_1 = new GpuShapeViewCommands();
    $this.ncd_1 = 1000;
    $this.ocd_1 = 1000;
    $this.pcd_1 = Companion_getInstance_27().b24_1;
    $this.qcd_1 = true;
    $this.rcd_1 = false;
    $this.scd_1 = antialiased;
    $this.tcd_1 = shape;
    $this.ucd_1 = false;
    $this.vcd_1 = false;
    $this.wcd_1 = false;
    $this.xcd_1 = 0;
    $this.ycd_1 = Companion_getInstance_32().z28();
    $this.zcd_1 = Companion_getInstance_32().z28();
    $this.ace_1 = false;
    $this.bce_1 = 1.0;
    $this.cce_1 = NaN;
    $this.dce_1 = Companion_getInstance_33().z28();
    $this.ece_1 = 100000;
    $this.fce_1 = false;
    $this.gce_1 = 10000.0;
    invalidateShape($this);
    return $this;
  }
  qbk(value) {
    this.pcd_1 = value;
    this.nai();
  }
  jbz() {
    return this.pcd_1;
  }
  jce(value) {
    this.scd_1 = value;
    invalidateShape(this);
  }
  ice(value) {
    this.tcd_1 = value;
    invalidateShape(this);
  }
  haj() {
    return _get_shapeBounds__actvvf(this).o25_1 * this.jbz().k24_1;
  }
  iaj() {
    return _get_shapeBounds__actvvf(this).p25_1 * this.jbz().l24_1;
  }
  nai() {
    super.nai();
    invalidateShape(this);
  }
  raf() {
    return new Rectangle(_get_shapeBounds__actvvf(this).m25_1 - this.haj(), _get_shapeBounds__actvvf(this).n25_1 - this.iaj(), _get_shapeBounds__actvvf(this).o25_1, _get_shapeBounds__actvvf(this).p25_1);
  }
  tcs(_this__u8e3s4) {
    var tmp;
    if (equals(_this__u8e3s4, EmptyShape_instance)) {
      tmp = false;
    } else {
      if (_this__u8e3s4 instanceof CompoundShape) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var this_0 = _this__u8e3s4.x5y_1;
          var tmp_0;
          if (isInterface(this_0, Collection)) {
            tmp_0 = this_0.g1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator = this_0.a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            // Inline function 'korlibs.korge.view.vector.GpuShapeView.<get-requireStencil>.<anonymous>' call
            if (this.tcs(element)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      } else {
        if (_this__u8e3s4 instanceof TextShape) {
          tmp = this.tcs(_this__u8e3s4.q5z());
        } else {
          if (_this__u8e3s4 instanceof FillShape) {
            tmp = !_this__u8e3s4.v5y();
          } else {
            if (_this__u8e3s4 instanceof PolylineShape) {
              tmp = false;
            } else {
              tmp = true;
            }
          }
        }
      }
    }
    return tmp;
  }
  uaf(ctx) {
    this.bce_1 = this.u9y().k2a().i2b() * ctx.g7z_1.z88();
    if (!(this.cce_1 === this.bce_1)) {
      invalidateShape(this);
    }
    ctx.r81();
    var doRequireTexture = this.tcs(this.tcd_1);
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.bj();
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>' call
    if (doRequireTexture) {
      var currentFrameBuffer = ctx.f7z_1.p6e();
      this.ncd_1 = currentFrameBuffer.i6e_1;
      this.ocd_1 = currentFrameBuffer.j6e_1;
      // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
      var width = this.ncd_1;
      var height = this.ocd_1;
      ctx.r81();
      // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
      var rb = ctx.m8a(width, height, false, true, 1);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
        // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
        ctx.o8a(rb);
        try {
          // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
          // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
          // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
          var this_0 = ctx.d80_1;
          var this_1 = this_0.m80_1;
          if (!(this_1.h80_1 === this_0)) {
            this_1.h80_1 = this_0;
            this_1.r81();
          }
          $l$block: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var scissor = AGScissor.h6p(0, 0, rb.i6e_1, rb.j6e_1);
            var temp = this_0.k81_1;
            this_0.t87();
            this_0.k81_1 = scissor;
            try {
              if (true) {
                ctx.h8a(Colors_getInstance().f3y_1);
              }
              renderCommands(this, ctx, doRequireTexture);
              break $l$block;
            }finally {
              this_0.t87();
              this_0.k81_1 = temp;
            }
          }
        }finally {
          ctx.p8a();
        }
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>.<anonymous>' call
        var texture = Texture_0(rb).m3g(0, 0, width, height);
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_2 = ctx.d80_1;
        var this_3 = this_2.m80_1;
        if (!(this_3.h80_1 === this_2)) {
          this_3.h80_1 = this_2;
          this_3.r81();
        }
        this_2.t81(texture, VOID, VOID, VOID, VOID, get_immutable(ctx.g7z_1.q88()));
        ctx.r81();
      }finally {
        ctx.n8a(rb);
      }
    } else {
      renderCommands(this, ctx, doRequireTexture);
    }
    var time = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
  }
}
class ScissorCommand {
  constructor(scissor) {
    this.ucs_1 = scissor;
  }
  toString() {
    return 'ScissorCommand(scissor=' + this.ucs_1.toString() + ')';
  }
  hashCode() {
    return this.ucs_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScissorCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ScissorCommand ? other : THROW_CCE();
    if (!this.ucs_1.equals(tmp0_other_with_cast.ucs_1))
      return false;
    return true;
  }
}
class ClearCommand {
  constructor(i) {
    this.vcs_1 = i;
  }
  toString() {
    return 'ClearCommand(i=' + this.vcs_1 + ')';
  }
  hashCode() {
    return this.vcs_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClearCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ClearCommand ? other : THROW_CCE();
    if (!(this.vcs_1 === tmp0_other_with_cast.vcs_1))
      return false;
    return true;
  }
}
class ShapeCommand {
  constructor(drawType, vertexIndex, vertexEnd, paintShader, program, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace) {
    drawType = drawType === VOID ? Companion_getInstance_18().b6o_1 : drawType;
    vertexIndex = vertexIndex === VOID ? 0 : vertexIndex;
    vertexEnd = vertexEnd === VOID ? 0 : vertexEnd;
    program = program === VOID ? null : program;
    colorMask = colorMask === VOID ? Companion_getInstance_24().s6f_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_19().p6f_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_20().n6f_1 : stencilRef;
    blendMode = blendMode === VOID ? null : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_23().d6g_1 : cullFace;
    this.wcs_1 = drawType;
    this.xcs_1 = vertexIndex;
    this.ycs_1 = vertexEnd;
    this.zcs_1 = paintShader;
    this.act_1 = program;
    this.bct_1 = colorMask;
    this.cct_1 = stencilOpFunc;
    this.dct_1 = stencilRef;
    this.ect_1 = blendMode;
    this.fct_1 = cullFace;
  }
  b87() {
    return this.ycs_1 - this.xcs_1 | 0;
  }
  toString() {
    return 'ShapeCommand(drawType=' + AGDrawType__toString_impl_eonaeb(this.wcs_1) + ', vertexIndex=' + this.xcs_1 + ', vertexEnd=' + this.ycs_1 + ', paintShader=' + toString_0(this.zcs_1) + ', program=' + toString_0(this.act_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.bct_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.cct_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.dct_1) + ', blendMode=' + toString_0(this.ect_1) + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.fct_1) + ')';
  }
  hashCode() {
    var result = AGDrawType__hashCode_impl_ylaury(this.wcs_1);
    result = imul(result, 31) + this.xcs_1 | 0;
    result = imul(result, 31) + this.ycs_1 | 0;
    result = imul(result, 31) + (this.zcs_1 == null ? 0 : this.zcs_1.hashCode()) | 0;
    result = imul(result, 31) + (this.act_1 == null ? 0 : this.act_1.hashCode()) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.bct_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.cct_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.dct_1) | 0;
    result = imul(result, 31) + (this.ect_1 == null ? 0 : this.ect_1.hashCode()) | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.fct_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShapeCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ShapeCommand ? other : THROW_CCE();
    if (!(this.wcs_1 === tmp0_other_with_cast.wcs_1))
      return false;
    if (!(this.xcs_1 === tmp0_other_with_cast.xcs_1))
      return false;
    if (!(this.ycs_1 === tmp0_other_with_cast.ycs_1))
      return false;
    if (!equals(this.zcs_1, tmp0_other_with_cast.zcs_1))
      return false;
    if (!equals(this.act_1, tmp0_other_with_cast.act_1))
      return false;
    if (!(this.bct_1 === tmp0_other_with_cast.bct_1))
      return false;
    if (!(this.cct_1 === tmp0_other_with_cast.cct_1))
      return false;
    if (!equals(this.dct_1, tmp0_other_with_cast.dct_1))
      return false;
    if (!equals(this.ect_1, tmp0_other_with_cast.ect_1))
      return false;
    if (!(this.fct_1 === tmp0_other_with_cast.fct_1))
      return false;
    return true;
  }
}
class GpuShapeViewCommands {
  constructor() {
    this.ecr_1 = 0;
    this.fcr_1 = floatArrayListOf(new Float32Array([]));
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.gcr_1 = ArrayList.h1();
    this.hcr_1 = null;
    this.icr_1 = FastArrayList.gy();
    this.jcr_1 = 0;
    this.kcr_1 = 0;
    this.lcr_1 = MatrixTransform.g2b();
    this.mcr_1 = FastArrayList.gy();
    this.ncr_1 = AGTextureUnits.a6i();
  }
  f3() {
    this.ecr_1 = 0;
    this.fcr_1.f3();
    this.gcr_1.f3();
  }
  scr(x, y, len, maxLen) {
    var tmp;
    if (maxLen <= 0.0) {
      var _unary__edvuaz = this.jcr_1;
      this.jcr_1 = _unary__edvuaz + 1 | 0;
      tmp = _unary__edvuaz <= 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      println('Invalid maxLen=' + maxLen);
    }
    this.fcr_1.i2j(x, y, len, maxLen);
    var _unary__edvuaz_0 = this.ecr_1;
    this.ecr_1 = _unary__edvuaz_0 + 1 | 0;
    return _unary__edvuaz_0;
  }
  rcr() {
    this.kcr_1 = this.ecr_1;
    return this.kcr_1;
  }
  tcr() {
    return this.ecr_1;
  }
  scs(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.gcr_1;
    var element = new ShapeCommand(drawType, startIndex, endIndex, paintShader, VOID, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace);
    this_0.h(element);
  }
  ncs(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex, $super) {
    colorMask = colorMask === VOID ? Companion_getInstance_24().s6f_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_19().p6f_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_20().n6f_1 : stencilRef;
    blendMode = blendMode === VOID ? Companion_getInstance_13().k7y_1 : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_23().d6g_1 : cullFace;
    startIndex = startIndex === VOID ? this.kcr_1 : startIndex;
    endIndex = endIndex === VOID ? this.ecr_1 : endIndex;
    var tmp;
    if ($super === VOID) {
      this.scs(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.scs.call(this, new AGDrawType(drawType), paintShader, new AGColorMask(colorMask), new AGStencilOpFunc(stencilOpFunc), new AGStencilReference(stencilRef), blendMode, new AGCullFace(cullFace), startIndex, endIndex);
    }
    return tmp;
  }
  l75(i) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.gcr_1;
    var element = new ClearCommand(i);
    this_0.h(element);
  }
  ocr(i, $super) {
    i = i === VOID ? 0 : i;
    var tmp;
    if ($super === VOID) {
      this.l75(i);
      tmp = Unit_instance;
    } else {
      tmp = $super.l75.call(this, i);
    }
    return tmp;
  }
  pcr(scissor) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.gcr_1;
    var element = new ScissorCommand(scissor);
    this_0.h(element);
  }
  r6e() {
    var tmp0_safe_receiver = this.hcr_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.icr_1.h(tmp0_safe_receiver);
    }
    this.hcr_1 = new AgCachedBuffer(_Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(this.fcr_1.n2j())));
  }
  qcr(ctx, globalMatrix, localMatrix, applyScissor, colorMul, doRequireTexture) {
    var tmp0_elvis_lhs = this.hcr_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var vertices = tmp;
    ctx.z7z_1.f86(this.icr_1);
    this.icr_1.f3();
    ctx.r81();
    var ag = ctx.f7z_1;
    var vao = AGVertexArrayObject.m6n(fastArrayListOf([new AGVertexData(GpuShapeViewPrograms_getInstance().dcs_1, ctx.c86(vertices))]), true);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.d80_1;
    var this_1 = this_0.m80_1;
    if (!(this_1.h80_1 === this_0)) {
      this_1.h80_1 = this_0;
      this_1.r81();
    }
    this_0.d88();
    var tempMat = (doRequireTexture ? Companion_getInstance_33().w28_1 : this_0.z86()).i2a(globalMatrix);
    // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
    var this_2 = this_0.m80_1;
    this_2.r81();
    var temp4 = this_2.s7z_1;
    var temp2d = this_2.t7z_1;
    this_2.t7z_1 = tempMat;
    this_2.s7z_1 = toMatrix4(tempMat);
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_3 = this_2.t6l(ProjViewUB_getInstance());
      var _unary__edvuaz = this_3.i6n();
      this_3.x7a(_unary__edvuaz + 1 | 0);
      this_3.y7a(this_3.i6n() + 1 | 0);
      var blockSize = this_3.m6l_1;
      var index0 = imul(this_3.i6n() - 1 | 0, blockSize);
      var index1 = imul(this_3.i6n(), blockSize);
      var texBlockSize = this_3.j6l_1.i6t().e1();
      var texIndex0 = imul(this_3.i6n() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_3.i6n(), texBlockSize);
      if (this_3.i6n() > 0) {
        arraycopy(this_3.o6l_1, index0, this_3.o6l_1, index1, blockSize);
      } else {
        arrayfill(this_3.o6l_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
      var $this$push = this_3.j6l_1;
      this_3.p6l_1.l7b($this$push.h6t(), this_2.s7z_1);
      if (true && this_3.i6n() >= 1) {
        var equals = arrayequal(this_3.o6l_1, index0, this_3.o6l_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_3.i6n();
          this_3.x7a(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    var tmp_0;
    try {
      this.lcr_1 = globalMatrix.k2a();
      var program = GpuShapeViewPrograms_getInstance().kcs_1;
      var scissor = Companion_getInstance_15().b6g_1;
      var this_4 = this.gcr_1;
      var n = 0;
      while (n < this_4.e1()) {
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var cmd = this_4.d1(_unary__edvuaz_1);
        if (cmd instanceof ScissorCommand) {
          scissor = cmd.ucs_1;
        } else {
          if (cmd instanceof ClearCommand) {
            var tmp1_stencil = cmd.vcs_1;
            ctx.h8a(VOID, VOID, tmp1_stencil, false, false, true);
          } else {
            if (cmd instanceof ShapeCommand) {
              var paintShader = cmd.zcs_1;
              this_0.j88(cmd.b87());
              var pixelScale = this.lcr_1.i2b() / ctx.g7z_1.z88();
              if (!(paintShader == null)) {
                $l$block_0: {
                  // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
                  var this_5 = this_0.m80_1.t6l(ShapeViewUB_getInstance());
                  var _unary__edvuaz_2 = this_5.i6n();
                  this_5.x7a(_unary__edvuaz_2 + 1 | 0);
                  this_5.y7a(this_5.i6n() + 1 | 0);
                  var blockSize_0 = this_5.m6l_1;
                  var index0_0 = imul(this_5.i6n() - 1 | 0, blockSize_0);
                  var index1_0 = imul(this_5.i6n(), blockSize_0);
                  var texBlockSize_0 = this_5.j6l_1.i6t().e1();
                  var texIndex0_0 = imul(this_5.i6n() - 1 | 0, texBlockSize_0);
                  var texIndex1_0 = imul(this_5.i6n(), texBlockSize_0);
                  if (this_5.i6n() > 0) {
                    arraycopy(this_5.o6l_1, index0_0, this_5.o6l_1, index1_0, blockSize_0);
                  } else {
                    arrayfill(this_5.o6l_1, 0, 0, blockSize_0);
                  }
                  // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var $this$push_0 = this_5.j6l_1;
                  var it = this_5.p6l_1;
                  it.b7b(paintShader.gct_1);
                  it.c7b($this$push_0.vct(), pixelScale);
                  it.h7b($this$push_0.wct(), _RGBA___get_premultiplied__impl__3bulqc(colorMul));
                  if (true && this_5.i6n() >= 1) {
                    var equals_0 = arrayequal(this_5.o6l_1, index0_0, this_5.o6l_1, index1_0, blockSize_0);
                    if (equals_0) {
                      var _unary__edvuaz_3 = this_5.i6n();
                      this_5.x7a(_unary__edvuaz_3 - 1 | 0);
                      break $l$block_0;
                    }
                  }
                }
                if (!(paintShader.hct_1 == null)) {
                  var tex = ctx.v7z_1.j2p();
                  tex.a6k(paintShader.hct_1);
                  this.ncr_1.v6i(DefaultShaders_getInstance().d6w(), tex);
                  this.mcr_1.h(tex);
                }
              }
              var tmp2_elvis_lhs = cmd.act_1;
              var _program = tmp2_elvis_lhs == null ? program : tmp2_elvis_lhs;
              var tmp4_frameBuffer = ctx.i80_1.b6e_1;
              var tmp5_frameBufferInfo = ctx.i80_1.h6g();
              var tmp6_scissor = applyMatrixBounds(scissor, tempMat);
              var tmp7_uniformBlocks = ctx.y89(_program);
              var tmp8_textureUnits = this.ncr_1.kx();
              var tmp9_stencilOpFunc = cmd.cct_1;
              var tmp10_stencilRef = cmd.dct_1;
              var tmp11_colorMask = cmd.bct_1;
              var tmp3_elvis_lhs = cmd.ect_1;
              var tmp12_blending = (tmp3_elvis_lhs == null ? Companion_getInstance_13().k7y_1 : tmp3_elvis_lhs).u81_1;
              var tmp13_cullFace = cmd.fct_1;
              var tmp14_drawType = cmd.wcs_1;
              var tmp15_drawOffset = cmd.xcs_1;
              var tmp16_vertexCount = cmd.b87();
              draw(ag, new AGBatch(tmp4_frameBuffer, tmp5_frameBufferInfo, vao, VOID, VOID, _program, tmp7_uniformBlocks, tmp8_textureUnits, tmp12_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp6_scissor, tmp13_cullFace, tmp14_drawType, tmp15_drawOffset, tmp16_vertexCount));
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
      tmp_0 = Unit_instance;
    }finally {
      this_2.r81();
      this_2.s7z_1 = temp4;
      this_2.t7z_1 = temp2d;
      this_2.t6l(ProjViewUB_getInstance()).z7a();
    }
    var _iterator__ex2g4s = this.mcr_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var tex_0 = _iterator__ex2g4s.c1();
      ctx.v7z_1.k2p(tex_0);
    }
    this.mcr_1.f3();
  }
}
class ShapeViewUB extends UniformBlock {
  constructor() {
    ShapeViewUB_instance = null;
    super(5);
    ShapeViewUB_instance = this;
    this.nct_1 = this.n6t().f6t(this, u_ProgramType$factory());
    this.oct_1 = this.r6t().f6t(this, u_Color$factory());
    this.pct_1 = this.r6t().f6t(this, u_ColorMul$factory());
    this.qct_1 = this.n6t().f6t(this, u_GlobalAlpha$factory());
    this.rct_1 = this.n6t().f6t(this, u_GlobalPixelScale$factory());
    this.sct_1 = this.v6s().f6t(this, u_Transform$factory());
    this.tct_1 = this.r6t().f6t(this, u_Gradientp0$factory());
    this.uct_1 = this.r6t().f6t(this, u_Gradientp1$factory());
  }
  xct() {
    return this.nct_1.ho(this, u_ProgramType$factory_0());
  }
  yct() {
    return this.oct_1.ho(this, u_Color$factory_0());
  }
  wct() {
    return this.pct_1.ho(this, u_ColorMul$factory_0());
  }
  zct() {
    return this.qct_1.ho(this, u_GlobalAlpha$factory_0());
  }
  vct() {
    return this.rct_1.ho(this, u_GlobalPixelScale$factory_0());
  }
  acu() {
    return this.sct_1.ho(this, u_Transform$factory_0());
  }
  bcu() {
    return this.tct_1.ho(this, u_Gradientp0$factory_0());
  }
  ccu() {
    return this.uct_1.ho(this, u_Gradientp1$factory_0());
  }
}
class PaintShader {
  constructor(uniforms, texture, program) {
    uniforms = uniforms === VOID ? new UniformBlockBuffer(ShapeViewUB_getInstance()) : uniforms;
    program = program === VOID ? GpuShapeViewPrograms_getInstance().kcs_1 : program;
    this.gct_1 = uniforms;
    this.hct_1 = texture;
    this.ict_1 = program;
  }
  toString() {
    return 'PaintShader(uniforms=' + this.gct_1.toString() + ', texture=' + toString_0(this.hct_1) + ', program=' + this.ict_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.gct_1);
    result = imul(result, 31) + (this.hct_1 == null ? 0 : hashCode(this.hct_1)) | 0;
    result = imul(result, 31) + this.ict_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PaintShader))
      return false;
    var tmp0_other_with_cast = other instanceof PaintShader ? other : THROW_CCE();
    if (!equals(this.gct_1, tmp0_other_with_cast.gct_1))
      return false;
    if (!equals(this.hct_1, tmp0_other_with_cast.hct_1))
      return false;
    if (!this.ict_1.equals(tmp0_other_with_cast.ict_1))
      return false;
    return true;
  }
}
class GpuShapeViewPrograms {
  constructor() {
    GpuShapeViewPrograms_instance = this;
    this.ucr_1 = Attribute.n6u('a_MaxDist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 4);
    this.vcr_1 = Attribute.n6u('a_Dist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 5);
    this.wcr_1 = Varying.z6u('v_MaxDist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.xcr_1 = Varying.z6u('v_Dist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.ycr_1 = ProgramLayout.w6n([DefaultShaders_getInstance().g6r_1]);
    this.zcr_1 = ProgramLayout.w6n([DefaultShaders_getInstance().h6r_1]);
    this.acs_1 = ProgramLayout.w6n([this.vcr_1]);
    this.bcs_1 = ProgramLayout.w6n([DefaultShaders_getInstance().g6r_1, DefaultShaders_getInstance().h6r_1]);
    this.ccs_1 = ProgramLayout.w6n([DefaultShaders_getInstance().g6r_1, this.vcr_1]);
    this.dcs_1 = ProgramLayout.w6n([DefaultShaders_getInstance().g6r_1, this.vcr_1, this.ucr_1]);
    this.ecs_1 = 0;
    this.fcs_1 = 1;
    this.gcs_1 = 2;
    this.hcs_1 = 3;
    this.ics_1 = 4;
    this.jcs_1 = 5;
    var tmp = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.o6v();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    this_0.t6v(this_0.w6v(), this_0.x6v(this_0.x6v(this_0.g6t(), this_0.h6t()), this_0.a6w([this_0.y6v(), this_0.z6v(0.0), this_0.z6v(1.0)])));
    this_0.t6v(this_0.p6v(), DefaultShaders_getInstance().g6r_1);
    this_0.t6v(GpuShapeViewPrograms_getInstance().xcr_1, GpuShapeViewPrograms_getInstance().vcr_1);
    this_0.t6v(GpuShapeViewPrograms_getInstance().wcr_1, GpuShapeViewPrograms_getInstance().ucr_1);
    var tmp0_vertex = VertexShader(this_0.b6w());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_1 = ProgramBuilderDefault.o6v();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_1.k6y(GpuShapeViewPrograms_getInstance().xct(), this_1.z6v(5));
    var body = this_1.k6w();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body.t6v(body.w6v(), body.a6w([body.z6v(1.0), body.z6v(0.0), body.z6v(0.0), body.z6v(1.0)]));
    body.h6x();
    var stmIf = new If(cond, body.m6w());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.s6v_1.h(stmIf);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_0 = this_1.p6y(this_1.t6x(GpuShapeViewPrograms_getInstance().xcr_1), GpuShapeViewPrograms_getInstance().wcr_1);
    var body_0 = this_1.k6w();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body_0.e6x();
    var stmIf_0 = new If(cond_0, body_0.m6w());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.s6v_1.h(stmIf_0);
    var tmp_0 = GpuShapeViewPrograms_getInstance().xct();
    this_1.b6x(tmp_0, 0, 4, GpuShapeViewPrograms$PROGRAM_COMBINED$lambda(this_1));
    var aaAlpha = this_1.f6y(this_1.z6v(1.0), this_1.w6x(this_1.f6y(this_1.x6v(GpuShapeViewPrograms_getInstance().wcr_1, GpuShapeViewPrograms_getInstance().vct()), this_1.z6v(1.5)), this_1.x6v(GpuShapeViewPrograms_getInstance().wcr_1, GpuShapeViewPrograms_getInstance().vct()), this_1.t6x(this_1.x6v(GpuShapeViewPrograms_getInstance().xcr_1, GpuShapeViewPrograms_getInstance().vct()))));
    this_1.t6v(this_1.w6v(), this_1.x6v(this_1.x6v(this_1.x6v(this_1.w6v(), GpuShapeViewPrograms_getInstance().wct()), GpuShapeViewPrograms_getInstance().zct()), aaAlpha));
    var tmp1_fragment = FragmentShader(this_1.b6w());
    tmp.kcs_1 = new Program(tmp0_vertex, tmp1_fragment, 'GpuShapeViewPrograms.Combined');
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.Companion.single' call
    var block = ShapeViewUB_getInstance();
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_2 = new UniformBlockBuffer(block);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    this_2.a2q();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var _unary__edvuaz = this_2.i6n();
      this_2.x7a(_unary__edvuaz + 1 | 0);
      this_2.y7a(this_2.i6n() + 1 | 0);
      var blockSize = this_2.m6l_1;
      var index0 = imul(this_2.i6n() - 1 | 0, blockSize);
      var index1 = imul(this_2.i6n(), blockSize);
      var texBlockSize = this_2.j6l_1.i6t().e1();
      var texIndex0 = imul(this_2.i6n() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_2.i6n(), texBlockSize);
      if (this_2.i6n() > 0) {
        arraycopy(this_2.o6l_1, index0, this_2.o6l_1, index1, blockSize);
      } else {
        arrayfill(this_2.o6l_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
      this_2.j6l_1;
      // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.stencilPaintShader.<anonymous>' call
      this_2.p6l_1.d7b(ShapeViewUB_getInstance().xct(), 5);
      if (true && this_2.i6n() >= 1) {
        var equals = arrayequal(this_2.o6l_1, index0, this_2.o6l_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_2.i6n();
          this_2.x7a(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    tmp_1.lcs_1 = new PaintShader(this_2, null);
  }
  xct() {
    return ShapeViewUB_getInstance().xct().c6n_1;
  }
  yct() {
    return ShapeViewUB_getInstance().yct().c6n_1;
  }
  wct() {
    return ShapeViewUB_getInstance().wct().c6n_1;
  }
  zct() {
    return ShapeViewUB_getInstance().zct().c6n_1;
  }
  vct() {
    return ShapeViewUB_getInstance().vct().c6n_1;
  }
  acu() {
    return ShapeViewUB_getInstance().acu().c6n_1;
  }
  bcu() {
    return ShapeViewUB_getInstance().bcu().c6n_1;
  }
  ccu() {
    return ShapeViewUB_getInstance().ccu().c6n_1;
  }
  dcu(_this__u8e3s4) {
    // Inline function 'korlibs.graphics.shader.Companion.invoke' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.<get-pow2>.<anonymous>' call
    var $this$ExpressionBuilder = Companion_getInstance_25().p7h_1;
    return $this$ExpressionBuilder.q6x(_this__u8e3s4, $this$ExpressionBuilder.z6v(2.0));
  }
  mcs(stateTransform, paint, globalAlpha, lineWidth) {
    var tmp;
    if (paint instanceof NonePaint) {
      tmp = null;
    } else {
      if (paint instanceof RGBA) {
        // Inline function 'korlibs.graphics.shader.Companion.single' call
        var block = ShapeViewUB_getInstance();
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.also' call
        var this_0 = new UniformBlockBuffer(block);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        this_0.a2q();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
          var _unary__edvuaz = this_0.i6n();
          this_0.x7a(_unary__edvuaz + 1 | 0);
          this_0.y7a(this_0.i6n() + 1 | 0);
          var blockSize = this_0.m6l_1;
          var index0 = imul(this_0.i6n() - 1 | 0, blockSize);
          var index1 = imul(this_0.i6n(), blockSize);
          var texBlockSize = this_0.j6l_1.i6t().e1();
          var texIndex0 = imul(this_0.i6n() - 1 | 0, texBlockSize);
          var texIndex1 = imul(this_0.i6n(), texBlockSize);
          if (this_0.i6n() > 0) {
            arraycopy(this_0.o6l_1, index0, this_0.o6l_1, index1, blockSize);
          } else {
            arrayfill(this_0.o6l_1, 0, 0, blockSize);
          }
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
          var $this$push = this_0.j6l_1;
          // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
          var it = this_0.p6l_1;
          it.d7b($this$push.xct(), 0);
          it.h7b($this$push.yct(), _RGBA___get_premultiplied__impl__3bulqc(paint.u4d_1));
          it.d7b($this$push.zct(), globalAlpha);
          if (true && this_0.i6n() >= 1) {
            var equals = arrayequal(this_0.o6l_1, index0, this_0.o6l_1, index1, blockSize);
            if (equals) {
              var _unary__edvuaz_0 = this_0.i6n();
              this_0.x7a(_unary__edvuaz_0 - 1 | 0);
              break $l$block;
            }
          }
        }
        tmp = new PaintShader(this_0, null);
      } else {
        if (paint instanceof BitmapPaint) {
          var mat = Companion_getInstance_33().w28_1.p2a(paint.q5o_1).p2a(stateTransform).j2a().w29(1.0 / paint.p5o_1.t3w_1, 1.0 / paint.p5o_1.u3w_1);
          // Inline function 'korlibs.graphics.shader.Companion.single' call
          var block_0 = ShapeViewUB_getInstance();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.also' call
          var this_1 = new UniformBlockBuffer(block_0);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          this_1.a2q();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          $l$block_0: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var _unary__edvuaz_1 = this_1.i6n();
            this_1.x7a(_unary__edvuaz_1 + 1 | 0);
            this_1.y7a(this_1.i6n() + 1 | 0);
            var blockSize_0 = this_1.m6l_1;
            var index0_0 = imul(this_1.i6n() - 1 | 0, blockSize_0);
            var index1_0 = imul(this_1.i6n(), blockSize_0);
            var texBlockSize_0 = this_1.j6l_1.i6t().e1();
            var texIndex0_0 = imul(this_1.i6n() - 1 | 0, texBlockSize_0);
            var texIndex1_0 = imul(this_1.i6n(), texBlockSize_0);
            if (this_1.i6n() > 0) {
              arraycopy(this_1.o6l_1, index0_0, this_1.o6l_1, index1_0, blockSize_0);
            } else {
              arrayfill(this_1.o6l_1, 0, 0, blockSize_0);
            }
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
            var $this$push_0 = this_1.j6l_1;
            // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
            var it_0 = this_1.p6l_1;
            it_0.d7b($this$push_0.xct(), 1);
            it_0.l7b($this$push_0.acu(), toMatrix4(mat));
            it_0.d7b($this$push_0.zct(), globalAlpha);
            if (true && this_1.i6n() >= 1) {
              var equals_0 = arrayequal(this_1.o6l_1, index0_0, this_1.o6l_1, index1_0, blockSize_0);
              if (equals_0) {
                var _unary__edvuaz_2 = this_1.i6n();
                this_1.x7a(_unary__edvuaz_2 - 1 | 0);
                break $l$block_0;
              }
            }
          }
          tmp = new PaintShader(this_1, paint.p5o_1);
        } else {
          if (paint instanceof GradientPaint) {
            var gradientBitmap = Bitmap32.m3w(256, 1, VOID, true);
            // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
            var rect = gradientBitmap.x3w_1;
            if (true) {
              gradientBitmap.g3x();
            }
            var result;
            try {
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              paint.b5o(_RgbaPremultipliedArray___init__impl__lx83hy(gradientBitmap.j3w_1));
            }finally {
              result = true ? gradientBitmap.i3x(rect) : 0;
            }
            var npaint = paint.c5o(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_33().w28_1.p2a(paint.x5b_1).p2a(stateTransform));
            var mat_0 = paint.n5b_1.l3_1 === 0 ? npaint.d5c_1 : npaint.x5b_1.j2a();
            // Inline function 'korlibs.graphics.shader.Companion.single' call
            var block_1 = ShapeViewUB_getInstance();
            // Inline function 'kotlin.also' call
            // Inline function 'kotlin.also' call
            var this_2 = new UniformBlockBuffer(block_1);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            this_2.a2q();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            $l$block_1: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var _unary__edvuaz_3 = this_2.i6n();
              this_2.x7a(_unary__edvuaz_3 + 1 | 0);
              this_2.y7a(this_2.i6n() + 1 | 0);
              var blockSize_1 = this_2.m6l_1;
              var index0_1 = imul(this_2.i6n() - 1 | 0, blockSize_1);
              var index1_1 = imul(this_2.i6n(), blockSize_1);
              var texBlockSize_1 = this_2.j6l_1.i6t().e1();
              var texIndex0_1 = imul(this_2.i6n() - 1 | 0, texBlockSize_1);
              var texIndex1_1 = imul(this_2.i6n(), texBlockSize_1);
              if (this_2.i6n() > 0) {
                arraycopy(this_2.o6l_1, index0_1, this_2.o6l_1, index1_1, blockSize_1);
              } else {
                arrayfill(this_2.o6l_1, 0, 0, blockSize_1);
              }
              // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
              var $this$push_1 = this_2.j6l_1;
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              var it_1 = this_2.p6l_1;
              var tmp_0 = $this$push_1.xct();
              var tmp0 = paint.n5b_1.l3_1;
              it_1.d7b(tmp_0, tmp0 === 1 ? 3 : tmp0 === 2 ? 4 : 2);
              it_1.l7b($this$push_1.acu(), toMatrix4(mat_0));
              it_1.j7b($this$push_1.bcu(), new Vector4F(paint.o5b_1, paint.p5b_1, paint.q5b_1, 1.0));
              it_1.j7b($this$push_1.ccu(), new Vector4F(paint.r5b_1, paint.s5b_1, paint.t5b_1, 1.0));
              it_1.d7b($this$push_1.zct(), globalAlpha);
              if (true && this_2.i6n() >= 1) {
                var equals_1 = arrayequal(this_2.o6l_1, index0_1, this_2.o6l_1, index1_1, blockSize_1);
                if (equals_1) {
                  var _unary__edvuaz_4 = this_2.i6n();
                  this_2.x7a(_unary__edvuaz_4 - 1 | 0);
                  break $l$block_1;
                }
              }
            }
            tmp = new PaintShader(this_2, gradientBitmap);
          } else {
            // Inline function 'kotlin.TODO' call
            var reason = 'paint=' + toString(paint);
            throw NotImplementedError.md('An operation is not implemented: ' + reason);
          }
        }
      }
    }
    return tmp;
  }
}
//endregion
function *_generator_invoke__zhh2q8($this, $this$withContext, $completion) {
  var tmp = KorgeRunner_instance.a9f($this.p9d_1.z9e(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $this.q9d_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_14;
function Companion_getInstance_40() {
  if (Companion_instance_14 === VOID)
    new Companion();
  return Companion_instance_14;
}
function *_generator_start__v5y7pu($this, entry, $completion) {
  var tmp = Companion_getInstance_1().j1v($this.w9e_1);
  var tmp_0 = withContext(tmp, Korge$start$slambda_0($this, entry), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function Korge$_init_$lambda_95dffl(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$_init_$slambda_ys8r4w_0() {
  var i = new Korge$_init_$slambda_ys8r4w();
  var l = function (_this__u8e3s4, $completion) {
    return i.d9f(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$_init_$lambda_95dffl_0(it) {
  return Stage.t9h(it);
}
function Korge$start$slambda_0(this$0, $entry) {
  var i = new Korge$start$slambda(this$0, $entry);
  var l = function ($this$withContext, $completion) {
    return i.u1n($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_15;
function Companion_getInstance_41() {
  if (Companion_instance_15 === VOID)
    new Companion_0();
  return Companion_instance_15;
}
function *_generator_invoke__zhh2q8_0($this, $this$coroutineScope, $completion) {
  if (!($this.r9k_1.u9d_1 == null)) {
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var this_0 = $this.s9k_1.u9j_1;
    var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_37()));
    var name = 'sceneContainer';
    var size = Companion_getInstance_28().b2g_1;
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var tmp = views($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var views_0 = tmp;
    var width = size.dl();
    var height = size.el();
    var rwidth = width;
    var rheight = height;
    if (width === 0.0 && height === 0.0) {
      var tmp_0 = findFirstAscendant(this_0, KorgeRunner$invoke$slambda$slambda$slambda$lambda);
      var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
      var tmp1_elvis_lhs = base == null ? null : base.n2i();
      rwidth = tmp1_elvis_lhs == null ? views_0.u9j_1.n2i() : tmp1_elvis_lhs;
      var tmp3_elvis_lhs = base == null ? null : base.o2i();
      rheight = tmp3_elvis_lhs == null ? views_0.u9j_1.o2i() : tmp3_elvis_lhs;
    }
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SceneContainer.v9p(views_0, defaultTransition, name, Size2D.a2e(rwidth, rheight));
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
    var tmp_1 = addTo(this_1, this_0).w9p($this.r9k_1.u9d_1, [], VOID, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  var tmp_2 = $this.t9k_1($this.s9k_1.u9j_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  if ($this.r9k_1.c9e_1) {
    var tmp_3 = $this.u9k_1.s8i($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = coroutineScope(KorgeRunner$invoke$slambda$slambda$slambda_0($this.x9p_1, $this.y9p_1, $this.z9p_1, $this.a9q_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($this$coroutineScope, $completion) {
    return i.u1n($this$coroutineScope, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$loop, $completion) {
  var gameWindow = $this$loop;
  if (Companion_getInstance_39().zt()) {
    println('Korui[0]');
  }
  $l$block: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name = 'configureGameWindow';
    var start = PerformanceCounter_getInstance().r63();
    try {
      var tmp0_elvis_lhs = $this.d9q_1.k9e_1;
      var tmp;
      var tmp_0 = tmp0_elvis_lhs;
      if ((tmp_0 == null ? null : new RGBA(tmp_0)) == null) {
        tmp = Colors_getInstance().b3y_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      configure($this.b9q_1, $this.c9q_1, $this.d9q_1.j9e_1, null, $this.d9q_1.b9e_1, tmp);
      break $l$block;
    }finally {
      var end = PerformanceCounter_getInstance().r63();
      // Inline function 'korlibs.time.microseconds' call
      var this_0 = end - start;
      var tmp$ret$1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.e8i(name, tmp$ret$1);
    }
  }
  $l$block_0: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var start_0 = PerformanceCounter_getInstance().r63();
    try {
      try {
        if (!($this.e9q_1 == null)) {
          var tmp_1 = readBitmap(get_resourcesVfs().yh($this.e9q_1), $this.f9q_1, $completion);
          if (tmp_1 === get_COROUTINE_SUSPENDED())
            tmp_1 = yield tmp_1;
          $this$loop.g8i(tmp_1);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.error' call
          var this_1 = Companion_getInstance_40().b9f_1;
          var level = Level_ERROR_getInstance();
          var tmp_2;
          if (this_1.h2t(level)) {
            // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var tmp$ret$2 = "Couldn't get the application icon";
            this_1.i2t(level, tmp$ret$2);
            tmp_2 = Unit_instance;
          }
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      break $l$block_0;
    }finally {
      var end_0 = PerformanceCounter_getInstance().r63();
      // Inline function 'korlibs.time.microseconds' call
      var this_2 = end_0 - start_0;
      var tmp$ret$5 = toDuration(this_2, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.e8i('setIcon', tmp$ret$5);
    }
  }
  $this$loop.l8i($this$loop.z89());
  if (Companion_getInstance_39().zt()) {
    println('CanvasApplicationEx.IN[0]');
  }
  var input = new Input();
  var stats = new Stats();
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$6 = $completion.kc();
  var this_3 = Views.h9q(tmp$ret$6.xm(gameWindow.z8h()).xm(new InjectorContext($this.d9q_1.w9d_1)).xm(SupervisorJob()).xm(CoroutineName.k1b('Views')), $this.d9q_1.r9e_1 ? AGPrint.d79() : $this$loop.y8h(), $this.d9q_1.w9d_1, input, $this.d9q_1.v9d_1, stats, gameWindow, $this.d9q_1.d9e_1, $this.d9q_1.e9e_1, $this.d9q_1.f9e_1, VOID, $this.d9q_1.u9e_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>' call
  var tmp_3 = this_3.u22($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  if (Companion_getInstance_39().cu()) {
    Dyn__set_impl_2ozvx8(Companion_instance_13.y2w(), 'views', this_3);
  }
  var views = this_3;
  $this.d9q_1.w9d_1.x62(getKClass(GameWindow), gameWindow);
  $this.d9q_1.w9d_1.x62(getKClass(Korge), $this.d9q_1);
  views.x9j_1 = $this$loop.n8i();
  views.i9q($this.d9q_1.s9e_1);
  views.j9q($this.d9q_1.t9e_1);
  views.o9j_1 = numberToInt($this.d9q_1.h9e_1.h26_1);
  views.p9j_1 = numberToInt($this.d9q_1.h9e_1.i26_1);
  views.s9j_1 = $this.d9q_1.i9e_1.b9i_1;
  views.r9j_1 = $this.d9q_1.i9e_1.a9i_1;
  views.t9j_1 = $this.d9q_1.i9e_1.c9i_1;
  views.i9k_1 = $this.d9q_1.v9e_1;
  $l$block_1: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_0 = 'prepareViews';
    var start_1 = PerformanceCounter_getInstance().r63();
    try {
      KorgeReload_getInstance().i7y(gameWindow);
      var tmp_4 = KorgeRunner_instance.k9q(views, gameWindow, true, $this$loop.k8i(), Companion_instance_1.r1u(), $this.d9q_1.o9e_1, $this.d9q_1.x9d_1).h17($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      break $l$block_1;
    }finally {
      var end_1 = PerformanceCounter_getInstance().r63();
      // Inline function 'korlibs.time.microseconds' call
      var this_4 = end_1 - start_1;
      var tmp$ret$9 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.e8i(name_0, tmp$ret$9);
    }
  }
  $l$block_2: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_1 = 'completeViews';
    var start_2 = PerformanceCounter_getInstance().r63();
    try {
      completeViews(views);
      break $l$block_2;
    }finally {
      var end_2 = PerformanceCounter_getInstance().r63();
      // Inline function 'korlibs.time.microseconds' call
      var this_5 = end_2 - start_2;
      var tmp$ret$11 = toDuration(this_5, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.e8i(name_1, tmp$ret$11);
    }
  }
  launchImmediately(views, KorgeRunner$invoke$slambda$slambda_0($this.d9q_1, views, $this.g9q_1, gameWindow));
  if ($this.d9q_1.c9e_1) {
    var tmp_5 = gameWindow.s8i($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    gameWindow.q8i();
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, config, $completion) {
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
  beforeStartingKorge(config);
  if (null == null) {
    $l$block: {
      // Inline function 'korlibs.io.worker.Companion.init' call
      get_workerImpl().g35();
      if (get_workerImpl().h35()) {
        if (get_DEBUG_WORKER()) {
          println('INSIDE WORKER');
        }
        break $l$block;
      } else {
        if (get_DEBUG_WORKER()) {
          println('**NOT** INSIDE WORKER');
        }
      }
      // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
      get_nativeSoundProvider();
      get_RegisteredImageFormats().q5k([config.s9d_1]);
      var iconPath = config.m9e_1;
      var imageFormats = config.s9d_1;
      var entry = config.q9e_1;
      var windowSize = config.g9e_1;
      if (!Companion_getInstance_39().cu()) {
        var tmp = configureLoggerFromProperties(get_localCurrentDirVfs().yh('klogger.properties'), $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
      }
      var tmp0_elvis_lhs = config.t9d_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.js.getCoroutineContext' call
        tmp_0 = $completion.kc().xc(CoroutineKey_getInstance());
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp1_elvis_lhs = tmp_0;
      var realGameWindow = tmp1_elvis_lhs == null ? CreateDefaultGameWindow(config.p9e_1.u8j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, config.j9e_1)) : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = config.k9e_1;
      var tmp_1;
      var tmp_2 = tmp2_elvis_lhs;
      if ((tmp_2 == null ? null : new RGBA(tmp_2)) == null) {
        tmp_1 = Colors_getInstance().b3y_1;
      } else {
        tmp_1 = tmp2_elvis_lhs;
      }
      realGameWindow.j8i(tmp_1);
      var tmp_3 = realGameWindow.t8i(KorgeRunner$invoke$slambda_0(realGameWindow, windowSize, config, iconPath, imageFormats, entry), $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
    }
  }
  return Unit_instance;
}
function prepareViewsBase$getRealXY($views, x, y, scaleCoords) {
  return $views.a89(Vector2D.s24(x, y));
}
function prepareViewsBase$mouseDown(input, $views, downPos, downTime, type, p, button) {
  input.m83(button, true);
  input.l83(p, false);
  input.l83(p, true);
  $views.l9q();
  downPos._v = input.k83();
  downTime._v = new DateTime(Companion_getInstance_5().l1u());
  input.w82_1 = true;
}
function prepareViewsBase$mouseUp(input, $views, upPos, type, p, button) {
  input.m83(button, false);
  input.l83(p, false);
  $views.l9q();
  upPos._v = $views.l9i_1.k83();
}
function prepareViewsBase$mouseMove($views, moveMouseOutsideInNextFrame, moveTime, type, p, inside) {
  $views.l9i_1.l83(p, false);
  $views.l9i_1.w82_1 = inside;
  if (!inside) {
    moveMouseOutsideInNextFrame._v = true;
  }
  $views.l9q();
  moveTime._v = new DateTime(Companion_getInstance_5().l1u());
}
function prepareViewsBase$mouseDrag($views, moveTime, type, p) {
  $views.l9i_1.l83(p, false);
  $views.l9q();
  moveTime._v = new DateTime(Companion_getInstance_5().l1u());
}
function prepareViewsBase$dispatchSimulatedTouchEvent(mouseTouchEvent, $views, p, button, type, status) {
  mouseTouchEvent.b6a_1 = 0;
  mouseTouchEvent.e6a_1 = true;
  mouseTouchEvent.c6a_1 = Companion_getInstance_5().l1u();
  mouseTouchEvent.d6a_1 = false;
  mouseTouchEvent.m6a(type);
  mouseTouchEvent.r6a(button.s6d_1, p, status, VOID, Kind_MOUSE_getInstance(), button);
  mouseTouchEvent.n6a();
  $views.d66(mouseTouchEvent);
}
function prepareViewsBase$gamepadUpdated(input, e) {
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = e.m6b_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.gamepadUpdated.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var gamepad = this_0[_unary__edvuaz];
    input.g83_1[gamepad.n6b_1].v6b(gamepad);
  }
  input.n83();
}
function prepareViewsBase$renderBlock($views, $fixedSizeStep, moveMouseOutsideInNextFrame, event) {
  try {
    $views.n9q($fixedSizeStep, $views.m9q(), event.r66_1, event.s66_1);
    $views.l9i_1.v82_1 = false;
    if (moveMouseOutsideInNextFrame._v) {
      moveMouseOutsideInNextFrame._v = false;
      $views.l9i_1.v82_1 = true;
      $views.l9i_1.w82_1 = false;
      $views.l9q();
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = Companion_getInstance_40().b9f_1;
      var level = Level_ERROR_getInstance();
      var tmp;
      if (this_0.h2t(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.renderBlock.<anonymous>' call
        var tmp$ret$0 = 'views.gameWindow.onRenderEvent:';
        this_0.i2t(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      printStackTrace(e);
      if ($views.w9i_1)
        throw e;
    } else {
      throw $p;
    }
  }
}
function KorgeRunner$invoke$slambda_0($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
  var i = new KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry);
  var l = function ($this$loop, $completion) {
    return i.o9q($this$loop, $completion);
  };
  l.$arity = 1;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda($this$mapSingleton) {
  return new ResourcesRoot();
}
function KorgeRunner$prepareViewsBase$lambda_0($this$mapPrototype) {
  return new EmptyScene();
}
function KorgeRunner$prepareViewsBase$lambda_1($views, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_40().b9f_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.h2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<MouseEvent>:' + e.toString();
      this_0.i2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var p = prepareViewsBase$getRealXY($views, e.b68_1, e.c68_1, e.m68_1);
    var tmp_0;
    switch (e.z67_1.l3_1) {
      case 3:
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'mouseDown', p, e.d68_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.d68_1, Type_START_getInstance(), Status_ADD_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 2:
        prepareViewsBase$mouseUp($input, $views, $upPos, 'mouseUp', p, e.d68_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.d68_1, Type_END_getInstance(), Status_REMOVE_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 1:
        prepareViewsBase$mouseDrag($views, $moveTime, 'onMouseDrag', p);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.d68_1, Type_MOVE_getInstance(), Status_KEEP_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 0:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseMove', p, true);
        tmp_0 = Unit_instance;
        break;
      case 4:
        tmp_0 = Unit_instance;
        break;
      case 5:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseEnter', p, true);
        tmp_0 = Unit_instance;
        break;
      case 6:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseExit', p, false);
        tmp_0 = Unit_instance;
        break;
      case 7:
        tmp_0 = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $views.d66(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_2($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_40().b9f_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.h2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<KeyEvent>:' + e.toString();
      this_0.i2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.d66(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_3($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_40().b9f_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.h2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GestureEvent>:' + e.toString();
      this_0.i2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.d66(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_4($views) {
  return function (e) {
    $views.d66(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_5($views) {
  return function (e) {
    $views.d66(e);
    get_nativeSoundProvider().w2q(false);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_6($views) {
  return function (e) {
    $views.d66(e);
    get_nativeSoundProvider().w2q(true);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_7($views) {
  return function (e) {
    $views.d66(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda$slambda_0($views) {
  var i = new KorgeRunner$prepareViewsBase$lambda$slambda($views);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda_8($views) {
  return function (e) {
    try {
      $views.d66(e);
    }finally {
      launchImmediately($views, KorgeRunner$prepareViewsBase$lambda$slambda_0($views));
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_9($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $moveTime) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_40().b9f_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.h2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<TouchEvent>:' + e.toString();
      this_0.i2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $input.j83(e);
    var ee = $input.o82_1;
    var _iterator__ex2g4s = ee.j6a().a1();
    while (_iterator__ex2g4s.b1()) {
      var t = _iterator__ex2g4s.c1();
      t.o69_1 = prepareViewsBase$getRealXY($views, t.t69(), t.u69(), e.d6a_1);
    }
    $views.d66(ee);
    var tmp_0;
    if (ee.k6a() === 1) {
      var start = ee.u6a();
      var end = ee.v6a();
      var t_0 = first(ee.j6a());
      var p = t_0.o69_1;
      var x = t_0.t69();
      var y = t_0.u69();
      var button = MouseButton_LEFT_getInstance();
      if (start) {
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'onTouchStart', p, button);
      } else if (end) {
        prepareViewsBase$mouseUp($input, $views, $upPos, 'onTouchEnd', p, button);
      } else {
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'onTouchMove', p, true);
      }
      // Inline function 'kotlin.also' call
      var this_1 = $touchMouseEvent;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      this_1.a68_1 = 0;
      this_1.d68_1 = button;
      this_1.e68_1 = end ? 0 : 1 << button.s6d_1;
      this_1.b68_1 = numberToInt(x);
      this_1.c68_1 = numberToInt(y);
      this_1.m68_1 = false;
      this_1.n68_1 = true;
      this_1.z67_1 = start ? Type_DOWN_getInstance() : end ? Type_UP_getInstance() : Type_DRAG_getInstance();
      $views.d66(this_1);
      var tmp_1;
      if (end) {
        $moveMouseOutsideInNextFrame._v = true;
        tmp_1 = Unit_instance;
      }
      tmp_0 = tmp_1;
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_10($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_40().b9f_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.h2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e.toString();
      this_0.i2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.d66(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_11($views, $input) {
  return function (e) {
    prepareViewsBase$gamepadUpdated($input, e);
    $views.d66(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_12($views, $ag) {
  return function (e) {
    $views.q9q($ag.p6e().i6e_1, $ag.p6e().j6e_1);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_13($views) {
  return function (it) {
    $views.d66(it);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_14($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
  return function (event) {
    var tmp;
    if (!event.s66_1) {
      prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
      tmp = Unit_instance;
    } else {
      var this_0 = $views.h9j_1;
      var frameBuffer = this_0.p6e();
      this_0.m7z_1.a2q();
      this_0.f7z_1.t6e();
      var tmp_0;
      try {
        this_0.o8a(frameBuffer);
        var tmp_1;
        try {
          if (!$renderShown._v) {
            $renderShown._v = true;
            $firstRenderDeferred.y1a(Unit_instance);
          }
          prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
          tmp_1 = Unit_instance;
        }finally {
          this_0.p8a();
        }
        tmp_0 = tmp_1;
      }finally {
        this_0.f7z_1.n6a();
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
var KorgeRunner_instance;
function KorgeRunner_getInstance() {
  return KorgeRunner_instance;
}
function Korge_0(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowWidth, windowHeight, windowSize, virtualWidth, virtualHeight, virtualSize, scaleMode, scaleAnchor, clipBorders, displayMode, title, bgcolor, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, entry, $completion) {
  var tmp;
  if (args === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = args;
  }
  args = tmp;
  imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
  gameWindow = gameWindow === VOID ? null : gameWindow;
  mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  injector = injector === VOID ? new Injector() : injector;
  var tmp_0;
  if (configInjector === VOID) {
    tmp_0 = Korge$lambda;
  } else {
    tmp_0 = configInjector;
  }
  configInjector = tmp_0;
  debug = debug === VOID ? false : debug;
  trace = trace === VOID ? false : trace;
  context = context === VOID ? null : context;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  blocking = blocking === VOID ? true : blocking;
  gameId = gameId === VOID ? Companion_getInstance_40().c9f_1 : gameId;
  settingsFolder = settingsFolder === VOID ? null : settingsFolder;
  batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().i86_1 : batchMaxQuads;
  windowWidth = windowWidth === VOID ? numberToInt(DefaultViewport_getInstance().u83_1.h26_1) : windowWidth;
  windowHeight = windowHeight === VOID ? numberToInt(DefaultViewport_getInstance().u83_1.i26_1) : windowHeight;
  windowSize = windowSize === VOID ? Size2D.j26(windowWidth, windowHeight) : windowSize;
  virtualWidth = virtualWidth === VOID ? numberToInt(windowSize.h26_1) : virtualWidth;
  virtualHeight = virtualHeight === VOID ? numberToInt(windowSize.i26_1) : virtualHeight;
  virtualSize = virtualSize === VOID ? Size2D.j26(virtualWidth, virtualHeight) : virtualSize;
  scaleMode = scaleMode === VOID ? Companion_getInstance_26().w2f_1 : scaleMode;
  scaleAnchor = scaleAnchor === VOID ? Companion_getInstance_27().n24() : scaleAnchor;
  clipBorders = clipBorders === VOID ? true : clipBorders;
  displayMode = displayMode === VOID ? new KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) : displayMode;
  title = title === VOID ? 'Game' : title;
  bgcolor = bgcolor === VOID ? Colors_getInstance().b3y_1 : bgcolor;
  backgroundColor = backgroundColor === VOID ? bgcolor : backgroundColor;
  quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
  icon = icon === VOID ? null : icon;
  multithreaded = multithreaded === VOID ? null : multithreaded;
  forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
  var tmp_1;
  if (main === VOID) {
    tmp_1 = Korge$slambda_1();
  } else {
    tmp_1 = main;
  }
  main = tmp_1;
  debugAg = debugAg === VOID ? false : debugAg;
  debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
  debugFontColor = debugFontColor === VOID ? Colors_getInstance().a3y_1 : debugFontColor;
  var tmp_2;
  if (stageBuilder === VOID) {
    tmp_2 = Korge$lambda_0;
  } else {
    tmp_2 = stageBuilder;
  }
  stageBuilder = tmp_2;
  targetFps = targetFps === VOID ? 0.0 : targetFps;
  preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
  debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
  var tmp_3;
  if (entry === VOID) {
    tmp_3 = Korge$slambda_2();
  } else {
    tmp_3 = entry;
  }
  entry = tmp_3;
  return (new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, VOID, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance)).y9h(entry, $completion);
}
function Korge$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$slambda_1() {
  var i = new Korge$slambda();
  var l = function (_this__u8e3s4, $completion) {
    return i.d9f(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$lambda_0(it) {
  return Stage.t9h(it);
}
function Korge$slambda_2() {
  var i = new Korge$slambda_0();
  var l = function (_this__u8e3s4, $completion) {
    return i.d9f(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function get_simpleAnimator(_this__u8e3s4) {
  _init_properties_Animator_kt__gicf47();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = simpleAnimator$delegate;
    var property = simpleAnimator$factory();
    var tmp0_elvis_lhs = this_0.sx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.tx_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.sx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var simpleAnimator$delegate;
function _get_totalTime__xgts5c($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.c9r_1;
  totalTime$factory();
  return this_0.p1().t1u_1;
}
function Animator$TweenNode$computedVs$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.w9q_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(tmp0_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.animate.TweenNode.computedVs$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item();
        destination.h(tmp$ret$0);
      }
      tmp = destination;
    }
    var tmp1_elvis_lhs = tmp;
    return toMutableList(tmp1_elvis_lhs == null ? toList(this$0.v9q_1) : tmp1_elvis_lhs);
  };
}
function Animator$TweenNode$totalTime$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.y9q_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0 = tmp0_safe_receiver();
      tmp = tmp_0 == null ? null : tmp_0.t1u_1;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    var tmp_2 = tmp1_elvis_lhs;
    if ((tmp_2 == null ? null : new FastDuration(tmp_2)) == null) {
      tmp_1 = this$0.x9q_1;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return new FastDuration(tmp_1);
  };
}
var Companion_instance_16;
function Companion_getInstance_42() {
  if (Companion_instance_16 === VOID)
    new Companion_1();
  return Companion_instance_16;
}
function ensure($this) {
  if (!($this.o9r_1 == null))
    return ensure($this.o9r_1);
  if (!($this.z9r().v9r_1 == null))
    return Unit_instance;
  var tmp = $this.z9r();
  var tmp_0 = $this.z9r().r9r_1;
  tmp.v9r_1 = addFastUpdater($this.i9r_1, tmp_0, VOID, Animator$ensure$lambda($this));
}
function ensureInit($this) {
  var tmp0_elvis_lhs = $this.p9r_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var linit = tmp;
  $this.p9r_1 = null;
  linit($this);
}
function Animator$removeProps$lambda($props) {
  return function (it) {
    return !$props.u2(it.j8d_1);
  };
}
function Animator$ensure$lambda(this$0) {
  return function ($this$addFastUpdater, dt) {
    var tmp;
    if (this$0.w9r_1) {
      this$0.i9r_1.j9s();
      tmp = Unit_instance;
    }
    var tmp_0;
    if (FastDuration__compareTo_impl_4fhnj7(this$0.y9r_1.d9s(dt.t1u_1), Companion_instance_1.q1u()) >= 0) {
      if (this$0.n9r_1) {
        invoke(this$0.s9r_1);
      } else {
        this$0.k9s();
      }
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function animator(_this__u8e3s4, defaultTime, defaultSpeed, defaultEasing, parallel, looped, startImmediately, block) {
  defaultTime = defaultTime === VOID ? Companion_getInstance_42().e9r_1 : defaultTime;
  defaultSpeed = defaultSpeed === VOID ? Companion_getInstance_42().f9r_1 : defaultSpeed;
  defaultEasing = defaultEasing === VOID ? Companion_getInstance_42().g9r_1 : defaultEasing;
  parallel = parallel === VOID ? false : parallel;
  looped = looped === VOID ? false : looped;
  startImmediately = startImmediately === VOID ? Companion_getInstance_42().h9r_1 : startImmediately;
  var tmp;
  if (block === VOID) {
    tmp = animator$lambda;
  } else {
    tmp = block;
  }
  block = tmp;
  _init_properties_Animator_kt__gicf47();
  // Inline function 'kotlin.apply' call
  var tmp0_fastDefaultTime = get_fast(defaultTime);
  var this_0 = new Animator(_this__u8e3s4, tmp0_fastDefaultTime, defaultSpeed, defaultEasing, parallel, looped, null, VOID, 0, startImmediately);
  // Inline function 'kotlin.contracts.contract' call
  block(this_0);
  return this_0;
}
function tween(_this__u8e3s4, vs, time, easing, name, replace) {
  time = time === VOID ? _this__u8e3s4.l9s() : time;
  easing = easing === VOID ? _this__u8e3s4.l9r_1 : easing;
  name = name === VOID ? null : name;
  replace = replace === VOID ? true : replace;
  _init_properties_Animator_kt__gicf47();
  return _this__u8e3s4.p9s(vs.slice(), VOID, get_fast(time), VOID, easing, name, replace);
}
function block(_this__u8e3s4, name, callback) {
  name = name === VOID ? null : name;
  _init_properties_Animator_kt__gicf47();
  _this__u8e3s4.n9s(new BlockNode(name, callback));
}
function simpleAnimator$delegate$lambda($this$PropertyThis) {
  _init_properties_Animator_kt__gicf47();
  // Inline function 'kotlin.also' call
  var this_0 = animator($this$PropertyThis, VOID, VOID, VOID, true);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.animate.simpleAnimator$delegate.<anonymous>.<anonymous>' call
  this_0.w9r_1 = true;
  return this_0;
}
function animator$lambda(_this__u8e3s4) {
  _init_properties_Animator_kt__gicf47();
  return Unit_instance;
}
function simpleAnimator$factory() {
  return getPropertyCallableRef('simpleAnimator', 1, KProperty1, function (receiver) {
    return get_simpleAnimator(receiver);
  }, null);
}
function computedVs$factory() {
  return getPropertyCallableRef('computedVs', 1, KProperty1, function (receiver) {
    return receiver.e9s();
  }, null);
}
function totalTime$factory() {
  return getPropertyCallableRef('totalTime', 1, KProperty1, function (receiver) {
    return new FastDuration(_get_totalTime__xgts5c(receiver));
  }, null);
}
var properties_initialized_Animator_kt_opr5o7;
function _init_properties_Animator_kt__gicf47() {
  if (!properties_initialized_Animator_kt_opr5o7) {
    properties_initialized_Animator_kt_opr5o7 = true;
    simpleAnimator$delegate = new PropertyThis(VOID, simpleAnimator$delegate$lambda);
  }
}
function get_keys(_this__u8e3s4) {
  _init_properties_KeysEvents_kt__ekyd0z();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = keys$delegate;
    var property = keys$factory();
    var tmp0_elvis_lhs = this_0.sx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.tx_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.sx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var keys$delegate;
function *_generator_invoke__zhh2q8_4($this, it, $completion) {
  if ($this.q9s_1.u2(it.k67_1)) {
    var tmp = $this.r9s_1(it, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, e, $completion) {
  if ($this.s9s_1.u2(e.k67_1)) {
    var tmp = $this.t9s_1(e, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = $this.a9t_1.y9s_1.i1w($this.b9t_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var tmp = $this.c9t_1.w9s_1.i1w($this.d9t_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  var tmp = $this.e9t_1.x9s_1.i1w($this.f9t_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KeysEvents$down$slambda_0($keys, $callback) {
  var i = new KeysEvents$down$slambda($keys, $callback);
  var l = function (it, $completion) {
    return i.g9t(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function KeysEvents$up$slambda_0($keys, $callback) {
  var i = new KeysEvents$up$slambda($keys, $callback);
  var l = function (e, $completion) {
    return i.g9t(e, $completion);
  };
  l.$arity = 1;
  return l;
}
function KeysEvents$lambda$slambda_2(this$0, $event) {
  var i = new KeysEvents$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.k66_1;
    tmp.v9s_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.h9t().i9i_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_2(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_3(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_0(this$0, $event);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_0(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.k66_1;
    tmp.v9s_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.h9t().i9i_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_3(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_4(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_1(this$0, $event);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_1(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.k66_1;
    tmp.v9s_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.h9t().i9i_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_4(this$0, event));
    return Unit_instance;
  };
}
function keys$delegate$lambda($this$PropertyThis) {
  _init_properties_KeysEvents_kt__ekyd0z();
  return new KeysEvents($this$PropertyThis);
}
function keys$factory() {
  return getPropertyCallableRef('keys', 1, KProperty1, function (receiver) {
    return get_keys(receiver);
  }, null);
}
var properties_initialized_KeysEvents_kt_1mffin;
function _init_properties_KeysEvents_kt__ekyd0z() {
  if (!properties_initialized_KeysEvents_kt_1mffin) {
    properties_initialized_KeysEvents_kt_1mffin = true;
    keys$delegate = new PropertyThis(VOID, keys$delegate$lambda);
  }
}
function onMouseDragInternal(_this__u8e3s4, timeProvider, info, callback) {
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  info = info === VOID ? new MouseDragInfo(_this__u8e3s4) : info;
  var dragging = {_v: false};
  var sx = {_v: 0.0};
  var sy = {_v: 0.0};
  var cx = {_v: 0.0};
  var cy = {_v: 0.0};
  var view = _this__u8e3s4;
  var mousePos = {_v: Vector2D.w27()};
  var onDownCloseable = null;
  var onUpAnywhereCloseable = null;
  var onMoveAnywhereCloseable = null;
  // Inline function 'korlibs.korge.input.mouse' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  var $this$mouse = get_mouse(_this__u8e3s4);
  // Inline function 'korlibs.korge.input.MouseEvents.onDownCloseable' call
  var handler = onMouseDragInternal$slambda_2(dragging, info, mousePos, sx, sy, cx, cy, callback, timeProvider, view);
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEventCloseable' call
  var tmp = down$factory().get($this$mouse);
  onDownCloseable = tmp.p1v(onMouseDragInternal$lambda($this$mouse, handler));
  // Inline function 'korlibs.korge.input.MouseEvents.onUpAnywhereCloseable' call
  var handler_0 = onMouseDragInternal$slambda_3(dragging, info, mousePos, sx, sy, cx, cy, callback, timeProvider, view);
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEventCloseable' call
  var tmp_0 = upAnywhere$factory().get($this$mouse);
  onUpAnywhereCloseable = tmp_0.p1v(onMouseDragInternal$lambda_0($this$mouse, handler_0));
  // Inline function 'korlibs.korge.input.MouseEvents.onMoveAnywhereCloseable' call
  var handler_1 = onMouseDragInternal$slambda_4(dragging, info, mousePos, sx, sy, cx, cy, callback, timeProvider, view);
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEventCloseable' call
  var tmp_1 = moveAnywhere$factory().get($this$mouse);
  onMoveAnywhereCloseable = tmp_1.p1v(onMouseDragInternal$lambda_1($this$mouse, handler_1));
  var tmp_2;
  if (onDownCloseable == null) {
    throwUninitializedPropertyAccessException('onDownCloseable');
  } else {
    tmp_2 = onDownCloseable;
  }
  var tmp_3 = tmp_2;
  var tmp_4;
  if (onUpAnywhereCloseable == null) {
    throwUninitializedPropertyAccessException('onUpAnywhereCloseable');
  } else {
    tmp_4 = onUpAnywhereCloseable;
  }
  var tmp_5 = tmp_4;
  var tmp_6;
  if (onMoveAnywhereCloseable == null) {
    throwUninitializedPropertyAccessException('onMoveAnywhereCloseable');
  } else {
    tmp_6 = onMoveAnywhereCloseable;
  }
  return to(_this__u8e3s4, new OnMouseDragCloseable(tmp_3, tmp_5, tmp_6));
}
var MouseDragState_START_instance;
var MouseDragState_DRAG_instance;
var MouseDragState_END_instance;
var MouseDragState_entriesInitialized;
function MouseDragState_initEntries() {
  if (MouseDragState_entriesInitialized)
    return Unit_instance;
  MouseDragState_entriesInitialized = true;
  MouseDragState_START_instance = new MouseDragState('START', 0);
  MouseDragState_DRAG_instance = new MouseDragState('DRAG', 1);
  MouseDragState_END_instance = new MouseDragState('END', 2);
}
function draggable(_this__u8e3s4, selector, autoMove, onDrag) {
  selector = selector === VOID ? _this__u8e3s4 : selector;
  autoMove = autoMove === VOID ? true : autoMove;
  onDrag = onDrag === VOID ? null : onDrag;
  return draggableInternal(_this__u8e3s4, selector, autoMove, onDrag).bl_1;
}
function draggableInternal(_this__u8e3s4, selector, autoMove, onDrag) {
  selector = selector === VOID ? _this__u8e3s4 : selector;
  autoMove = autoMove === VOID ? true : autoMove;
  onDrag = onDrag === VOID ? null : onDrag;
  var view = _this__u8e3s4;
  var info = new DraggableInfo(view);
  var onMouseDragCloseable_0 = onMouseDragCloseable(selector, VOID, info, draggableInternal$lambda(info, view, autoMove, onDrag));
  return to(_this__u8e3s4, new DraggableCloseable(onMouseDragCloseable_0));
}
function onMouseDragCloseable(_this__u8e3s4, timeProvider, info, callback) {
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  info = info === VOID ? new MouseDragInfo(_this__u8e3s4) : info;
  return onMouseDragInternal(_this__u8e3s4, timeProvider, info, callback).cl_1;
}
function onMouseDragInternal$views(view) {
  return ensureNotNull(view.n9v()).o9v();
}
function onMouseDragInternal$updateMouse(mousePos, view) {
  var views = onMouseDragInternal$views(view);
  mousePos._v = views.p9v();
}
function onMouseDragInternal$handle(dragging, $info, mousePos, sx, sy, cx, cy, $callback, $timeProvider, view, it, state) {
  if (!state.equals(MouseDragState_START_getInstance()) && !dragging._v)
    return Unit_instance;
  onMouseDragInternal$updateMouse(mousePos, view);
  $info.x9t_1 = it;
  var px = mousePos._v.q24_1;
  var py = mousePos._v.r24_1;
  switch (state.l3_1) {
    case 0:
      dragging._v = true;
      sx._v = px;
      sy._v = py;
      $info.a2q();
      break;
    case 2:
      dragging._v = false;
      break;
    default:
      break;
  }
  cx._v = mousePos._v.q24_1;
  cy._v = mousePos._v.r24_1;
  var dx = cx._v - sx._v;
  var dy = cy._v - sy._v;
  $callback(onMouseDragInternal$views(view), $info.g9u(dx, dy, state.u6a(), state.v6a(), $timeProvider.l1u(), sx._v, sy._v, cx._v, cy._v));
}
function onMouseDragInternal$slambda_2($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
  var i = new onMouseDragInternal$slambda($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view);
  var l = function (it, $completion) {
    return i.a9w(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  var tmp = $this.b9w_1($this.c9w_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onMouseDragInternal$lambda$slambda_2($handler, $it) {
  var i = new onMouseDragInternal$lambda$slambda($handler, $it);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function onMouseDragInternal$lambda($this, $handler) {
  return function (it) {
    var tmp = $this.s9x();
    launchImmediately_0(tmp, onMouseDragInternal$lambda$slambda_2($handler, it));
    return Unit_instance;
  };
}
function onMouseDragInternal$slambda_3($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
  var i = new onMouseDragInternal$slambda_0($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view);
  var l = function (it, $completion) {
    return i.a9w(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  var tmp = $this.d9y_1($this.e9y_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onMouseDragInternal$lambda$slambda_3($handler, $it) {
  var i = new onMouseDragInternal$lambda$slambda_0($handler, $it);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function onMouseDragInternal$lambda_0($this, $handler) {
  return function (it) {
    var tmp = $this.s9x();
    launchImmediately_0(tmp, onMouseDragInternal$lambda$slambda_3($handler, it));
    return Unit_instance;
  };
}
function onMouseDragInternal$slambda_4($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
  var i = new onMouseDragInternal$slambda_1($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view);
  var l = function (it, $completion) {
    return i.a9w(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  var tmp = $this.p9y_1($this.q9y_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onMouseDragInternal$lambda$slambda_4($handler, $it) {
  var i = new onMouseDragInternal$lambda$slambda_1($handler, $it);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function onMouseDragInternal$lambda_1($this, $handler) {
  return function (it) {
    var tmp = $this.s9x();
    launchImmediately_0(tmp, onMouseDragInternal$lambda$slambda_4($handler, it));
    return Unit_instance;
  };
}
function draggableInternal$lambda($info, $view, $autoMove, $onDrag) {
  return function ($this$onMouseDragCloseable, it) {
    var tmp;
    if ($info.p9t_1) {
      $info.c9v_1 = $view.lw();
      tmp = Unit_instance;
    }
    $info.d9v_1 = $view.lw();
    $info.e9v_1 = Vector2D.s24($info.g9v() + $info.e9u($view), $info.h9v() + $info.f9u($view));
    $info.f9v_1 = Vector2D.s24($info.k9v() - $info.i9v(), $info.l9v() - $info.j9v());
    var tmp_0;
    if ($autoMove) {
      xy($view, $info.e9v_1);
      tmp_0 = Unit_instance;
    }
    var tmp0_safe_receiver = $onDrag;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver($info);
    return Unit_instance;
  };
}
function MouseDragState_START_getInstance() {
  MouseDragState_initEntries();
  return MouseDragState_START_instance;
}
function MouseDragState_DRAG_getInstance() {
  MouseDragState_initEntries();
  return MouseDragState_DRAG_instance;
}
function MouseDragState_END_getInstance() {
  MouseDragState_initEntries();
  return MouseDragState_END_instance;
}
function down$factory() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.k9w_1;
  }, null);
}
function upAnywhere$factory() {
  return getPropertyCallableRef('upAnywhere', 1, KProperty1, function (receiver) {
    return receiver.r9w_1;
  }, null);
}
function moveAnywhere$factory() {
  return getPropertyCallableRef('moveAnywhere', 1, KProperty1, function (receiver) {
    return receiver.t9w_1;
  }, null);
}
function set_mouseHitSearch(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitSearch$delegate;
  var property = mouseHitSearch$factory();
  var tmp0_elvis_lhs = this_0.qx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitSearch(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitSearch$delegate;
    var property = mouseHitSearch$factory_0();
    var tmp = _this__u8e3s4.px();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.qx_1;
      tmp_0 = tmp0_safe_receiver.a3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.rx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.qx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.qx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitSearch$delegate;
function set_mouseHitResult(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResult$delegate;
  var property = mouseHitResult$factory();
  var tmp0_elvis_lhs = this_0.qx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResult(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResult$delegate;
    var property = mouseHitResult$factory_0();
    var tmp = _this__u8e3s4.px();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.qx_1;
      tmp_0 = tmp0_safe_receiver.a3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.rx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.qx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.qx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResult$delegate;
function set_mouseHitResultUsed(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResultUsed$delegate;
  var property = mouseHitResultUsed$factory();
  var tmp0_elvis_lhs = this_0.qx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResultUsed(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResultUsed$delegate;
    var property = mouseHitResultUsed$factory_0();
    var tmp = _this__u8e3s4.px();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.qx_1;
      tmp_0 = tmp0_safe_receiver.a3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.rx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.qx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.qx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResultUsed$delegate;
function set_mouseDebugHandlerOnce(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugHandlerOnce$delegate;
  var property = mouseDebugHandlerOnce$factory();
  var tmp0_elvis_lhs = this_0.qx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugHandlerOnce(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugHandlerOnce$delegate;
    var property = mouseDebugHandlerOnce$factory_0();
    var tmp = _this__u8e3s4.px();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.qx_1;
      tmp_0 = tmp0_safe_receiver.a3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.rx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.qx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.qx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugHandlerOnce$delegate;
function set_mouseDebugLastFrameClicked(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugLastFrameClicked$delegate;
  var property = mouseDebugLastFrameClicked$factory();
  var tmp0_elvis_lhs = this_0.qx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugLastFrameClicked(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugLastFrameClicked$delegate;
    var property = mouseDebugLastFrameClicked$factory_0();
    var tmp = _this__u8e3s4.px();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.qx_1;
      tmp_0 = tmp0_safe_receiver.a3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.rx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.qx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.qx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugLastFrameClicked$delegate;
function get_mouse(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = mouse$delegate;
    var property = mouse$factory();
    var tmp0_elvis_lhs = this_0.sx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.tx_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.sx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouse$delegate;
function set_cursor(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = cursor$delegate;
  var property = cursor$factory();
  var tmp0_elvis_lhs = this_0.qx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_cursor(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = cursor$delegate;
    var property = cursor$factory_0();
    var tmp = _this__u8e3s4.px();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.qx_1;
      tmp_0 = tmp0_safe_receiver.a3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.rx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.qx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.qx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var cursor$delegate;
function mouseHitTest($this, views) {
  if (!get_mouseHitSearch(views.l9i_1)) {
    set_mouseHitSearch(views.l9i_1, true);
    set_mouseHitResult(views.l9i_1, views.u9j_1.r9y(views.p9v()));
    var view = get_mouseHitResult(views.l9i_1);
    $l$loop: while (!(view == null) && get_cursor(view) == null) {
      view = view.l23();
    }
    var tmp0_safe_receiver = view;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_cursor(tmp0_safe_receiver);
    var newCursor = tmp1_elvis_lhs == null ? Cursor_DEFAULT_getInstance() : tmp1_elvis_lhs;
    if (!equals(views.o9i_1.x8h(), newCursor)) {
      views.o9i_1.w8h(newCursor);
    }
  }
  return get_mouseHitResult(views.l9i_1);
}
function MouseEvents$Companion$installDebugExtensionOnce$lambda($views) {
  return function (_this__u8e3s4, ctx) {
    var scale = ctx.b8a();
    // Inline function 'kotlin.math.max' call
    var a = 1 * scale;
    var space = Math.max(a, 2.0);
    var matrix = $views.q88();
    var yy = 60 * scale;
    var lineHeight = 8 * scale;
    var mouseHit = mouseHitTest(Companion_instance_17, $views);
    var tmp;
    if (!(mouseHit == null)) {
      var bounds = mouseHit.s9y();
      if (get_mouseDebugLastFrameClicked(_this__u8e3s4)) {
        $views.t9y(mouseHit);
      }
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = _this__u8e3s4.h9j_1.d80_1;
      var this_1 = this_0.m80_1;
      if (!(this_1.h80_1 === this_0)) {
        this_1.h80_1 = this_0;
        this_1.r81();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$1 = get_Bitmaps_white();
      var tmp0_tex = ctx.s81(tmp$ret$1);
      var tmp1_x = bounds.m25_1;
      var tmp2_y = bounds.n25_1;
      var tmp3_width = bounds.o25_1;
      var tmp4_height = bounds.p25_1;
      var tmp5_colorMul = RGBA__withAd_impl_cralao(Colors_getInstance().c3y_1, 0.3);
      var tmp6_m = mouseHit.u9y();
      this_0.t81(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp6_m, VOID, tmp5_colorMul);
      var tmp7_$receiver = _this__u8e3s4.h9j_1;
      var tmp8_font = _this__u8e3s4.v9y();
      var tmp9_str = toString_0(mouseHit) + ' : ' + $views.p9v().q24_1 + ',' + $views.p9v().r24_1;
      var tmp10_y = numberToInt(yy);
      var tmp11_colMul = ctx.c80_1;
      var tmp12_blendMode = Companion_getInstance_13().u7y_1;
      var tmp13_m = get_immutable(matrix);
      drawText(tmp7_$receiver, tmp8_font, lineHeight, tmp9_str, 0, tmp10_y, tmp13_m, tmp11_colMul, tmp12_blendMode, false);
      yy = yy + lineHeight;
      yy = yy + space;
      tmp = Unit_instance;
    }
    var mouseHitResultUsed = get_mouseHitResultUsed(_this__u8e3s4.l9i_1);
    var tmp_0;
    if (!(mouseHitResultUsed == null)) {
      var bounds_0 = mouseHitResultUsed.s9y();
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_2 = _this__u8e3s4.h9j_1.d80_1;
      var this_3 = this_2.m80_1;
      if (!(this_3.h80_1 === this_2)) {
        this_3.h80_1 = this_2;
        this_3.r81();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$4 = get_Bitmaps_white();
      var tmp0_tex_0 = ctx.s81(tmp$ret$4);
      var tmp1_x_0 = bounds_0.m25_1;
      var tmp2_y_0 = bounds_0.n25_1;
      var tmp3_width_0 = bounds_0.o25_1;
      var tmp4_height_0 = bounds_0.p25_1;
      var tmp5_colorMul_0 = Companion_getInstance_2().k4c(0, 0, 255, 63);
      var tmp6_m_0 = mouseHitResultUsed.u9y();
      this_2.t81(tmp0_tex_0, tmp1_x_0, tmp2_y_0, tmp3_width_0, tmp4_height_0, tmp6_m_0, VOID, tmp5_colorMul_0);
      var vview = mouseHitResultUsed;
      while (!(vview == null)) {
        var tmp7_$receiver_0 = _this__u8e3s4.h9j_1;
        var tmp8_font_0 = _this__u8e3s4.v9y();
        var tmp9_str_0 = vview.toString();
        var tmp10_y_0 = numberToInt(yy);
        var tmp11_colMul_0 = ctx.c80_1;
        var tmp12_blendMode_0 = Companion_getInstance_13().u7y_1;
        var tmp13_m_0 = get_immutable(matrix);
        drawText(tmp7_$receiver_0, tmp8_font_0, lineHeight, tmp9_str_0, 0, tmp10_y_0, tmp13_m_0, tmp11_colMul_0, tmp12_blendMode_0, false);
        vview = vview.l23();
        yy = yy + lineHeight;
        yy = yy + space;
      }
      tmp_0 = Unit_instance;
    }
    set_mouseDebugLastFrameClicked(_this__u8e3s4, false);
    return Unit_instance;
  };
}
function MouseEvents$MouseEventsUpdate$lambda(this$0) {
  return function ($this$addUpdaterWithViews, views, dt) {
    this$0.w9y(views, dt.hj_1);
    return Unit_instance;
  };
}
var Companion_instance_17;
function Companion_getInstance_43() {
  return Companion_instance_17;
}
function temporalLastEvent($this, lastEventNew, block) {
  var old = $this.n9x_1;
  var tmp = $this;
  tmp.n9x_1 = lastEventNew == null ? $this.n9x_1 : lastEventNew;
  try {
    return block();
  }finally {
    $this.n9x_1 = old;
  }
}
function MouseEvents$closeable$lambda(this$0) {
  return function (event) {
    var tmp;
    if (!this$0.e9w_1.b9z()) {
      return Unit_instance;
    }
    var tmp_0 = this$0;
    var tmp_1 = event.k66_1;
    tmp_0.f9w_1 = tmp_1 instanceof Views ? tmp_1 : THROW_CCE();
    this$0.m9x_1 = event;
    this$0.n9x_1.r68(event);
    this$0.o9x_1 = event.n68_1;
    this$0.l9x_1 = true;
    var tmp_2;
    switch (event.z67_1.l3_1) {
      case 2:
        this$0.p9x_1.r68(event);
        this$0.g9x_1 = this$0.o9v().l9i_1.k83();
        this$0.d9x_1 = PerformanceCounter_getInstance().s63();
        var elapsedTime = Duration__minus_impl_q5cfm7(this$0.d9x_1, this$0.e9x_1);
        var tmp_3;
        if (this$0.g9x_1.u2g(this$0.f9x_1) < this$0.o9v().l9i_1.r82_1 && Duration__compareTo_impl_pchp0f(elapsedTime, this$0.o9v().l9i_1.q82_1) < 0) {
          var _unary__edvuaz = this$0.k9x_1;
          this$0.k9x_1 = _unary__edvuaz + 1 | 0;
          var tmp_4;
          if (this$0.c9z()) {
            this$0.h9w_1.w1v(this$0);
            var tmp_5;
            if (this$0.h9w_1.a1w() > 0) {
              event.t68(this$0.e9w_1);
              tmp_5 = Unit_instance;
            }
            tmp_4 = tmp_5;
          }
          tmp_3 = tmp_4;
        }

        tmp_2 = tmp_3;
        break;
      case 3:
        if (!event.k68_1) {
          set_mouseDebugLastFrameClicked(this$0.o9v(), true);
        }

        this$0.e9x_1 = PerformanceCounter_getInstance().s63();
        this$0.f9x_1 = this$0.o9v().l9i_1.k83();
        var tmp_6;
        if (this$0.g9w_1.b1w()) {
          var tmp_7;
          if (this$0.c9z()) {
            this$0.g9w_1.w1v(this$0);
            tmp_7 = Unit_instance;
          }
          tmp_6 = tmp_7;
        }

        tmp_2 = tmp_6;
        break;
      case 7:
        if (this$0.c9z()) {
          this$0.w9w_1.w1v(this$0);
        } else {
          this$0.y9w_1.w1v(this$0);
        }

        this$0.x9w_1.w1v(this$0);
        tmp_2 = Unit_instance;
        break;
      default:
        tmp_2 = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
function MouseEvents$update$lambda($over, this$0) {
  return function () {
    var tmp;
    if ($over) {
      this$0.n9w_1.w1v(this$0);
      tmp = Unit_instance;
    } else {
      this$0.o9w_1.w1v(this$0);
      this$0.q9w_1.w1v(this$0);
      tmp = Unit_instance;
    }
    this$0.r9w_1.w1v(this$0);
    return Unit_instance;
  };
}
function mouseHitSearch$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouseHitResult$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseHitResultUsed$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseDebugHandlerOnce$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return new Once();
}
function mouseDebugLastFrameClicked$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouse$delegate$lambda($this$PropertyThis) {
  _init_properties_MouseEvents_kt__io5soc();
  return new MouseEvents($this$PropertyThis);
}
function cursor$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseHitSearch$factory() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitSearch$factory_0() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitResult$factory() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResult$factory_0() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResultUsed$factory() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseHitResultUsed$factory_0() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory_0() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory_0() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouse$factory() {
  return getPropertyCallableRef('mouse', 1, KProperty1, function (receiver) {
    return get_mouse(receiver);
  }, null);
}
function cursor$factory() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
function cursor$factory_0() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
var properties_initialized_MouseEvents_kt_t0zz8y;
function _init_properties_MouseEvents_kt__io5soc() {
  if (!properties_initialized_MouseEvents_kt_t0zz8y) {
    properties_initialized_MouseEvents_kt_t0zz8y = true;
    mouseHitSearch$delegate = new Property(VOID, mouseHitSearch$delegate$lambda);
    mouseHitResult$delegate = new Property(VOID, mouseHitResult$delegate$lambda);
    mouseHitResultUsed$delegate = new Property(VOID, mouseHitResultUsed$delegate$lambda);
    mouseDebugHandlerOnce$delegate = new Property(VOID, mouseDebugHandlerOnce$delegate$lambda);
    mouseDebugLastFrameClicked$delegate = new Property(VOID, mouseDebugLastFrameClicked$delegate$lambda);
    mouse$delegate = new PropertyThis(VOID, mouse$delegate$lambda);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = cursor$delegate$lambda;
    cursor$delegate = new Property(null, default_0);
  }
}
function get_touch(_this__u8e3s4) {
  _init_properties_TouchEvents_kt__159jsq();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = touch$delegate;
    var property = touch$factory();
    var tmp0_elvis_lhs = this_0.sx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.tx_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.sx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var touch$delegate;
function onTouchEvent($this, views, e) {
  $this.ca0_1.f3();
  var now = views.m9i_1.l1u();
  if (e.a6a_1.equals(Type_START_getInstance())) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = e.j6a();
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.d1(_unary__edvuaz);
      if (!it.q69_1.equals(Status_KEEP_getInstance())) {
        var info = $this.ea0($this.da0($this.aa0_1.j2p(), it));
        info.k9z_1 = now;
        info.o9z_1 = views;
        // Inline function 'korlibs.datastructure.set' call
        var this_1 = $this.ba0_1;
        var key = info.h9z_1;
        // Inline function 'kotlin.js.asDynamic' call
        this_1.set(key, info);
        $this.t9z_1.w1v(info);
      }
    }
  }
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_2 = e.j6a();
  var n_0 = 0;
  while (n_0 < this_2.e1()) {
    // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
    var _unary__edvuaz_0 = n_0;
    n_0 = _unary__edvuaz_0 + 1 | 0;
    var it_0 = this_2.d1(_unary__edvuaz_0);
    // Inline function 'korlibs.datastructure.get' call
    var this_3 = $this.ba0_1;
    var key_0 = it_0.n69_1;
    // Inline function 'kotlin.js.asDynamic' call
    var info_0 = this_3.get(key_0);
    if (!(info_0 == null)) {
      info_0.n9z_1 = now;
      $this.ca0_1.h($this.da0(info_0, it_0));
    }
  }
  if (e.a6a_1.equals(Type_START_getInstance())) {
    $this.v9z_1.w1v($this);
  }
  if (e.a6a_1.equals(Type_MOVE_getInstance())) {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = $this.ca0_1.ey_1;
    var n_1 = 0;
    while (n_1 < array.length) {
      // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_1 = n_1;
      n_1 = _unary__edvuaz_1 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it_1 = array[_unary__edvuaz_1];
      $this.u9z_1.w1v(it_1);
    }
    $this.w9z_1.w1v($this);
  }
  if (e.a6a_1.equals(Type_END_getInstance())) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_4 = e.j6a();
    var n_2 = 0;
    while (n_2 < this_4.e1()) {
      // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
      var _unary__edvuaz_2 = n_2;
      n_2 = _unary__edvuaz_2 + 1 | 0;
      var it_2 = this_4.d1(_unary__edvuaz_2);
      if (!it_2.q69_1.equals(Status_KEEP_getInstance())) {
        // Inline function 'korlibs.datastructure.get' call
        var this_5 = $this.ba0_1;
        var key_1 = it_2.n69_1;
        // Inline function 'kotlin.js.asDynamic' call
        var info_1 = this_5.get(key_1);
        if (!(info_1 == null)) {
          $this.z9z_1.w1v($this.da0(info_1, it_2));
          $this.x9z_1.w1v($this);
          // Inline function 'korlibs.datastructure.remove' call
          var this_6 = $this.ba0_1;
          var key_2 = info_1.h9z_1;
          // Inline function 'kotlin.js.asDynamic' call
          this_6.delete(key_2);
          $this.aa0_1.k2p(info_1);
        }
      }
    }
  }
  $this.y9z_1.w1v($this);
}
function TouchEvents$infoPool$lambda(it) {
  return new Info(it);
}
function TouchEvents$lambda(this$0) {
  return function (e) {
    var tmp = e.k66_1;
    onTouchEvent(this$0, tmp instanceof Views ? tmp : THROW_CCE(), e);
    return Unit_instance;
  };
}
function singleTouch(_this__u8e3s4, removeTouch, supportStartAnywhere, block) {
  removeTouch = removeTouch === VOID ? false : removeTouch;
  supportStartAnywhere = supportStartAnywhere === VOID ? false : supportStartAnywhere;
  _init_properties_TouchEvents_kt__159jsq();
  var ids = FastIntMap();
  touch(_this__u8e3s4, singleTouch$lambda(_this__u8e3s4, supportStartAnywhere, ids, block, removeTouch));
}
function touch(_this__u8e3s4, block) {
  _init_properties_TouchEvents_kt__159jsq();
  return block(get_touch(_this__u8e3s4));
}
function singleTouch$getById(ids, $block, id) {
  var tmp$ret$2;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var res = ids.get(id);
    if (!(res == null)) {
      tmp$ret$2 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.input.singleTouch.getById.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = new singleTouch$SingleTouchInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.singleTouch.getById.<anonymous>.<anonymous>' call
    $block(this_0.pa0_1, id);
    var out = this_0;
    // Inline function 'korlibs.datastructure.set' call
    // Inline function 'kotlin.js.asDynamic' call
    ids.set(id, out);
    tmp$ret$2 = out;
  }
  return tmp$ret$2;
}
function touch$delegate$lambda($this$PropertyThis) {
  _init_properties_TouchEvents_kt__159jsq();
  return new TouchEvents($this$PropertyThis);
}
function singleTouch$lambda$lambda($this_singleTouch, $supportStartAnywhere, $ids, $block) {
  return function (it) {
    var info = singleTouch$getById($ids, $block, it.h9z_1);
    var handler = info.pa0_1;
    info.qa0_1 = !($this_singleTouch.ra0(it.l9z_1) == null);
    var tmp;
    if (handler.ha0_1.b1w() && info.qa0_1) {
      handler.ha0_1.w1v(it);
      tmp = Unit_instance;
    }
    var tmp_0;
    if ($supportStartAnywhere) {
      handler.ia0_1.w1v(it);
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function singleTouch$lambda$lambda_0($supportStartAnywhere, $this_singleTouch, $ids, $block) {
  return function (it) {
    var info = singleTouch$getById($ids, $block, it.h9z_1);
    var tmp;
    if (!$supportStartAnywhere && !info.qa0_1) {
      return Unit_instance;
    }
    var handler = info.pa0_1;
    var tmp_0;
    if (handler.ja0_1.b1w() && !($this_singleTouch.ra0(it.l9z_1) == null)) {
      handler.ja0_1.w1v(it);
      tmp_0 = Unit_instance;
    }
    handler.ka0_1.w1v(it);
    return Unit_instance;
  };
}
function singleTouch$lambda$lambda_1($supportStartAnywhere, $this_singleTouch, $removeTouch, $ids, $block) {
  return function (it) {
    var info = singleTouch$getById($ids, $block, it.h9z_1);
    var tmp;
    if (!$supportStartAnywhere && !info.qa0_1) {
      return Unit_instance;
    }
    var handler = info.pa0_1;
    var hitTest = handler.la0_1.b1w() || handler.na0_1.b1w() ? !($this_singleTouch.ra0(it.l9z_1) == null) : false;
    var tmp_0;
    if (hitTest) {
      handler.la0_1.w1v(it);
      tmp_0 = Unit_instance;
    }
    handler.ma0_1.w1v(it);
    var tmp_1;
    if (Companion_getInstance_29().p2g(it.m9z_1, it.l9z_1) <= it.o9v().l9i_1.r82_1 && Duration__compareTo_impl_pchp0f(it.p9z(), it.o9v().l9i_1.q82_1) <= 0) {
      if (info.qa0_1 && hitTest) {
        handler.na0_1.w1v(it);
      }
      handler.oa0_1.w1v(it);
      tmp_1 = Unit_instance;
    }
    var tmp_2;
    if ($removeTouch) {
      var this_0 = $ids;
      var key = it.h9z_1;
      // Inline function 'kotlin.js.asDynamic' call
      this_0.delete(key);
      tmp_2 = Unit_instance;
    }
    return Unit_instance;
  };
}
function singleTouch$lambda($this_singleTouch, $supportStartAnywhere, $ids, $block, $removeTouch) {
  return function ($this$touch) {
    $this$touch.t9z_1.v1v(singleTouch$lambda$lambda($this_singleTouch, $supportStartAnywhere, $ids, $block));
    $this$touch.u9z_1.v1v(singleTouch$lambda$lambda_0($supportStartAnywhere, $this_singleTouch, $ids, $block));
    $this$touch.z9z_1.v1v(singleTouch$lambda$lambda_1($supportStartAnywhere, $this_singleTouch, $removeTouch, $ids, $block));
    return Unit_instance;
  };
}
function touch$factory() {
  return getPropertyCallableRef('touch', 1, KProperty1, function (receiver) {
    return get_touch(receiver);
  }, null);
}
var properties_initialized_TouchEvents_kt_a232zc;
function _init_properties_TouchEvents_kt__159jsq() {
  if (!properties_initialized_TouchEvents_kt_a232zc) {
    properties_initialized_TouchEvents_kt_a232zc = true;
    touch$delegate = new PropertyThis(VOID, touch$delegate$lambda);
  }
}
function materialRoundRect(_this__u8e3s4, x, y, width, height, color, radius, shadowOffset, shadowColor, shadowRadius, highlightPos, highlightRadius, highlightColor, borderSize, borderColor) {
  color = color === VOID ? Colors_getInstance().c3y_1 : color;
  radius = radius === VOID ? Companion_getInstance_30().k2d_1 : radius;
  shadowOffset = shadowOffset === VOID ? Companion_getInstance_29().e25_1 : shadowOffset;
  shadowColor = shadowColor === VOID ? Colors_getInstance().b3y_1 : shadowColor;
  shadowRadius = shadowRadius === VOID ? 0.0 : shadowRadius;
  highlightPos = highlightPos === VOID ? Companion_getInstance_29().e25_1 : highlightPos;
  highlightRadius = highlightRadius === VOID ? 0.0 : highlightRadius;
  highlightColor = highlightColor === VOID ? Colors_getInstance().a3y_1 : highlightColor;
  borderSize = borderSize === VOID ? 0.0 : borderSize;
  borderColor = borderColor === VOID ? Colors_getInstance().a3y_1 : borderColor;
  $l$block: {
    // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
    var this_0 = _this__u8e3s4.e61().t6l(MaterialBlockUB_getInstance());
    var _unary__edvuaz = this_0.i6n();
    this_0.x7a(_unary__edvuaz + 1 | 0);
    this_0.y7a(this_0.i6n() + 1 | 0);
    var blockSize = this_0.m6l_1;
    var index0 = imul(this_0.i6n() - 1 | 0, blockSize);
    var index1 = imul(this_0.i6n(), blockSize);
    var texBlockSize = this_0.j6l_1.i6t().e1();
    var texIndex0 = imul(this_0.i6n() - 1 | 0, texBlockSize);
    var texIndex1 = imul(this_0.i6n(), texBlockSize);
    if (this_0.i6n() > 0) {
      arraycopy(this_0.o6l_1, index0, this_0.o6l_1, index1, blockSize);
    } else {
      arrayfill(this_0.o6l_1, 0, 0, blockSize);
    }
    // Inline function 'korlibs.korge.render.materialRoundRect.<anonymous>' call
    var $this$push = this_0.j6l_1;
    var it = this_0.p6l_1;
    it.k7b($this$push.ha1(), radius);
    it.e7b($this$push.ia1(), Vector2F.e2i(width, height));
    it.h7b($this$push.ja1(), _RGBA___get_premultipliedFast__impl__qiau4g(color));
    it.g7b($this$push.ka1(), times(highlightPos, Size2D.a2e(width, height)));
    var tmp = $this$push.la1();
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    it.d7b(tmp, highlightRadius * tmp$ret$0 * 1.25);
    it.h7b($this$push.ma1(), _RGBA___get_premultipliedFast__impl__qiau4g(highlightColor));
    it.c7b($this$push.na1(), borderSize * 0.5);
    it.h7b($this$push.oa1(), _RGBA___get_premultipliedFast__impl__qiau4g(borderColor));
    it.h7b($this$push.pa1(), _RGBA___get_premultipliedFast__impl__qiau4g(shadowColor));
    it.g7b($this$push.qa1(), shadowOffset);
    it.d7b($this$push.ra1(), shadowRadius);
    if (true && this_0.i6n() >= 1) {
      var equals = arrayequal(this_0.o6l_1, index0, this_0.o6l_1, index1, blockSize);
      if (equals) {
        var _unary__edvuaz_0 = this_0.i6n();
        this_0.x7a(_unary__edvuaz_0 - 1 | 0);
        break $l$block;
      }
    }
  }
  _this__u8e3s4.f8b(x, y, width, height, MaterialRender_getInstance().da2_1, Margin.j28(shadowRadius + shadowOffset.a()));
}
function drawText_0(_this__u8e3s4, placements, textRangeStart, textRangeEnd, filtering) {
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  filtering = filtering === VOID ? _this__u8e3s4.c8b_1 : filtering;
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n_0 = 0;
  while (n_0 < placements.e1()) {
    // Inline function 'korlibs.korge.render.drawText.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    var it = placements.d1(_unary__edvuaz);
    var tmp = get_lazyBitmap(it.t5r_1);
    var tmp_0 = it.u5r_1;
    var tmp_1;
    if (tmp_0 == null ? true : tmp_0 instanceof RGBA) {
      var tmp_2 = tmp_0;
      tmp_1 = tmp_2 == null ? null : tmp_2.u4d_1;
    } else {
      tmp_1 = null;
    }
    var tmp0_elvis_lhs = tmp_1;
    var tmp_3;
    var tmp_4 = tmp0_elvis_lhs;
    if ((tmp_4 == null ? null : new RGBA(tmp_4)) == null) {
      tmp_3 = Colors_getInstance().a3y_1;
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    drawText_1(_this__u8e3s4, it.q5r_1, tmp, it.s5r_1, it.r5r_1, tmp_3, true, textRangeStart - n | 0, textRangeEnd - n | 0, filtering);
    n = n + it.q5r_1.length | 0;
  }
}
var MaterialBlockUB_instance;
function MaterialBlockUB_getInstance() {
  if (MaterialBlockUB_instance === VOID)
    new MaterialBlockUB();
  return MaterialBlockUB_instance;
}
var MaterialRender_instance;
function MaterialRender_getInstance() {
  if (MaterialRender_instance === VOID)
    new MaterialRender();
  return MaterialRender_instance;
}
function drawText_1(_this__u8e3s4, text, font, textSize, pos, color, baseline, textRangeStart, textRangeEnd, filtering) {
  textSize = textSize === VOID ? 16.0 : textSize;
  pos = pos === VOID ? Companion_getInstance_29().e25_1 : pos;
  color = color === VOID ? Colors_getInstance().a3y_1 : color;
  baseline = baseline === VOID ? false : baseline;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  filtering = filtering === VOID ? _this__u8e3s4.c8b_1 : filtering;
  var scale = font.t4p(textSize);
  var sx = pos.q24_1;
  var sy = pos.r24_1 + (baseline ? -font.e3g() * scale : 0.0);
  var n = 0;
  var inductionVariable = 0;
  var last = text.length;
  while (inductionVariable < last) {
    var char = charSequenceGet(text, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    var glyph = font.v4p(char);
    if (textRangeStart <= n ? n < textRangeEnd : false) {
      _this__u8e3s4.e8b(new Rectangle(sx + glyph.d4o_1 * scale, sy + glyph.e4o_1 * scale, glyph.l4o() * scale, glyph.m4o() * scale), RGBA__times_impl_wehs9n(color, _this__u8e3s4.b8b_1), filtering, glyph.c4o_1, get_agProgram(font));
    }
    sx = sx + glyph.f4o_1 * scale;
    n = n + 1 | 0;
  }
}
function u_ShadowColor$factory() {
  return getPropertyCallableRef('u_ShadowColor', 1, KProperty1, function (receiver) {
    return receiver.pa1();
  }, null);
}
function u_ShadowRadius$factory() {
  return getPropertyCallableRef('u_ShadowRadius', 1, KProperty1, function (receiver) {
    return receiver.ra1();
  }, null);
}
function u_ShadowOffset$factory() {
  return getPropertyCallableRef('u_ShadowOffset', 1, KProperty1, function (receiver) {
    return receiver.qa1();
  }, null);
}
function u_HighlightPos$factory() {
  return getPropertyCallableRef('u_HighlightPos', 1, KProperty1, function (receiver) {
    return receiver.ka1();
  }, null);
}
function u_HighlightRadius$factory() {
  return getPropertyCallableRef('u_HighlightRadius', 1, KProperty1, function (receiver) {
    return receiver.la1();
  }, null);
}
function u_HighlightColor$factory() {
  return getPropertyCallableRef('u_HighlightColor', 1, KProperty1, function (receiver) {
    return receiver.ma1();
  }, null);
}
function u_Size$factory() {
  return getPropertyCallableRef('u_Size', 1, KProperty1, function (receiver) {
    return receiver.ia1();
  }, null);
}
function u_Radius$factory() {
  return getPropertyCallableRef('u_Radius', 1, KProperty1, function (receiver) {
    return receiver.ha1();
  }, null);
}
function u_BorderSizeHalf$factory() {
  return getPropertyCallableRef('u_BorderSizeHalf', 1, KProperty1, function (receiver) {
    return receiver.na1();
  }, null);
}
function u_BorderColor$factory() {
  return getPropertyCallableRef('u_BorderColor', 1, KProperty1, function (receiver) {
    return receiver.oa1();
  }, null);
}
function u_BackgroundColor$factory() {
  return getPropertyCallableRef('u_BackgroundColor', 1, KProperty1, function (receiver) {
    return receiver.ja1();
  }, null);
}
function u_ShadowColor$factory_0() {
  return getPropertyCallableRef('u_ShadowColor', 1, KProperty1, function (receiver) {
    return receiver.pa1();
  }, null);
}
function u_ShadowRadius$factory_0() {
  return getPropertyCallableRef('u_ShadowRadius', 1, KProperty1, function (receiver) {
    return receiver.ra1();
  }, null);
}
function u_ShadowOffset$factory_0() {
  return getPropertyCallableRef('u_ShadowOffset', 1, KProperty1, function (receiver) {
    return receiver.qa1();
  }, null);
}
function u_HighlightPos$factory_0() {
  return getPropertyCallableRef('u_HighlightPos', 1, KProperty1, function (receiver) {
    return receiver.ka1();
  }, null);
}
function u_HighlightRadius$factory_0() {
  return getPropertyCallableRef('u_HighlightRadius', 1, KProperty1, function (receiver) {
    return receiver.la1();
  }, null);
}
function u_HighlightColor$factory_0() {
  return getPropertyCallableRef('u_HighlightColor', 1, KProperty1, function (receiver) {
    return receiver.ma1();
  }, null);
}
function u_Size$factory_0() {
  return getPropertyCallableRef('u_Size', 1, KProperty1, function (receiver) {
    return receiver.ia1();
  }, null);
}
function u_Radius$factory_0() {
  return getPropertyCallableRef('u_Radius', 1, KProperty1, function (receiver) {
    return receiver.ha1();
  }, null);
}
function u_BorderSizeHalf$factory_0() {
  return getPropertyCallableRef('u_BorderSizeHalf', 1, KProperty1, function (receiver) {
    return receiver.na1();
  }, null);
}
function u_BorderColor$factory_0() {
  return getPropertyCallableRef('u_BorderColor', 1, KProperty1, function (receiver) {
    return receiver.oa1();
  }, null);
}
function u_BackgroundColor$factory_0() {
  return getPropertyCallableRef('u_BackgroundColor', 1, KProperty1, function (receiver) {
    return receiver.ja1();
  }, null);
}
function set__debugAnnotateView(_this__u8e3s4, _set____db54di) {
  _init_properties_RenderContextExt_kt__49d41k();
  var this_0 = _debugAnnotateView$delegate;
  var property = _debugAnnotateView$factory();
  var tmp0_elvis_lhs = this_0.qx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _debugAnnotateView$delegate;
    var property = _debugAnnotateView$factory_0();
    var tmp = _this__u8e3s4.px();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.qx_1;
      tmp_0 = tmp0_safe_receiver.a3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.rx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.qx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.qx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _debugAnnotateView$delegate;
function get_debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  return get__debugAnnotateView(_this__u8e3s4);
}
function get_views(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp = _this__u8e3s4.g7z_1;
  return tmp instanceof Views ? tmp : null;
}
function _debugAnnotateView$delegate$lambda() {
  _init_properties_RenderContextExt_kt__49d41k();
  return null;
}
function _debugAnnotateView$factory() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
function _debugAnnotateView$factory_0() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
var properties_initialized_RenderContextExt_kt_9hx4ly;
function _init_properties_RenderContextExt_kt__49d41k() {
  if (!properties_initialized_RenderContextExt_kt_9hx4ly) {
    properties_initialized_RenderContextExt_kt_9hx4ly = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _debugAnnotateView$delegate$lambda;
    _debugAnnotateView$delegate = new Property(null, default_0);
  }
}
function *_generator_sceneAfterDestroyInternal__rup219($this, $completion) {
  var tmp = $this.va2($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    cancel($this.q14(), SceneCancellationException.ka2($this));
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function Scene$coroutineContext$delegate$lambda(this$0) {
  return function () {
    return this$0.o9v().i9i_1.xm(new InjectorContext(this$0.wa2())).xm(SupervisorJob(this$0.o9v().i9i_1.xc(Key_instance))).xm(CoroutineName.k1b('Scene:' + toString(this$0)));
  };
}
function Scene$sceneView$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.apply' call
    var this_0 = this$0.ya2(this$0.xa2().e1());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.Scene.sceneView$delegate.<anonymous>.<anonymous>' call
    this$0.qa2_1.ha5(this_0);
    return this_0;
  };
}
function Scene$resources$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.inject.Injector.getSync' call
    return this$0.wa2().g63(getKClass(Resources));
  };
}
function onSizeChanged($this, sceneView, size_0) {
  var width = size_0.dl();
  var height = size_0.el();
  var out = place_0(new Rectangle(0.0, 0.0, width, height), Size2D.j26($this.fa9(), $this.ga9()), $this.da9_1, $this.ca9_1);
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.korge.view.size' call
  var width_0 = $this.fa9();
  var height_0 = $this.ga9();
  var tmp$ret$0 = size(sceneView, numberToDouble(width_0), numberToDouble(height_0));
  var this_0 = scale(xy_0(tmp$ret$0, out.m25_1, out.n25_1), out.o25_1 / $this.fa9(), out.p25_1 / $this.ga9());
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.ScaledScene.onSizeChanged.<anonymous>' call
  set_filter(this_0, $this.ea9_1 ? Linear_getInstance() : Nearest_getInstance());
}
function coroutineContext$factory() {
  return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
    return receiver.q14();
  }, null);
}
function sceneView$factory() {
  return getPropertyCallableRef('sceneView', 1, KProperty1, function (receiver) {
    return receiver.la5();
  }, null);
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  var scene = $this.ha9_1.s9p_1;
  if (!(scene == null)) {
    println('[ReloadEvent] Reloading ' + toString_0($this.ha9_1.s9p_1) + ' . doFullReload=' + $this.ia9_1.pa9());
    var tmp;
    if ($this.ia9_1.pa9()) {
      tmp = $this.ia9_1.qa9(getKClassFromExpression(scene), scene.wa2());
    } else {
      tmp = getKClassFromExpression(scene);
    }
    var tmp_0 = tmp;
    var sceneClass = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
    var this_0 = $this.ha9_1;
    var injects = [];
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var time = toDuration(0, DurationUnit_SECONDS_getInstance());
    var transition = this_0.q9p_1;
    var sceneInjector = this_0.p9p_1.k9i_1.z62().x62(getKClass(SceneContainer), this_0).x62(getKClass(Resources), new Resources(this_0.q14(), this_0.p9p_1.r9q().e33_1, this_0.p9p_1.r9q()));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < injects.length) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var inject = injects[_unary__edvuaz];
      var tmp_1 = getKClassFromExpression(inject);
      sceneInjector.x62(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), inject);
    }
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = sceneInjector.g63(sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $this.ia9_1.c7y(scene, this_1);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    var newScene = this_1;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_44().ra9_1;
    var level = Level_INFO_getInstance();
    var tmp_2;
    if (this_2.h2t(level)) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var tmp$ret$4 = 'Changing scene to... ' + toString(sceneClass) + ' ... ' + toString(newScene);
      this_2.i2t(level, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
    if (false) {
      newScene.i63(sceneInjector);
      var tmp_3 = getKClassFromExpression(newScene);
      var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
      this_0.p9p_1.k9i_1.b63(tmp_4, SceneContainer$lambda$slambda$lambda(sceneInjector, sceneClass, $this.ia9_1, scene));
    }
    var tmp_5 = this_0.ta9(newScene, time, transition, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var scene_0 = tmp_5;
    scene_0.o9v().t9y(scene_0.la5());
  }
  return Unit_instance;
}
function SceneContainer$lambda$slambda$lambda($sceneInjector, $sceneClass, $event, $scene) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = $sceneInjector.g63($sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $event.c7y($scene, this_0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    return this_0;
  };
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.ua9_1.la5();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.ua9_1.ya7(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return this_0;
}
function *_generator_invoke__zhh2q8_14($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.va9_1.la5();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.va9_1.za7(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_15($this, $completion) {
  var tmp = $this.wa9_1.ba8($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  var tmp = $this.xa9_1.ca8($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.xa9_1.da8();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_17($this, $completion) {
  var tmp = $this.ya9_1.ea8($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_18($this, $completion) {
  var tmp = $this.za9_1.aa8($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator__changeTo__ueovgq($this, clazz, injects, time, transition, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects_0 = injects.slice();
  var sceneInjector = $this.p9p_1.k9i_1.z62().x62(getKClass(SceneContainer), $this).x62(getKClass(Resources), new Resources($this.q14(), $this.p9p_1.r9q().e33_1, $this.p9p_1.r9q()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.x62(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
  var newScene = sceneInjector.g63(clazz);
  // Inline function 'korlibs.logger.Logger.info' call
  var this_0 = Companion_getInstance_44().ra9_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_0.h2t(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_0.i2t(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (false) {
    newScene.i63(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    $this.p9p_1.k9i_1.b63(tmp_2, SceneContainer$_changeTo$lambda(sceneInjector, clazz));
  }
  var tmp_3 = $this.ta9(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return tmp_3;
}
function _changeTo($this, clazz, injects, time, transition, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq.bind(VOID, $this, clazz, injects, time, transition), $completion);
}
function *_generator__changeTo__ueovgq_0($this, newScene, time, transition, $completion) {
  var oldScene = $this.s9p_1;
  $this.s9p_1 = newScene;
  $this.r9p_1.lac(newScene.qa2_1, transition);
  try {
    var tmp = newScene.q14();
    var tmp_0 = launchUnscopedAndWait(tmp, SceneContainer$_changeTo$slambda_5(newScene), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  finally {
  }
  launchUnscoped(newScene, SceneContainer$_changeTo$slambda_6(newScene));
  if (!(oldScene == null)) {
    var tmp_1 = oldScene.q14();
    var tmp_2 = launchUnscopedAndWait(tmp_1, SceneContainer$_changeTo$slambda_7(oldScene), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$3 = toDuration(0, DurationUnit_SECONDS_getInstance());
  if (Duration__compareTo_impl_pchp0f(time, tmp$ret$3) > 0) {
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = ratio$factory($this.r9p_1);
    var initial = Companion_getInstance_38().cx_1;
    var end = Companion_getInstance_38().fx_1;
    var tmp$ret$4 = new V2(this_0, new Ratio(initial), new Ratio(end), _interpolateRatio$ref(), true);
    var tmp_3 = tween_0($this.r9p_1, [tmp$ret$4], time, VOID, VOID, VOID, VOID, VOID, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  } else {
    $this.r9p_1.iac_1 = Companion_getInstance_38().fx_1;
  }
  $this.r9p_1.mac();
  if (!(oldScene == null)) {
    var tmp_4 = oldScene.q14();
    var tmp_5 = launchUnscopedAndWait(tmp_4, SceneContainer$_changeTo$slambda_8(oldScene), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    launchUnscoped(oldScene, SceneContainer$_changeTo$slambda_9(oldScene));
  }
  var tmp_6 = newScene.q14();
  launchUnscoped_0(tmp_6, SceneContainer$_changeTo$slambda_10(newScene));
  return newScene;
}
var Companion_instance_18;
function Companion_getInstance_44() {
  if (Companion_instance_18 === VOID)
    new Companion_3();
  return Companion_instance_18;
}
function SceneContainer$lambda$lambda(this$0) {
  return function (it) {
    var tmp;
    if (it instanceof SceneContainer) {
      tmp = !equals(it, this$0);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function SceneContainer$lambda$slambda_0(this$0, $event) {
  var i = new SceneContainer$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$lambda(this$0) {
  return function (event) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var hasChildScenes = !descendantsWith(this$0, VOID, SceneContainer$lambda$lambda(this$0)).g1();
    var tmp;
    if (hasChildScenes) {
      println('[ReloadEvent] Scene ' + toString_0(this$0.s9p_1) + ' not reloaded because has child scenes...');
      return Unit_instance;
    }
    launchImmediately(this$0, SceneContainer$lambda$slambda_0(this$0, event));
    return Unit_instance;
  };
}
function SceneContainer$_changeTo$lambda($sceneInjector, $clazz) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
    return $sceneInjector.g63($clazz);
  };
}
function SceneContainer$_changeTo$slambda_5($newScene) {
  var i = new SceneContainer$_changeTo$slambda($newScene);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_6($newScene) {
  var i = new SceneContainer$_changeTo$slambda_0($newScene);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_7($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_1($oldScene);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function _interpolateRatio$ref() {
  var l = function (p0, p1, p2) {
    return new Ratio(_interpolateRatio(p0.bx_1, p1.bx_1, p2.bx_1));
  };
  l.callableName = '_interpolateRatio';
  return l;
}
function SceneContainer$_changeTo$slambda_8($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_2($oldScene);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_9($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_3($oldScene);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_10($newScene) {
  var i = new SceneContainer$_changeTo$slambda_4($newScene);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function ratio$factory($b0) {
  return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
    return new Ratio($b0.iac_1);
  }, function (value) {
    $b0.iac_1 = value.bx_1;
    return Unit_instance;
  });
}
function get_AlphaTransition() {
  _init_properties_Transition_kt__s6zoln();
  return AlphaTransition;
}
var AlphaTransition;
function Transition(name, render) {
  name = name === VOID ? 'Transition' : name;
  _init_properties_Transition_kt__s6zoln();
  return new Transition$1(render, name);
}
function withEasing(_this__u8e3s4, easing) {
  _init_properties_Transition_kt__s6zoln();
  return new withEasing$1(_this__u8e3s4, easing);
}
function _get_transitionProcess__5hlux5($this) {
  var tmp = $this.kac_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('transitionProcess');
  }
}
function AlphaTransition$lambda(ctx, prev, next, ratio) {
  _init_properties_Transition_kt__s6zoln();
  var prevAlpha = prev.sak();
  var nextAlpha = next.sak();
  try {
    prev.rak(1.0 - Ratio__toFloat_impl_1ftup5(ratio.bx_1));
    next.rak(Ratio__toFloat_impl_1ftup5(ratio.bx_1));
    prev.qaf(ctx);
    next.qaf(ctx);
  }finally {
    prev.rak(prevAlpha);
    next.rak(nextAlpha);
  }
  return Unit_instance;
}
var properties_initialized_Transition_kt_wb2qvd;
function _init_properties_Transition_kt__s6zoln() {
  if (!properties_initialized_Transition_kt_wb2qvd) {
    properties_initialized_Transition_kt_wb2qvd = true;
    AlphaTransition = Transition('AlphaTransition', AlphaTransition$lambda);
  }
}
function createProgram$_anonymous_$lambda$0_hhid5m($median$delegate) {
  return $median$delegate.ho(null, getLocalDelegateReference('median', KProperty0, false, function () {
    return THROW_ISE();
  }));
}
function MsdfRender$createProgram$lambda($this$FUNC, a, b, c) {
  $this$FUNC.g6x($this$FUNC.o7i($this$FUNC.n7i(a, b), $this$FUNC.n7i($this$FUNC.o7i(a, b), c)));
  return Unit_instance;
}
function MsdfRender$createProgram$lambda_0($$this$buildShader) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.t6v($this$IF_ELSE_BINARY_LOOKUP.w6v(), $this$IF_ELSE_BINARY_LOOKUP.e6w(Companion_getInstance_6().g86_1[n], $this$IF_ELSE_BINARY_LOOKUP.c6w($$this$buildShader.p6v(), 'xy')));
    return Unit_instance;
  };
}
var MsdfRender_instance;
function MsdfRender_getInstance() {
  if (MsdfRender_instance === VOID)
    new MsdfRender();
  return MsdfRender_instance;
}
function get_DEFAULT_EASING() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_EASING;
}
var DEFAULT_EASING;
function get_DEFAULT_TIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_TIME;
}
var DEFAULT_TIME;
function get_DEFAULT_FTIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_FTIME;
}
var DEFAULT_FTIME;
function tween_0(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_TIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  var tmp;
  if (waitTime === VOID) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance();
    tmp = get_DURATION_NIL();
  } else {
    tmp = waitTime;
  }
  waitTime = tmp;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp_0;
  if (callback === VOID) {
    tmp_0 = tween$lambda;
  } else {
    tmp_0 = callback;
  }
  callback = tmp_0;
  return tween_1(_this__u8e3s4, vs.slice(), get_fast(time), easing, get_fast(waitTime), timeout, autoInvalidate, callback, $completion);
}
function *_generator_tween__vopi21(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.r1u() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  if (!(_this__u8e3s4 == null)) {
    var tc = {_v: null};
    try {
      var tmp_0;
      if (timeout) {
        // Inline function 'korlibs.time.FastDuration.times' call
        var tmp$ret$0 = FastDuration__times_impl_h6amcp(time, numberToDouble(2));
        tmp_0 = FastDuration__plus_impl_q1enab(tmp$ret$0, get_fastMilliseconds_0(300));
      } else {
        tmp_0 = Companion_instance_1.r1u();
      }
      var tmp_1 = tmp_0;
      var tmp_2 = withTimeoutNullable(tmp_1, tween$slambda_0(_this__u8e3s4, tc, vs, time, easing, callback, waitTime, autoInvalidate), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    } catch ($p) {
      if ($p instanceof TimeoutCancellationException) {
        var e = $p;
        var tmp0_safe_receiver = tc._v;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.kan(time);
        }
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function tween_1(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.r1u() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_tween__vopi21.bind(VOID, _this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback), $completion);
}
function _update($this, dt) {
  if ($this.dan_1) {
    $this.wam_1.j9s();
  }
  if ($this.gan_1) {
    return $this.pan();
  }
  $this.ean_1 = FastDuration__plus_impl_q1enab($this.ean_1, dt);
  var ratio = clamp(FastDuration__div_impl_rlslck($this.ean_1, $this.fan_1), 0.0, 1.0);
  $this.kan($this.ean_1);
  $this.aan_1($this.zam_1.vw(ratio));
  var tmp;
  var tmp_0 = $this.qan();
  // Inline function 'korlibs.time.NIL' call
  Companion_getInstance();
  var tmp$ret$0 = get_DURATION_NIL();
  if (!equals(tmp_0, tmp$ret$0)) {
    tmp = FastDuration__compareTo_impl_4fhnj7_0($this.ean_1, $this.qan()) >= 0;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.ran();
  }
  if (ratio >= 1.0) {
    return $this.pan();
  }
}
function TweenComponent$updater$lambda(this$0) {
  return function (it) {
    _update(this$0, it.j8k_1);
    return Unit_instance;
  };
}
function TweenComponent$lambda(this$0) {
  return function (it) {
    this$0.gan_1 = true;
    return Unit_instance;
  };
}
function *_generator_withTimeoutNullable__i31xu0(time, block, $completion) {
  var tmp;
  var tmp_0;
  var tmp_1 = time;
  if ((tmp_1 == null ? null : new FastDuration(tmp_1)) == null) {
    tmp_0 = true;
  } else {
    var tmp_2 = time;
    tmp_0 = equals(tmp_2 == null ? null : new FastDuration(tmp_2), new FastDuration(Companion_instance_1.r1u()));
  }
  if (tmp_0) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.kc();
    var tmp_3 = block(CoroutineScope_0(tmp$ret$0), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp = tmp_3;
  } else {
    var tmp_4 = withTimeout(toLongRound(_FastDuration___get_fastMilliseconds__impl__pe68va(time)), block, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp = tmp_4;
  }
  return tmp;
}
function withTimeoutNullable(time, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_withTimeoutNullable__i31xu0.bind(VOID, time, block), $completion);
}
function tween$lambda(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function tween$lambda_0(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_19($this, $this$withTimeoutNullable, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.g19();
  // Inline function 'korlibs.korge.tween.tween.<anonymous>.<anonymous>' call
  var view = $this.san_1;
  $this.tan_1._v = new TweenComponent(view, toList($this.uan_1), $this.van_1, $this.wan_1, $this.xan_1, cancellable, $this.yan_1, $this.zan_1);
  var tmp$ret$0 = cancellable.s16();
  var tmp = returnIfSuspended(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function tween$slambda_0($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
  var i = new tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate);
  var l = function ($this$withTimeoutNullable, $completion) {
    return i.u1n($this$withTimeoutNullable, $completion);
  };
  l.$arity = 1;
  return l;
}
var properties_initialized_tween_kt_p0n8nv;
function _init_properties_tween_kt__1g7sex() {
  if (!properties_initialized_tween_kt_p0n8nv) {
    properties_initialized_tween_kt_p0n8nv = true;
    DEFAULT_EASING = get_EASE_IN_OUT_QUAD(Companion_getInstance_37());
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_TIME = toDuration(1, DurationUnit_SECONDS_getInstance());
    DEFAULT_FTIME = get_fastSeconds(1);
  }
}
function *_generator_invoke__zhh2q8_20($this, $completion) {
  var tmp = $this.aao_1($this.bao_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_21($this, $completion) {
  var tmp = $this.cao_1($this.dao_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_19;
function Companion_getInstance_45() {
  if (Companion_instance_19 === VOID)
    new Companion_4();
  return Companion_instance_19;
}
function _get_halfSide__37ya73($this) {
  // Inline function 'kotlin.math.min' call
  var a = $this.n2i();
  var b = $this.o2i();
  var tmp$ret$0 = Math.min(a, b);
  return numberToInt(tmp$ret$0) / 2 | 0;
}
function setInitialState($this) {
  var width = $this.n2i();
  var height = $this.o2i();
  size($this.jar_1, width, height);
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  Companion_getInstance_30();
  var corner = $this.war();
  var tmp$ret$0 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
  $this.jar_1.cav(tmp$ret$0);
  $this.jar_1.dav($this.iar_1 ? 10.0 : 0.0);
  size($this.kar_1, width, height);
  var tmp = Companion_getInstance_46();
  var tmp0_elvis_lhs = $this.sar_1;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    tmp_0 = get_Bitmaps_transparent();
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  tmp.hav($this.mar_1, tmp_0, width, height, Companion_getInstance_27().f24_1);
  $this.mar_1.rak(!$this.iav() ? 0.5 : $this.nar_1 ? 1.0 : 1.0);
  $this.j9s();
}
function UIButton$lambda$lambda(this$0) {
  return function (it) {
    this$0.jav(it.q9z() / this$0.n2i(), it.r9z() / this$0.o2i());
    var tmp;
    if (this$0.gay()) {
      set_focused(this$0, true);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function UIButton$lambda$lambda_0(this$0) {
  return function (it) {
    this$0.hay();
    return Unit_instance;
  };
}
function UIButton$lambda$lambda_1(this$0) {
  return function (it) {
    this$0.tar_1.w1v(it);
    return Unit_instance;
  };
}
function UIButton$lambda(this$0) {
  return function ($this$singleTouch, it) {
    $this$singleTouch.ha0_1.v1v(UIButton$lambda$lambda(this$0));
    $this$singleTouch.ma0_1.v1v(UIButton$lambda$lambda_0(this$0));
    $this$singleTouch.na0_1.v1v(UIButton$lambda$lambda_1(this$0));
    return Unit_instance;
  };
}
function UIButton$slambda_3($$this$mouse, this$0) {
  var i = new UIButton$slambda($$this$mouse, this$0);
  var l = function (it, $completion) {
    return i.a9w(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UIButton$lambda$slambda_1($handler, $it) {
  var i = new UIButton$lambda$slambda($handler, $it);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function UIButton$lambda_0($this, $handler) {
  return function (it) {
    var tmp = $this.s9x();
    launchImmediately_0(tmp, UIButton$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function UIButton$slambda_4($$this$mouse, this$0) {
  var i = new UIButton$slambda_0($$this$mouse, this$0);
  var l = function (it, $completion) {
    return i.a9w(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UIButton$lambda$slambda_2($handler, $it) {
  var i = new UIButton$lambda$slambda_0($handler, $it);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function UIButton$lambda_1($this, $handler) {
  return function (it) {
    var tmp = $this.s9x();
    launchImmediately_0(tmp, UIButton$lambda$slambda_2($handler, it));
    return Unit_instance;
  };
}
function _interpolateColor$ref() {
  var l = function (p0, p1, p2) {
    return new RGBA(_interpolateColor(p0.bx_1, p1.u4d_1, p2.u4d_1));
  };
  l.callableName = '_interpolateColor';
  return l;
}
function UIButton$slambda_5(this$0) {
  var i = new UIButton$slambda_1(this$0);
  var l = function (it, $completion) {
    return i.g9t(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UIButton$slambda_6(this$0, $$this$keys) {
  var i = new UIButton$slambda_2(this$0, $$this$keys);
  var l = function (it, $completion) {
    return i.g9t(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function align$factory($b0) {
  return getPropertyCallableRef('align', 0, KMutableProperty0, function () {
    return $b0.rb1_1;
  }, function (value) {
    return $b0.bb5(value);
  });
}
function text$factory($b0) {
  return getPropertyCallableRef('text', 0, KMutableProperty0, function () {
    return $b0.qb1_1;
  }, function (value) {
    return $b0.cb5(value);
  });
}
function over$factory() {
  return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
    return receiver.i9w_1;
  }, null);
}
function out$factory() {
  return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
    return receiver.j9w_1;
  }, null);
}
function bgColor$factory($b0) {
  return getPropertyCallableRef('bgColor', 0, KMutableProperty0, function () {
    return new RGBA($b0.rau_1);
  }, function (value) {
    return $b0.xb4(value.u4d_1);
  });
}
function get_UI_DEFAULT_SIZE() {
  _init_properties_UIDefaults_kt__ebmksm();
  return UI_DEFAULT_SIZE;
}
var UI_DEFAULT_SIZE;
var properties_initialized_UIDefaults_kt_arkqjc;
function _init_properties_UIDefaults_kt__ebmksm() {
  if (!properties_initialized_UIDefaults_kt_arkqjc) {
    properties_initialized_UIDefaults_kt_arkqjc = true;
    UI_DEFAULT_SIZE = Size2D.j26(100, 32);
  }
}
function set__focusable(_this__u8e3s4, _set____db54di) {
  _init_properties_UIFocusManager_kt__odyms7();
  var this_0 = _focusable$delegate;
  var property = _focusable$factory();
  var tmp0_elvis_lhs = this_0.qx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__focusable(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _focusable$delegate;
    var property = _focusable$factory_0();
    var tmp = _this__u8e3s4.px();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.qx_1;
      tmp_0 = tmp0_safe_receiver.a3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.rx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.qx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.qx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _focusable$delegate;
function get_uiFocusManager(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = uiFocusManager$delegate;
    var property = uiFocusManager$factory();
    var tmp0_elvis_lhs = this_0.sx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.tx_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.sx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var uiFocusManager$delegate;
function set_focused(_this__u8e3s4, value) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0_safe_receiver = _this__u8e3s4.zb4(Scope_instance).n9v();
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_uiFocusManager(tmp0_safe_receiver);
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.bbk(value ? _this__u8e3s4 : null);
  }
}
function get_focused(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0_safe_receiver = _this__u8e3s4.zb4(Scope_instance).n9v();
  return equals(tmp0_safe_receiver == null ? null : get_uiFocusedView(tmp0_safe_receiver), _this__u8e3s4);
}
function focus(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  set_focused(_this__u8e3s4, true);
}
var Scope_instance;
function Scope_getInstance() {
  return Scope_instance;
}
function _get_rfocusView__qys03k(_this__u8e3s4, $this) {
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UIFocusManager.<get-rfocusView>.<anonymous>' call
  return _this__u8e3s4.zb4(Scope_instance);
}
function UIFocusManager$changeFocusIndex$lambda(it) {
  return !(get_focusable(it) == null);
}
function UIFocusManager$changeFocusIndex$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
  var tmp = a.ab5();
  // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
  var tmp$ret$1 = b.ab5();
  return compareValues(tmp, tmp$ret$1);
}
function UIFocusManager$lambda(this$0) {
  return function (it) {
    var tmp;
    if (it.k67_1.equals(Key_TAB_getInstance())) {
      this$0.dbk(it.n67_1 ? -1 : 1);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function get_uiFocusedView(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  return get_uiFocusManager(_this__u8e3s4).abk_1;
}
function get_focusable(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, UIFocusable) ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? get__focusable(_this__u8e3s4) : tmp0_elvis_lhs;
}
function _focusable$delegate$lambda() {
  _init_properties_UIFocusManager_kt__odyms7();
  return null;
}
function uiFocusManager$delegate$lambda($this$PropertyThis) {
  _init_properties_UIFocusManager_kt__odyms7();
  return new UIFocusManager($this$PropertyThis);
}
function _focusable$factory() {
  return getPropertyCallableRef('_focusable', 1, KMutableProperty1, function (receiver) {
    return get__focusable(receiver);
  }, function (receiver, value) {
    return set__focusable(receiver, value);
  });
}
function _focusable$factory_0() {
  return getPropertyCallableRef('_focusable', 1, KMutableProperty1, function (receiver) {
    return get__focusable(receiver);
  }, function (receiver, value) {
    return set__focusable(receiver, value);
  });
}
function uiFocusManager$factory() {
  return getPropertyCallableRef('uiFocusManager', 1, KProperty1, function (receiver) {
    return get_uiFocusManager(receiver);
  }, null);
}
var properties_initialized_UIFocusManager_kt_a5rjit;
function _init_properties_UIFocusManager_kt__odyms7() {
  if (!properties_initialized_UIFocusManager_kt_a5rjit) {
    properties_initialized_UIFocusManager_kt_a5rjit = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _focusable$delegate$lambda;
    _focusable$delegate = new Property(null, default_0);
    uiFocusManager$delegate = new PropertyThis(VOID, uiFocusManager$delegate$lambda);
  }
}
function _interpolate$ref() {
  var l = function (p0, p1, p2) {
    return _interpolate(p0.bx_1, p1, p2);
  };
  l.callableName = '_interpolate';
  return l;
}
function UIMaterialLayer$Highlights$addHighlight$lambda(this$0) {
  return function (it) {
    this$0.fbk_1.j9s();
    return Unit_instance;
  };
}
function _interpolate$ref_0() {
  var l = function (p0, p1, p2) {
    return _interpolate(p0.bx_1, p1, p2);
  };
  l.callableName = '_interpolate';
  return l;
}
function _interpolate$ref_1() {
  var l = function (p0, p1, p2) {
    return _interpolate(p0.bx_1, p1, p2);
  };
  l.callableName = '_interpolate';
  return l;
}
function UIMaterialLayer$Highlights$removeHighlight$lambda(this$0) {
  return function (it) {
    this$0.fbk_1.j9s();
    return Unit_instance;
  };
}
function UIMaterialLayer$Highlights$removeHighlight$lambda_0(this$0, $highlight) {
  return function () {
    this$0.gbk_1.h3($highlight);
    return Unit_instance;
  };
}
function _get_computedRadius__cigsus($this) {
  var tmp0_safe_receiver = $this.tau_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = $this.n2i();
    var b = $this.o2i();
    var tmp$ret$0 = Math.min(a, b);
    tmp = tmp0_safe_receiver.t2d(tmp$ret$0 / 2.0);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? $this.sau_1 : tmp1_elvis_lhs;
  return tmp2_elvis_lhs == null ? Companion_getInstance_30().k2d_1 : tmp2_elvis_lhs;
}
function radiusRatio$factory($b0) {
  return getPropertyCallableRef('radiusRatio', 0, KMutableProperty0, function () {
    return $b0.jbk_1;
  }, function (value) {
    $b0.jbk_1 = value;
    return Unit_instance;
  });
}
function radiusRatio$factory_0($b0) {
  return getPropertyCallableRef('radiusRatio', 0, KMutableProperty0, function () {
    return $b0.jbk_1;
  }, function (value) {
    $b0.jbk_1 = value;
    return Unit_instance;
  });
}
function alpha$factory($b0) {
  return getPropertyCallableRef('alpha', 0, KMutableProperty0, function () {
    return $b0.kbk_1;
  }, function (value) {
    $b0.kbk_1 = value;
    return Unit_instance;
  });
}
function containerPos$factory() {
  return getPropertyCallableRef('containerPos', 1, KMutableProperty1, function (receiver) {
    return receiver.lbo();
  }, function (receiver, value) {
    return receiver.mbo(value);
  });
}
function containerPos$factory_0() {
  return getPropertyCallableRef('containerPos', 1, KMutableProperty1, function (receiver) {
    return receiver.lbo();
  }, function (receiver, value) {
    return receiver.mbo(value);
  });
}
function registerUISupportOnce($this) {
  if ($this.iaf_1)
    return Unit_instance;
  var tmp0_elvis_lhs = $this.n9v();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stage = tmp;
  $this.iaf_1 = true;
  if (equals(getExtra(stage, 'uiSupport'), true))
    return Unit_instance;
  setExtra(stage, 'uiSupport', true);
  // Inline function 'korlibs.korge.input.keys' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UIView.registerUISupportOnce.<anonymous>' call
  get_keys(stage);
}
var Companion_instance_20;
function Companion_getInstance_46() {
  if (Companion_instance_20 === VOID)
    new Companion_5();
  return Companion_instance_20;
}
function get_centered(_this__u8e3s4) {
  return center(_this__u8e3s4);
}
function anchor(_this__u8e3s4, anchor) {
  _this__u8e3s4.qbk(anchor);
  return _this__u8e3s4;
}
function center(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.anchor' call
  return anchor(_this__u8e3s4, Anchor2D.o24(numberToDouble(0.5), numberToDouble(0.5)));
}
function clearBitmaps($this, onParentChanged) {
  if ($this.bbw_1.g1())
    return Unit_instance;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.bbw_1;
  var n = 0;
  while (n < this_0.e1()) {
    // Inline function 'korlibs.korge.view.BaseGraphics.clearBitmaps.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = this_0.d1(_unary__edvuaz);
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    if (!equals(it, get_bmp(tmp$ret$0))) {
      var tmp0_safe_receiver = $this.gbw_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y7z_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.u85(it, 'BaseGraphics');
      }
    }
  }
  $this.bbw_1.f3();
}
function _get_bitmapWidth__ndy7bu($this) {
  return $this.z5h().n2i();
}
function _get_bitmapHeight__5t1vx1($this) {
  return $this.z5h().o2i();
}
function _getLocalBoundsInternal($this, strokes) {
  var bounds = boundsUnsafe($this, strokes);
  return new Rectangle(bounds.m25_1 - $this.haj(), bounds.n25_1 - $this.iaj(), bounds.o25_1, bounds.p25_1);
}
function _getLocalBoundsInternal$default($this, strokes, $super) {
  strokes = strokes === VOID ? $this.kbw_1 : strokes;
  return _getLocalBoundsInternal($this, strokes);
}
function boundsUnsafe($this, strokes) {
  if ($this.fbw_1) {
    $this.fbw_1 = false;
    $this.mbw_1 = $this.nbw(false);
    $this.lbw_1 = $this.nbw(true);
  }
  return strokes ? $this.lbw_1 : $this.mbw_1;
}
var ZIndexComparator_instance;
function ZIndexComparator_getInstance() {
  return ZIndexComparator_instance;
}
function Container$renderChildrenInternal$lambda(it) {
  var tmp;
  if (it instanceof FixedSizeContainer) {
    tmp = it.s5y();
  } else {
    tmp = false;
  }
  return tmp;
}
function addTo(_this__u8e3s4, parent) {
  parent.ha5(_this__u8e3s4);
  return _this__u8e3s4;
}
function dummyView(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = DummyView.hc8();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.dummyView.<anonymous>' call
  _this__u8e3s4.wai(this_0);
  return this_0;
}
var Companion_instance_21;
function Companion_getInstance_47() {
  return Companion_instance_21;
}
function installFpsDebugOverlay(_this__u8e3s4) {
  var longWindow = new TimeSlidingWindow(240);
  var shortWindow = new TimeSlidingWindow(10);
  var previousTime = {_v: new FastDuration(PerformanceCounter_getInstance().t63())};
  var frames = {_v: 0};
  var batchCount = {_v: 0};
  var vertexCount = {_v: 0};
  var instanceCount = {_v: 0};
  var tmp = _this__u8e3s4.o9v().g9k_1;
  tmp.v1v(installFpsDebugOverlay$lambda(batchCount, vertexCount, instanceCount));
  var tmp_0 = get_debugLineRenderContext(_this__u8e3s4.o9v().h9j_1).g89_1;
  tmp_0.v1v(installFpsDebugOverlay$lambda_0(batchCount, vertexCount));
  var tmp_1 = _this__u8e3s4.o9v().h9j_1.d80_1.l81_1;
  tmp_1.v1v(installFpsDebugOverlay$lambda_1(batchCount, vertexCount));
  var tmp_2 = _this__u8e3s4.o9v().h9j_1.d80_1.m81_1;
  tmp_2.v1v(installFpsDebugOverlay$lambda_2(instanceCount));
  var tmp_3 = _this__u8e3s4.o9v();
  tmp_3.kc8(installFpsDebugOverlay$lambda_3(previousTime, frames, longWindow, shortWindow, batchCount, vertexCount, instanceCount));
}
function installFpsDebugOverlay$lambda($batchCount, $vertexCount, $instanceCount) {
  return function (it) {
    $batchCount._v = 0;
    $vertexCount._v = 0;
    $instanceCount._v = 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_0($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.o89_1 | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_1($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.b87() | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_2($instanceCount) {
  return function (it) {
    $instanceCount._v = $instanceCount._v + it | 0;
    return Unit_instance;
  };
}
function invoke$drawTextWithShadow($this_addDebugRenderer, $ctx, fontSize, matrix, text, x, y) {
  var tmp0_font = $this_addDebugRenderer.v9y();
  var tmp1_colMul = $ctx.c80_1;
  var tmp2_blendMode = Companion_getInstance_13().u7y_1;
  drawText($ctx, tmp0_font, fontSize, text, x, y, matrix, tmp1_colMul, tmp2_blendMode, false);
}
function installFpsDebugOverlay$lambda_3($previousTime, $frames, $longWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
  return function ($this$addDebugRenderer, ctx) {
    var scale = ctx.b8a();
    var fontSize = 8.0 * scale;
    var currentTime = PerformanceCounter_getInstance().t63();
    var elapsedTime = FastDuration__minus_impl_evs237(currentTime, $previousTime._v.t1u_1);
    var tmp;
    if ($frames._v > 3) {
      var tmp_0;
      if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, get_fastMilliseconds_0(4)) > 0) {
        $longWindow.rc8(elapsedTime);
        $shortWindow.rc8(elapsedTime);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    var _unary__edvuaz = $frames._v;
    $frames._v = _unary__edvuaz + 1 | 0;
    $previousTime._v = new FastDuration(currentTime);
    var matrix = $this$addDebugRenderer.v9i_1.q88();
    invoke$drawTextWithShadow($this$addDebugRenderer, ctx, fontSize, matrix, 'FPS: ' + ('' + roundDecimalPlaces($shortWindow.pc8(), 1)) + (', batchCount=' + $batchCount._v + ', vertexCount=' + $vertexCount._v + ', instanceCount=' + $instanceCount._v) + (', (' + Companion_getInstance_39().yt() + ')'), 0, 0);
    var graphLeft = 1.0;
    var graphTop = fontSize * 2;
    var overlayLines = 60;
    var overlayWidth = 120.0 * scale;
    var overlayHeight = 30 * scale;
    var overlayHeightGap = 5.0;
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    var this_0 = $this$addDebugRenderer.h9j_1;
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_1 = get_debugLineRenderContext(this_0);
    var this_2 = this_1.f89_1;
    if (!(this_2.h80_1 === this_1)) {
      this_2.h80_1 = this_1;
      this_2.r81();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_3 = get_debugLineRenderContext(this_0);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory(this_3);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(matrix == null))
          this_3.r89_1 = matrix;
        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_13().u7y_1;
          var doUpdate = !(this_1.q89_1 === blending);
          var old = this_1.q89_1;
          try {
            if (doUpdate) {
              this_1.f89_1.r81();
              this_1.q89_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var color = Colors_getInstance().q43_1;
            var oldColor = this_1.i89_1;
            this_1.i89_1 = color;
            try {
              // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              this_1.w89(graphLeft, graphTop, graphLeft, graphTop + overlayHeight);
              this_1.w89(graphLeft, graphTop + overlayHeight, graphLeft + overlayWidth, graphTop + overlayHeight);
            }finally {
              this_1.i89_1 = oldColor;
            }
            var inductionVariable = 0;
            if (inductionVariable <= 0)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var color_0 = index === 0 ? Colors_getInstance().a3y_1 : Colors_getInstance().b3y_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_0 = this_1.i89_1;
                this_1.i89_1 = color_0;
                try {
                  // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ratio = $longWindow.e1() / $longWindow.lc8_1;
                  var totalOverlayLines = coerceAtLeast(numberToInt(overlayLines * ratio), 1);
                  if ($longWindow.e1() > 0) {
                    var previousX = 0.0;
                    var previousY = 0.0;
                    var minFps = 0.0;
                    var maxFps = 150.0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < totalOverlayLines)
                      do {
                        var n = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'kotlin.run' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        var p0 = convertRange_0(n, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.e1(), 1));
                        var p1 = convertRange_0(n + 1 | 0, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.e1(), 1));
                        var plen = 0;
                        var timeSum = get_fastMilliseconds_0(0);
                        var inductionVariable_1 = p0;
                        var last = coerceAtMost(p1, $longWindow.e1());
                        if (inductionVariable_1 < last)
                          do {
                            var m = inductionVariable_1;
                            inductionVariable_1 = inductionVariable_1 + 1 | 0;
                            timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.qc8(m));
                            plen = plen + 1 | 0;
                          }
                           while (inductionVariable_1 < last);
                        if (plen === 0) {
                          timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.qc8(p0));
                          plen = plen + 1 | 0;
                        }
                        var time = FastDuration__div_impl_rlslck_0(timeSum, plen);
                        var fps = _Frequency___get_hertz__impl__9m7k6x(toFrequency(time));
                        var fps_0 = fps;
                        var scaledFreq = convertRange(fps_0, minFps, maxFps, overlayHeightGap, overlayHeight);
                        var y = graphTop + overlayHeight - scaledFreq;
                        var x = graphLeft + n * overlayWidth / overlayLines;
                        if (n > 0) {
                          this_1.w89(previousX, previousY + index, x, y + index);
                        }
                        previousY = y;
                        previousX = x;
                      }
                       while (inductionVariable_0 < totalOverlayLines);
                  }
                }finally {
                  this_1.i89_1 = oldColor_0;
                }
              }
               while (inductionVariable <= 0);
            break $l$block;
          }finally {
            if (doUpdate) {
              this_1.f89_1.r81();
            }
            this_1.q89_1 = old;
          }
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
    return Unit_instance;
  };
}
function currentMatrix$factory($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.r89_1;
  }, function (value) {
    $b0.r89_1 = value;
    return Unit_instance;
  });
}
var GraphicsRenderer_SYSTEM_instance;
var GraphicsRenderer_CPU_instance;
var GraphicsRenderer_GPU_instance;
var GraphicsRenderer_entriesInitialized;
function GraphicsRenderer_initEntries() {
  if (GraphicsRenderer_entriesInitialized)
    return Unit_instance;
  GraphicsRenderer_entriesInitialized = true;
  GraphicsRenderer_SYSTEM_instance = new GraphicsRenderer('SYSTEM', 0);
  GraphicsRenderer_CPU_instance = new GraphicsRenderer('CPU', 1);
  GraphicsRenderer_GPU_instance = new GraphicsRenderer('GPU', 2);
}
function _get_anchorable__ebfoik($this) {
  var tmp0_elvis_lhs = $this.acb_1;
  return ensureNotNull(tmp0_elvis_lhs == null ? $this.bcb_1 : tmp0_elvis_lhs);
}
function ensure_0($this) {
  if ($this.hcb_1.l3_1 === 2) {
    if (!($this.acb_1 == null)) {
      var tmp1_safe_receiver = $this.acb_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.pal();
      }
      $this.acb_1 = null;
    }
    if ($this.bcb_1 == null) {
      var tmp = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView' call
      // Inline function 'kotlin.also' call
      var this_0 = GpuShapeView.hce(EmptyShape_instance, true);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics.<anonymous>' call
      var tmp$ret$2 = (new ShapeBuilder(null, null)).p4u();
      this_0.ice(tmp$ret$2);
      var this_1 = addTo(this_0, $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_1.jce($this.ccb_1);
      this_1.icd_1 = $this.fcb_1;
      this_1.kcd_1 = $this.ecb_1;
      this_1.ice($this.gcb_1);
      tmp.bcb_1 = this_1;
    }
  } else {
    if (!($this.bcb_1 == null)) {
      var tmp2_safe_receiver = $this.bcb_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.pal();
      }
      $this.bcb_1 = null;
    }
    if ($this.acb_1 == null) {
      var tmp_0 = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.cpuGraphics' call
      // Inline function 'kotlin.also' call
      var this_2 = addTo(CpuGraphics.fc6(false), $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      var tmp$ret$9 = (new ShapeBuilder(null, null)).p4u();
      this_2.gc6(tmp$ret$9);
      if (false) {
        this_2.zbw();
      }
      this_2.fbw_1 = true;
      this_2.cal();
      this_2.zbw();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_2.zc5_1 = $this.ccb_1;
      this_2.xbv_1 = $this.fcb_1;
      this_2.dbz_1 = $this.ecb_1;
      this_2.gc6($this.gcb_1);
      tmp_0.acb_1 = this_2;
    }
    var tmp3_safe_receiver = $this.acb_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.xbw($this.hcb_1.equals(GraphicsRenderer_SYSTEM_getInstance()));
    }
  }
}
function GraphicsRenderer_SYSTEM_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_SYSTEM_instance;
}
function GraphicsRenderer_GPU_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_GPU_instance;
}
function *_generator_forceLoadSourceFile__yy5vos($this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.pce($this, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    var tmp_0 = readBitmapSlice(currentVfs.yh('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    $this.vbq(tmp_0);
    $this.waj(1.0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$0 = get_Bitmaps_white();
      $this.vbq(tmp$ret$0);
      $this.waj(100.0);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_baseForceLoadSourceFile__natc6b(_this__u8e3s4, $this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.pb4_1.pce(_this__u8e3s4, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function trySetSourceActually($this) {
  var source = $this.ubq_1.sy();
  if (!(source == null)) {
    $this.tbq_1 = true;
    $this.pbz(source);
  }
}
function sourceFile$factory($b0) {
  return getPropertyCallableRef('sourceFile', 0, KMutableProperty0, function () {
    return $b0.zce();
  }, function (value) {
    return $b0.yce(value);
  });
}
var Companion_instance_22;
function Companion_getInstance_48() {
  return Companion_instance_22;
}
var Companion_instance_23;
function Companion_getInstance_49() {
  return Companion_instance_23;
}
function clipBorders$factory($b0) {
  return getPropertyCallableRef('clipBorders', 0, KMutableProperty0, function () {
    return $b0.t9j_1;
  }, function (value) {
    $b0.t9j_1 = value;
    return Unit_instance;
  });
}
function virtualSizeDouble$factory($b0) {
  return getPropertyCallableRef('virtualSizeDouble', 0, KMutableProperty0, function () {
    return $b0.mch();
  }, function (value) {
    return $b0.nch(value);
  });
}
function clip$factory() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.s5y();
  }, function (receiver, value) {
    return receiver.lch(value);
  });
}
function clip$factory_0() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.s5y();
  }, function (receiver, value) {
    return receiver.lch(value);
  });
}
function unscaledSize$factory() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.paf();
  }, function (receiver, value) {
    return receiver.oaf(value);
  });
}
function unscaledSize$factory_0() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.paf();
  }, function (receiver, value) {
    return receiver.oaf(value);
  });
}
function get_agProgram(_this__u8e3s4) {
  switch (_this__u8e3s4.q4o()) {
    case 'msdf':
      return MsdfRender_getInstance().qam_1;
    case 'psdf':
      return MsdfRender_getInstance().tam_1;
    case 'sdf':
      return MsdfRender_getInstance().tam_1;
    default:
      return null;
  }
}
function *_generator_invoke__zhh2q8_22($this, $completion) {
  var tmp = $this.och_1.mcl(ensureNotNull(get_views($this.pch_1)).f9j_1, $this.qch_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_24;
function Companion_getInstance_50() {
  return Companion_instance_24;
}
function updateLineCount($this) {
  var tmp = $this;
  // Inline function 'kotlin.text.count' call
  var count = 0;
  var indexedObject = $this.y5p();
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(indexedObject)) {
    var element = charSequenceGet(indexedObject, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'korlibs.korge.view.Text.updateLineCount.<anonymous>' call
    if (element === _Char___init__impl__6a9atx(10)) {
      count = count + 1 | 0;
    }
  }
  tmp.dck_1 = count + 1 | 0;
}
function *_generator_forceLoadFontSource__wlrz09($this, currentVfs, sourceFile, $completion) {
  $this.pcl(sourceFile);
  $this.qck_1 = true;
  if (!(sourceFile == null)) {
    var tmp = readFont(currentVfs.yh('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    $this.qcl(tmp);
  }
  return Unit_instance;
}
function setContainerPosition($this, pos, baseline) {
  var x = pos.dl();
  var y = pos.el();
  if ($this.vck_1) {
    setRealContainerPosition($this, x, y);
  } else {
    setRealContainerPosition($this, x + HorizontalAlign__getOffsetX_impl_urzzxf($this.nck_1.f4x_1, $this.uck_1.o25_1), y - VerticalAlign__getOffsetY_impl_iso0y6($this.nck_1.g4x_1, $this.uck_1.p25_1, baseline));
  }
}
function setRealContainerPosition($this, x, y) {
  position($this.ock_1, x, y);
}
function Text$_renderInternal$slambda_0(this$0, $ctx, $fontSource) {
  var i = new Text$_renderInternal$slambda(this$0, $ctx, $fontSource);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function textSize$factory($b0) {
  return getPropertyCallableRef('textSize', 0, KMutableProperty0, function () {
    return $b0.ick_1;
  }, function (value) {
    return $b0.tcl(value);
  });
}
function fontSource$factory($b0) {
  return getPropertyCallableRef('fontSource', 0, KMutableProperty0, function () {
    return $b0.tck_1;
  }, function (value) {
    return $b0.pcl(value);
  });
}
function fontSize$factory() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.o4o();
  }, function (receiver, value) {
    return receiver.ucl(value);
  });
}
function fontSize$factory_0() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.o4o();
  }, function (receiver, value) {
    return receiver.ucl(value);
  });
}
function _get_allBitmap__bdn8f($this) {
  if ($this.eb2_1 == null) {
    var tmp = $this;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = $this.qb1_1.m5q();
      var tmp_0;
      if (isInterface(this_0, Collection)) {
        tmp_0 = this_0.g1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.TextBlock.<get-allBitmap>.<anonymous>' call
        if (!isInterface(element, BitmapFont)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    tmp.eb2_1 = tmp$ret$0;
  }
  return ensureNotNull($this.eb2_1);
}
function invalidateText($this) {
  invalidProps($this);
  if ($this.zb1_1) {
    // Inline function 'korlibs.korge.view.size' call
    var width = $this.qb1_1.n2i();
    var height = $this.qb1_1.o2i();
    size($this, numberToDouble(width), numberToDouble(height));
  }
  $this.eb2_1 = null;
}
function invalidProps($this) {
  $this.pb1_1 = true;
  $this.j9s();
}
function ensureTexture($this) {
  if (!$this.pb1_1)
    return Unit_instance;
  $this.pb1_1 = false;
  var bmp = NativeImage(toIntCeil($this.n2i()), toIntCeil($this.o2i()));
  if ($this.db2_1 == null) {
    var tmp = $this;
    // Inline function 'korlibs.korge.view.image' call
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var texture = get_Bitmaps_transparent();
    var anchor = Companion_getInstance_27().b24_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Image.rb4(texture, anchor);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.image.<anonymous>' call
    tmp.db2_1 = addTo(this_0, $this);
  }
  var tmp0_safe_receiver = $this.db2_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.vbq(slice(bmp));
  }
  var tmp1_safe_receiver = $this.db2_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    var tmp_0 = tmp1_safe_receiver;
    var tmp_1 = $this.qb1_1.x5q_1.a5q_1;
    var tmp2_safe_receiver = isInterface(tmp_1, BitmapFont) ? tmp_1 : null;
    tmp_0.hbz_1 = tmp2_safe_receiver == null ? null : get_agProgram(tmp2_safe_receiver);
  }
  var tmp3_safe_receiver = $this.db2_1;
  if (tmp3_safe_receiver == null)
    null;
  else {
    tmp3_safe_receiver.dbz_1 = $this.cb2_1;
  }
  // Inline function 'korlibs.image.bitmap.context2d' call
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = bmp.x3w_1;
  if (true) {
    bmp.g3x();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = bmp.p44(true);
    try {
      // Inline function 'korlibs.korge.view.TextBlock.ensureTexture.<anonymous>' call
      var tmp0_text = $this.qb1_1;
      var tmp1_bounds = Companion_getInstance_32().x2d($this.yb1_1.h28_1, $this.yb1_1.e28_1, ctx.n2i() - $this.yb1_1.f28_1, ctx.o2i() - $this.yb1_1.g28_1);
      var tmp2_includePartialLines = $this.sb1_1;
      var tmp3_wordWrap = $this.wb1_1;
      var tmp4_ellipsis = $this.xb1_1;
      var tmp5_align = $this.rb1_1;
      var tmp6_fill = $this.ub1_1;
      var tmp7_stroke = $this.vb1_1;
      var tmp8_textRangeStart = $this.ab2_1;
      var tmp9_textRangeEnd = $this.bb2_1;
      drawRichText(ctx, tmp0_text, tmp1_bounds, tmp3_wordWrap, tmp2_includePartialLines, tmp4_ellipsis, tmp6_fill, tmp7_stroke, tmp5_align, true, tmp8_textRangeStart, tmp9_textRangeEnd);
    }finally {
      ctx.a18();
    }
  }finally {
    result = true ? bmp.i3x(rect) : 0;
  }
}
var Companion_instance_25;
function Companion_getInstance_51() {
  if (Companion_instance_25 === VOID)
    new Companion_10();
  return Companion_instance_25;
}
var Companion_instance_26;
function Companion_getInstance_52() {
  return Companion_instance_26;
}
function updateRenderColorTransform($this) {
  $this.h9m_1 = $this.m9m_1;
  $this.o9m_1 = true;
  var parent = $this.l23();
  if (!((parent == null ? null : get_filter(parent)) == null)) {
    $this.g9m_1.p4d($this.f9m_1);
  } else {
    var tmp;
    if (!(parent == null)) {
      tmp = !isInterface($this, ColorReference);
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.g9m_1.q4d($this.f9m_1, parent.yak());
    } else {
      $this.g9m_1.p4d($this.f9m_1);
    }
  }
}
function updateRenderColorTransformIfRequired($this) {
  if ($this.h9m_1 === $this.m9m_1)
    return Unit_instance;
  updateRenderColorTransform($this);
}
function updateRenderBlendMode($this) {
  $this.j9m_1 = $this.l9m_1;
  $this.n9m_1 = true;
  var tmp = $this;
  var tmp_0;
  if ($this.l9l_1.equals(Companion_getInstance_13().l7y_1)) {
    var tmp1_safe_receiver = $this.l23();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.zak();
    tmp_0 = tmp2_elvis_lhs == null ? Companion_getInstance_13().k7y_1 : tmp2_elvis_lhs;
  } else {
    tmp_0 = $this.l9l_1;
  }
  tmp.i9m_1 = tmp_0;
}
function updateRenderBlendModeIfRequired($this) {
  if ($this.j9m_1 === $this.l9m_1)
    return Unit_instance;
  updateRenderBlendMode($this);
}
function View$bviewAll$delegate$lambda(this$0) {
  return function () {
    return listOf(this$0);
  };
}
function View$addRenderPhase$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.korge.view.View.addRenderPhase.<anonymous>' call
  var tmp = a.zcl();
  // Inline function 'korlibs.korge.view.View.addRenderPhase.<anonymous>' call
  var tmp$ret$1 = b.zcl();
  return compareValues(tmp, tmp$ret$1);
}
function addFastUpdater(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_instance_1.q1u() : firstTime;
  if (first)
    updatable(_this__u8e3s4, new FastDuration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.s65(tmp, addFastUpdater$lambda(updatable, _this__u8e3s4));
}
function addUpdaterWithViews(_this__u8e3s4, updatable) {
  var tmp = Companion_instance_27;
  return _this__u8e3s4.s65(tmp, addUpdaterWithViews$lambda(updatable, _this__u8e3s4));
}
function hasAncestor(_this__u8e3s4, ancestor) {
  var tmp;
  if (equals(_this__u8e3s4, ancestor)) {
    tmp = true;
  } else {
    var tmp0_safe_receiver = _this__u8e3s4.l23();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, ancestor);
    tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  return tmp;
}
function scale(_this__u8e3s4, sx, sy) {
  sy = sy === VOID ? sx : sy;
  _this__u8e3s4.cak(Scale.g2d(sx, sy));
  return _this__u8e3s4;
}
function position(_this__u8e3s4, x, y) {
  return xy(_this__u8e3s4, Vector2D.s24(x, y));
}
function size(_this__u8e3s4, width, height) {
  return size_0(_this__u8e3s4, Size2D.a2e(width, height));
}
function descendantsWith(_this__u8e3s4, out, check) {
  var tmp;
  if (out === VOID) {
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp = ArrayList.h1();
  } else {
    tmp = out;
  }
  out = tmp;
  if (!(_this__u8e3s4 == null)) {
    if (check(_this__u8e3s4)) {
      // Inline function 'kotlin.collections.plusAssign' call
      out.h(_this__u8e3s4);
    }
    if (_this__u8e3s4.z9k_1) {
      // Inline function 'korlibs.korge.view.View.forEachChild' call
      var tmp0_safe_receiver = _this__u8e3s4.mai();
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < tmp0_safe_receiver.e1()) {
          // Inline function 'korlibs.korge.view.descendantsWith.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var child = tmp0_safe_receiver.d1(_unary__edvuaz);
          descendantsWith(child, out, check);
        }
        tmp_0 = Unit_instance;
      }
    }
  }
  return out;
}
function scrollParentsToMakeVisible(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.firstAncestorOfType' call
  var tmp = firstAncestor(_this__u8e3s4, false, scrollParentsToMakeVisible$lambda);
  var tmp0_safe_receiver = (tmp == null ? true : tmp instanceof UIScrollable) ? tmp : THROW_CCE();
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.kbo(_this__u8e3s4);
  }
}
function findFirstAscendant(_this__u8e3s4, cond) {
  var current = _this__u8e3s4;
  while (!(current == null)) {
    if (cond(current))
      return current;
    current = current.l23();
  }
  return null;
}
function get_ancestorCount(_this__u8e3s4) {
  var count = 0;
  var parent = _this__u8e3s4 == null ? null : _this__u8e3s4.l23();
  while (!(parent == null)) {
    count = count + 1 | 0;
    parent = parent.l23();
  }
  return count;
}
function xy(_this__u8e3s4, p) {
  _this__u8e3s4.y4z(p);
  return _this__u8e3s4;
}
function size_0(_this__u8e3s4, size) {
  _this__u8e3s4.iak(size);
  return _this__u8e3s4;
}
function firstAncestor(_this__u8e3s4, includeThis, condition) {
  includeThis = includeThis === VOID ? true : includeThis;
  if (_this__u8e3s4 == null)
    return null;
  if (includeThis && condition(_this__u8e3s4))
    return _this__u8e3s4;
  var tmp0_safe_receiver = _this__u8e3s4.l23();
  return tmp0_safe_receiver == null ? null : firstAncestor(tmp0_safe_receiver, true, condition);
}
function alpha(_this__u8e3s4, alpha) {
  _this__u8e3s4.rak(alpha);
  return _this__u8e3s4;
}
function xy_0(_this__u8e3s4, x, y) {
  _this__u8e3s4.saj(x, y);
  return _this__u8e3s4;
}
function addFastUpdater$lambda($updatable, $this_addFastUpdater) {
  return function (it) {
    $updatable($this_addFastUpdater, new FastDuration(FastDuration__times_impl_h6amcp(it.j8k_1, $this_addFastUpdater.raj())));
    return Unit_instance;
  };
}
function addUpdaterWithViews$lambda($updatable, $this_addUpdaterWithViews) {
  return function (it) {
    $updatable($this_addUpdaterWithViews, it.fcm_1, new Duration(Duration__times_impl_sfuzvp(it.hcm(), $this_addUpdaterWithViews.raj())));
    return Unit_instance;
  };
}
function scrollParentsToMakeVisible$lambda(it) {
  return it instanceof UIScrollable;
}
function scale$factory($b0) {
  return getPropertyCallableRef('scale', 0, KMutableProperty0, function () {
    return $b0.xaj();
  }, function (value) {
    return $b0.waj(value);
  });
}
function bviewAll$factory() {
  return getPropertyCallableRef('bviewAll', 1, KProperty1, function (receiver) {
    return receiver.gaj();
  }, null);
}
function currentMatrix$factory_0($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.r89_1;
  }, function (value) {
    $b0.r89_1 = value;
    return Unit_instance;
  });
}
function *_generator_invoke__zhh2q8_23($this, $completion) {
  var tmp = $this.icm_1.wce(ensureNotNull(get_views($this.jcm_1)), VOID, $this.kcm_1.rce_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0($view, $ctx, this$0) {
  var i = new ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_24($this, $completion) {
  var tmp = $this.mcm_1.ncm($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_init__qn9atk($this, $completion) {
  var tmp = $this;
  var tmp_0 = debugBmpFont($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.d9j_1 = tmp_0;
  return Unit_instance;
}
function *_generator_closeSuspend__agjafw($this, $completion) {
  KorgeReload_getInstance().j7y();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.q9j_1;
  var n = 0;
  while (n < this_0.e1()) {
    // Inline function 'korlibs.korge.view.Views.closeSuspend.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var tmp = this_0.d1(_unary__edvuaz).g1p($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  $this.q9j_1.f3();
  cancel($this.i9i_1);
  $this.o9i_1.r8i();
  return Unit_instance;
}
function Views$_init_$lambda_jivasj(it) {
  return Stage.t9h(it);
}
function Views$realSettingsFolder$delegate$lambda(this$0) {
  return function () {
    return !(this$0.q9i_1 == null) ? ensureNotNull(this$0.q9i_1) : StandardPaths_instance.g2y(this$0.ocm());
  };
}
function Views$close$slambda_0(this$0) {
  var i = new Views$close$slambda(this$0);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function Views$tempViewsPool$lambda(it) {
  return FastArrayList.gy();
}
function Views$lambda(this$0) {
  return function (it) {
    this$0.h9j_1.t85();
    return Unit_instance;
  };
}
function Views$lambda_0(this$0) {
  return function (it) {
    this$0.h9j_1.k8a();
    return Unit_instance;
  };
}
var Companion_instance_27;
function Companion_getInstance_53() {
  return Companion_instance_27;
}
var Companion_instance_28;
function Companion_getInstance_54() {
  return Companion_instance_28;
}
function updateSingleViewWithViewsAll(_this__u8e3s4, views, delta) {
  // Inline function 'kotlin.also' call
  var this_0 = views.z9i_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_0.j8k_1 = delta;
  _this__u8e3s4.d66(this_0);
  // Inline function 'kotlin.also' call
  var this_1 = views.a9j_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_1.gcm_1 = delta;
  _this__u8e3s4.d66(this_1);
}
function setBoundsInfo(_this__u8e3s4, reqVirtualSize, actualSize, scaleMode, anchor, virtualSize, targetSize) {
  scaleMode = scaleMode === VOID ? Companion_getInstance_26().z2f() : scaleMode;
  anchor = anchor === VOID ? Companion_getInstance_27().n24() : anchor;
  virtualSize = virtualSize === VOID ? Ref_0() : virtualSize;
  targetSize = targetSize === VOID ? Ref_0() : targetSize;
  var reqVirtualSize_0 = toInt(reqVirtualSize);
  var actualSize_0 = toInt(actualSize);
  virtualSize.q2q(reqVirtualSize_0);
  targetSize.q2q(scaleMode.a2g(virtualSize.p1(), actualSize_0));
  var ratioX = targetSize.p1().h2g_1 / reqVirtualSize_0.h2g_1;
  var ratioY = targetSize.p1().i2g_1 / reqVirtualSize_0.i2g_1;
  var actualVirtualWidth = toIntRound(actualSize_0.h2g_1 / ratioX);
  var actualVirtualHeight = toIntRound(actualSize_0.i2g_1 / ratioY);
  _this__u8e3s4.t88(Companion_getInstance_33().w28_1.y29(ratioX, ratioY).h2a(toIntRound((actualVirtualWidth - reqVirtualSize_0.h2g_1 | 0) * anchor.k24_1), toIntRound((actualVirtualHeight - reqVirtualSize_0.i2g_1 | 0) * anchor.l24_1)));
  _this__u8e3s4.p88(_this__u8e3s4.u88().j2a());
  _this__u8e3s4.v88(_this__u8e3s4.u88().k2a());
  _this__u8e3s4.r88(_this__u8e3s4.q88().k2a());
  var tl = _this__u8e3s4.a89(Vector2D.y27(0, 0));
  var br = _this__u8e3s4.a89(Vector2D.s24(actualSize_0.h2g_1, actualSize_0.i2g_1));
  _this__u8e3s4.x88(Companion_getInstance_32().x2d(tl.q24_1, tl.r24_1, br.q24_1, br.r24_1));
}
function *_generator_views__wf4006($completion) {
  // Inline function 'korlibs.inject.Injector.get' call
  var tmp = injector($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.g63(getKClass(Views));
}
function views($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_views__wf4006.bind(VOID), $completion);
}
function quality$factory($b0) {
  return getPropertyCallableRef('quality', 0, KMutableProperty0, function () {
    return $b0.z89();
  }, function (value) {
    return $b0.l8i(value);
  });
}
function continuousRenderMode$factory($b0) {
  return getPropertyCallableRef('continuousRenderMode', 0, KMutableProperty0, function () {
    return $b0.v8i();
  }, function (value) {
    return $b0.u8i(value);
  });
}
function debugExtraFontScale$factory($b0) {
  return getPropertyCallableRef('debugExtraFontScale', 0, KMutableProperty0, function () {
    return $b0.b80_1;
  }, function (value) {
    $b0.b80_1 = value;
    return Unit_instance;
  });
}
function debugExtraFontColor$factory($b0) {
  return getPropertyCallableRef('debugExtraFontColor', 0, KMutableProperty0, function () {
    return new RGBA($b0.c80_1);
  }, function (value) {
    $b0.c80_1 = value.u4d_1;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory($b0) {
  return getPropertyCallableRef('updatedSinceFrame', 0, KMutableProperty0, function () {
    return $b0.j8g_1;
  }, function (value) {
    $b0.j8g_1 = value;
    return Unit_instance;
  });
}
function forceRenderEveryFrame$factory() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.m9q();
  }, function (receiver, value) {
    return receiver.s9q(value);
  });
}
function forceRenderEveryFrame$factory_0() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.m9q();
  }, function (receiver, value) {
    return receiver.s9q(value);
  });
}
function debugFontExtraScale$factory() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.tcm();
  }, function (receiver, value) {
    return receiver.i9q(value);
  });
}
function debugFontExtraScale$factory_0() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.tcm();
  }, function (receiver, value) {
    return receiver.i9q(value);
  });
}
function debugFontColor$factory() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.ucm());
  }, function (receiver, value) {
    return receiver.j9q(value.u4d_1);
  });
}
function debugFontColor$factory_0() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.ucm());
  }, function (receiver, value) {
    return receiver.j9q(value.u4d_1);
  });
}
function virtualSize$factory($b0) {
  return getPropertyCallableRef('virtualSize', 0, KMutableProperty0, function () {
    return $b0.d9k_1;
  }, function (value) {
    $b0.d9k_1 = value;
    return Unit_instance;
  });
}
function targetSize$factory($b0) {
  return getPropertyCallableRef('targetSize', 0, KMutableProperty0, function () {
    return $b0.f9k_1;
  }, function (value) {
    $b0.f9k_1 = value;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory_0() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.acn();
  }, function (receiver, value) {
    return receiver.gcn(value);
  });
}
function updatedSinceFrame$factory_1() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.acn();
  }, function (receiver, value) {
    return receiver.gcn(value);
  });
}
function centerOn(_this__u8e3s4, other) {
  return centerYOn(centerXOn(_this__u8e3s4, other), other);
}
function centerYOn(_this__u8e3s4, other) {
  return alignY(_this__u8e3s4, other, 0.5, true);
}
function centerXOn(_this__u8e3s4, other) {
  return alignX(_this__u8e3s4, other, 0.5, true);
}
function alignY(_this__u8e3s4, other, ratio, inside, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignXY(_this__u8e3s4, other, ratio, inside, false, padding);
}
function alignX(_this__u8e3s4, other, ratio, inside, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignXY(_this__u8e3s4, other, ratio, inside, true, padding);
}
function alignXY(_this__u8e3s4, other, ratio, inside, doX, padding) {
  padding = padding === VOID ? 0.0 : padding;
  var bounds = other.aam(_this__u8e3s4.l23());
  var localBounds = _this__u8e3s4.s9y();
  var ratioM1_1 = ratio * 2 - 1;
  var rratioM1_1 = inside ? ratioM1_1 : -ratioM1_1;
  var iratio = inside ? ratio : 1.0 - ratio;
  if (doX) {
    _this__u8e3s4.taj(bounds.m25_1 + bounds.o25_1 * ratio - localBounds.t25() - _this__u8e3s4.oak() * iratio - padding * rratioM1_1);
  } else {
    _this__u8e3s4.uaj(bounds.n25_1 + bounds.p25_1 * ratio - localBounds.v25() - _this__u8e3s4.qak() * iratio - padding * rratioM1_1);
  }
  return _this__u8e3s4;
}
var Companion_instance_29;
function Companion_getInstance_55() {
  return Companion_instance_29;
}
var Companion_instance_30;
function Companion_getInstance_56() {
  return Companion_instance_30;
}
function DirectionalBlurFilter$Companion$fragment$lambda($loopLen, $gaussianResult, $$this$FragmentShaderDefault) {
  return function ($this$ELSE) {
    $this$ELSE.t6v($this$ELSE.w6v(), $this$ELSE.a6w([$this$ELSE.z6v(0.0), $this$ELSE.z6v(0.0), $this$ELSE.z6v(0.0), $this$ELSE.z6v(0.0)]));
    $this$ELSE.t6v($loopLen, $this$ELSE.o6x($this$ELSE.u6x(BlurUB_getInstance().lcp())));
    // Inline function 'korlibs.graphics.shader.Builder.FOR_0_UNTIL_FIXED_BREAK' call
    var len = $loopLen;
    // Inline function 'korlibs.graphics.shader.Builder.FOR_0_UNTIL_FIXED' call
    // Inline function 'korlibs.graphics.shader.Builder.FOR_0_UNTIL' call
    var len_0 = $this$ELSE.x6x(256);
    var temp = $this$ELSE.i6x(VarType_Int1_getInstance());
    // Inline function 'kotlin.apply' call
    var this_0 = $this$ELSE.k6w();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Builder.FOR_0_UNTIL.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.Builder.FOR_0_UNTIL_FIXED_BREAK.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_0.r6y(temp, len);
    var body = this_0.k6w();
    // Inline function 'korlibs.graphics.shader.Builder.FOR_0_UNTIL_FIXED_BREAK.<anonymous>.<anonymous>' call
    body.f6x();
    var stmIf = new If(cond, body.m6w());
    // Inline function 'kotlin.collections.plusAssign' call
    this_0.s6v_1.h(stmIf);
    // Inline function 'korlibs.korge.view.filter.Companion.fragment.<anonymous>.<anonymous>.<anonymous>' call
    var xfloat = this_0.i6x(this_0.k6x());
    this_0.t6v(xfloat, this_0.p6x(temp));
    this_0.t6v($gaussianResult, this_0.x6v(BlurUB_getInstance().mcp(), this_0.r6x(this_0.x6v(this_0.x6v(this_0.e6y(xfloat), xfloat), BlurUB_getInstance().ncp()))));
    var addTemp = this_0.i6x(this_0.l6x());
    this_0.t6v(addTemp, this_0.x6v(this_0.x6v(BlurUB_getInstance().ocp(), xfloat), TexInfoUB_getInstance().xcp()));
    this_0.t6v(this_0.w6v(), this_0.h6y(this_0.w6v(), this_0.x6v(Companion_getInstance_62().acq(this_0, $$this$FragmentShaderDefault.d6w(), this_0.h6y(Companion_getInstance_62().zcp(this_0), addTemp), true), $gaussianResult)));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_0 = this_0.l6y(temp, this_0.x6x(0));
    var body_0 = this_0.k6w();
    // Inline function 'korlibs.korge.view.filter.Companion.fragment.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    body_0.t6v(body_0.w6v(), body_0.h6y(body_0.w6v(), body_0.x6v(Companion_getInstance_62().acq(body_0, $$this$FragmentShaderDefault.d6w(), body_0.f6y(Companion_getInstance_62().zcp(body_0), addTemp), true), $gaussianResult)));
    var stmIf_0 = new If(cond_0, body_0.m6w());
    // Inline function 'kotlin.collections.plusAssign' call
    this_0.s6v_1.h(stmIf_0);
    var body_1 = this_0;
    var stmFor = new ForSimple(temp, $this$ELSE.x6x(0), len_0, body_1.m6w());
    // Inline function 'kotlin.collections.plusAssign' call
    $this$ELSE.s6v_1.h(stmFor);
    return Unit_instance;
  };
}
var BlurUB_instance;
function BlurUB_getInstance() {
  if (BlurUB_instance === VOID)
    new BlurUB();
  return BlurUB_instance;
}
var Companion_instance_31;
function Companion_getInstance_57() {
  if (Companion_instance_31 === VOID)
    new Companion_16();
  return Companion_instance_31;
}
function _get_rradius__1gjegj($this) {
  return $this.hco_1 * $this.jco_1;
}
function gaussian($this, x, constant1, constant2) {
  // Inline function 'kotlin.math.exp' call
  var x_0 = -x * x * constant2;
  return constant1 * Math.exp(x_0);
}
function u_radius$factory() {
  return getPropertyCallableRef('u_radius', 1, KProperty1, function (receiver) {
    return receiver.lcp();
  }, null);
}
function u_constant1$factory() {
  return getPropertyCallableRef('u_constant1', 1, KProperty1, function (receiver) {
    return receiver.mcp();
  }, null);
}
function u_constant2$factory() {
  return getPropertyCallableRef('u_constant2', 1, KProperty1, function (receiver) {
    return receiver.ncp();
  }, null);
}
function u_direction$factory() {
  return getPropertyCallableRef('u_direction', 1, KProperty1, function (receiver) {
    return receiver.ocp();
  }, null);
}
function u_radius$factory_0() {
  return getPropertyCallableRef('u_radius', 1, KProperty1, function (receiver) {
    return receiver.lcp();
  }, null);
}
function u_constant1$factory_0() {
  return getPropertyCallableRef('u_constant1', 1, KProperty1, function (receiver) {
    return receiver.mcp();
  }, null);
}
function u_constant2$factory_0() {
  return getPropertyCallableRef('u_constant2', 1, KProperty1, function (receiver) {
    return receiver.ncp();
  }, null);
}
function u_direction$factory_0() {
  return getPropertyCallableRef('u_direction', 1, KProperty1, function (receiver) {
    return receiver.ocp();
  }, null);
}
var Companion_instance_32;
function Companion_getInstance_58() {
  if (Companion_instance_32 === VOID)
    new Companion_17();
  return Companion_instance_32;
}
function DropshadowFilter$render$lambda($ctx, this$0, $filterScale, $blendMode) {
  return function (newtex, matrix) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = $ctx.d80_1;
    var this_1 = this_0.m80_1;
    if (!(this_1.h80_1 === this_0)) {
      this_1.h80_1 = this_0;
      this_1.r81();
    }
    var tmp0_x = this$0.pcq_1 * $filterScale;
    var tmp1_y = this$0.qcq_1 * $filterScale;
    var tmp2_filtering = this$0.tcq_1;
    var tmp3_colorMul = this$0.rcq_1;
    var tmp4_program = Companion_getInstance_58().ocq_1;
    this_0.t81(newtex, tmp0_x, tmp1_y, VOID, VOID, matrix, tmp2_filtering, tmp3_colorMul, $blendMode, tmp4_program);
    return Unit_instance;
  };
}
function filtering$factory($b0) {
  return getPropertyCallableRef('filtering', 0, KMutableProperty0, function () {
    return $b0.xcn();
  }, function (value) {
    return $b0.pcn(value);
  });
}
function get_renderToTextureResultPool(_this__u8e3s4) {
  _init_properties_Filter_kt__xu8pbc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = renderToTextureResultPool$delegate;
    var property = renderToTextureResultPool$factory();
    var tmp = _this__u8e3s4.px();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.qx_1;
      tmp_0 = tmp0_safe_receiver.a3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.rx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.qx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.qx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var renderToTextureResultPool$delegate;
var Companion_instance_33;
function Companion_getInstance_59() {
  if (Companion_instance_33 === VOID)
    new Companion_18();
  return Companion_instance_33;
}
function expandedBorderRectangle(_this__u8e3s4, inp) {
  _init_properties_Filter_kt__xu8pbc();
  return inp.s2e(getBorder(_this__u8e3s4, toIntCeil(inp.o25_1), toIntCeil(inp.p25_1)));
}
function getBorder(_this__u8e3s4, texWidth, texHeight) {
  _init_properties_Filter_kt__xu8pbc();
  return _this__u8e3s4.lco(texWidth, texHeight);
}
function renderToTextureWithBorder(_this__u8e3s4, ctx, matrix, texture, texWidth, texHeight, filterScale, block) {
  _init_properties_Filter_kt__xu8pbc();
  var filter = _this__u8e3s4;
  var margin = getBorder(filter, texWidth, texHeight);
  var borderLeft = toIntCeil(margin.r28_1 * filterScale);
  var borderTop = toIntCeil(margin.o28_1 * filterScale);
  var newTexWidth = texWidth + toIntCeil(margin.l28() * filterScale) | 0;
  var newTexHeight = texHeight + toIntCeil(margin.m28() * filterScale) | 0;
  // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
  ctx.r81();
  // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
  var rb = ctx.m8a(newTexWidth, newTexHeight, false, true, 1);
  try {
    // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.o8a(rb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.d80_1;
      var this_1 = this_0.m80_1;
      if (!(this_1.h80_1 === this_0)) {
        this_1.h80_1 = this_0;
        this_1.r81();
      }
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var scissor = AGScissor.h6p(0, 0, rb.i6e_1, rb.j6e_1);
        var temp = this_0.k81_1;
        this_0.t87();
        this_0.k81_1 = scissor;
        try {
          if (true) {
            ctx.h8a(Colors_getInstance().f3y_1);
          }
          // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>.<anonymous>' call
          // Inline function 'korlibs.korge.view.filter.renderToTextureWithBorder.<anonymous>' call
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          var this_2 = ctx.d80_1;
          var matrix_0 = Companion_getInstance_33().w28_1;
          var this_3 = this_2.m80_1;
          this_3.r81();
          var temp4 = this_3.s7z_1;
          var temp2d = this_3.t7z_1;
          this_3.t7z_1 = matrix_0;
          this_3.s7z_1 = toMatrix4(matrix_0);
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var this_4 = this_3.t6l(ProjViewUB_getInstance());
            var _unary__edvuaz = this_4.i6n();
            this_4.x7a(_unary__edvuaz + 1 | 0);
            this_4.y7a(this_4.i6n() + 1 | 0);
            var blockSize = this_4.m6l_1;
            var index0 = imul(this_4.i6n() - 1 | 0, blockSize);
            var index1 = imul(this_4.i6n(), blockSize);
            var texBlockSize = this_4.j6l_1.i6t().e1();
            var texIndex0 = imul(this_4.i6n() - 1 | 0, texBlockSize);
            var texIndex1 = imul(this_4.i6n(), texBlockSize);
            if (this_4.i6n() > 0) {
              arraycopy(this_4.o6l_1, index0, this_4.o6l_1, index1, blockSize);
            } else {
              arrayfill(this_4.o6l_1, 0, 0, blockSize);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
            var $this$push = this_4.j6l_1;
            this_4.p6l_1.l7b($this$push.h6t(), this_3.s7z_1);
            if (true && this_4.i6n() >= 1) {
              var equals = arrayequal(this_4.o6l_1, index0, this_4.o6l_1, index1, blockSize);
              if (equals) {
                var _unary__edvuaz_0 = this_4.i6n();
                this_4.x7a(_unary__edvuaz_0 - 1 | 0);
                break $l$block;
              }
            }
          }
          var tmp;
          try {
            filter.mco(ctx, Companion_getInstance_33().w28_1.b2a(borderLeft, borderTop), texture, newTexWidth, newTexHeight, Colors_getInstance().a3y_1, Companion_getInstance_13().k7y_1, filterScale);
            tmp = Unit_instance;
          }finally {
            this_3.r81();
            this_3.s7z_1 = temp4;
            this_3.t7z_1 = temp2d;
            this_3.t6l(ProjViewUB_getInstance()).z7a();
          }
          break $l$block_0;
        }finally {
          this_0.t87();
          this_0.k81_1 = temp;
        }
      }
    }finally {
      ctx.p8a();
    }
    // Inline function 'korlibs.korge.view.filter.renderToTextureWithBorder.<anonymous>' call
    block(Texture_0(rb).m3g(0, 0, newTexWidth, newTexHeight), matrix.e2a(-borderLeft | 0, -borderTop | 0));
    ctx.r81();
  }finally {
    ctx.n8a(rb);
  }
}
function renderToTextureWithBorderUnsafe(_this__u8e3s4, ctx, matrix, texture, texWidth, texHeight, filterScale, result) {
  result = result === VOID ? new RenderToTextureResult() : result;
  _init_properties_Filter_kt__xu8pbc();
  var filter = _this__u8e3s4;
  var margin = getBorder(filter, texWidth, texHeight);
  var borderLeft = toIntCeil(margin.r28_1 * filterScale);
  var borderTop = toIntCeil(margin.o28_1 * filterScale);
  var newTexWidth = texWidth + toIntCeil(margin.l28() * filterScale) | 0;
  var newTexHeight = texHeight + toIntCeil(margin.m28() * filterScale) | 0;
  ctx.r81();
  var fb = ctx.m8a(newTexWidth, newTexHeight);
  result.uco_1 = borderLeft;
  result.vco_1 = borderTop;
  result.sco_1 = newTexWidth;
  result.tco_1 = newTexHeight;
  result.yco_1 = texture;
  result.rco_1 = filter;
  result.wco_1 = filterScale;
  result.xco_1 = matrix.e2a(-borderLeft | 0, -borderTop | 0);
  result.bcp_1 = ctx;
  result.zco_1 = fb;
  return result;
}
function renderToTextureResultPool$delegate$lambda() {
  _init_properties_Filter_kt__xu8pbc();
  var tmp = renderToTextureResultPool$delegate$lambda$lambda;
  return Pool.g2p(tmp, VOID, renderToTextureResultPool$delegate$lambda$lambda_0);
}
function renderToTextureResultPool$delegate$lambda$lambda(it) {
  _init_properties_Filter_kt__xu8pbc();
  it.a18();
  return Unit_instance;
}
function renderToTextureResultPool$delegate$lambda$lambda_0(it) {
  _init_properties_Filter_kt__xu8pbc();
  return new RenderToTextureResult();
}
function renderToTextureResultPool$factory() {
  return getPropertyCallableRef('renderToTextureResultPool', 1, KProperty1, function (receiver) {
    return get_renderToTextureResultPool(receiver);
  }, null);
}
var properties_initialized_Filter_kt_lkm0w6;
function _init_properties_Filter_kt__xu8pbc() {
  if (!properties_initialized_Filter_kt_lkm0w6) {
    properties_initialized_Filter_kt_lkm0w6 = true;
    renderToTextureResultPool$delegate = new Property(VOID, renderToTextureResultPool$delegate$lambda);
  }
}
var Companion_instance_34;
function Companion_getInstance_60() {
  if (Companion_instance_34 === VOID)
    new Companion_19();
  return Companion_instance_34;
}
var Linear_instance;
function Linear_getInstance() {
  if (Linear_instance === VOID)
    new Linear();
  return Linear_instance;
}
var Nearest_instance;
function Nearest_getInstance() {
  if (Nearest_instance === VOID)
    new Nearest();
  return Nearest_instance;
}
var Companion_instance_35;
function Companion_getInstance_61() {
  if (Companion_instance_35 === VOID)
    new Companion_20();
  return Companion_instance_35;
}
function _get__program__9g4ap2($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.icq_1;
  _program$factory();
  return this_0.p1();
}
function ShaderFilter$BaseProgramProvider$_program$delegate$lambda(this$0) {
  return function () {
    return this$0.jcq(this$0.kcq(), this$0.fcq());
  };
}
var TexInfoUB_instance;
function TexInfoUB_getInstance() {
  if (TexInfoUB_instance === VOID)
    new TexInfoUB();
  return TexInfoUB_instance;
}
var Companion_instance_36;
function Companion_getInstance_62() {
  if (Companion_instance_36 === VOID)
    new Companion_21();
  return Companion_instance_36;
}
function _restoreUniforms($this, ctx, filterScale) {
  // Inline function 'korlibs.memory.fastForEachOneBits' call
  var value = $this.wcn_1;
  var index = 0;
  while (!(value === 0)) {
    var shift = countTrailingZeroBits(value);
    index = index + shift | 0;
    if (index < 32) {
      // Inline function 'korlibs.korge.view.filter.ShaderFilter._restoreUniforms.<anonymous>' call
      var it = index;
      ctx.o7z_1.c6i($this.vcn_1, it);
      $this.vcn_1.e6i(it, null);
    }
    value = value >>> (shift + 1 | 0) | 0;
    index = index + 1 | 0;
  }
  $this.wcn_1 = 0;
}
function _updateUniforms($this, ctx, filterScale, texture, texWidth, texHeight) {
  $this.rcn_1 = Vector2D.g2a(texture.v3e_1.n2i(), texture.v3e_1.o2i());
  $this.tcn_1 = Vector2D.g2a(1.0 / texture.v3e_1.n2i(), 1.0 / texture.v3e_1.o2i());
  $this.scn_1 = Vector2D.g2a(texWidth / texture.v3e_1.n2i(), texHeight / texture.v3e_1.o2i());
  $l$block: {
    // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
    var this_0 = ctx.t6l(TexInfoUB_getInstance());
    var _unary__edvuaz = this_0.i6n();
    this_0.x7a(_unary__edvuaz + 1 | 0);
    this_0.y7a(this_0.i6n() + 1 | 0);
    var blockSize = this_0.m6l_1;
    var index0 = imul(this_0.i6n() - 1 | 0, blockSize);
    var index1 = imul(this_0.i6n(), blockSize);
    var texBlockSize = this_0.j6l_1.i6t().e1();
    var texIndex0 = imul(this_0.i6n() - 1 | 0, texBlockSize);
    var texIndex1 = imul(this_0.i6n(), texBlockSize);
    if (this_0.i6n() > 0) {
      arraycopy(this_0.o6l_1, index0, this_0.o6l_1, index1, blockSize);
    } else {
      arrayfill(this_0.o6l_1, 0, 0, blockSize);
    }
    // Inline function 'korlibs.korge.view.filter.ShaderFilter._updateUniforms.<anonymous>' call
    var $this$push = this_0.j6l_1;
    var it = this_0.p6l_1;
    it.c7b($this$push.acr(), filterScale);
    it.g7b($this$push.ycq(), $this.rcn_1);
    it.g7b($this$push.zcq(), $this.scn_1);
    it.g7b($this$push.xcp(), $this.tcn_1);
    if (true && this_0.i6n() >= 1) {
      var equals = arrayequal(this_0.o6l_1, index0, this_0.o6l_1, index1, blockSize);
      if (equals) {
        var _unary__edvuaz_0 = this_0.i6n();
        this_0.x7a(_unary__edvuaz_0 - 1 | 0);
        break $l$block;
      }
    }
  }
  $this.mcq(ctx, filterScale);
}
function u_TextureSize$factory() {
  return getPropertyCallableRef('u_TextureSize', 1, KProperty1, function (receiver) {
    return receiver.ycq();
  }, null);
}
function u_MaxTexCoords$factory() {
  return getPropertyCallableRef('u_MaxTexCoords', 1, KProperty1, function (receiver) {
    return receiver.zcq();
  }, null);
}
function u_StdTexDerivates$factory() {
  return getPropertyCallableRef('u_StdTexDerivates', 1, KProperty1, function (receiver) {
    return receiver.xcp();
  }, null);
}
function u_filterScale$factory() {
  return getPropertyCallableRef('u_filterScale', 1, KProperty1, function (receiver) {
    return receiver.acr();
  }, null);
}
function u_TextureSize$factory_0() {
  return getPropertyCallableRef('u_TextureSize', 1, KProperty1, function (receiver) {
    return receiver.ycq();
  }, null);
}
function u_MaxTexCoords$factory_0() {
  return getPropertyCallableRef('u_MaxTexCoords', 1, KProperty1, function (receiver) {
    return receiver.zcq();
  }, null);
}
function u_StdTexDerivates$factory_0() {
  return getPropertyCallableRef('u_StdTexDerivates', 1, KProperty1, function (receiver) {
    return receiver.xcp();
  }, null);
}
function u_filterScale$factory_0() {
  return getPropertyCallableRef('u_filterScale', 1, KProperty1, function (receiver) {
    return receiver.acr();
  }, null);
}
function _program$factory() {
  return getPropertyCallableRef('_program', 1, KProperty1, function (receiver) {
    return _get__program__9g4ap2(receiver);
  }, null);
}
function get_backdropFilter(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.r9m_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseBackdropFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseBackdropFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.bcr_1;
}
function set_filterScale(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var this_0 = filterScale$delegate;
  var property = filterScale$factory();
  var value = this_0.ux_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.sx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_filterScale(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = filterScale$delegate;
    var property = filterScale$factory_0();
    var tmp0_elvis_lhs = this_0.sx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.tx_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.sx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var filterScale$delegate;
function renderFiltered(_this__u8e3s4, ctx, filter, first) {
  first = first === VOID ? true : first;
  _init_properties_ViewFilter_kt__pd9xp9();
  var bounds = _this__u8e3s4.s9y(VOID, false);
  if (bounds.o25_1 <= 0.0 || bounds.p25_1 <= 0.0)
    return Unit_instance;
  var tmp = Companion_getInstance_59();
  // Inline function 'kotlin.math.min' call
  var a = get_filterScale(_this__u8e3s4);
  var b = filter.kco();
  var tmp$ret$0 = Math.min(a, b);
  var tryFilterScale = tmp.xcq(tmp$ret$0);
  var texWidthNoBorder = coerceAtLeast(numberToInt(bounds.o25_1 * tryFilterScale), 1);
  var texHeightNoBorder = coerceAtLeast(numberToInt(bounds.p25_1 * tryFilterScale), 1);
  var realFilterScale = clamp_0(texWidthNoBorder / bounds.o25_1, 0.03125, 1.0);
  var tmp_0;
  switch (false) {
    case true:
      tmp_0 = clamp_1(toIntCeil(1.0 / get_filterScale(_this__u8e3s4)), 1, 8);
      break;
    case false:
      tmp_0 = 0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var edgeSize = tmp_0;
  var texWidth = texWidthNoBorder + imul(edgeSize, 2) | 0;
  var texHeight = texHeightNoBorder + imul(edgeSize, 2) | 0;
  var addx = -bounds.m25_1 + edgeSize;
  var addy = -bounds.n25_1 + edgeSize;
  // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
  ctx.r81();
  // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
  var rb = ctx.m8a(texWidth, texHeight, false, true, 1);
  try {
    // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.o8a(rb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.d80_1;
      var this_1 = this_0.m80_1;
      if (!(this_1.h80_1 === this_0)) {
        this_1.h80_1 = this_0;
        this_1.r81();
      }
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var scissor = AGScissor.h6p(0, 0, rb.i6e_1, rb.j6e_1);
        var temp = this_0.k81_1;
        this_0.t87();
        this_0.k81_1 = scissor;
        try {
          if (true) {
            ctx.h8a(Colors_getInstance().f3y_1);
          }
          // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>.<anonymous>' call
          // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
          var mat = _this__u8e3s4.xak().c2a(addx, addy).x29(realFilterScale);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          var this_2 = ctx.d80_1.m80_1;
          this_2.r81();
          var temp4 = this_2.s7z_1;
          var temp2d = this_2.t7z_1;
          this_2.t7z_1 = mat;
          this_2.s7z_1 = toMatrix4(mat);
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var this_3 = this_2.t6l(ProjViewUB_getInstance());
            var _unary__edvuaz = this_3.i6n();
            this_3.x7a(_unary__edvuaz + 1 | 0);
            this_3.y7a(this_3.i6n() + 1 | 0);
            var blockSize = this_3.m6l_1;
            var index0 = imul(this_3.i6n() - 1 | 0, blockSize);
            var index1 = imul(this_3.i6n(), blockSize);
            var texBlockSize = this_3.j6l_1.i6t().e1();
            var texIndex0 = imul(this_3.i6n() - 1 | 0, texBlockSize);
            var texIndex1 = imul(this_3.i6n(), texBlockSize);
            if (this_3.i6n() > 0) {
              arraycopy(this_3.o6l_1, index0, this_3.o6l_1, index1, blockSize);
            } else {
              arrayfill(this_3.o6l_1, 0, 0, blockSize);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
            var $this$push = this_3.j6l_1;
            this_3.p6l_1.l7b($this$push.h6t(), this_2.s7z_1);
            if (true && this_3.i6n() >= 1) {
              var equals = arrayequal(this_3.o6l_1, index0, this_3.o6l_1, index1, blockSize);
              if (equals) {
                var _unary__edvuaz_0 = this_3.i6n();
                this_3.x7a(_unary__edvuaz_0 - 1 | 0);
                break $l$block;
              }
            }
          }
          var tmp_1;
          try {
            var tmp_2;
            if (first) {
              _this__u8e3s4.gal(ctx);
              tmp_2 = Unit_instance;
            } else {
              _this__u8e3s4.hal(ctx);
              tmp_2 = Unit_instance;
            }
            tmp_1 = tmp_2;
          }finally {
            this_2.r81();
            this_2.s7z_1 = temp4;
            this_2.t7z_1 = temp2d;
            this_2.t6l(ProjViewUB_getInstance()).z7a();
          }
          break $l$block_0;
        }finally {
          this_0.t87();
          this_0.k81_1 = temp;
        }
      }
    }finally {
      ctx.p8a();
    }
    // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
    var texture = Texture_0(rb).m3g(0, 0, texWidth, texHeight);
    var mat_0 = _this__u8e3s4.u9y().h2a(-addx, -addy).z29(1.0 / realFilterScale);
    filter.mco(ctx, mat_0, texture, texWidth, texHeight, _this__u8e3s4.aal(), _this__u8e3s4.l9l_1, realFilterScale);
    ctx.r81();
  }finally {
    ctx.n8a(rb);
  }
}
function set_filter(_this__u8e3s4, value) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var enabled = !(value == null);
  if (enabled) {
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'korlibs.korge.view.View.getOrCreateAndAddRenderPhase' call
      // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
      var tmp0_safe_receiver = _this__u8e3s4.r9m_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = tmp0_safe_receiver.a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
            if (element instanceof ViewRenderPhaseFilter) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        tmp = tmp$ret$1;
      }
      var tmp_0 = tmp;
      var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp$ret$3 = tmp0_safe_receiver_0;
        break $l$block_0;
      }
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.filter.<set-filter>.<anonymous>' call
      var this_0 = new ViewRenderPhaseFilter(value);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getOrCreateAndAddRenderPhase.<anonymous>' call
      _this__u8e3s4.fal(this_0);
      tmp$ret$3 = this_0;
    }
    tmp$ret$3.ccr_1 = value;
  } else {
    // Inline function 'korlibs.korge.view.View.removeRenderPhaseOfType' call
    var tmp0_safe_receiver_1 = _this__u8e3s4.r9m_1;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      removeAll(tmp0_safe_receiver_1, _set_filter_$lambda_rgmh04);
    }
  }
  _this__u8e3s4.nai();
}
function get_filter(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.r9m_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.ccr_1;
}
var Companion_instance_37;
function Companion_getInstance_63() {
  return Companion_instance_37;
}
function filterScale$delegate$lambda($this$extraPropertyThis, it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return Companion_getInstance_59().xcq(it);
}
function filterScale$delegate$lambda_0($this$extraPropertyThis) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return 1.0;
}
function _set_filter_$lambda_rgmh04(it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return it instanceof ViewRenderPhaseFilter;
}
function filterScale$factory() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
function filterScale$factory_0() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
var properties_initialized_ViewFilter_kt_mku9up;
function _init_properties_ViewFilter_kt__pd9xp9() {
  if (!properties_initialized_ViewFilter_kt_mku9up) {
    properties_initialized_ViewFilter_kt_mku9up = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var transform = filterScale$delegate$lambda;
    var default_0 = filterScale$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.ux_1 = transform;
    filterScale$delegate = this_0;
  }
}
function _get_shapeBounds__actvvf($this) {
  var valid = $this.lcd_1 ? $this.wcd_1 : $this.vcd_1;
  if (!valid) {
    if ($this.lcd_1)
      $this.wcd_1 = true;
    else
      $this.vcd_1 = true;
    var result = $this.tcd_1.k5y($this.lcd_1);
    if ($this.lcd_1)
      $this.zcd_1 = result;
    else
      $this.ycd_1 = result;
    return result;
  }
  return $this.lcd_1 ? $this.zcd_1 : $this.ycd_1;
}
function invalidateShape($this) {
  $this.xcd_1 = 0;
  $this.ucd_1 = false;
  $this.vcd_1 = false;
  $this.wcd_1 = false;
  $this.j9s();
}
function requireShape($this) {
  if ($this.ucd_1)
    return Unit_instance;
  $this.ucd_1 = true;
  $this.mcd_1.f3();
  $this.mcd_1.ocr();
  $this.mcd_1.pcr(Companion_getInstance_15().b6g_1);
  $this.ace_1 = true;
  renderShape($this, $this.tcd_1);
  $this.mcd_1.r6e();
  $this.cce_1 = $this.bce_1;
}
function renderCommands($this, ctx, doRequireTexture) {
  var mat = doRequireTexture ? $this.u9y().k29(get_immutable(ctx.g7z_1.u88())) : $this.u9y();
  $this.dce_1 = mat.f2a(-$this.haj(), -$this.iaj());
  requireShape($this);
  $this.mcd_1.qcr(ctx, $this.dce_1, $this.wak(), $this.qcd_1, $this.aal(), doRequireTexture);
}
function renderShape($this, shape) {
  if (!equals(shape, EmptyShape_instance)) {
    if (shape instanceof CompoundShape) {
      var _iterator__ex2g4s = shape.x5y_1.a1();
      while (_iterator__ex2g4s.b1()) {
        var v = _iterator__ex2g4s.c1();
        renderShape($this, v);
      }
    } else {
      if (shape instanceof TextShape) {
        renderShape($this, shape.q5z());
      } else {
        if (shape instanceof FillShape) {
          $this.xcd_1 = $this.xcd_1 + 1 | 0;
          if ($this.xcd_1 > $this.ece_1)
            return Unit_instance;
          renderFill($this, shape);
        } else {
          if (shape instanceof PolylineShape) {
            $this.xcd_1 = $this.xcd_1 + 1 | 0;
            if ($this.xcd_1 > $this.ece_1)
              return Unit_instance;
            renderStroke$default($this, shape.c5z_1, shape.z5y_1, shape.b5z_1, shape.e5z_1, shape.d5z_1);
          } else {
            var reason = 'shape=' + toString(shape);
            throw NotImplementedError.md('An operation is not implemented: ' + reason);
          }
        }
      }
    }
  }
}
function renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef) {
  var gpuShapeViewCommands = $this.mcd_1;
  var pointsList = toStrokePointsList(toCurvesList(strokePath), strokeInfo, StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance(), VOID, forceClosed);
  gpuShapeViewCommands.pcr(Companion_getInstance_15().b6g_1);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pointsList.e1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var points = pointsList.d1(_unary__edvuaz);
    var startIndex = gpuShapeViewCommands.rcr();
    var vector = points.x37();
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var inductionVariable = 0;
    var last = vector.e1();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>.<anonymous>' call
        var x = vector.n27(n_0, 0);
        var y = vector.n27(n_0, 1);
        var dx = vector.n27(n_0, 2);
        var dy = vector.n27(n_0, 3);
        var len = vector.n27(n_0, 4);
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = vector.n27(n_0, 5);
        var maxLen = Math.abs(this_0);
        var px = x + dx * len;
        var py = y + dy * len;
        gpuShapeViewCommands.scr(px, py, $this.scd_1 ? len : 0.0, $this.scd_1 ? maxLen : $this.gce_1);
      }
       while (inductionVariable < last);
    var endIndex = gpuShapeViewCommands.tcr();
    var info = GpuShapeViewPrograms_getInstance().mcs(stateTransform, paint, globalAlpha, strokeInfo.g37_1);
    var tmp0_drawType = Companion_getInstance_18().f6o_1;
    var tmp1_blendMode = Companion_getInstance_13().k7y_1;
    gpuShapeViewCommands.ncs(tmp0_drawType, info, VOID, stencilOpFunc, stencilRef, tmp1_blendMode, VOID, startIndex, endIndex);
  }
}
function renderStroke$default($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef, $super) {
  forceClosed = forceClosed === VOID ? null : forceClosed;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_19().p6f_1 : stencilOpFunc;
  stencilRef = stencilRef === VOID ? Companion_getInstance_20().n6f_1 : stencilRef;
  return renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef);
}
function getPointsForPath($this, points, type) {
  if (points.e1() < 3)
    return null;
  var vertexStart = $this.mcd_1.rcr();
  var bb = BoundsBuilder__plus_impl_cz7f7x_0(Companion_getInstance_31().c26(), points);
  var xMid = (_BoundsBuilder___get_xmax__impl__gsz0km(bb) + _BoundsBuilder___get_xmin__impl__o2sib0(bb)) / 2;
  var yMid = (_BoundsBuilder___get_ymax__impl__oia4uz(bb) + _BoundsBuilder___get_ymin__impl__5n2e8j(bb)) / 2;
  var pMid = Vector2D.s24(xMid, yMid);
  var isStrip = type === Companion_getInstance_18().f6o_1;
  var antialiased = $this.scd_1;
  var isStripAndAntialiased = antialiased && isStrip;
  if (!isStrip) {
    $this.mcd_1.scr(xMid, yMid, 0.0, $this.gce_1);
  }
  var inductionVariable = 0;
  var last = points.e1() + 1 | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = points.d1(n % points.e1() | 0);
      var x = p.dl();
      var y = p.el();
      var len = isStripAndAntialiased ? Companion_getInstance_29().p2g(p, pMid) : 0.0;
      var maxLen = isStripAndAntialiased ? len : $this.gce_1;
      if (isStrip) {
        $this.mcd_1.scr(xMid, yMid, 0.0, maxLen);
      }
      $this.mcd_1.scr(x, y, len, maxLen);
    }
     while (inductionVariable < last);
  var vertexEnd = $this.mcd_1.tcr();
  return new PointsResult(toAGScissor(_BoundsBuilder___get_bounds__impl__s1l1gx(bb)), points.e1() + 2 | 0, vertexStart, vertexEnd);
}
function getPointsForPath_0($this, path, type) {
  return getPointsForPath($this, get_cachedPoints(path), type);
}
function getPointsForPathList($this, path, type) {
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var this_0 = getPoints2List(path);
  var destination = ArrayList.h1();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.getPointsForPathList.<anonymous>' call
    var tmp0_safe_receiver = getPointsForPath($this, element, type);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  return destination;
}
function renderFill($this, shape) {
  var tmp0_elvis_lhs = GpuShapeViewPrograms_getInstance().mcs(shape.o5y_1, shape.n5y_1, shape.p5y_1, 1.0E7);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var paintShader = tmp;
  var drawFill = !$this.fce_1;
  var drawAntialiasingBorder = $this.fce_1 ? true : $this.scd_1;
  var shapeIsConvex = shape.v5y();
  var isSimpleDraw = shapeIsConvex && shape.m5y_1 == null && !$this.fce_1;
  var pathDataList = getPointsForPathList($this, shape.l5y_1, isSimpleDraw ? Companion_getInstance_18().f6o_1 : Companion_getInstance_18().g6o_1);
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
  var bb = Companion_getInstance_31().c26();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pathDataList.e1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = pathDataList.d1(_unary__edvuaz);
    bb = plus_0(bb, it.ocs_1);
  }
  var pathBoundsNoExpanded = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  var pathBounds = toAGScissor(pathBoundsNoExpanded.s2e(MarginInt.u28(2)));
  var clipDataStart = $this.mcd_1.rcr();
  var tmp1_safe_receiver = shape.m5y_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
    tmp_0 = getPointsForPath_0($this, tmp1_safe_receiver, Companion_getInstance_18().g6o_1);
  }
  var clipData = tmp_0;
  var clipDataEnd = $this.mcd_1.tcr();
  var tmp3_elvis_lhs = clipData == null ? null : clipData.ocs_1;
  var clipBounds = tmp3_elvis_lhs == null ? Companion_getInstance_15().b6g_1 : tmp3_elvis_lhs;
  if (!isSimpleDraw || $this.ace_1) {
    $this.ace_1 = true;
    $this.mcd_1.pcr(isSimpleDraw ? Companion_getInstance_15().b6g_1 : !clipBounds.equals(Companion_getInstance_15().b6g_1) ? Companion_getInstance_15().m6p(pathBounds, clipBounds) : pathBounds);
  }
  if (isSimpleDraw) {
    $this.ace_1 = false;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < pathDataList.e1()) {
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var pathData = pathDataList.d1(_unary__edvuaz_0);
      var tmp0_$this = $this.mcd_1;
      var tmp1_drawType = Companion_getInstance_18().f6o_1;
      var tmp2_startIndex = pathData.qcs_1;
      var tmp3_endIndex = pathData.rcs_1;
      var tmp4_colorMask = _AGColorMask___init__impl__j38ai8(true);
      var tmp5_blendMode = $this.zak();
      tmp0_$this.ncs(tmp1_drawType, paintShader, tmp4_colorMask, VOID, VOID, tmp5_blendMode, VOID, tmp2_startIndex, tmp3_endIndex);
    }
    return Unit_instance;
  }
  var winding = shape.l5y_1.c3d_1;
  var stencilReferenceValue = 1;
  var stencilCompare = Companion_getInstance_21().g6q_1;
  if (drawFill) {
    switch (winding.l3_1) {
      case 0:
        stencilReferenceValue = 1;
        stencilCompare = Companion_getInstance_21().g6q_1;
        var stencilOpFunc = AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_19().p6f_1, true), Companion_getInstance_21().f6q_1), Companion_getInstance_22().r6q_1);
        var stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_20().n6f_1, 1);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_1 = 0;
        while (n_1 < pathDataList.e1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          var pathData_0 = pathDataList.d1(_unary__edvuaz_1);
          writeStencil($this, pathData_0.qcs_1, pathData_0.rcs_1, stencilOpFunc, stencilRef, Companion_getInstance_23().d6g_1);
        }

        break;
      case 1:
        stencilReferenceValue = 0;
        stencilCompare = Companion_getInstance_21().m6q_1;
        var stencilOpFunc_0 = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_19().p6f_1, true), Companion_getInstance_21().f6q_1);
        var stencilRef_0 = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_20().n6f_1, 255);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_2 = 0;
        while (n_2 < pathDataList.e1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_2 = n_2;
          n_2 = _unary__edvuaz_2 + 1 | 0;
          var pathData_1 = pathDataList.d1(_unary__edvuaz_2);
          writeStencil($this, pathData_1.qcs_1, pathData_1.rcs_1, AGStencilOpFunc__withActionOnBothPass_impl_qbn6at(stencilOpFunc_0, Companion_getInstance_22().q6q_1, Companion_getInstance_22().o6q_1), stencilRef_0, Companion_getInstance_23().d6g_1);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    if (!(clipData == null)) {
      if (winding.equals(Winding_NON_ZERO_getInstance())) {
        writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_19().p6f_1, true), Companion_getInstance_21().m6q_1), Companion_getInstance_22().r6q_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(Companion_getInstance_20().n6f_1, 0), 255), Companion_getInstance_23().e6g_1);
      }
      writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_19().p6f_1, true), Companion_getInstance_21().f6q_1), Companion_getInstance_22().r6q_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_20().n6f_1, 2), Companion_getInstance_23().g6g_1);
      stencilReferenceValue = 3;
    }
  }
  if (drawAntialiasingBorder && shape.m5y_1 == null) {
    renderStroke($this, shape.o5y_1, shape.l5y_1, shape.n5y_1, shape.p5y_1, new StrokeInfo(1.6 / $this.bce_1, VOID, LineScaleMode_NONE_getInstance(), LineCap_BUTT_getInstance(), LineCap_BUTT_getInstance(), LineJoin_MITER_getInstance(), 5.0), true, !drawFill ? Companion_getInstance_19().p6f_1 : AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_19().p6f_1, true), AGCompareMode__inverted_impl_7xxk8m(stencilCompare)), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_20().n6f_1, stencilReferenceValue), 0));
  }
  if (drawFill) {
    writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare);
    $this.mcd_1.l75(0);
  }
}
function writeStencil($this, pathDataStart, pathDataEnd, stencilOpFunc, stencilRef, cullFace) {
  var tmp0_$this = $this.mcd_1;
  var tmp1_drawType = Companion_getInstance_18().g6o_1;
  var tmp2_paintShader = GpuShapeViewPrograms_getInstance().lcs_1;
  var tmp3_colorMask = _AGColorMask___init__impl__j38ai8_0(false, false, false, false);
  var tmp4_blendMode = Companion_getInstance_13().m7y_1;
  tmp0_$this.scs(tmp1_drawType, tmp2_paintShader, tmp3_colorMask, stencilOpFunc, stencilRef, tmp4_blendMode, cullFace, pathDataStart, pathDataEnd);
}
function writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare) {
  var vstart = $this.mcd_1.rcr();
  var x0 = pathBounds.t25();
  var y0 = pathBounds.v25();
  var x1 = pathBounds.u25();
  var y1 = pathBounds.w25();
  $this.mcd_1.scr(x0, y0, 0.0, $this.gce_1);
  $this.mcd_1.scr(x1, y0, 0.0, $this.gce_1);
  $this.mcd_1.scr(x1, y1, 0.0, $this.gce_1);
  $this.mcd_1.scr(x0, y1, 0.0, $this.gce_1);
  var vend = $this.mcd_1.tcr();
  var tmp0_$this = $this.mcd_1;
  var tmp1_drawType = Companion_getInstance_18().g6o_1;
  var tmp2_colorMask = _AGColorMask___init__impl__j38ai8(true);
  var tmp3_stencilOpFunc = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_19().p6f_1, true), stencilCompare);
  var tmp4_stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_20().n6f_1, stencilReferenceValue), 0);
  var tmp5_blendMode = $this.zak();
  tmp0_$this.ncs(tmp1_drawType, paintShader, tmp2_colorMask, tmp3_stencilOpFunc, tmp4_stencilRef, tmp5_blendMode, VOID, vstart, vend);
}
var ShapeViewUB_instance;
function ShapeViewUB_getInstance() {
  if (ShapeViewUB_instance === VOID)
    new ShapeViewUB();
  return ShapeViewUB_instance;
}
function GpuShapeViewPrograms$PROGRAM_COMBINED$lambda($$this$FragmentShaderDefault) {
  return function ($this$IF_ELSE_LIST, it) {
    var tmp;
    switch (it) {
      case 0:
        $this$IF_ELSE_LIST.t6v($this$IF_ELSE_LIST.w6v(), GpuShapeViewPrograms_getInstance().yct());
        tmp = Unit_instance;
        break;
      case 1:
        $this$IF_ELSE_LIST.t6v($this$IF_ELSE_LIST.w6v(), $this$IF_ELSE_LIST.e6w($$this$FragmentShaderDefault.d6w(), $this$IF_ELSE_LIST.v6x($this$IF_ELSE_LIST.y6x([$this$IF_ELSE_LIST.c6w($this$IF_ELSE_LIST.x6v(GpuShapeViewPrograms_getInstance().acu(), $this$IF_ELSE_LIST.a6w([$$this$FragmentShaderDefault.p6v(), $this$IF_ELSE_LIST.z6v(0.0), $this$IF_ELSE_LIST.z6v(1.0)])), 'xy')]))));
        tmp = Unit_instance;
        break;
      case 2:
        $this$IF_ELSE_LIST.t6v($this$IF_ELSE_LIST.w6v(), $this$IF_ELSE_LIST.e6w($$this$FragmentShaderDefault.d6w(), $this$IF_ELSE_LIST.c6w($this$IF_ELSE_LIST.x6v(GpuShapeViewPrograms_getInstance().acu(), $this$IF_ELSE_LIST.a6w([$this$IF_ELSE_LIST.a6y($$this$FragmentShaderDefault.p6v()), $this$IF_ELSE_LIST.b6y($$this$FragmentShaderDefault.p6v()), $this$IF_ELSE_LIST.z6v(0.0), $this$IF_ELSE_LIST.z6v(1.0)])), 'xy')));
        tmp = Unit_instance;
        break;
      case 3:
        var rpoint = $this$IF_ELSE_LIST.i6x(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.t6v($this$IF_ELSE_LIST.c6w(rpoint, 'xy'), $this$IF_ELSE_LIST.c6w($this$IF_ELSE_LIST.x6v(GpuShapeViewPrograms_getInstance().acu(), $this$IF_ELSE_LIST.a6w([$this$IF_ELSE_LIST.a6y($$this$FragmentShaderDefault.p6v()), $this$IF_ELSE_LIST.b6y($$this$FragmentShaderDefault.p6v()), $this$IF_ELSE_LIST.z6v(0.0), $this$IF_ELSE_LIST.z6v(1.0)])), 'xy'));
        var x = $this$IF_ELSE_LIST.a6y(rpoint);
        var y = $this$IF_ELSE_LIST.b6y(rpoint);
        var x0 = $this$IF_ELSE_LIST.a6y(GpuShapeViewPrograms_getInstance().bcu());
        var y0 = $this$IF_ELSE_LIST.b6y(GpuShapeViewPrograms_getInstance().bcu());
        var r0 = $this$IF_ELSE_LIST.c6y(GpuShapeViewPrograms_getInstance().bcu());
        var x1 = $this$IF_ELSE_LIST.a6y(GpuShapeViewPrograms_getInstance().ccu());
        var y1 = $this$IF_ELSE_LIST.b6y(GpuShapeViewPrograms_getInstance().ccu());
        var r1 = $this$IF_ELSE_LIST.c6y(GpuShapeViewPrograms_getInstance().ccu());
        var ratio = $this$IF_ELSE_LIST.a6y($$this$FragmentShaderDefault.h6w());
        var r0r1_2 = $this$IF_ELSE_LIST.b6y($$this$FragmentShaderDefault.h6w());
        var r0pow2 = $this$IF_ELSE_LIST.c6y($$this$FragmentShaderDefault.h6w());
        var r1pow2 = $this$IF_ELSE_LIST.d6y($$this$FragmentShaderDefault.h6w());
        var y0_y1 = $this$IF_ELSE_LIST.a6y($$this$FragmentShaderDefault.u6y());
        var x0_x1 = $this$IF_ELSE_LIST.b6y($$this$FragmentShaderDefault.u6y());
        var r0_r1 = $this$IF_ELSE_LIST.c6y($$this$FragmentShaderDefault.u6y());
        var radial_scale = $this$IF_ELSE_LIST.d6y($$this$FragmentShaderDefault.u6y());
        $this$IF_ELSE_LIST.t6v(r0r1_2, $this$IF_ELSE_LIST.x6v($this$IF_ELSE_LIST.x6v($this$IF_ELSE_LIST.z6v(2.0), r0), r1));
        $this$IF_ELSE_LIST.t6v(r0pow2, GpuShapeViewPrograms_getInstance().dcu(r0));
        $this$IF_ELSE_LIST.t6v(r1pow2, GpuShapeViewPrograms_getInstance().dcu(r1));
        $this$IF_ELSE_LIST.t6v(x0_x1, $this$IF_ELSE_LIST.f6y(x0, x1));
        $this$IF_ELSE_LIST.t6v(y0_y1, $this$IF_ELSE_LIST.f6y(y0, y1));
        $this$IF_ELSE_LIST.t6v(r0_r1, $this$IF_ELSE_LIST.f6y(r0, r1));
        $this$IF_ELSE_LIST.t6v(radial_scale, $this$IF_ELSE_LIST.i6w($this$IF_ELSE_LIST.z6v(1.0), $this$IF_ELSE_LIST.f6y($this$IF_ELSE_LIST.f6y(GpuShapeViewPrograms_getInstance().dcu($this$IF_ELSE_LIST.f6y(r0, r1)), GpuShapeViewPrograms_getInstance().dcu($this$IF_ELSE_LIST.f6y(x0, x1))), GpuShapeViewPrograms_getInstance().dcu($this$IF_ELSE_LIST.f6y(y0, y1)))));
        $this$IF_ELSE_LIST.t6v(ratio, $this$IF_ELSE_LIST.f6y($this$IF_ELSE_LIST.z6v(1.0), $this$IF_ELSE_LIST.x6v($this$IF_ELSE_LIST.f6y($this$IF_ELSE_LIST.h6y($this$IF_ELSE_LIST.h6y($this$IF_ELSE_LIST.x6v($this$IF_ELSE_LIST.e6y(r1), r0_r1), $this$IF_ELSE_LIST.x6v(x0_x1, $this$IF_ELSE_LIST.f6y(x1, x))), $this$IF_ELSE_LIST.x6v(y0_y1, $this$IF_ELSE_LIST.f6y(y1, y))), $this$IF_ELSE_LIST.s6x($this$IF_ELSE_LIST.f6y($this$IF_ELSE_LIST.h6y($this$IF_ELSE_LIST.f6y($this$IF_ELSE_LIST.x6v(r1pow2, $this$IF_ELSE_LIST.h6y(GpuShapeViewPrograms_getInstance().dcu($this$IF_ELSE_LIST.f6y(x0, x)), GpuShapeViewPrograms_getInstance().dcu($this$IF_ELSE_LIST.f6y(y0, y)))), $this$IF_ELSE_LIST.x6v(r0r1_2, $this$IF_ELSE_LIST.h6y($this$IF_ELSE_LIST.x6v($this$IF_ELSE_LIST.f6y(x0, x), $this$IF_ELSE_LIST.f6y(x1, x)), $this$IF_ELSE_LIST.x6v($this$IF_ELSE_LIST.f6y(y0, y), $this$IF_ELSE_LIST.f6y(y1, y))))), $this$IF_ELSE_LIST.x6v(r0pow2, $this$IF_ELSE_LIST.h6y(GpuShapeViewPrograms_getInstance().dcu($this$IF_ELSE_LIST.f6y(x1, x)), GpuShapeViewPrograms_getInstance().dcu($this$IF_ELSE_LIST.f6y(y1, y))))), GpuShapeViewPrograms_getInstance().dcu($this$IF_ELSE_LIST.f6y($this$IF_ELSE_LIST.h6y($this$IF_ELSE_LIST.h6y($this$IF_ELSE_LIST.f6y($this$IF_ELSE_LIST.f6y($this$IF_ELSE_LIST.x6v(x1, y0), $this$IF_ELSE_LIST.x6v(x, y0)), $this$IF_ELSE_LIST.x6v(x0, y1)), $this$IF_ELSE_LIST.x6v(x, y1)), $this$IF_ELSE_LIST.x6v(x0, y)), $this$IF_ELSE_LIST.x6v(x1, y)))))), radial_scale)));
        $this$IF_ELSE_LIST.t6v($this$IF_ELSE_LIST.w6v(), $this$IF_ELSE_LIST.e6w($$this$FragmentShaderDefault.d6w(), $this$IF_ELSE_LIST.y6x([ratio, $this$IF_ELSE_LIST.z6v(0.0)])));
        tmp = Unit_instance;
        break;
      case 4:
        var rpoint_0 = $this$IF_ELSE_LIST.i6x(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.t6v($this$IF_ELSE_LIST.c6w(rpoint_0, 'xy'), $this$IF_ELSE_LIST.c6w($this$IF_ELSE_LIST.x6v(GpuShapeViewPrograms_getInstance().acu(), $this$IF_ELSE_LIST.a6w([$this$IF_ELSE_LIST.a6y($$this$FragmentShaderDefault.p6v()), $this$IF_ELSE_LIST.b6y($$this$FragmentShaderDefault.p6v()), $this$IF_ELSE_LIST.z6v(0.0), $this$IF_ELSE_LIST.z6v(1.0)])), 'xy'));
        var x_0 = $this$IF_ELSE_LIST.a6y(rpoint_0);
        var y_0 = $this$IF_ELSE_LIST.b6y(rpoint_0);
        var ratio_0 = $this$IF_ELSE_LIST.a6y($$this$FragmentShaderDefault.h6w());
        var angle = $this$IF_ELSE_LIST.b6y($$this$FragmentShaderDefault.h6w());
        var x0_0 = $this$IF_ELSE_LIST.a6y(GpuShapeViewPrograms_getInstance().bcu());
        var y0_0 = $this$IF_ELSE_LIST.b6y(GpuShapeViewPrograms_getInstance().bcu());
        var PI2 = $this$IF_ELSE_LIST.z6v(3.141592653589793 * 2);
        $this$IF_ELSE_LIST.t6v(angle, $this$IF_ELSE_LIST.m6x($this$IF_ELSE_LIST.f6y(y_0, y0_0), $this$IF_ELSE_LIST.f6y(x_0, x0_0)));
        // Inline function 'korlibs.graphics.shader.Builder.IF' call

        var cond = $this$IF_ELSE_LIST.m6y(angle, $this$IF_ELSE_LIST.z6v(0.0));
        var body = $this$IF_ELSE_LIST.k6w();
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>.<anonymous>' call

        body.t6v(angle, body.h6y(angle, PI2));
        var stmIf = new If(cond, body.m6w());
        // Inline function 'kotlin.collections.plusAssign' call

        $this$IF_ELSE_LIST.s6v_1.h(stmIf);
        $this$IF_ELSE_LIST.t6v(ratio_0, $this$IF_ELSE_LIST.i6w(angle, PI2));
        $this$IF_ELSE_LIST.t6v($this$IF_ELSE_LIST.w6v(), $this$IF_ELSE_LIST.e6w($$this$FragmentShaderDefault.d6w(), $this$IF_ELSE_LIST.v6x($this$IF_ELSE_LIST.y6x([ratio_0, $this$IF_ELSE_LIST.z6v(0.0)]))));
        tmp = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
var GpuShapeViewPrograms_instance;
function GpuShapeViewPrograms_getInstance() {
  if (GpuShapeViewPrograms_instance === VOID)
    new GpuShapeViewPrograms();
  return GpuShapeViewPrograms_instance;
}
function u_ProgramType$factory() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.xct();
  }, null);
}
function u_Color$factory() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.yct();
  }, null);
}
function u_ColorMul$factory() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.wct();
  }, null);
}
function u_GlobalAlpha$factory() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.zct();
  }, null);
}
function u_GlobalPixelScale$factory() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.vct();
  }, null);
}
function u_Transform$factory() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.acu();
  }, null);
}
function u_Gradientp0$factory() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.bcu();
  }, null);
}
function u_Gradientp1$factory() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.ccu();
  }, null);
}
function u_ProgramType$factory_0() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.xct();
  }, null);
}
function u_Color$factory_0() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.yct();
  }, null);
}
function u_ColorMul$factory_0() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.wct();
  }, null);
}
function u_GlobalAlpha$factory_0() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.zct();
  }, null);
}
function u_GlobalPixelScale$factory_0() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.vct();
  }, null);
}
function u_Transform$factory_0() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.acu();
  }, null);
}
function u_Gradientp0$factory_0() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.bcu();
  }, null);
}
function u_Gradientp1$factory_0() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.ccu();
  }, null);
}
function beforeStartingKorge(config) {
}
function completeViews(views) {
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForLambda(Korge$_init_$slambda_ys8r4w, VOID, VOID, [1]);
initMetadataForLambda(Korge$start$slambda, VOID, VOID, [1]);
initMetadataForClass(Korge, 'Korge', Korge, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(KorgeDisplayMode, 'KorgeDisplayMode');
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KorgeRunner$invoke$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$prepareViewsBase$lambda$slambda, VOID, VOID, [0]);
initMetadataForObject(KorgeRunner, 'KorgeRunner', VOID, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda_0, VOID, VOID, [1]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(RootAnimationNode, 'RootAnimationNode');
initMetadataForClass(TweenNode, 'TweenNode');
initMetadataForClass(BlockNode, 'BlockNode');
initMetadataForClass(Animator, 'Animator', VOID, VOID, [CloseableCancellable], [1]);
initMetadataForLambda(KeysEvents$down$slambda, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$up$slambda, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForClass(KeysEvents, 'KeysEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(MouseDragInfo, 'MouseDragInfo');
initMetadataForClass(OnMouseDragCloseable, 'OnMouseDragCloseable', VOID, VOID, [AutoCloseable]);
initMetadataForClass(MouseDragState, 'MouseDragState');
initMetadataForClass(DraggableInfo, 'DraggableInfo');
initMetadataForClass(DraggableCloseable, 'DraggableCloseable', VOID, VOID, [AutoCloseable]);
initMetadataForLambda(onMouseDragInternal$slambda, VOID, VOID, [1]);
initMetadataForLambda(onMouseDragInternal$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(onMouseDragInternal$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(onMouseDragInternal$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(onMouseDragInternal$slambda_1, VOID, VOID, [1]);
initMetadataForLambda(onMouseDragInternal$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(MouseEventsUpdate, 'MouseEventsUpdate');
initMetadataForClass(MouseEvents, 'MouseEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Info, 'Info', Info);
initMetadataForClass(TouchEvents, 'TouchEvents');
initMetadataForClass(SingleTouchHandler, 'SingleTouchHandler', SingleTouchHandler);
initMetadataForClass(singleTouch$SingleTouchInfo, 'SingleTouchInfo');
initMetadataForObject(MaterialBlockUB, 'MaterialBlockUB');
initMetadataForObject(MaterialRender, 'MaterialRender');
initMetadataForClass(SceneCancellationException, 'SceneCancellationException');
initMetadataForClass(Scene, 'Scene', VOID, VOID, [InjectorDependency, CoroutineScope], [0]);
initMetadataForClass(EmptyScene, 'EmptyScene', EmptyScene, VOID, VOID, [0]);
initMetadataForClass(ScaledScene, 'ScaledScene', VOID, VOID, VOID, [0]);
initMetadataForClass(PixelatedScene, 'PixelatedScene', VOID, VOID, VOID, [0]);
initMetadataForClass(VisitEntry, 'VisitEntry');
initMetadataForCompanion(Companion_3);
initMetadataForLambda(SceneContainer$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_1, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_2, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_3, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_4, VOID, VOID, [0]);
initMetadataForClass(BaseView, 'BaseView', BaseView.tbz);
initMetadataForClass(View, 'View');
initMetadataForClass(Container, 'Container', Container.ia5);
initMetadataForClass(CachedContainer, 'CachedContainer', CachedContainer.ubz);
initMetadataForClass(FixedSizeCachedContainer, 'FixedSizeCachedContainer', FixedSizeCachedContainer.obt);
initMetadataForClass(UIView, 'UIView', UIView.jaf);
initMetadataForClass(SceneContainer, 'SceneContainer', VOID, VOID, [UIView, CoroutineScope], [2, 4, 6, 3]);
initMetadataForInterface(TransitionProcess, 'TransitionProcess');
initMetadataForClass(TransitionView, 'TransitionView', TransitionView.kaf);
protoOf(Transition$1).fam = start;
protoOf(Transition$1).gam = end;
initMetadataForClass(Transition$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1$create$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1);
initMetadataForObject(MsdfRender, 'MsdfRender');
initMetadataForClass(TweenComponent, 'TweenComponent');
initMetadataForLambda(tween$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_4);
initMetadataForLambda(UIButton$slambda, VOID, VOID, [1]);
initMetadataForLambda(UIButton$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(UIButton$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(UIButton$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(UIButton$slambda_1, VOID, VOID, [1]);
initMetadataForLambda(UIButton$slambda_2, VOID, VOID, [1]);
initMetadataForInterface(UIFocusable, 'UIFocusable');
initMetadataForClass(UIFocusableView, 'UIFocusableView', UIFocusableView.tay, VOID, [UIView, UIFocusable]);
initMetadataForClass(UIButton, 'UIButton', UIButton.say);
initMetadataForClass(UIBaseContainer, 'UIBaseContainer');
initMetadataForClass(UIContainer, 'UIContainer');
initMetadataForClass(UIVerticalHorizontalStack, 'UIVerticalHorizontalStack');
initMetadataForClass(UIVerticalStack, 'UIVerticalStack', UIVerticalStack.cb8);
initMetadataForClass(UIHorizontalStack, 'UIHorizontalStack', UIHorizontalStack.zbg);
initMetadataForObject(Scope, 'Scope');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(UIFocusManager, 'UIFocusManager');
initMetadataForClass(Highlight, 'Highlight');
initMetadataForClass(Highlights, 'Highlights');
initMetadataForClass(UIMaterialLayer, 'UIMaterialLayer', UIMaterialLayer.uay);
initMetadataForClass(UIScrollable, 'UIScrollable');
initMetadataForCompanion(Companion_5);
initMetadataForClass(InternalViewAutoscaling, 'InternalViewAutoscaling', InternalViewAutoscaling);
initMetadataForClass(RectBase, 'RectBase', RectBase.ccf);
initMetadataForClass(BaseImage, 'BaseImage');
initMetadataForClass(BaseGraphics, 'BaseGraphics');
initMetadataForClass(CacheTexture, 'CacheTexture', VOID, VOID, [AutoCloseable]);
initMetadataForObject(ZIndexComparator, 'ZIndexComparator', VOID, VOID, [Comparator]);
initMetadataForClass(ContainerCollection$iterator$1);
initMetadataForClass(ContainerCollection, 'ContainerCollection', VOID, VOID, [MutableIterable, Collection, KtList]);
initMetadataForClass(CpuGraphics, 'CpuGraphics', CpuGraphics.fc6);
initMetadataForClass(DummyView, 'DummyView', DummyView.hc8);
initMetadataForCompanion(Companion_6);
initMetadataForClass(FixedSizeContainer, 'FixedSizeContainer', FixedSizeContainer.jc8);
initMetadataForClass(SContainer, 'SContainer', SContainer.xa7);
initMetadataForClass(TimeSlidingWindow, 'TimeSlidingWindow');
initMetadataForClass(GraphicsRenderer, 'GraphicsRenderer');
initMetadataForClass(Graphics, 'Graphics', Graphics.kce);
initMetadataForInterface(ViewFileRef, 'ViewFileRef', VOID, VOID, VOID, [3]);
protoOf(Image).wce = forceLoadSourceFile$default;
initMetadataForClass(Image, 'Image', VOID, VOID, [BaseImage, ViewFileRef], [3]);
initMetadataForCompanion(Companion_7);
initMetadataForCompanion(Companion_8);
initMetadataForClass(SolidRect, 'SolidRect');
initMetadataForClass(Stage, 'Stage', VOID, VOID, [FixedSizeContainer, CoroutineScope, BoundsProvider]);
initMetadataForCompanion(Companion_9);
initMetadataForLambda(Text$_renderInternal$slambda, VOID, VOID, [0]);
initMetadataForClass(Text, 'Text', VOID, VOID, VOID, [2]);
initMetadataForCompanion(Companion_10);
initMetadataForClass(TextBlock, 'TextBlock', TextBlock.gb2);
initMetadataForInterface(ColorReference, 'ColorReference');
initMetadataForCompanion(Companion_11);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForInterface(ViewRenderPhase, 'ViewRenderPhase');
initMetadataForLambda(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda, VOID, VOID, [0]);
protoOf(Mixin_0).wce = forceLoadSourceFile$default;
initMetadataForClass(Mixin_0, 'Mixin', Mixin_0, VOID, [ViewFileRef], [3]);
initMetadataForLambda(Views$close$slambda, VOID, VOID, [0]);
initMetadataForClass(Views, 'Views', VOID, VOID, [BaseEventListener, CoroutineScope, BoundsProvider, AutoCloseable, DeviceDimensionsProvider], [0]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(ViewsUpdateEvent, 'ViewsUpdateEvent');
initMetadataForCompanion(Companion_13);
initMetadataForClass(ViewsResizedEvent, 'ViewsResizedEvent');
initMetadataForCompanion(Companion_14);
initMetadataForInterface(Filter, 'Filter');
initMetadataForClass(ComposedFilter, 'ComposedFilter', ComposedFilter.ocn, VOID, [Filter]);
initMetadataForClass(BlurFilter, 'BlurFilter', BlurFilter.mcn, VOID, [ComposedFilter, Filter]);
initMetadataForCompanion(Companion_15);
initMetadataForObject(BlurUB, 'BlurUB');
initMetadataForClass(BaseProgramProvider, 'BaseProgramProvider', BaseProgramProvider);
initMetadataForCompanion(Companion_16);
protoOf(ShaderFilter).kco = get_recommendedFilterScale;
initMetadataForClass(ShaderFilter, 'ShaderFilter', VOID, VOID, [Filter]);
initMetadataForClass(DirectionalBlurFilter, 'DirectionalBlurFilter', DirectionalBlurFilter);
initMetadataForCompanion(Companion_17);
protoOf(DropshadowFilter).kco = get_recommendedFilterScale;
initMetadataForClass(DropshadowFilter, 'DropshadowFilter', DropshadowFilter, VOID, [Filter]);
initMetadataForCompanion(Companion_18);
initMetadataForClass(RenderToTextureResult, 'RenderToTextureResult', RenderToTextureResult, VOID, [DisposableHandle]);
protoOf(IdentityFilter).kco = get_recommendedFilterScale;
protoOf(IdentityFilter).lco = computeBorder;
initMetadataForClass(IdentityFilter, 'IdentityFilter', VOID, VOID, [Filter]);
initMetadataForCompanion(Companion_19);
initMetadataForObject(Linear, 'Linear');
initMetadataForObject(Nearest, 'Nearest');
initMetadataForCompanion(Companion_20);
initMetadataForObject(TexInfoUB, 'TexInfoUB');
initMetadataForCompanion(Companion_21);
initMetadataForClass(ViewRenderPhaseBackdropFilter, 'ViewRenderPhaseBackdropFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForCompanion(Companion_22);
protoOf(ViewRenderPhaseFilter).acm = beforeRender;
protoOf(ViewRenderPhaseFilter).bcm = afterRender;
initMetadataForClass(ViewRenderPhaseFilter, 'ViewRenderPhaseFilter', ViewRenderPhaseFilter, VOID, [ViewRenderPhase]);
initMetadataForClass(PointsResult, 'PointsResult');
initMetadataForClass(GpuShapeView, 'GpuShapeView', GpuShapeView.hce);
initMetadataForClass(ScissorCommand, 'ScissorCommand');
initMetadataForClass(ClearCommand, 'ClearCommand');
initMetadataForClass(ShapeCommand, 'ShapeCommand');
initMetadataForClass(GpuShapeViewCommands, 'GpuShapeViewCommands', GpuShapeViewCommands);
initMetadataForObject(ShapeViewUB, 'ShapeViewUB');
initMetadataForClass(PaintShader, 'PaintShader');
initMetadataForObject(GpuShapeViewPrograms, 'GpuShapeViewPrograms');
//endregion
//region block: init
KorgeRunner_instance = new KorgeRunner();
Companion_instance_17 = new Companion_2();
Scope_instance = new Scope();
ZIndexComparator_instance = new ZIndexComparator();
Companion_instance_21 = new Companion_6();
Companion_instance_22 = new Companion_7();
Companion_instance_23 = new Companion_8();
Companion_instance_24 = new Companion_9();
Companion_instance_26 = new Companion_11();
Companion_instance_27 = new Companion_12();
Companion_instance_28 = new Companion_13();
Companion_instance_29 = new Companion_14();
Companion_instance_30 = new Companion_15();
Companion_instance_37 = new Companion_22();
//endregion
//region block: exports
export {
  views as views116j359zi8nvf,
  Korge_0 as Korge3fi4cwjkh8up9,
  Companion_getInstance_44 as Companion_getInstance2b4rje0hs8ulh,
  Companion_getInstance_45 as Companion_getInstancequ1o8fwft10r,
  Companion_instance_30 as Companion_instancemwhzkt5i9y3h,
  Companion_getInstance_58 as Companion_getInstance347d6rnwg0m6u,
  Companion_instance_24 as Companion_instance1qzytx5vkv693,
  MouseEvents as MouseEvents19mapgq8ez76g,
  draggable as draggable20qgpvq8etapv,
  get_mouse as get_mouse1jstwhfaumelj,
  get_AlphaTransition as get_AlphaTransition23l7sd982osvm,
  PixelatedScene as PixelatedSceneoudxoze5iszc,
  SceneContainer as SceneContainer99ijjqni12hp,
  Scene as Scenezu810y12qpqp,
  withEasing as withEasingtnol1eyyo9sf,
  UIButton as UIButton259u54yn72ttw,
  UIHorizontalStack as UIHorizontalStack2hv4gvky7dghi,
  UIVerticalStack as UIVerticalStack2gichhwk4pg3x,
  centerOn as centerOnqo5dp4jcubi5,
  DropshadowFilter as DropshadowFilter3mmze965vo4ad,
  set_filter as set_filter36wgvpm5cukpc,
  get_filterScale as get_filterScaleuvlwz3cded4n,
  set_filterScale as set_filterScale3iptc9lhu4vp1,
  Container as Container7486fjmip554,
  FixedSizeContainer as FixedSizeContainersre0rworj71w,
  Image as Image1b2d7ghyim7p5,
  SolidRect as SolidRect131p7hyzlx7j8,
  Stage as Stage1ggtrzujnnkl0,
  Text as Text3kimhvgfxflj3,
  addTo as addTo25e29vq105prw,
  alpha as alphaher384qrj9q4,
  get_centered as get_centeredilxldnbf7ma6,
  findFirstAscendant as findFirstAscendante8nli1jx4t64,
  scale as scalea9fc0mbrr7ub,
  xy as xyssniz4rympby,
  xy_0 as xy1gb51vhy014mx,
};
//endregion
